/* (7) toki-wheel.part5.js — persistence + share links + overlay + segments ops + undo + voice + SOUND toggle + recording + CSV + badge drag */
(function(){
  'use strict';

  var TW = window.TokiWheel, U = TW && TW.util, R = TW && TW.refs;
  if(!TW || !U || !R) return;

  TW.ensureState();

  // =========================================================
  // ✅ USER-EDITABLE: Featured Images button inside image picker
  // =========================================================
  var TW_FEATURED_IMG_BUTTON_LABEL = 'Browse Featured Images';

  // ✅ CHANGE THIS ANYTIME:
  // - Use a tag/keyword your picker understands (ex: "food", "animals", "tokiphon-featured")
  var TW_FEATURED_IMG_TAG = 'food';

  // =========================================================
  // ✅ USER-EDITABLE: Segment auto-color variety (every Nth)
  // - Example: 3 => 0,3,6,9,12,... (wraps)
  // =========================================================
  var TW_SEG_COLOR_STEP = 3;

  // =========================================================
  // ✅ SESSION-ONLY: Sound toggle key (per page)
  // - Sound defaults OFF each new tab/session
  // - NOT saved in localStorage wheel state
  // =========================================================
  var TW_SOUND_SESSION_KEY = 'twSoundEnabled::' + String(window.location.pathname || '/');

  function getSessionSoundFlag(){
    try{
      var v = localStorage.getItem(TW_SOUND_SESSION_KEY);
      if(v == null) return 'no'; // ✅ default OFF every session
      v = String(v).toLowerCase();
      return (v === 'yes') ? 'yes' : 'no';
    }catch(_){
      return 'no';
    }
  }

  function setSessionSoundFlag(on){
    try{
      localStorage.setItem(TW_SOUND_SESSION_KEY, on ? 'yes' : 'no');
    }catch(_){}
  }

  function isSoundOn(){
    return getSessionSoundFlag() === 'yes';
  }

  TW.isSoundEnabled = isSoundOn;

  // =========================================================
  // ✅ SESSION-ONLY: Voice toggle key (per page)
  // - Voice defaults OFF each new tab/session
  // - NOT saved in localStorage wheel state
  // =========================================================
  var TW_VOICE_SESSION_KEY = 'twVoiceEnabled::' + String(window.location.pathname || '/');

  function getSessionVoiceFlag(){
    try{
      var v = localStorage.getItem(TW_VOICE_SESSION_KEY);
      if(v == null) return 'no'; // ✅ default OFF every session
      v = String(v).toLowerCase();
      return (v === 'yes') ? 'yes' : 'no';
    }catch(_){
      return 'no';
    }
  }

  function setSessionVoiceFlag(on){
    try{
      localStorage.setItem(TW_VOICE_SESSION_KEY, on ? 'yes' : 'no');
    }catch(_){}
  }

  function isVoiceOn(){
    return getSessionVoiceFlag() === 'yes';
  }

  function setVoiceOn(on){
    setSessionVoiceFlag(!!on);
    try{
      TW.state = TW.state || {};
      TW.state.ui = TW.state.ui || {};
      TW.state.ui.voiceOn = on ? 'yes' : 'no';
    }catch(_){}
  }

  function syncVoiceStateFromSession(){
    try{
      TW.state = TW.state || {};
      TW.state.ui = TW.state.ui || {};
      TW.state.ui.voiceOn = isVoiceOn() ? 'yes' : 'no';
    }catch(_){}
  }

  function stopRecordedPhraseAudio(){
    try{
      var a = TW._recordedPhraseAudio;
      if(a){
        try{ a.pause(); }catch(_){}
        try{ a.currentTime = 0; }catch(_){}
        try{ a.onended = null; a.onerror = null; a.onplay = null; a.onplaying = null; }catch(_){}
      }
    }catch(_){}
  }

  function stopAllVoiceNow(){
    try{ TW._voiceRunId = (TW._voiceRunId || 0) + 1; }catch(_){}
    try{ safeCancel(); }catch(_){}
    try{ stopRecordedPhraseAudio(); }catch(_){}

    // 2026-05-09B APPLE GHOST-VOICE FIX:
    // iOS/Safari can release one stale queued utterance after a toggle/cancel.
    // Cancel several times over a short window and keep the run id invalidated
    // so delayed callbacks cannot speak the last winning segment.
    try{ setTimeout(function(){ try{ TW._voiceRunId = (TW._voiceRunId || 0) + 1; safeCancel(); stopRecordedPhraseAudio(); }catch(_){} }, 60); }catch(_){}
    try{ setTimeout(function(){ try{ TW._voiceRunId = (TW._voiceRunId || 0) + 1; safeCancel(); stopRecordedPhraseAudio(); }catch(_){} }, 180); }catch(_){}
    try{ setTimeout(function(){ try{ TW._voiceRunId = (TW._voiceRunId || 0) + 1; safeCancel(); stopRecordedPhraseAudio(); }catch(_){} }, 420); }catch(_){}
  }


  // APPLE VOICE/SOUND SURGICAL FIX 2026-05-08I:
  // Start every page load with Sound and Voice OFF. This avoids iOS/Safari
  // restoring a stale selected state from bfcache/sessionStorage while Windows
  // correctly appears off.
  try{ syncVoiceStateFromSession(); }catch(_){ }

  // =========================================================
// ✅ SESSION DEFAULTS (OFF by default)
// - Sound + Voice should start OFF each *new* session/tab.
// - We DO NOT force-write "off" on every load because that can race UI init,
//   break toggles, and interfere with iOS/Chrome gesture unlocking.
// - If sessionStorage has no value, getSession*Flag() already treats it as OFF.
// - We still force OFF on iOS back/forward-cache restores (pageshow persisted).
// =========================================================
try{
  window.addEventListener('pageshow', function(e){
    try{
      if(e && e.persisted){
        try{ syncVoiceStateFromSession(); }catch(_){ }
        try{ applySoundStateToAllAudio(); }catch(_){ }
        try{ if(typeof updateVoiceHeaderUI === 'function') updateVoiceHeaderUI(); }catch(_){ }
        try{ if(typeof ensureHeaderSoundToggle === 'function') ensureHeaderSoundToggle(); }catch(_){ }
      }
    }catch(_){}
  });
}catch(_){ }



// =========================================================
  // ✅ GLOBAL AUDIO GATE (fix: "Sound Off" still plays on some builds)
  // - Track all Audio() instances and hard-mute/pause when sound is off
  // - Works across iOS Safari/Chrome where some sounds bypass TW.play* wrappers
  // =========================================================
  (function patchGlobalAudioConstructor(){
    try{
      if(TW._audioCtorPatched) return;
      TW._audioCtorPatched = true;

      TW._allAudio = TW._allAudio || [];

      var OrigAudio = window.Audio;
      if(typeof OrigAudio !== 'function') return;

      function WrappedAudio(src){
        var a;
        try{
          // support Audio() and new Audio()
          a = arguments.length ? new OrigAudio(src) : new OrigAudio();
        }catch(_){
          // fallback call form
          a = OrigAudio.apply(window, arguments);
        }

        try{
          // track
          TW._allAudio.push(a);
          // tag (for debugging)
          a.__twTracked = true;
        }catch(_){}

        // apply current sound state immediately
        try{
          a.muted = !isSoundOn();
          if(a.muted){
            try{ a.pause(); }catch(_){}
          }
        }catch(_){}

        return a;
      }

      // preserve prototype chain
      WrappedAudio.prototype = OrigAudio.prototype;
      try{
        window.Audio = WrappedAudio;
      }catch(_){}
    }catch(_){}
  })();

  function applySoundStateToAllAudio(){
    try{
      var on = isSoundOn();

      // Legacy engine-known audios
      try{
        if(TW._spinAudio){
          TW._spinAudio.muted = !on;
          if(!on){ try{ TW._spinAudio.pause(); TW._spinAudio.currentTime = 0; }catch(_){ } }
        }
      }catch(_){}
      try{
        if(TW._winAudio){
          TW._winAudio.muted = !on;
          if(!on){ try{ TW._winAudio.pause(); TW._winAudio.currentTime = 0; }catch(_){ } }
        }
      }catch(_){}

      // Runtime audios used by the newer engine (part4)
      try{
        if(TW._rt && TW._rt.spinAudio){
          TW._rt.spinAudio.muted = !on;
          if(!on){ try{ TW._rt.spinAudio.pause(); TW._rt.spinAudio.currentTime = 0; }catch(_){ } }
        }
      }catch(_){}
      try{
        if(TW._rt && TW._rt.lastWinAudio){
          TW._rt.lastWinAudio.muted = !on;
          if(!on){ try{ TW._rt.lastWinAudio.pause(); TW._rt.lastWinAudio.currentTime = 0; }catch(_){ } }
        }
      }catch(_){}

      // Any tracked Audio() calls (constructor wrapper)
      try{
        var list = TW._allAudio || [];
        for(var i=0;i<list.length;i++){
          var a = list[i];
          if(!a) continue;
          try{
            a.muted = !on;
            if(!on){ try{ a.pause(); }catch(_){ } }
          }catch(_){}
        }
      }catch(_){}

      // Reusable cache used by part4 (TW._audCache.byUrl)
      try{
        if(TW._audCache && TW._audCache.byUrl){
          var map = TW._audCache.byUrl;
          for(var url in map){
            if(!Object.prototype.hasOwnProperty.call(map, url)) continue;
            var ca = map[url];
            if(!ca) continue;
            try{
              ca.muted = !on;
              if(!on){ try{ ca.pause(); ca.currentTime = 0; }catch(_){ } }
            }catch(_){}
          }
        }
      }catch(_){}
    }catch(_){}
  }

  // =========================================================
  // ✅ FIDGET MODE CSS (INJECTED, SCOPED, NO REDESIGN)
  // =========================================================
  function injectFidgetCSS(){
    try{
      if(document.getElementById('twFidgetCSS')) return;

      var css = ''
      + '.tw-fidgetGlass{position:absolute; inset:-2px; border-radius:inherit; pointer-events:none; opacity:0; transition:opacity .18s ease;'
      + 'background:radial-gradient(ellipse at center, rgba(255,255,255,.06), rgba(0,0,0,.22) 65%, rgba(0,0,0,.40));'
      + 'box-shadow:inset 0 0 0 1px rgba(255,255,255,.08), inset 0 0 40px rgba(0,0,0,.25);}'
      + '.tw-fidgetOn .tw-fidgetGlass{opacity:1;}'

      + '.tw-fidgetBadge{position:absolute; left:50%; top:10px; transform:translateX(-50%);'
      + 'font-weight:900; letter-spacing:.12em; font-size:11px; padding:6px 10px; border-radius:999px;'
      + 'background:rgba(0,0,0,.35); color:rgba(255,255,255,.92);'
      + 'box-shadow:0 6px 18px rgba(0,0,0,.20), inset 0 0 0 1px rgba(255,255,255,.10);'
      + 'backdrop-filter:blur(10px) saturate(1.1); -webkit-backdrop-filter:blur(10px) saturate(1.1);'
      + 'pointer-events:none; opacity:0; transition:opacity .18s ease;}'
      + '.tw-fidgetOn .tw-fidgetBadge{opacity:1;}'

      + '.tw-fidgetCharge{position:absolute; left:50%; top:50%; width:92px; height:92px; transform:translate(-50%,-50%);'
      + 'border-radius:50%; pointer-events:none;'
      + 'background:conic-gradient(rgba(34,211,238,.95) calc(var(--p,0)*1turn), rgba(255,255,255,.10) 0);'
      + 'mask:radial-gradient(circle at center, transparent 58%, #000 60%);'
      + '-webkit-mask:radial-gradient(circle at center, transparent 58%, #000 60%);'
      + 'filter:drop-shadow(0 10px 18px rgba(0,0,0,.25));'
      + 'opacity:.95;}'

      + '.tw-fidgetX{position:absolute; right:10px; top:10px; width:34px; height:34px; border-radius:999px;'
      + 'border:none; background:rgba(0,0,0,.35); color:rgba(255,255,255,.92); font-size:20px; line-height:32px;'
      + 'box-shadow:0 6px 18px rgba(0,0,0,.20), inset 0 0 0 1px rgba(255,255,255,.10);'
      + 'backdrop-filter:blur(10px) saturate(1.1); -webkit-backdrop-filter:blur(10px) saturate(1.1);'
      + 'cursor:pointer; opacity:.95;}'
      + '.tw-fidgetX:active{transform:scale(.98);}'

      + '.tw-fidgetPanel{position:absolute; left:50%; top:62%; bottom:auto; transform:translateX(-50%);'
      + 'width:min(420px, calc(100% - 22px));'
      + 'background:rgba(0,0,0,.35); color:rgba(255,255,255,.92);'
      + 'border-radius:16px; padding:8px 8px;'
      + 'box-shadow:0 10px 26px rgba(0,0,0,.25), inset 0 0 0 1px rgba(255,255,255,.10);'
      + 'backdrop-filter:blur(12px) saturate(1.12); -webkit-backdrop-filter:blur(12px) saturate(1.12);'
      + 'opacity:0; transition:opacity .18s ease;'
      + 'max-height:52vh; overflow:auto; -webkit-overflow-scrolling:touch;}'
      + '.tw-fidgetOn .tw-fidgetPanel{opacity:1;}'

      + '@media (min-width: 700px) and (max-width: 979px){'
      + '.tw-fidgetPanel{top:65%; max-height:52vh;}'
      + '}'

      + '@media (min-width: 980px){'
      + '.tw-fidgetPanel{top:66%; max-height:50vh;}'
      + '}'
      + '@media (min-width: 1400px){'
      + '.tw-fidgetPanel{top:68%; max-height:48vh;}'
      + '}'

      + '.tw-fidgetRow{display:flex; align-items:center; justify-content:space-between; gap:8px; margin:4px 0; flex-wrap:nowrap;}'
      + '.tw-fidgetLab{font-size:12px; opacity:.92; font-weight:900; letter-spacing:.02em; white-space:nowrap;}'
      + '.tw-fidgetGroup{display:flex; gap:5px; flex-wrap:wrap; justify-content:flex-end;}'
      + '.tw-fidgetBtn{appearance:none; border:none; border-radius:12px; padding:7px 9px;'
      + 'background:rgba(255,255,255,.12); color:rgba(255,255,255,.92); font-weight:900; font-size:12px;'
      + 'box-shadow:inset 0 0 0 1px rgba(255,255,255,.10); cursor:pointer; line-height:1;}'
      + '.tw-fidgetBtn:active{transform:scale(.99);}'
      + '.tw-fidgetBtn.isOn{background:rgba(34,211,238,.22); box-shadow:inset 0 0 0 1px rgba(34,211,238,.45);}'

      + '.tw-fidgetToggle{display:flex; align-items:center; justify-content:space-between; gap:6px; width:auto; min-width:96px;}'
      + '.tw-fidgetStop{width:100%; padding:9px 10px; border-radius:14px;}'

      + '.tw-fidgetOn.tw-fidgetFast .tw-fidgetBadge{filter:drop-shadow(0 0 10px rgba(34,211,238,.35));}'
      + '.tw-fidgetFast .tw-fidgetPanel{box-shadow:0 12px 32px rgba(0,0,0,.28), inset 0 0 0 1px rgba(34,211,238,.20);}'

      + '@media (max-width: 520px){'
      + '.tw-fidgetPanel{'
      + 'top:78%;'
      + 'max-height:58vh;'
      + 'width:calc(100% - 16px);'
      + 'padding:7px 7px; border-radius:14px;'
      + 'padding-bottom:calc(7px + env(safe-area-inset-bottom));'
      + '}'
      + '.tw-fidgetRow{margin:3px 0; gap:7px;}'
      + '.tw-fidgetLab{font-size:11px; max-width:44%; overflow:hidden; text-overflow:ellipsis;}'
      + '.tw-fidgetGroup{gap:4px;}'
      + '.tw-fidgetBtn{padding:6px 8px; font-size:11px; border-radius:11px;}'
      + '.tw-fidgetToggle{min-width:86px; gap:5px;}'
      + '}'

      + '@media (max-width: 520px) and (max-height: 720px){'
      + '.tw-fidgetPanel{top:80%; max-height:62vh;}'
      + '.tw-fidgetRow{margin:2px 0;}'
      + '.tw-fidgetBtn{padding:6px 8px;}'
      + '}'

      + '.tw-fidgetBurst{position:absolute; left:50%; top:50%; transform:translate(-50%,-50%); width:1px; height:1px; pointer-events:none;}'
      + '.tw-fidgetBurst.go .tw-fidgetSpark{animation:twFidgetSpark .48s ease-out forwards;}'
      + '.tw-fidgetSpark{position:absolute; left:0; top:0; width:6px; height:6px; border-radius:50%;'
      + 'background:rgba(34,211,238,.95); box-shadow:0 0 10px rgba(34,211,238,.35); opacity:0;'
      + '--sx: 0; --sy: 0;}'

      + '@keyframes twFidgetSpark{'
      + '0%{opacity:0; transform:translate(0,0) scale(.5);}'
      + '12%{opacity:1;}'
      + '100%{opacity:0; transform:translate(calc(var(--sx)*1px), calc(var(--sy)*1px)) scale(.2);}'
      + '}'
      ;

      css += '.tw-fidgetBurst.go .tw-fidgetSpark{opacity:1;}';

      // ✅ SURGICAL ADD: overlay forced-hide helper class
      css += '.tw-ovHidePanel{display:none !important;}';

      var st = document.createElement('style');
      st.id = 'twFidgetCSS';
      st.textContent = css;
      document.head.appendChild(st);
    }catch(_){}
  }
  injectFidgetCSS();

  // =========================================================
  // ✅ iOS/Safari FIX CSS (fonts + control appearance)
  // + ✅ Overlay layout parity on iOS (safe-area + rounding + full cover)
  // =========================================================
  function injectIOSFixCSS(){
    try{
      if(document.getElementById('twIOSFixCSS')) return;

      var css = ''
      + '#toki-wheel-root, .toki-wheel, .tw-wrap, .tw-header, .tw-panel, .tw-modal, .tw-popover{'
      + 'font-family: Fredoka, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif !important;'
      + '}'
      + '.tw-accordTitle, .tw-title, .tw-h, .tw-h2, .tw-mini, .tw-btn, .tw-x{'
      + 'font-family: Fredoka, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif !important;'
      + '}'

      // kill iOS blue check / native styling in controls we render in panels/popovers
      + '.tw-wrap input[type="checkbox"], .tw-wrap input[type="radio"], .tw-modal input[type="checkbox"], .tw-modal input[type="radio"], .tw-popover input[type="checkbox"], .tw-popover input[type="radio"]{'
      + '-webkit-appearance:none !important; appearance:none !important;'
      + 'background:none !important; box-shadow:none !important;'
      + '}'
      + '.tw-wrap select, .tw-modal select, .tw-popover select{'
      + '-webkit-appearance:none !important; appearance:none !important;'
      + '}'

      // hide Safari details marker (can look like a “blue check” in some themes)
      + 'summary::-webkit-details-marker{display:none !important;}'
      + 'summary{list-style:none !important;}'

      // remove tap highlight (iOS “blue flash”)
      + '.tw-wrap, .tw-wrap *{ -webkit-tap-highlight-color: rgba(0,0,0,0); }'

      // ✅ overlay iOS parity: full-viewport, safe-area padding, rounded main, no “peek” of page
      + '.tw-overlay .tw-overlayBack{'
      + 'position:fixed !important; inset:0 !important;'
      + 'transform:translateZ(0) !important;'
      + '}'
      + '.tw-wrap.tw-overlay{'
      + 'position:fixed !important; inset:0 !important;'
      + 'padding-top: env(safe-area-inset-top, 0px) !important;'
      + 'padding-bottom: env(safe-area-inset-bottom, 0px) !important;'
      + 'padding-left: env(safe-area-inset-left, 0px) !important;'
      + 'padding-right: env(safe-area-inset-right, 0px) !important;'
      + 'overflow:hidden !important;'
      + 'background: var(--tw-ovBack) !important;'
      + '}'
      + '.tw-wrap.tw-overlay .tw-main{'
      + 'max-height: calc(100vh - env(safe-area-inset-top,0px) - env(safe-area-inset-bottom,0px)) !important;'
      + 'overflow:auto !important; -webkit-overflow-scrolling:touch !important;'
      + 'border-radius: 22px !important;'
      + 'margin: 0 auto !important;'
      + '}'
      + '.tw-overlay body, body.twOverlayBody{'
      + 'overscroll-behavior:none !important;'
      + '}'
      ;

      var st = document.createElement('style');
      st.id = 'twIOSFixCSS';
      st.textContent = css;
      document.head.appendChild(st);
    }catch(_){}
  }
  injectIOSFixCSS();

  // =========================================================
  // ✅ STABLE STORAGE KEY (PER PAGE, INDEPENDENT OF LOADER VERSION)
  // =========================================================
  var KEY_BASE = (TW.CONST.KEY || 'toki-wheel');
  var PATH = String(window.location.pathname || '/');
  var VER = (window.TW_STORAGE_VER != null) ? String(window.TW_STORAGE_VER) : 'v1';
  var LEGACY_KEY = KEY_BASE + '::' + PATH + '::' + VER;
  var KEY = KEY_BASE + '::page::' + encodeURIComponent(PATH) + '::current';
  var DASHBOARD_KEY = KEY_BASE + '::dashboard::v1';
  var DASHBOARD_ACTIVE_KEY = KEY_BASE + '::dashboardActive::v1';
  var SHOW_SESSION_PREFIX = KEY_BASE + '::showSession::v1::';
  var WHEEL_SCHEMA_VERSION = 1;

  function validateMigratedWheelState(state){
    if(!state || typeof state !== 'object') throw new Error('Saved wheel is not an object.');
    if(!Array.isArray(state.segments) || !state.segments.length) throw new Error('Saved wheel has no segments.');
    if(TW.CONST && TW.CONST.MAX_SEGMENTS && state.segments.length > TW.CONST.MAX_SEGMENTS){
      throw new Error('Saved wheel contains more segments than this loader supports.');
    }
    for(var i=0;i<state.segments.length;i++){
      if(!state.segments[i] || typeof state.segments[i] !== 'object') throw new Error('Saved wheel contains an invalid segment.');
    }
    return true;
  }

  var WHEEL_SCHEMA_MIGRATIONS = {
    0:function(state){
      // Version 0 covers every save created before explicit wheel schema
      // versioning. This migration is deliberately non-destructive: it adds
      // the containers/version marker while preserving unknown fields.
      state.ui = state.ui && typeof state.ui === 'object' ? state.ui : {};
      state._meta = state._meta && typeof state._meta === 'object' ? state._meta : {};
      state._meta.wheelSchemaVersion = 1;
      return state;
    }
  };

  function migrateWheelState(input){
    var state = U.clone(input) || null;
    if(!state || typeof state !== 'object') throw new Error('Saved wheel could not be copied safely.');
    state._meta = state._meta && typeof state._meta === 'object' ? state._meta : {};
    var fromVersion = parseInt(state._meta.wheelSchemaVersion, 10);
    if(!isFinite(fromVersion) || fromVersion < 0) fromVersion = 0;
    if(fromVersion > WHEEL_SCHEMA_VERSION) throw new Error('This wheel was saved by a newer wheel format.');
    var currentVersion = fromVersion;
    while(currentVersion < WHEEL_SCHEMA_VERSION){
      var migrate = WHEEL_SCHEMA_MIGRATIONS[currentVersion];
      if(typeof migrate !== 'function') throw new Error('A required wheel migration is unavailable.');
      state = migrate(state);
      currentVersion += 1;
      state._meta = state._meta && typeof state._meta === 'object' ? state._meta : {};
      state._meta.wheelSchemaVersion = currentVersion;
    }
    validateMigratedWheelState(state);
    return { state:state, fromVersion:fromVersion, toVersion:currentVersion, migrated:fromVersion !== currentVersion };
  }

  function showWheelMigrationError(source, error){
    var root = document.getElementById('toki-wheel-root');
    if(root){
      root.innerHTML = '<div class="tw-homeLoadError" role="alert"><strong>Saved wheel could not be opened safely</strong><span>Your original saved wheel was not changed. Return to the dashboard and keep it while we update the wheel converter.</span></div>';
    }
    try{ console.error('Wheel schema migration failed', { source:source || 'unknown', message:(error && error.message) || 'Unknown error' }); }catch(_){ }
  }

  TW.WHEEL_SCHEMA_VERSION = WHEEL_SCHEMA_VERSION;
  TW.migrateWheelState = migrateWheelState;

  function makeDashboardId(){
    return 'dw_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
  }

  function cloneDashboardState(state){
    var st = U.clone(state) || null;
    if(!st) return null;
    st.ui = st.ui || {};
    st._meta = st._meta || {};
    st._meta.wheelSchemaVersion = WHEEL_SCHEMA_VERSION;
    return st;
  }

  function getDashboardStore(){
    var raw = null, parsed = null;
    try{ raw = localStorage.getItem(DASHBOARD_KEY); }catch(_){ }
    parsed = raw ? U.safeJSONParse(raw) : null;
    if(Array.isArray(parsed)) return parsed;
    return [];
  }

  function setDashboardStore(list){
    try{
      localStorage.setItem(DASHBOARD_KEY, U.safeJSONStringify(Array.isArray(list) ? list : []));
      return true;
    }catch(_){
      return false;
    }
  }

  function findDashboardIndexById(list, id){
    if(!Array.isArray(list) || !id) return -1;
    for(var i=0;i<list.length;i++){
      if(String((list[i] && list[i].id) || '') === String(id)) return i;
    }
    return -1;
  }

  function getDashboardTitleFromState(st){
    var ui = (st && st.ui) ? st.ui : {};
    return String(ui.title || 'WHEEL').trim() || 'WHEEL';
  }

  function getDashboardDescFromState(st){
    var ui = (st && st.ui) ? st.ui : {};
    return String(ui.desc || '').trim();
  }

  function flashDashboardSaveButton(label, timeoutMs){
    var btn = R.btnDashboardSave;
    if(!btn) return;
    var span = btn.querySelector('span');
    if(!span){
      var status = document.getElementById('twDashboardSaveStatus');
      if(!status){
        status = document.createElement('div');
        status.id = 'twDashboardSaveStatus';
        status.className = 'tw-dashboardSaveStatus';
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        status.style.cssText = 'position:fixed;z-index:2147482500;max-width:calc(100vw - 24px);padding:9px 13px;border:2px solid #1f1f1f;border-radius:12px;background:#fff8ee;color:#1f1f1f;box-shadow:3px 3px 0 #1f1f1f;font:800 14px/1.2 Fredoka,system-ui,sans-serif;pointer-events:none;opacity:0;transform:translateY(-4px);transition:opacity .16s ease,transform .16s ease;';
        document.body.appendChild(status);
      }
      if(status.__twDashboardFlashTimer) clearTimeout(status.__twDashboardFlashTimer);
      var rect = btn.getBoundingClientRect();
      status.textContent = label || '✓ Saved on this device';
      status.style.right = Math.max(12, window.innerWidth - rect.right) + 'px';
      status.style.top = Math.min(window.innerHeight - 54, rect.bottom + 9) + 'px';
      status.style.opacity = '1';
      status.style.transform = 'translateY(0)';
      status.__twDashboardFlashTimer = setTimeout(function(){
        status.style.opacity = '0';
        status.style.transform = 'translateY(-4px)';
        status.__twDashboardFlashTimer = null;
      }, timeoutMs || 1600);
      return;
    }
    if(btn.__twDashboardFlashTimer){
      clearTimeout(btn.__twDashboardFlashTimer);
      btn.__twDashboardFlashTimer = null;
    }
    if(btn.__twDashboardFlashOriginal == null){
      btn.__twDashboardFlashOriginal = span.textContent || 'Save';
    }
    span.textContent = label || 'Saved';
    btn.__twDashboardFlashTimer = setTimeout(function(){
      span.textContent = btn.__twDashboardFlashOriginal || 'Save';
      btn.__twDashboardFlashTimer = null;
    }, timeoutMs || 1400);
  }

  function consumeDashboardActiveState(){
    var raw = null, parsed = null;
    try{ raw = sessionStorage.getItem(DASHBOARD_ACTIVE_KEY); }catch(_){ }
    if(!raw) return null;
    parsed = U.safeJSONParse(raw);
    if(!parsed || !parsed.state) return null;
    try{
      var migration = migrateWheelState(parsed.state);
      parsed.state = migration.state;
      parsed._wheelMigration = migration;
    }catch(error){
      try{ sessionStorage.removeItem(DASHBOARD_ACTIVE_KEY); }catch(_){ }
      return { _migrationError:error };
    }
    try{ sessionStorage.removeItem(DASHBOARD_ACTIVE_KEY); }catch(_){ }
    return parsed;
  }

  TW.dashboardStorageKey = DASHBOARD_KEY;
  TW.dashboardActiveKey = DASHBOARD_ACTIVE_KEY;
  TW.getDashboardStore = getDashboardStore;
  TW.setDashboardStore = setDashboardStore;
  TW.getDashboardCardMeta = function(st){
    return {
      title: getDashboardTitleFromState(st),
      desc: getDashboardDescFromState(st),
      segmentCount: Array.isArray(st && st.segments) ? st.segments.length : 0
    };
  };

  TW.saveToDashboard = function(){
    TW.ensureState();
    TW.state._meta = TW.state._meta && typeof TW.state._meta === 'object' ? TW.state._meta : {};
    TW.state._meta.wheelSchemaVersion = WHEEL_SCHEMA_VERSION;

    var snapshot = cloneDashboardState(TW.state);
    if(!snapshot) return null;

    snapshot._meta = snapshot._meta || {};
    snapshot._meta.wheelSchemaVersion = WHEEL_SCHEMA_VERSION;
    if(!snapshot._meta.dashboardId){
      snapshot._meta.dashboardId = makeDashboardId();
    }

    var id = String(snapshot._meta.dashboardId || '');
    var now = new Date().toISOString();
    var list = getDashboardStore();
    var idx = findDashboardIndexById(list, id);
    var prev = (idx >= 0) ? (list[idx] || {}) : null;

    var item = {
      id: id,
      title: getDashboardTitleFromState(snapshot),
      desc: getDashboardDescFromState(snapshot),
      pagePath: PATH,
      createdAt: (prev && prev.createdAt) ? prev.createdAt : now,
      updatedAt: now,
      pinned: !!(prev && prev.pinned),
      state: snapshot
    };

    if(idx >= 0) list[idx] = item;
    else list.unshift(item);

    if(!setDashboardStore(list)){
      flashDashboardSaveButton('Save failed', 1800);
      try{ alert('Could not save this wheel to the dashboard.'); }catch(_){ }
      return null;
    }

    TW.track && TW.track('wheel_save', {
      plan: TW.access && TW.access.getUserPlan ? TW.access.getUserPlan() : 'free',
      segment_count: Array.isArray(snapshot.segments) ? snapshot.segments.length : 0,
      save_type: idx >= 0 ? 'update' : 'new'
    });

    flashDashboardSaveButton('✓ Saved', 1600);
    try{ sessionStorage.setItem(KEY_BASE + '::saveReminderDone', '1'); }catch(_){ }
    return item;
  };

  function safeParseJSON(s){
    try{ return JSON.parse(s); }catch(_){ return null; }
  }

  function readPagePreset(){
    var p = window.TOKI_WHEEL_PRESET || window.TokiWheelPreset || null;

    if(!p){
      try{
        var root = document.getElementById('toki-wheel-root');
        if(root){
          var s = root.getAttribute('data-tw-preset') || root.getAttribute('data-twPreset') || '';
          s = String(s || '').trim();
          if(s) p = safeParseJSON(s);
        }
      }catch(_){}
    }

    if(!p || typeof p !== 'object') return null;

    var out = {};
    if(Array.isArray(p.palette)) out.palette = p.palette.slice(0);
    if(Array.isArray(p.segments)) out.segments = p.segments.slice(0);

    out.title = (p.title != null) ? String(p.title) : undefined;
    out.desc  = (p.desc  != null) ? String(p.desc)  : undefined;

    out.centerBadgeUrl   = (p.centerBadgeUrl != null) ? String(p.centerBadgeUrl) : undefined;
    out.centerBadgeMask  = (p.centerBadgeMask != null) ? String(p.centerBadgeMask) : undefined;

    // ✅ preset revision (auto-apply without pressing Reset)
    out.presetRev = (p.presetRev != null) ? String(p.presetRev) : undefined;

    // ✅ snippet-only background + header text color
    out.pageBg = (p.pageBg != null) ? String(p.pageBg) : undefined;
    out.headerTextColor = (p.headerTextColor != null) ? String(p.headerTextColor) : undefined;


    out.centerBadgeScale = (p.centerBadgeScale != null) ? parseFloat(p.centerBadgeScale) : undefined;
    if(!(out.centerBadgeScale > 0)) out.centerBadgeScale = undefined;

    out.centerBadgeOffX  = (p.centerBadgeOffX != null) ? parseFloat(p.centerBadgeOffX) : undefined;
    out.centerBadgeOffY  = (p.centerBadgeOffY != null) ? parseFloat(p.centerBadgeOffY) : undefined;

    out.spinSoundId   = (p.spinSoundId != null) ? String(p.spinSoundId) : undefined;
    out.winSoundId    = (p.winSoundId  != null) ? String(p.winSoundId)  : undefined;

    out.confettiOn    = (p.confettiOn != null) ? String(p.confettiOn) : undefined;
    out.countdownOn   = (p.countdownOn != null) ? String(p.countdownOn) : undefined;
    out.countdownSec  = (p.countdownSec != null) ? parseInt(p.countdownSec, 10) : undefined;

    // ✅ per-page overlay stage colors
    out.overlayBg  = (p.overlayBg  != null) ? String(p.overlayBg)  : undefined;
    out.overlayBg2 = (p.overlayBg2 != null) ? String(p.overlayBg2) : undefined;

    out.requiredPlan = (p.requiredPlan != null) ? String(p.requiredPlan) : undefined;
    out.force = !!p.force;
    out.useAsReset = (p.useAsReset == null) ? true : !!p.useAsReset;

    return out;
  }

  function applyPresetToConstPalette(preset){
    if(!preset || !Array.isArray(preset.palette) || !preset.palette.length) return;
    try{
      TW.CONST.PALETTE = preset.palette.slice(0);
    }catch(_){}
  }


function _resolveSliceUrlFromId(id){
  id = String(id || '').trim();
  if(!id) return '';
  try{
    var lib = (TW.CONST && Array.isArray(TW.CONST.SEGMENT_IMAGE_LIBRARY)) ? TW.CONST.SEGMENT_IMAGE_LIBRARY : [];
    for(var i=0;i<lib.length;i++){
      if(String(lib[i] && lib[i].id || '').trim() === id){
        return String(lib[i].url || '').trim();
      }
    }
  }catch(_){}
  return '';
}

function applyPresetToState(preset){
  if(!preset) return;

  applyPresetToConstPalette(preset);

  TW.state.ui = TW.state.ui || {};

  if(preset.title != null) TW.state.ui.title = preset.title;
  if(preset.desc  != null) TW.state.ui.desc  = preset.desc;

  if(preset.centerBadgeUrl != null) TW.state.ui.centerBadgeUrl = preset.centerBadgeUrl;
  if(preset.centerBadgeMask != null) TW.state.ui.centerBadgeMask = preset.centerBadgeMask;

  if(preset.centerBadgeScale != null){
    TW.state.ui.centerBadgeScale = preset.centerBadgeScale;
  }
  if(preset.centerBadgeOffX != null && isFinite(preset.centerBadgeOffX)){
    TW.state.ui.centerBadgeOffX = preset.centerBadgeOffX;
  }
  if(preset.centerBadgeOffY != null && isFinite(preset.centerBadgeOffY)){
    TW.state.ui.centerBadgeOffY = preset.centerBadgeOffY;
  }

  if(preset.spinSoundId != null) TW.state.ui.spinSoundId = preset.spinSoundId;
  if(preset.winSoundId  != null) TW.state.ui.winSoundId  = preset.winSoundId;

  if(preset.confettiOn != null) TW.state.ui.confettiOn = preset.confettiOn;
  if(preset.countdownOn != null) TW.state.ui.countdownOn = preset.countdownOn;
  if(preset.countdownSec != null && isFinite(preset.countdownSec)){
    TW.state.ui.countdownSec = preset.countdownSec;
  }

  if(preset.overlayBg != null)  TW.state.ui.overlayBg = preset.overlayBg;
  if(preset.overlayBg2 != null) TW.state.ui.overlayBg2 = preset.overlayBg2;
  if(preset.requiredPlan != null) TW.state.ui.requiredPlan = String(preset.requiredPlan);

  // ✅ persist preset revision + snippet-only colors
  if(preset.presetRev != null) TW.state.ui._presetRev = String(preset.presetRev);
  if(preset.pageBg != null) TW.state.ui.pageBg = String(preset.pageBg);
  if(preset.headerTextColor != null) TW.state.ui.headerTextColor = String(preset.headerTextColor);

  if(Array.isArray(preset.segments)){
    TW.state.segments = preset.segments.map(function(s, i){
      s = s || {};

      // allow either sliceImgUrl or sliceImgId
      var sliceUrl = '';
      if(s.sliceImgUrl != null) sliceUrl = String(s.sliceImgUrl || '').trim();
      if(!sliceUrl && s.sliceImgId != null) sliceUrl = _resolveSliceUrlFromId(s.sliceImgId);

      return {
        label: (s.label != null) ? String(s.label).toUpperCase() : '',
        weight: (s.weight != null && parseFloat(s.weight) > 0) ? parseFloat(s.weight) : 1,
        color: (s.color != null) ? String(s.color) : (TW.CONST.PALETTE[i % TW.CONST.PALETTE.length]),
        // ✅ keep simple "white"/"black" support
        tcolor: (String(s.tcolor || 'white').toLowerCase() === 'black') ? 'black' : 'white',
        // ✅ this is what your renderer uses for segment images
        sliceImgUrl: sliceUrl,
        textureId: String(s.textureId || '').trim(),
        textureUrl: U.safeImageSource ? U.safeImageSource(s.textureUrl || '') : String(s.textureUrl || '').trim()
      };
    }).slice(0, TW.CONST.MAX_SEGMENTS);
  }
}

TW._pagePreset = TW._pagePreset || null;

  var saveFailureWarningShown = false;
  function save(){
    try{
      // Surgical voice/sound persistence rule:
      // keep the wheel itself persistent, but never save the per-session
      // Sound/Voice button ON state into localStorage.
      var clean = U.clone ? U.clone(TW.state) : JSON.parse(JSON.stringify(TW.state || {}));
      if(clean && clean.ui){
        delete clean.ui.voiceOn;
        delete clean.ui.soundOn;
        delete clean.ui.soundEnabled;
      }
      clean._meta = clean._meta && typeof clean._meta === 'object' ? clean._meta : {};
      clean._meta.wheelSchemaVersion = WHEEL_SCHEMA_VERSION;
      clean._storageSchema = 2;
      localStorage.setItem(KEY, U.safeJSONStringify(clean));
      saveFailureWarningShown = false;
      return true;
    }catch(_){
      if(!saveFailureWarningShown){
        saveFailureWarningShown = true;
        setTimeout(function(){
          alert('This browser could not save your latest wheel changes. Browser storage may be full or unavailable. Remove large custom images or export anything important before refreshing.');
        }, 0);
      }
      return false;
    }
  }

  var saveTimer = null;
  TW.saveSoon = function(){
    if(saveTimer) clearTimeout(saveTimer);
    saveTimer = setTimeout(function(){
      saveTimer = null;
      save();
      if(TW._shareOpen) TW.openShare(true);
    }, 120);
  };

  function loadLocal(){
    var s = null, parsed = null;
    try{ s = localStorage.getItem(KEY); }catch(_){}
    parsed = s ? U.safeJSONParse(s) : null;
    if(parsed && Array.isArray(parsed.segments)) return parsed;

    // Non-destructive migration: copy a valid versioned save to the stable key.
    // The old key is deliberately retained as a recovery copy.
    try{ s = localStorage.getItem(LEGACY_KEY); }catch(_){ s = null; }
    parsed = s ? U.safeJSONParse(s) : null;
    if(parsed && Array.isArray(parsed.segments)){
      try{
        parsed._storageSchema = 2;
        localStorage.setItem(KEY, U.safeJSONStringify(parsed));
      }catch(_){ }
      return parsed;
    }
    return null;
  }

  function b64enc(str){
    try{ return btoa(unescape(encodeURIComponent(str))); }catch(_){ return ''; }
  }

  // =========================================================
  // ✅ LOCAL RETENTION UI (NO CLOUD, NO STORED IMAGE)
  // =========================================================
  function makeLocalWheelPreview(state){
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 120 120');
    svg.setAttribute('role', 'img');
    svg.setAttribute('aria-label', 'Preview of your saved wheel');
    var segs = Array.isArray(state && state.segments) ? state.segments.slice(0, 24) : [];
    if(!segs.length) return svg;
    var palette = (TW.CONST && Array.isArray(TW.CONST.PALETTE) && TW.CONST.PALETTE.length) ? TW.CONST.PALETTE : ['#5BC0EB','#FDE74C','#9BC53D','#FA7921','#E55934'];
    var cx = 60, cy = 60, radius = 54;
    function point(angle){
      return [cx + radius * Math.cos(angle), cy + radius * Math.sin(angle)];
    }
    for(var i=0;i<segs.length;i++){
      var start = -Math.PI / 2 + (i * Math.PI * 2 / segs.length);
      var end = -Math.PI / 2 + ((i + 1) * Math.PI * 2 / segs.length);
      var a = point(start), b = point(end);
      var path = document.createElementNS(ns, 'path');
      path.setAttribute('d', 'M '+cx+' '+cy+' L '+a[0]+' '+a[1]+' A '+radius+' '+radius+' 0 '+(end-start > Math.PI ? 1 : 0)+' 1 '+b[0]+' '+b[1]+' Z');
      path.setAttribute('fill', String(segs[i].color || segs[i].bg || palette[i % palette.length]));
      path.setAttribute('stroke', '#fff8ee');
      path.setAttribute('stroke-width', '1.5');
      svg.appendChild(path);
    }
    var hub = document.createElementNS(ns, 'circle');
    hub.setAttribute('cx','60'); hub.setAttribute('cy','60'); hub.setAttribute('r','8');
    hub.setAttribute('fill','#1f1f1f'); hub.setAttribute('stroke','#fff8ee'); hub.setAttribute('stroke-width','2');
    svg.appendChild(hub);
    return svg;
  }

  function openSavedWheel(item){
    if(!item || !item.state) return;
    TW.track && TW.track('returning_wheel_continue', {
      source:'returning_card',
      segment_count:Array.isArray(item.state.segments) ? item.state.segments.length : 0
    });
    try{ sessionStorage.setItem(DASHBOARD_ACTIVE_KEY, U.safeJSONStringify(item)); }catch(_){ }
    var target = String(item.pagePath || PATH);
    if(target === PATH){ window.location.reload(); }
    else{ window.location.href = target; }
  }

  function showReturningWheelCard(){
    var root = R.root || document.getElementById('toki-wheel-root');
    if(!root) return;
    try{
      if(sessionStorage.getItem(KEY_BASE + '::returnCardSeen') === '1') return;
      sessionStorage.setItem(KEY_BASE + '::returnCardSeen', '1');
    }catch(_){ }
    var list = getDashboardStore().filter(function(item){ return item && item.state && Array.isArray(item.state.segments); });
    if(!list.length) return;
    list.sort(function(a,b){ return String(b.updatedAt || '').localeCompare(String(a.updatedAt || '')); });
    var item = list[0];
    TW.track && TW.track('returning_wheel_card_view', {
      source:'local_dashboard',
      saved_wheel_count:list.length,
      segment_count:Array.isArray(item.state.segments) ? item.state.segments.length : 0
    });
    var card = document.createElement('section');
    card.className = 'tw-returnCard';
    card.setAttribute('aria-label','Continue with your saved wheel');
    var preview = document.createElement('div'); preview.className = 'tw-returnPreview';
    preview.appendChild(makeLocalWheelPreview(item.state));
    var copy = document.createElement('div'); copy.className = 'tw-returnCopy';
    var eyebrow = document.createElement('span'); eyebrow.className = 'tw-returnEyebrow'; eyebrow.textContent = 'Saved on this device';
    var title = document.createElement('strong'); title.textContent = String(item.title || 'Your saved wheel');
    var note = document.createElement('span'); note.textContent = 'Continue where you left off.';
    copy.appendChild(eyebrow); copy.appendChild(title); copy.appendChild(note);
    var actions = document.createElement('div'); actions.className = 'tw-returnActions';
    var go = document.createElement('button'); go.type='button'; go.className='tw-btn tw-returnContinue'; go.textContent='Continue';
    var close = document.createElement('button'); close.type='button'; close.className='tw-returnClose'; close.setAttribute('aria-label','Dismiss saved wheel'); close.textContent='×';
    go.addEventListener('click', function(){ openSavedWheel(item); });
    close.addEventListener('click', function(){ card.remove(); });
    actions.appendChild(go); actions.appendChild(close);
    card.appendChild(preview); card.appendChild(copy); card.appendChild(actions);
    root.insertBefore(card, root.firstChild);
  }

  function setupSaveReminder(){
    var root = R.root || document.getElementById('toki-wheel-root');
    if(!root) return;
    if(TW.access && TW.access.getUserPlan && TW.access.getUserPlan() !== 'free') return;
    try{
      if(localStorage.getItem(KEY_BASE + '::saveReminderNever') === '1') return;
      if(sessionStorage.getItem(KEY_BASE + '::saveReminderDone') === '1') return;
    }catch(_){ }
    var categories = {};
    var adjustmentCount = 0;
    var shown = false;
    var pendingTimer = null;
    function categoryFor(target, eventType){
      var id = String((target && target.id) || '').toLowerCase();
      var name = String((target && target.name) || '').toLowerCase();
      var cls = String((target && target.className) || '').toLowerCase();
      var all = id + ' ' + name + ' ' + cls;
      if(/title|subtitle|desc/.test(all)) return 'identity';
      if(/color|palette|texture|sticker|badge|image|font/.test(all)) return 'appearance';
      if(/segment|option|entry|label|weight|remove|delete|add/.test(all)) return 'entries';
      if(/sound|voice|confetti|timer|countdown|spin|winner|mode/.test(all)) return 'behavior';
      return eventType === 'change' ? 'settings' : '';
    }
    function safeToPrompt(){
      if(TW._rt && TW._rt.spinning) return false;
      if(R.modalBack && !R.modalBack.hidden) return false;
      return !document.querySelector('.tw-modal:not([hidden]), .tw-winnerModal:not([hidden])');
    }
    function reminderWasHandled(){
      try{
        return localStorage.getItem(KEY_BASE + '::saveReminderNever') === '1' ||
          sessionStorage.getItem(KEY_BASE + '::saveReminderDone') === '1';
      }catch(_){ return false; }
    }
    function queuePrompt(){
      if(shown || reminderWasHandled()) return;
      if(safeToPrompt()){
        showPrompt();
        return;
      }
      if(pendingTimer) clearTimeout(pendingTimer);
      pendingTimer = setTimeout(function(){
        pendingTimer = null;
        queuePrompt();
      }, 650);
    }
    function showPrompt(){
      if(shown || reminderWasHandled()) return;
      if(!safeToPrompt()){ queuePrompt(); return; }
      shown = true;
      var box = document.createElement('aside'); box.className='tw-saveReminder'; box.setAttribute('role','dialog'); box.setAttribute('aria-modal','false');
      box.innerHTML = '<strong>Keep this wheel for next time?</strong><span>Save it free on this device. No account needed, and the wheel stays in your browser.</span>';
      var actions = document.createElement('div'); actions.className='tw-saveReminderActions';
      var saveBtn=document.createElement('button'); saveBtn.type='button'; saveBtn.className='tw-btn'; saveBtn.textContent='Save on this device';
      var laterBtn=document.createElement('button'); laterBtn.type='button'; laterBtn.className='tw-btn tw-btnSecondary'; laterBtn.textContent='Not now';
      var neverBtn=document.createElement('button'); neverBtn.type='button'; neverBtn.className='tw-saveReminderNever'; neverBtn.textContent="Don't ask again";
      saveBtn.addEventListener('click',function(){
        TW.track && TW.track('save_reminder_choice', { choice:'save', adjustment_count:adjustmentCount });
        TW.saveToDashboard && TW.saveToDashboard(); box.remove();
      });
      laterBtn.addEventListener('click',function(){
        TW.track && TW.track('save_reminder_choice', { choice:'not_now', adjustment_count:adjustmentCount });
        try{sessionStorage.setItem(KEY_BASE+'::saveReminderDone','1');}catch(_){} box.remove();
      });
      neverBtn.addEventListener('click',function(){
        TW.track && TW.track('save_reminder_choice', { choice:'never', adjustment_count:adjustmentCount });
        try{localStorage.setItem(KEY_BASE+'::saveReminderNever','1');}catch(_){} box.remove();
      });
      actions.appendChild(saveBtn); actions.appendChild(laterBtn); actions.appendChild(neverBtn); box.appendChild(actions); root.appendChild(box);
      TW.track && TW.track('save_reminder_view', { trigger:'customization', category_count:Object.keys(categories).length });
    }
    function noteChange(event){
      if(shown) return;
      var category = categoryFor(event.target, event.type);
      if(!category) return;
      categories[category] = true;
      adjustmentCount += 1;
      if(adjustmentCount >= 3) setTimeout(queuePrompt, 900);
    }
    root.addEventListener('change', noteChange, true);
    root.addEventListener('click', function(event){
      if(event.target && event.target.closest && event.target.closest('#twDashboardSave')) return;
      noteChange(event);
    }, true);
  }

  function setupLocalRetentionUI(){
    showReturningWheelCard();
    setupSaveReminder();
  }
  function b64dec(str){
    try{ return decodeURIComponent(escape(atob(str))); }catch(_){ return ''; }
  }

  // ---------- privacy-first short link vault ----------
  // The Worker stores ONLY encrypted wheel data. The private key stays in the URL fragment (#tw_key=...),
  // which is read by the browser and is not sent to the Worker.
  var TW_LINK_VAULT_URL = String(window.TW_LINK_VAULT_URL || 'https://stwl-link-vault.johnniedropmx.workers.dev').replace(/\/+$/, '');
  var TW_LINK_TTL_SECONDS = {
    challenge: 60 * 60 * 24 * 7,
    exact:     60 * 60 * 24 * 30,
    overlay:   60 * 60 * 24 * 30,
    obs:       60 * 60 * 24 * 30,
    general:   60 * 60 * 24 * 7
  };
  var TW_MAX_SHARED_JSON_CHARS = 1250000;
  var TW_MAX_SHARED_ENCODED_CHARS = 1700000;

  function cleanSharedText(value, maxLen){
    return String(value == null ? '' : value).slice(0, maxLen);
  }

  function sanitizeSharedWheelState(state){
    if(!state || typeof state !== 'object' || Array.isArray(state)) return null;
    if(!Array.isArray(state.segments) || !state.segments.length) return null;

    var maxSegments = (TW.CONST && TW.CONST.MAX_SEGMENTS) || 1000;
    state.segments = state.segments.slice(0, maxSegments).map(function(segment, index){
      segment = (segment && typeof segment === 'object' && !Array.isArray(segment)) ? segment : {};
      segment.label = cleanSharedText(segment.label, 200);
      var weight = Number(segment.weight);
      segment.weight = (Number.isFinite(weight) && weight > 0 && weight <= 1000000) ? weight : 1;
      var fallbackColor = TW.CONST.PALETTE[index % TW.CONST.PALETTE.length];
      segment.color = /^#[0-9a-fA-F]{6}$/.test(String(segment.color || '')) ? String(segment.color) : fallbackColor;
      segment.tcolor = String(segment.tcolor || '').toLowerCase() === 'black' ? 'black' : 'white';
      segment.textureId = cleanSharedText(segment.textureId, 100);
      segment.textureUrl = cleanSharedText(U.safeImageSource ? U.safeImageSource(segment.textureUrl || '') : segment.textureUrl, 1000);
      return segment;
    });

    state.ui = (state.ui && typeof state.ui === 'object' && !Array.isArray(state.ui)) ? state.ui : {};
    state.ui.title = cleanSharedText(state.ui.title, 200);
    state.ui.desc = cleanSharedText(state.ui.desc, 2000);
    state.pins = Array.isArray(state.pins) ? state.pins.slice(0, 500) : [];
    state.teams = Array.isArray(state.teams) ? state.teams.slice(0, 100) : [];
    state.history = Array.isArray(state.history) ? state.history.slice(0, 500) : [];
    state._meta = { lastWinnerIdx:-1 };
    return state;
  }

  function getBaseUrl(){
    return window.location.origin + window.location.pathname;
  }

  function bytesToBase64Url(bytes){
    try{
      var bin = '';
      var arr = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
      for(var i=0;i<arr.length;i+=8192){
        var chunk = arr.subarray(i, i + 8192);
        bin += String.fromCharCode.apply(null, chunk);
      }
      return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
    }catch(_){ return ''; }
  }

  function base64UrlToBytes(str){
    str = String(str || '').replace(/-/g, '+').replace(/_/g, '/');
    while(str.length % 4) str += '=';
    var bin = atob(str);
    var out = new Uint8Array(bin.length);
    for(var i=0;i<bin.length;i++) out[i] = bin.charCodeAt(i);
    return out;
  }

  function vaultAvailable(){
    return !!(window.crypto && crypto.subtle && window.TextEncoder && window.TextDecoder && window.fetch);
  }

  function getFragmentParams(){
    try{
      var h = String(window.location.hash || '').replace(/^#/, '');
      return new URLSearchParams(h);
    }catch(_){ return new URLSearchParams(''); }
  }

  function randomBase64Url(byteLen){
    var arr = new Uint8Array(byteLen);
    crypto.getRandomValues(arr);
    return bytesToBase64Url(arr);
  }

  function importAesKey(keyText, usages){
    return crypto.subtle.importKey('raw', base64UrlToBytes(keyText), { name:'AES-GCM' }, false, usages);
  }

  function encryptTextForVault(plainText){
    if(!vaultAvailable()) return Promise.reject(new Error('vault_crypto_unavailable'));
    var keyText = randomBase64Url(32);
    var iv = new Uint8Array(12);
    crypto.getRandomValues(iv);
    return importAesKey(keyText, ['encrypt']).then(function(key){
      return crypto.subtle.encrypt({ name:'AES-GCM', iv:iv }, key, new TextEncoder().encode(String(plainText || '')));
    }).then(function(cipher){
      return {
        keyText:keyText,
        encryptedData: bytesToBase64Url(new TextEncoder().encode(JSON.stringify({
          v:1,
          alg:'AES-GCM',
          iv:bytesToBase64Url(iv),
          data:bytesToBase64Url(cipher)
        })))
      };
    });
  }

  function decryptTextFromVault(encryptedData, keyText){
    if(!vaultAvailable()) return Promise.reject(new Error('vault_crypto_unavailable'));
    if(typeof encryptedData !== 'string' || !encryptedData.length || encryptedData.length > TW_MAX_SHARED_ENCODED_CHARS){
      return Promise.reject(new Error('vault_payload_too_large'));
    }
    if(typeof keyText !== 'string' || keyText.length < 40 || keyText.length > 60){
      return Promise.reject(new Error('vault_key_invalid'));
    }
    var packed = JSON.parse(new TextDecoder().decode(base64UrlToBytes(encryptedData)));
    if(!packed || packed.v !== 1 || packed.alg !== 'AES-GCM' || typeof packed.iv !== 'string' || typeof packed.data !== 'string'){
      return Promise.reject(new Error('vault_payload_invalid'));
    }
    var iv = base64UrlToBytes(packed.iv);
    var cipher = base64UrlToBytes(packed.data);
    if(iv.length !== 12 || !cipher.length || cipher.length > TW_MAX_SHARED_JSON_CHARS + 32){
      return Promise.reject(new Error('vault_payload_invalid'));
    }
    return importAesKey(keyText, ['decrypt']).then(function(key){
      return crypto.subtle.decrypt({ name:'AES-GCM', iv:iv }, key, cipher);
    }).then(function(plainBuf){
      return new TextDecoder().decode(plainBuf);
    });
  }

  function vaultSave(encryptedData, linkType, ttlSeconds){
    return fetch(TW_LINK_VAULT_URL + '/save', {
      method:'POST',
      headers:{ 'content-type':'application/json' },
      body: JSON.stringify({
        linkType: linkType || 'general',
        encryptedData: encryptedData,
        ttlSeconds: ttlSeconds || TW_LINK_TTL_SECONDS.general
      })
    }).then(function(r){ return r.json(); }).then(function(res){
      if(!res || !res.ok || !res.id) throw new Error((res && res.error) || 'vault_save_failed');
      return res;
    });
  }

  function vaultLoad(id){
    return fetch(TW_LINK_VAULT_URL + '/load/' + encodeURIComponent(id), { method:'GET' })
      .then(function(r){ return r.json(); })
      .then(function(res){
        if(!res || !res.ok || !res.encryptedData) throw new Error((res && res.error) || 'vault_load_failed');
        return res;
      });
  }

  function buildVaultFragment(keyText, extras){
    var hp = new URLSearchParams();
    // Short key name keeps shared links cleaner. Loader still supports #tw_key= for old links.
    hp.set('k', keyText);
    extras = extras || {};
    Object.keys(extras).forEach(function(k){
      var v = extras[k];
      if(v != null && String(v) !== '') hp.set(k, String(v));
    });
    return '#' + hp.toString();
  }

  function createVaultLink(linkType, extras){
    linkType = linkType || 'general';
    extras = extras || {};

    // SURGICAL 2026-06-06: overlay share links must reopen as overlay links,
    // even when the current editor is not already in overlay mode.
    var stateForLink = TW.state;
    if(linkType === 'overlay'){
      try{
        stateForLink = U.safeJSONParse(U.safeJSONStringify(TW.state)) || TW.state;
        stateForLink.ui = stateForLink.ui || {};
        stateForLink.ui.overlay = true;
        stateForLink.ui.streamMode = false;
      }catch(_){
        stateForLink = TW.state;
      }
    }

    var payload = {
      v:1,
      linkType:linkType,
      wheelState: stateForLink
    };
    return encryptTextForVault(U.safeJSONStringify(payload))
      .then(function(enc){
        return vaultSave(enc.encryptedData, linkType, TW_LINK_TTL_SECONDS[linkType] || TW_LINK_TTL_SECONDS.general)
          .then(function(saved){
            var qs = new URLSearchParams();
            // Short public URL params. Loader still supports old names for backwards compatibility.
            qs.set('l', saved.id);
            qs.set('m', linkType);
            if(linkType === 'overlay') qs.set('tw_overlay', '1');
            return getBaseUrl() + '?' + qs.toString() + buildVaultFragment(enc.keyText, extras);
          });
      });
  }

  function applyVaultLinkIfAny(){
    var qs;
    try{ qs = new URLSearchParams(window.location.search || ''); }catch(_){ qs = new URLSearchParams(''); }
    var id = qs.get('l') || qs.get('tw_link') || qs.get('twl') || '';
    if(!id) return Promise.resolve(false);

    var hp = getFragmentParams();
    var keyText = hp.get('k') || hp.get('tw_key') || hp.get('key') || '';
    if(!keyText) return Promise.resolve(false);

    return vaultLoad(id).then(function(record){
      return decryptTextFromVault(record.encryptedData, keyText);
    }).then(function(plain){
      if(typeof plain !== 'string' || plain.length > TW_MAX_SHARED_JSON_CHARS) return false;
      var payload = U.safeJSONParse(plain);
      if(!payload || !payload.wheelState || !Array.isArray(payload.wheelState.segments)) return false;
      var safeState = sanitizeSharedWheelState(payload.wheelState);
      if(!safeState) return false;
      TW.state = safeState;
      TW.ensureState();
      TW._vaultLink = { id:id, mode: qs.get('m') || qs.get('tw_mode') || payload.linkType || 'general' };
      return true;
    }).catch(function(err){
      try{ console.warn('[STWL link vault] Could not load encrypted wheel link:', err); }catch(_){ }
      return false;
    });
  }

  function encodeQ(v){
    return encodeURIComponent(String(v == null ? '' : v));
  }

  function decodeQ(v){
    try{ return decodeURIComponent(String(v == null ? '' : v).replace(/\+/g, ' ')); }catch(_){ return String(v == null ? '' : v); }
  }

  function getChallengeMetaFromUrl(){
    var out = { active:false, from:'', result:'', message:'', cardType:'shared_spin', spinsAllowed:3, code:'' };
    try{
      var qs = new URLSearchParams(window.location.search || '');
      var hp = getFragmentParams();
      var mode = String(qs.get('m') || qs.get('tw_mode') || '').toLowerCase();
      var active = qs.get('tw_challenge') === '1' || qs.get('challenge') === '1' || mode === 'challenge';
      if(!active) return out;
      out.active = true;
      out.from = decodeQ(hp.get('tw_from') || hp.get('from') || qs.get('tw_from') || qs.get('from') || '');
      out.result = decodeQ(hp.get('tw_result') || hp.get('result') || qs.get('tw_result') || qs.get('result') || '');
      out.message = decodeQ(hp.get('tw_msg') || hp.get('msg') || qs.get('tw_msg') || qs.get('msg') || '');
      out.cardType = String(hp.get('tw_card') || hp.get('card') || qs.get('tw_card') || qs.get('card') || 'shared_spin').toLowerCase();
      var n = parseInt(hp.get('tw_spins') || hp.get('spins') || qs.get('tw_spins') || qs.get('spins') || '3', 10);
      out.spinsAllowed = (n > 0 && n <= 10) ? n : 3;
      out.code = qs.get('l') || qs.get('tw_link') || qs.get('twl') || shortChallengeCodeFromUrl(window.location.href || '');
      return out;
    }catch(_){
      return out;
    }
  }

  function buildChallengeUrlAsync(opts){
    opts = opts || {};
    var fragmentMeta = {
      tw_from: opts.from || '',
      tw_result: opts.result || '',
      tw_msg: opts.message || '',
      tw_spins: String(opts.spinsAllowed || 3),
      tw_card: opts.cardType || 'shared_spin'
    };
    return createVaultLink('challenge', fragmentMeta);
  }

  function showEncryptedLinkFailure(){
    alert('The encrypted share link could not be created, so no wheel-data link was copied. Please check your connection and try again.');
  }

  var TW_CHALLENGE_SHARE_CARD_RECT_URL = 'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/challengesocialcardrectangle_8b15897c-369a-477d-9a88-c7976fe0e5b2.png?v=1776870735';
  var TW_CHALLENGE_CARD_OPTIONS = [
    {
      id:'dare_drop',
      label:'Dare Drop',
      url:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/youvebeendaredcard.png?v=1777317224',
      noteLabel:'Dare note',
      placeholder:'Spin if you dare. Professor Vortex is watching.',
      button:'Send dare card'
    },
    {
      id:'challenge_spark',
      label:'Challenge Spark',
      url:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/youvebeenchallengedcard.png?v=1777317224',
      noteLabel:'Challenge note',
      placeholder:'I challenge you to spin this wheel.',
      button:'Send challenge card'
    },
    {
      id:'chaos_pick',
      label:'Chaos Pick',
      url:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/youvebeenchosencard.png?v=1777317224',
      noteLabel:'Chosen note',
      placeholder:'The wheel picked you. No pressure. Probably.',
      button:'Send chosen card'
    },
    {
      id:'shared_spin',
      label:'Shared Spin',
      url:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/youvebeensentaspincard.png?v=1777317224',
      noteLabel:'Spin note',
      placeholder:'I sent this spin your way.',
      button:'Send shared spin'
    },
    {
      id:'spin_waiting',
      label:'Spin Waiting',
      url:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/youvegotaspinwaitingcard.png?v=1777317224',
      noteLabel:'Waiting note',
      placeholder:'This one has your name on it.',
      button:'Send waiting spin'
    }
  ];

  function getChallengeCardOption(cardType){
    cardType = String(cardType || '').toLowerCase();
    for(var i=0;i<TW_CHALLENGE_CARD_OPTIONS.length;i++){
      if(TW_CHALLENGE_CARD_OPTIONS[i].id === cardType) return TW_CHALLENGE_CARD_OPTIONS[i];
    }
    return TW_CHALLENGE_CARD_OPTIONS[0];
  }

  function getChallengeCardUrl(cardType){
    return getChallengeCardOption(cardType).url;
  }

  function challengeStorageKey(){
    try{
      var code = (TW.challenge && TW.challenge.code) || shortChallengeCodeFromUrl(window.location.href || '');
      return 'tw_challenge_spins_' + String(code || 'local');
    }catch(_){ return 'tw_challenge_spins_local'; }
  }

  TW.challengeSpinsUsed = function(){
    try{ return Math.max(0, parseInt(sessionStorage.getItem(challengeStorageKey()) || '0', 10) || 0); }catch(_){ return 0; }
  };

  TW.challengeSpinsAllowed = function(){
    var ch = TW.challenge || {};
    return ch.active ? (parseInt(ch.spinsAllowed || 3, 10) || 3) : 0;
  };

  TW.challengeSpinsRemaining = function(){
    return Math.max(0, TW.challengeSpinsAllowed() - TW.challengeSpinsUsed());
  };

  TW.challengeCanPreviewSpin = function(){
    var ch = TW.challenge || {};
    if(!ch.active) return false;
    return TW.challengeSpinsRemaining() > 0;
  };

  TW.challengeConsumePreviewSpin = function(){
    if(!TW.challengeCanPreviewSpin()) return 0;
    var next = TW.challengeSpinsUsed() + 1;
    try{ sessionStorage.setItem(challengeStorageKey(), String(next)); }catch(_){ }
    try{ TW.renderAll && TW.renderAll(); }catch(_){ }
    try{ TW.refreshAccessUI && TW.refreshAccessUI(); }catch(_){ }
    return TW.challengeSpinsRemaining();
  };

  TW.openChallengeLimitModal = function(){
    var ch = TW.challenge || {};
    if(TW.openChallengeComposer){
      TW.openChallengeComposer({
        result: ch.result || '',
        wheelTitle: (TW.state && TW.state.ui && TW.state.ui.title) ? TW.state.ui.title : 'WHEEL',
        from: '',
        message: ch.message || 'I spun it. Your turn.',
        cardType: ch.cardType || 'shared_spin'
      });
      return;
    }
    TW.openPlanUpsell && TW.openPlanUpsell((TW.access && TW.access.getWheelPlan && TW.access.getWheelPlan()) || 'vortex_pro', {
      title:'Challenge spins complete',
      message:'You used your 3 challenge spins. Send the challenge on or unlock the wheel for full access.'
    });
  };

  function shortChallengeCodeFromUrl(url){
    var str = String(url || '');
    var h = 2166136261 >>> 0;
    for(var i=0;i<str.length;i++){
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return ('000000' + (h >>> 0).toString(36).toUpperCase()).slice(-6);
  }

  function buildChallengeHeadline(opts){
    opts = opts || {};
    return opts.from ? (String(opts.from) + ' challenged you') : 'You were challenged';
  }

  function buildChallengeResultLine(opts){
    opts = opts || {};
    return opts.result ? ('Result to beat: ' + String(opts.result).toUpperCase()) : 'Spin and see what you get.';
  }

  function buildChallengeShareText(opts){
    opts = opts || {};
    var lines = [];
    lines.push(buildChallengeHeadline(opts) + '.');
    if(opts.result) lines.push('Result to beat: ' + String(opts.result).toUpperCase() + '.');
    if(opts.message) lines.push(String(opts.message));
    lines.push('Every public wheel includes unlimited challenge spins.');
    return lines.join(' ');
  }

  function buildChallengeDareText(opts){
    opts = opts || {};
    var lines = [];
    lines.push(buildChallengeHeadline(opts));
    if(opts.result) lines.push('Result to beat: ' + String(opts.result).toUpperCase());
    if(opts.message) lines.push(String(opts.message));
    lines.push('Every public wheel includes unlimited challenge spins.');
    return lines.join('\n');
  }

  function buildChallengeShareTitle(opts){
    opts = opts || {};
    return opts.wheelTitle || 'Spin The Wheel Challenge';
  }

  function loadImageAsObject(url){
    return new Promise(function(resolve, reject){
      try{
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function(){ resolve(img); };
        img.onerror = reject;
        img.src = url;
      }catch(err){ reject(err); }
    });
  }

  function wrapCanvasText(ctx, text, x, y, maxWidth, lineHeight, maxLines){
    text = String(text || '').trim();
    if(!text) return y;
    var words = text.split(/\s+/);
    var line = '';
    var lines = [];
    for(var i=0;i<words.length;i++){
      var test = line ? (line + ' ' + words[i]) : words[i];
      if(ctx.measureText(test).width > maxWidth && line){
        lines.push(line);
        line = words[i];
      }else{
        line = test;
      }
    }
    if(line) lines.push(line);
    if(maxLines && lines.length > maxLines){
      lines = lines.slice(0, maxLines);
      var last = lines[lines.length - 1];
      while(last.length > 2 && ctx.measureText(last + '…').width > maxWidth){
        last = last.slice(0, -1);
      }
      lines[lines.length - 1] = last + '…';
    }
    for(var j=0;j<lines.length;j++) ctx.fillText(lines[j], x, y + j * lineHeight);
    return y + Math.max(0, lines.length - 1) * lineHeight;
  }

  function generateChallengeCardFile(opts){
    opts = opts || {};
    return loadImageAsObject(opts.cardUrl || getChallengeCardUrl(opts.cardType)).then(function(img){
      var canvas = document.createElement('canvas');
      canvas.width = img.naturalWidth || 1080;
      canvas.height = img.naturalHeight || 1080;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      return new Promise(function(resolve){
        canvas.toBlob(function(blob){
          if(!blob || !window.File){ resolve(null); return; }
          resolve(new File([blob], 'spinthewheellab-challenge-card.png', { type:'image/png' }));
        }, 'image/png');
      });
    }).catch(function(){ return null; });
  }

  function downloadFile(file){
    try{
      if(!file) return;
      var url = URL.createObjectURL(file);
      var a = document.createElement('a');
      a.href = url;
      a.download = file.name || 'download.png';
      document.body.appendChild(a);
      a.click();
      setTimeout(function(){ try{ URL.revokeObjectURL(url); }catch(_){} try{ document.body.removeChild(a); }catch(_){} }, 300);
    }catch(_){ }
  }

  function nativeChallengeShare(opts){
    opts = opts || {};
    var payload = {
      title: buildChallengeShareTitle(opts),
      text: buildChallengeShareText(opts),
      url: opts.url || ''
    };
    try{
      if(!navigator.share) return Promise.reject(new Error('share_unavailable'));
      return generateChallengeCardFile(opts).then(function(file){
        if(file && navigator.canShare){
          try{
            if(navigator.canShare({ files:[file] })) return navigator.share({
              title: payload.title,
              text: payload.text,
              url: payload.url,
              files:[file]
            });
          }catch(_){ }
        }
        return navigator.share(payload);
      });
    }catch(_){
      return Promise.reject(_);
    }
  }


  function applyHashIfAny(){
    var encoded = '';
    try{
      var qs = new URLSearchParams(window.location.search || '');
      encoded = qs.get('tw_data') || '';
    }catch(_){ encoded = ''; }

    if(!encoded){
      var h = window.location.hash || '';
      var m = h.match(/#tw=([^&]+)/);
      if(!m) return false;
      encoded = m[1] || '';
    }

    if(typeof encoded !== 'string' || encoded.length > TW_MAX_SHARED_ENCODED_CHARS) return false;
    var decoded = b64dec(encoded || '');
    if(!decoded || decoded.length > TW_MAX_SHARED_JSON_CHARS) return false;
    var obj = U.safeJSONParse(decoded);
    if(!obj) return false;
    if(!Array.isArray(obj.segments)) return false;

    var safeState = sanitizeSharedWheelState(obj);
    if(!safeState) return false;
    TW.state = safeState;
    TW.ensureState();
    return true;
  }

  // ---------- overlay ----------
  function lockPageScroll(on){
    try{
      if(on){
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.body.classList.add('twOverlayBody');
      }else{
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.body.classList.remove('twOverlayBody');
      }
    }catch(_){}
  }

  function getOverlayStageCss(){
    var ui = (TW.state && TW.state.ui) ? TW.state.ui : {};
    var p  = TW._pagePreset || {};

    if(ui.streamMode) return 'transparent';

    var c1 = (ui.overlayBg  != null ? ui.overlayBg  : (p.overlayBg  != null ? p.overlayBg  : null));
    var c2 = (ui.overlayBg2 != null ? ui.overlayBg2 : (p.overlayBg2 != null ? p.overlayBg2 : null));

    c1 = c1 ? String(c1) : '#0b0c10';
    c2 = c2 ? String(c2) : '';

    if(c2){
      return 'linear-gradient(180deg, ' + c1 + ' 0%, ' + c2 + ' 100%)';
    }
    return c1;
  }

  function syncOverlayCssVars(){
    try{
      var css = getOverlayStageCss();
      document.documentElement.style.setProperty('--tw-ovBack', css);
    }catch(_){}
  }

  function applyOverlayGlass(on){
    if(!R.overlayBack) return;
    var b = R.overlayBack;

    b.style.position = 'fixed';
    b.style.left = '0';
    b.style.top = '0';
    b.style.right = '0';
    b.style.bottom = '0';

    if(on){
      syncOverlayCssVars();
      b.style.background = getOverlayStageCss();
      b.style.backdropFilter = 'none';
      b.style.webkitBackdropFilter = 'none';
      b.style.transform = 'translateZ(0)';
      // ✅ extra iOS parity: prevent body/html background “peeking”
      try{ document.body.style.background = getOverlayStageCss(); }catch(_){}
      try{ document.documentElement.style.background = getOverlayStageCss(); }catch(_){}
    }else{
      b.style.background = '';
      b.style.backdropFilter = '';
      b.style.webkitBackdropFilter = '';
      b.style.transform = '';
      try{ document.body.style.background = ''; }catch(_){}
      try{ document.documentElement.style.background = ''; }catch(_){}
    }
  }

  function fixOverlayLayout(){
    if(!R.wrap) return;
    if(!TW.state.ui.overlay) return;

    try{
      R.wrap.style.left = '0';
      R.wrap.style.right = '0';
      R.wrap.style.marginLeft = 'auto';
      R.wrap.style.marginRight = 'auto';

      var panels = R.wrap.querySelectorAll('.tw-panel, .tw-panels, .tw-col, .tw-col2, .tw-side, .tw-main');
      for(var i=0;i<panels.length;i++){
        var el = panels[i];
        if(!el || !el.style) continue;
        el.style.marginLeft = 'auto';
        el.style.marginRight = 'auto';
        if(el.style.transform && String(el.style.transform).indexOf('translateX') !== -1){
          el.style.transform = 'none';
        }
        // ✅ iOS: ensure overlay main is rounded + clipped
        if(el.classList && el.classList.contains('tw-main')){
          el.style.borderRadius = '0';
          el.style.overflow = 'visible';
          el.style.webkitOverflowScrolling = 'auto';
          el.style.maxHeight = 'none';
        }
      }

      document.documentElement.style.overflowX = 'hidden';
      document.body.style.overflowX = 'hidden';
    }catch(_){}
  }

  function overlayEnforceOnlyTopWheelPins(){
    try{
      if(!R.wrap) return;

      var old = R.wrap.querySelectorAll('.tw-ovHidePanel');
      for(var i=0;i<old.length;i++){
        old[i].classList.remove('tw-ovHidePanel');
      }

      if(!TW.state.ui.overlay) return;

      var wheelWrap = R.wheelWrap || (R.wrap.querySelector && R.wrap.querySelector('.tw-wheelWrap'));
      var pinList   = R.pinsList || R.pinList || (R.wrap.querySelector && (R.wrap.querySelector('#twPinsList') || R.wrap.querySelector('#twPins') || R.wrap.querySelector('.tw-pins') || R.wrap.querySelector('[data-tw-pins]')));

      var wheelCard = null;
      var pinsCard  = R.side || (pinList && pinList.closest ? pinList.closest('.tw-side, .tw-vaultRebuilt, .tw-card') : null);

      var cards = R.wrap.querySelectorAll('.tw-card');
      for(var c=0;c<cards.length;c++){
        var card = cards[c];
        if(!wheelCard && wheelWrap && card.contains(wheelWrap)) wheelCard = card;
        if(!pinsCard && pinList && card.contains(pinList)) pinsCard = card;
      }

      var header = R.wrap.querySelector('.tw-header');

      var extras = R.wrap.querySelectorAll('.tw-accord, details, .tw-panel, .tw-panels');
      for(var e=0;e<extras.length;e++){
        extras[e].classList.add('tw-ovHidePanel');
      }

      for(var k=0;k<cards.length;k++){
        var card2 = cards[k];
        if(card2 === wheelCard) continue;
        if(card2 === pinsCard) continue;
        card2.classList.add('tw-ovHidePanel');
      }

      var blocks = R.wrap.querySelectorAll('.tw-wrap > *');
      for(var b=0;b<blocks.length;b++){
        var el = blocks[b];
        if(!el) continue;
        if(header && el === header) continue;
        if(el.classList && el.classList.contains('tw-overlayBack')) continue;
        if(el.classList && el.classList.contains('tw-presentationDock')) continue;
        if(el.classList && el.classList.contains('tw-presentationExit')) continue;

        if(el.classList && el.classList.contains('tw-main')) continue;

        if(wheelWrap && el.contains(wheelWrap)) continue;
        if(pinList && el.contains(pinList)) continue;

        if(el.classList) el.classList.add('tw-ovHidePanel');
      }

      if(pinsCard){
        pinsCard.classList.remove('tw-ovHidePanel');
        pinsCard.style.display = '';
        pinsCard.style.visibility = 'visible';
        pinsCard.style.opacity = '1';
      }

      var presentationDock = R.wrap.querySelector('.tw-presentationDock');
      if(presentationDock) presentationDock.classList.remove('tw-ovHidePanel');
      var presentationExit = R.wrap.querySelector('.tw-presentationExit');
      if(presentationExit) presentationExit.classList.remove('tw-ovHidePanel');

    }catch(_){}
  }

  var _optWasHidden = null;
  var _cusWasHidden = null;
  var _vaultHome = null;
  var _vaultNext = null;

  function mountVaultForOverlay(){
    try{
      if(!R.side || !R.main) return;
      if(!_vaultHome){
        _vaultHome = R.side.parentNode;
        _vaultNext = R.side.nextSibling;
      }
      if(R.side.parentNode !== R.main) R.main.appendChild(R.side);
      R.side.classList.remove('tw-ovHidePanel');
      R.side.removeAttribute('hidden');
      R.side.style.setProperty('display','block','important');
      R.side.style.setProperty('visibility','visible','important');
      R.side.style.setProperty('opacity','1','important');
      R.side.style.removeProperty('order');
      if(R.pinsTitle){
        R.pinsTitle.removeAttribute('hidden');
        R.pinsTitle.style.setProperty('display','flex','important');
      }
      if(R.pinsList){
        R.pinsList.removeAttribute('hidden');
        R.pinsList.style.removeProperty('display');
        R.pinsList.style.setProperty('visibility','visible','important');
      }
    }catch(_){ }
  }
  TW.ensureOverlayVault = mountVaultForOverlay;

  function restoreVaultAfterOverlay(){
    try{
      if(R.side){
        ['display','visibility','opacity','order'].forEach(function(p){ R.side.style.removeProperty(p); });
      }
      if(R.pinsTitle) R.pinsTitle.style.removeProperty('display');
      if(R.pinsList){ R.pinsList.style.removeProperty('display'); R.pinsList.style.removeProperty('visibility'); }
      if(_vaultHome && R.side && R.side.parentNode !== _vaultHome){
        if(_vaultNext && _vaultNext.parentNode === _vaultHome) _vaultHome.insertBefore(R.side,_vaultNext);
        else _vaultHome.appendChild(R.side);
      }
    }catch(_){ }
  }

  function ensurePresentationExitButton(){
    if(!R.wrap) return null;
    var btn = R.wrap.querySelector(".tw-presentationExit");
    if(!btn){
      btn = U.el("button", {
        class:"tw-presentationExit",
        type:"button",
        "aria-label":"Exit presentation mode"
      }, ["×"]);
      btn.onclick = function(ev){
        try{ ev.preventDefault(); ev.stopPropagation(); }catch(_){}
        applyPresentationMode("normal");
      };
      R.wrap.appendChild(btn);
    }
    try{ btn.textContent = "×"; btn.setAttribute("aria-label", "Exit presentation mode"); btn.setAttribute("title", "Exit"); }catch(_){}
    return btn;
  }

  function removePresentationExitButton(){
    try{
      if(!R.wrap) return;
      var btn = R.wrap.querySelector(".tw-presentationExit");
      if(btn && btn.parentNode) btn.parentNode.removeChild(btn);
    }catch(_){}
  }

  function isHomepagePublicWheelPreset(){
    try{
      var p = TW._pagePreset || window.TOKI_WHEEL_PRESET || {};
      var title = String(p.title || '').toLowerCase();
      var plan = String(p.requiredPlan || window.TOKI_WHEEL_REQUIRED_PLAN || '').toLowerCase();
      return (plan === 'free' && title.indexOf('spin the wheel lab') !== -1);
    }catch(_){ return false; }
  }

  function overlayAutoOpenAllowed(){
    // Surgical homepage guard: overlay can still be opened manually, but the
    // homepage/free wheel should never auto-open from a stale URL flag.
    try{
      if(window.TOKI_DISABLE_AUTO_OVERLAY_ON_LOAD === true) return false;
      var p = TW._pagePreset || window.TOKI_WHEEL_PRESET || {};
      if(p && (p.disableOverlayAutoOpen === true || p.noAutoOverlay === true)) return false;
      if(isHomepagePublicWheelPreset()) return false;
    }catch(_){ }
    return true;
  }

  function clearOverlayUrlFlags(){
    try{
      if(!window.history || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      var qs = url.searchParams;
      var changed = false;
      ['tw_overlay','overlay','tw_stream','stream'].forEach(function(k){
        if(qs.has(k)){ qs.delete(k); changed = true; }
      });
      var m = String(qs.get('m') || qs.get('tw_mode') || '').toLowerCase();
      if(m === 'overlay' || m === 'stream' || m === 'obs'){
        qs.delete('m');
        qs.delete('tw_mode');
        changed = true;
      }
      if(changed) window.history.replaceState(null, '', url.toString());
    }catch(_){ }
  }

  function syncPresentationUrlFlag(mode){
    // Streamer mode removed. Only normal overlay links remain supported.
    try{
      if(!window.history || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      var qs = url.searchParams;

      qs.delete('tw_stream');
      qs.delete('stream');
      qs.delete('tw_overlay');
      qs.delete('overlay');

      if(mode === 'overlay'){
        qs.set('tw_overlay', '1');
        if(qs.get('m')) qs.set('m', 'overlay');
      }else{
        if(qs.get('m') === 'obs' || qs.get('m') === 'stream' || qs.get('m') === 'overlay') qs.delete('m');
      }

      window.history.replaceState(null, '', url.toString());
    }catch(_){ }
  }

  function applyPresentationMode(mode){
    var wrap = R.wrap;
    if(!wrap) return;

    mode = (mode === 'overlay') ? 'overlay' : 'normal';
    var on = (mode !== 'normal');
    var isStream = false;

    syncPresentationUrlFlag(mode);

    if(on && TW._fidget && TW._fidget.on && TW.exitFidgetMode){
      TW.exitFidgetMode('overlay');
    }

    TW.state.ui.overlay = !!on;
    TW.state.ui.streamMode = !!isStream;

    if(on){
      wrap.classList.add('tw-overlay');
      wrap.classList.add('tw-inOverlay');
      wrap.classList.toggle('tw-streamMode', isStream);
      try{ document.body.classList.toggle('twStreamBody', isStream); }catch(_){}
      try{ document.documentElement.classList.toggle('twStreamHtml', isStream); }catch(_){}
      try{ document.body.classList.toggle('twOverlayBody', !isStream); }catch(_){}
      try{ document.documentElement.classList.toggle('twOverlayHtml', !isStream); }catch(_){}
      if(isStream){
        try{ document.body.style.background = 'transparent'; }catch(_){}
        try{ document.documentElement.style.background = 'transparent'; }catch(_){}
      }
      if(R.overlayBack) R.overlayBack.hidden = !!isStream;
      ensurePresentationExitButton();
      ensurePresentationStageControls();
      lockPageScroll(true);

      if(_optWasHidden == null) _optWasHidden = !!(R.optDetails && R.optDetails.hidden);
      if(_cusWasHidden == null) _cusWasHidden = !!(R.cusDetails && R.cusDetails.hidden);

      if(R.optDetails) R.optDetails.hidden = true;
      if(R.cusDetails) R.cusDetails.hidden = true;

      applyOverlayGlass(!isStream);

      fixOverlayLayout();
      requestAnimationFrame(fixOverlayLayout);
      setTimeout(fixOverlayLayout, 120);

      overlayEnforceOnlyTopWheelPins();
      mountVaultForOverlay();
      requestAnimationFrame(overlayEnforceOnlyTopWheelPins);
      requestAnimationFrame(mountVaultForOverlay);
      setTimeout(function(){ overlayEnforceOnlyTopWheelPins(); mountVaultForOverlay(); }, 120);

      if(R.overlayBack){
        R.overlayBack.onclick = isStream ? null : function(){ TW.toggleOverlay(); };
      }

      if(!TW._overlayFixBound){
        TW._overlayFixBound = true;
        window.addEventListener('resize', function(){
          if(TW.state && TW.state.ui && TW.state.ui.overlay){
            fixOverlayLayout();
            overlayEnforceOnlyTopWheelPins();
            applyPresentationArrangement();
            var compact = false;
            try{ compact = !!(window.matchMedia && window.matchMedia('(max-width:1024px)').matches); }catch(_){ }
            applyPresentationWheelSize(compact ? 100 : presentationSizePct, false);
          }
        }, { passive:true });
      }
    }else{
      wrap.classList.remove('tw-overlay');
      wrap.classList.remove('tw-inOverlay');
      wrap.classList.remove('tw-streamMode');
      try{ document.body.classList.remove('twStreamBody'); }catch(_){}
      try{ document.documentElement.classList.remove('twStreamHtml'); }catch(_){}
      try{ document.body.classList.remove('twOverlayBody'); }catch(_){}
      try{ document.documentElement.classList.remove('twOverlayHtml'); }catch(_){}
      if(R.overlayBack){
        R.overlayBack.hidden = true;
        R.overlayBack.onclick = null;
      }
      removePresentationExitButton();
      removePresentationStageControls();
      lockPageScroll(false);

      applyOverlayGlass(false);

      overlayEnforceOnlyTopWheelPins();
      restoreVaultAfterOverlay();

      if(R.optDetails){
        R.optDetails.hidden = (_optWasHidden == null) ? false : _optWasHidden;
      }
      if(R.cusDetails){
        R.cusDetails.hidden = (_cusWasHidden == null) ? false : _cusWasHidden;
      }
      _optWasHidden = null;
      _cusWasHidden = null;
    }

    if(!TW._showInPlaceSwitch) TW.saveSoon();
  }

  TW.applyOverlay = function(on){
    applyPresentationMode(on ? 'overlay' : 'normal');
  };

  TW.toggleOverlay = function(){
    applyPresentationMode((TW.state && TW.state.ui && TW.state.ui.overlay) ? 'normal' : 'overlay');
  };

  // Streamer mode removed. These no-ops prevent older cached buttons/links from reactivating it.
  TW.applyStreamMode = function(){
    applyPresentationMode('normal');
  };

  TW.toggleStreamMode = function(){
    applyPresentationMode('normal');
  };

  function resetSharedModalAppearance(back, modal){
    if(!back || !modal) return;
    /* The winner modal installs viewport resize/scroll positioning callbacks.
       This shared container may immediately become the Spin Invite composer;
       leave no winner-position function alive to reshape it on keyboard open. */
    TW._positionWinnerModal = null;
    ['isSpinBizPromo','hasVortexContent','tw-winnerModalActive','tw-bizPopupStyle-classic','tw-bizPopupStyle-spotlight','tw-bizPopupStyle-prize','tw-bizPopupStyle-fullscreen','tw-bizPopupEntrance-pop','tw-bizPopupEntrance-zoom','tw-bizPopupEntrance-drop','tw-bizPopupEntrance-fade'].forEach(function(name){
      modal.classList.remove(name);
    });
    ['left','top','right','transform','max-height','animation'].forEach(function(prop){ modal.style.removeProperty(prop); });
    back.classList.remove('tw-bizSpotlightBack');
    ['background','background-color','background-image','backdrop-filter','-webkit-backdrop-filter'].forEach(function(prop){ back.style.removeProperty(prop); });
    var shade = document.querySelector('.tw-bizSpotlightShade');
    if(shade && shade.parentNode) shade.parentNode.removeChild(shade);
  }


  // ---------- challenge composer ----------
  TW.openChallengeComposer = function(opts){
    opts = opts || {};
    var back = R.modalBack, modal = R.modal;
    if(!back || !modal) return;

    /* Winner-popup themes must never leak into general dialogs. */
    resetSharedModalAppearance(back, modal);
    modal.classList.add('tw-challengeComposerMobile');
    back.hidden = false;
    modal.hidden = false;
    modal.innerHTML = '';

    var close = function(reason){
      back.hidden = true;
      modal.hidden = true;
      modal.innerHTML = '';
      modal.classList.remove('tw-challengeComposerMobile');
      if(reason === 'x' || reason === 'backdrop'){
        try{ if(typeof TW.playReturnSound === 'function') TW.playReturnSound(); }catch(_){ }
        setTimeout(function(){
          try{ TW.recenterWheel && TW.recenterWheel(true); }catch(_){ }
        }, 40);
      }
    };
    back.onclick = function(){ close('backdrop'); };

    var top = U.el('div', { class:'tw-modalTop' }, [
      U.el('h3', { class:'tw-modalTitle', text:'Send a spin invite' }),
      (function(){
        var x = U.el('button', { class:'tw-x', type:'button', 'aria-label':'Close' }, ['×']);
        x.onclick = function(){ close('x'); };
        return x;
      })()
    ]);

    var typeSelect = U.el('select', { class:'tw-select tw-challengeTypeSelect', 'aria-label':'Spin invite style' });
    TW_CHALLENGE_CARD_OPTIONS.forEach(function(o){
      typeSelect.appendChild(U.el('option', { value:o.id, text:o.label }));
    });
    typeSelect.value = (opts.cardType && getChallengeCardOption(opts.cardType).id) || 'shared_spin';

    var startingOption = getChallengeCardOption(typeSelect.value);
    function challengeNoteLabel(option){
      option = option || getChallengeCardOption(typeSelect.value || 'shared_spin');
      return (option.label || 'Spin Invite') + ' note';
    }
    function challengeButtonLabel(option){
      option = option || getChallengeCardOption(typeSelect.value || 'shared_spin');
      return 'Send ' + (option.label || 'Spin Invite');
    }
    var startingMessage = opts.message || startingOption.placeholder;
    var fromInput = U.el('input', { class:'tw-input', type:'text', placeholder:'Your name (optional)', value: opts.from || '' });
    var msgLabel = U.el('label', { text: challengeNoteLabel(startingOption) });
    var msgInput = U.el('input', { class:'tw-input', type:'text', placeholder: startingOption.placeholder || 'Add a quick note.', value: startingMessage });
    var nativeBtn = U.el('button', { class:'tw-btn tw-btnPrimary tw-shareInvitePrimary', type:'button' }, [challengeButtonLabel(startingOption)]);
    var lastAutoMessage = startingOption.placeholder || '';

    var previewImg = U.el('img', { class:'tw-shareCardPreviewImg', alt:'Spin invite card preview' });
    previewImg.src = getChallengeCardUrl(typeSelect.value);

    function getOpts(){
      var cardType = typeSelect.value || 'shared_spin';
      return {
        wheelTitle: opts.wheelTitle || 'Spin The Wheel Challenge',
        from: fromInput.value || '',
        result: opts.result || '',
        message: msgInput.value || '',
        cardType: cardType,
        cardUrl: getChallengeCardUrl(cardType),
        spinsAllowed: 3,
        url: '',
        code: ''
      };
    }

    function getOptsWithLink(){
      var data = getOpts();
      return buildChallengeUrlAsync(data).then(function(link){
        data.url = link;
        data.code = shortChallengeCodeFromUrl(link);
        return data;
      });
    }

    function setBtnFlash(btn, txt){
      var old = btn.textContent;
      btn.textContent = txt;
      setTimeout(function(){ btn.textContent = old; }, 1400);
    }

    function refreshUi(){
      var selected = getChallengeCardOption(typeSelect.value || 'shared_spin');
      previewImg.src = selected.url;
      if(msgLabel) msgLabel.textContent = challengeNoteLabel(selected);
      if(msgInput){
        msgInput.placeholder = selected.placeholder || 'Add a quick note.';
        if(!msgInput.value || msgInput.value === lastAutoMessage){
          msgInput.value = selected.placeholder || '';
        }
        lastAutoMessage = selected.placeholder || '';
      }
      if(nativeBtn) nativeBtn.textContent = challengeButtonLabel(selected);
      return getOpts();
    }

    nativeBtn.onclick = function(){
      refreshUi();
      nativeBtn.disabled = true;
      nativeBtn.textContent = 'Preparing...';
      getOptsWithLink().then(function(data){
        nativeBtn.disabled = false;
        nativeBtn.textContent = challengeButtonLabel(getChallengeCardOption(typeSelect.value));
        return nativeChallengeShare(data).then(function(){
          TW.track && TW.track('share', { method:'native_invite', content_type:'wheel' });
          close('x');
        }).catch(function(){
          copyText(data.url);
          TW.track && TW.track('share', { method:'copy_invite_link', content_type:'wheel' });
          setBtnFlash(nativeBtn, 'Link copied');
        });
      }).catch(function(){
        nativeBtn.disabled = false;
        nativeBtn.textContent = challengeButtonLabel(getChallengeCardOption(typeSelect.value));
        showEncryptedLinkFailure();
      });
    };

    typeSelect.addEventListener('change', refreshUi);

    modal.appendChild(top);
    modal.appendChild(U.el('div', { class:'tw-mini', text:'Send a clean square card with a short private wheel link tucked inside. The note is optional, but Professor Vortex recommends a tiny dramatic flourish.' }));
    modal.appendChild(U.el('div', { style:'height:10px;' }));
    modal.appendChild(U.el('div', { class:'tw-shareCardPreview tw-shareCardPreviewSquare' }, [ previewImg ]));
    modal.appendChild(U.el('div', { style:'height:10px;' }));
    modal.appendChild(U.el('div', { class:'tw-field' }, [ U.el('label', { text:'Card style' }), typeSelect ]));
    if(TW.enhanceSelectMenu){
      TW.enhanceSelectMenu(typeSelect, { ariaLabel:'Card style' });
      if(typeSelect._twMenuSyncLabel) typeSelect._twMenuSyncLabel();
    }
    modal.appendChild(U.el('div', { class:'tw-field' }, [ U.el('label', { text:'Your name' }), fromInput ]));
    modal.appendChild(U.el('div', { class:'tw-field' }, [ msgLabel, msgInput ]));
    modal.appendChild(U.el('div', { style:'height:12px;' }));
    modal.appendChild(U.el('div', { class:'tw-toolbar', style:'justify-content:center;' }, [ nativeBtn ]));

    refreshUi();
  };


  function applyChallengeModeUi(){
    try{
      var active=!!(TW.challenge&&TW.challenge.active);
      if(R.root) R.root.classList.toggle('tw-challengeMode',active);
      if(active&&R.challengeBanner&&R.wheelCard){
        R.wheelCard.insertBefore(R.challengeBanner,R.wheelCard.firstChild);
        R.challengeBanner.hidden=false;
      }
    }catch(_){ }
  }

  // ---------- share modal ----------
  function copyText(txt){
    if(navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(txt).catch(function(){});
    }else{
      var ta = document.createElement('textarea');
      ta.value = txt;
      document.body.appendChild(ta);
      ta.select();
      try{ document.execCommand('copy'); }catch(_){}
      document.body.removeChild(ta);
    }
  }

  TW.openShare = function(refreshOnly){
    var back = R.modalBack, modal = R.modal;
    if(!back || !modal) return;

    resetSharedModalAppearance(back, modal);

    TW._shareOpen = true;

    function close(){
      TW._shareOpen = false;
      back.hidden = true;
      modal.hidden = true;
      modal.innerHTML = '';
    }

    // No live scroll boxes now, so refreshOnly does not need to rebuild anything.
    if(refreshOnly && !modal.hidden) return;

    back.hidden = false;
    modal.hidden = false;
    back.onclick = close;
    modal.innerHTML = '';

    var top = U.el('div', { class:'tw-modalTop' }, [
      U.el('h3', { class:'tw-modalTitle', text:'Share' }),
      (function(){
        var x = U.el('button', { class:'tw-x', type:'button', 'aria-label':'Close' }, ['×']);
        x.onclick = close;
        return x;
      })()
    ]);

    var info = U.el('div', { class:'tw-mini', text:'Create clean encrypted links. The exact wheel setup is saved temporarily as unreadable encrypted data, not stuffed into the visible URL.' });

    function flash(btn, text, restoreText){
      btn.textContent = text;
      setTimeout(function(){ btn.textContent = restoreText || btn.getAttribute('data-label') || 'Copy link'; }, 1400);
    }

    function makeLinkButton(label, linkType, copiedText){
      var btn = U.el('button', { class:'tw-btn', type:'button' }, [label]);
      btn.setAttribute('data-label', label);
      btn.onclick = function(){
        btn.disabled = true;
        btn.textContent = 'Creating...';
        createVaultLink(linkType, {}).then(function(link){
          copyText(link);
          TW.track && TW.track('share', { method:'copy_' + String(linkType || 'exact') + '_link', content_type:'wheel' });
          btn.disabled = false;
          flash(btn, copiedText || 'Copied', label);
        }).catch(function(err){
          try{ console.warn('[STWL share] Short link failed:', err); }catch(_){ }
          btn.disabled = false;
          flash(btn, 'Not copied', label);
          showEncryptedLinkFailure();
        });
      };
      return btn;
    }

    var btnExact = makeLinkButton('Copy exact wheel link', 'exact', 'Exact link copied');
    btnExact.classList.add('tw-btnPrimary');
    var btnPlain = U.el('button', { class:'tw-btn', type:'button' }, ['Copy plain page link']);
    btnPlain.onclick = function(){
      copyText(getBaseUrl());
      TW.track && TW.track('share', { method:'copy_plain_link', content_type:'wheel' });
      flash(btnPlain, 'Plain link copied');
    };
    var btnChallenge = U.el('button', { class:'tw-btn tw-btnPrimary tw-shareInvitePrimary', type:'button' }, ['Send spin invite']);
    btnChallenge.onclick = function(){
      close();
      TW.openChallengeComposer && TW.openChallengeComposer({
        result: (TW.lastWinner && TW.lastWinner.label) ? TW.lastWinner.label : '',
        wheelTitle: (TW.state && TW.state.ui && TW.state.ui.title) ? TW.state.ui.title : 'Spin The Wheel Challenge',
        from:'',
        message:'',
        cardType:'shared_spin'
      });
    };

    modal.appendChild(top);
    modal.appendChild(info);
    modal.appendChild(U.el('div', { class:'tw-divider' }));
    modal.appendChild(U.el('div', { class:'tw-accordTitle', text:'Clean encrypted links' }));
    modal.appendChild(U.el('div', { class:'tw-mini tw-shareHint', text:'Create a clean link for the exact customized wheel, or copy the plain page link without the wheel setup.' }));
    modal.appendChild(U.el('div', { class:'tw-toolbar tw-shareActions' }, [ btnExact, btnPlain ]));
    modal.appendChild(U.el('div', { class:'tw-divider' }));
    modal.appendChild(U.el('div', { class:'tw-accordTitle', text:'Spin invite' }));
    modal.appendChild(U.el('div', { class:'tw-mini tw-shareHint', text:'Sends a clean square card plus a short encrypted wheel link. Every public wheel includes unlimited spins.' }));
    modal.appendChild(U.el('div', { style:'height:10px;' }));
    modal.appendChild(U.el('div', { class:'tw-toolbar', style:'justify-content:center;' }, [ btnChallenge ]));
    modal.appendChild(U.el('div', { class:'tw-privacyNote tw-sharePrivacyNote' }, [
      U.el('span', { class:'tw-privacyNoteBadge', text:'Sharing note' }),
      U.el('span', { class:'tw-privacyNoteText', text:'A shared wheel can reveal its segments, settings, notes, images, links, and other included content to anyone who receives the complete link, and recipients may copy or forward it. The stored wheel payload is encrypted, but the complete link contains what the recipient’s browser needs to open it; encryption does not make a link private after you share it. Links are temporary—generally 7 days for invites and 30 days for other supported shared links—and are not permanent storage. Do not share confidential, financial, medical, student, child, government ID, or other sensitive personal information.' })
    ]));
  };

  function normalizeSegments(){
    TW.state.segments = TW.state.segments || [];
    if(TW.state.segments.length > TW.CONST.MAX_SEGMENTS){
      TW.state.segments = TW.state.segments.slice(0, TW.CONST.MAX_SEGMENTS);
    }
    for(var i=0;i<TW.state.segments.length;i++){
      var s = TW.state.segments[i];
      if(!s) s = TW.state.segments[i] = { label:'', weight:1, color: TW.CONST.PALETTE[i%TW.CONST.PALETTE.length], tcolor:'white' };
      s.label = (s.label||'').toUpperCase();
      var w = parseFloat(s.weight);
      if(!(w > 0)) w = 1;
      s.weight = w;
      if(!s.color) s.color = TW.CONST.PALETTE[i%TW.CONST.PALETTE.length];
      if(!s.tcolor) s.tcolor = 'white';
      if(String(s.tcolor).toLowerCase() === 'black') s.tcolor = 'black';
      else s.tcolor = 'white';
    }
  }

  function _segKeyLoose(s){
    s = s || {};
    var lab = String(s.label || '').toUpperCase().trim();
    var w = (s.weight == null ? 1 : parseFloat(s.weight));
    if(!(w > 0)) w = 1;
    return lab + '|' + w;
  }

  function segmentsEqualLoose(a, b){
    if(!Array.isArray(a) || !Array.isArray(b)) return false;
    if(a.length !== b.length) return false;
    for(var i=0;i<a.length;i++){
      if(_segKeyLoose(a[i]) !== _segKeyLoose(b[i])) return false;
    }
    return true;
  }

  // =========================================================
  // ✅ Segment add: assign every 3rd palette color (more variety)
  // =========================================================
  function palettePickIndex(segIndex){
    var pal = TW.CONST.PALETTE || [];
    var n = pal.length || 1;
    var step = parseInt(TW_SEG_COLOR_STEP, 10);
    if(!(step > 0)) step = 1;
    // 0,3,6,9... wrapping
    return ((segIndex * step) % n + n) % n;
  }

  TW.pickColorForIndex = function(segIndex){
    var pal = TW.CONST.PALETTE || [];
    if(!pal.length) return '#22d3ee';
    return pal[palettePickIndex(segIndex)];
  };

  TW.addSegments = function(labels){
    labels = (labels||[]).map(function(s){ return (s||'').trim(); }).filter(Boolean);
    if(!labels.length) return { added:0, skipped:0, total:(TW.state.segments || []).length };

    TW.pushUndo();
    normalizeSegments();

    var segs = TW.state.segments;
    var beforeCount = segs.length;
    for(var i=0;i<labels.length;i++){
      if(segs.length >= TW.CONST.MAX_SEGMENTS) break;
      var idx = palettePickIndex(segs.length);
      segs.push({
        label: labels[i].toUpperCase(),
        weight: 1,
        color: (TW.CONST.PALETTE && TW.CONST.PALETTE.length) ? TW.CONST.PALETTE[idx] : '#22d3ee',
        tcolor: 'black'
      });
    }
    var addedCount = segs.length - beforeCount;
    var skippedCount = Math.max(0, labels.length - addedCount);
    TW._segmentEditorPage = Math.max(0, Math.floor((segs.length - 1) / ((TW.CONST && TW.CONST.SEGMENT_EDITOR_PAGE_SIZE) || 50)));
    TW.renderAll && TW.renderAll();
    TW.saveSoon();
    return { added:addedCount, skipped:skippedCount, total:segs.length };
  };

  TW.shuffleSegments = function(){
    TW.pushUndo();
    normalizeSegments();
    var a = TW.state.segments;
    TW._segmentEditorPage = 0;
    for(var i=a.length-1;i>0;i--){
      var j = Math.floor(U.rand01() * (i+1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    TW.renderAll && TW.renderAll();
    TW.saveSoon();
  };

  TW.sortSegments = function(az){
    TW.pushUndo();
    normalizeSegments();
    TW._segmentEditorPage = 0;
    TW.state.segments.sort(function(x,y){
      var a = (x.label||''); var b = (y.label||'');
      return az ? a.localeCompare(b) : b.localeCompare(a);
    });
    TW.renderAll && TW.renderAll();
    TW.saveSoon();
  };

  TW.removeDuplicateSegments = function(){
    normalizeSegments();
    var seen = Object.create(null);
    var before = TW.state.segments.length;
    var next = TW.state.segments.filter(function(segment){
      var key = String(segment && segment.label || '').trim().toLocaleUpperCase();
      if(!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
    if(next.length === before) return;
    TW.pushUndo();
    TW.state.segments = next;
    TW._segmentEditorPage = 0;
    TW.renderAll && TW.renderAll();
    TW.saveSoon();
  };

  TW.clearSegments = function(){
    if(!confirm('Clear all segments?')) return;
    TW.pushUndo();
    TW.state.segments = [];
    TW._segmentEditorPage = 0;
    if(TW._closeColorPopover) TW._closeColorPopover();
    TW.renderAll && TW.renderAll();
    TW.saveSoon();
  };


  // =========================
  // Vortex AI helpers (no confirm)
  // =========================
  function vortexTextColor(hex){
    var value = String(hex || '').replace('#','');
    if(!/^[0-9a-fA-F]{6}$/.test(value)) return 'white';
    var rgb = [0,2,4].map(function(i){
      var channel = parseInt(value.slice(i,i+2),16) / 255;
      return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    });
    var luminance = 0.2126*rgb[0] + 0.7152*rgb[1] + 0.0722*rgb[2];
    var blackContrast = (luminance + 0.05) / 0.05;
    var whiteContrast = 1.05 / (luminance + 0.05);
    return blackContrast >= whiteContrast ? 'black' : 'white';
  }

  var PRESENTATION_SIZE_KEY = KEY_BASE + '::presentationWheelSizeV3::' + PATH;
  var PRESENTATION_LAYOUT_KEY = KEY_BASE + '::presentationLayoutV1::' + PATH;
  var PRESENTATION_WINNER_KEY = KEY_BASE + '::presentationWinnerPositionV1::' + PATH;
  var presentationSizePct = 100;
  var presentationLayout = 'left';
  var presentationWinnerPosition = 'center';
  try{
    var savedPresentationSize = parseInt(localStorage.getItem(PRESENTATION_SIZE_KEY) || '100', 10);
    if(isFinite(savedPresentationSize)) presentationSizePct = Math.max(45, Math.min(180, savedPresentationSize));
    presentationLayout = localStorage.getItem(PRESENTATION_LAYOUT_KEY) || 'left';
    if(presentationLayout === 'standard') presentationLayout = 'left';
    presentationWinnerPosition = localStorage.getItem(PRESENTATION_WINNER_KEY) || 'center';
  }catch(_){ }

  function applyPresentationArrangement(){
    if(!R.wrap) return;
    ['standard','left','center','right'].forEach(function(name){ R.wrap.classList.remove('tw-overlayLayout-' + name); });
    ['center','left','right','top'].forEach(function(name){ document.body.classList.remove('twWinnerPos-' + name); });
    if(['left','center','right'].indexOf(presentationLayout) < 0) presentationLayout = 'left';
    if(['center','left','right','top'].indexOf(presentationWinnerPosition) < 0) presentationWinnerPosition = 'center';
    var compact = false;
    try{ compact = !!(window.matchMedia && window.matchMedia('(max-width:1024px)').matches); }catch(_){ }
    R.wrap.classList.add('tw-overlayLayout-' + (compact ? 'center' : presentationLayout));
    document.body.classList.add('twWinnerPos-center');
  }

  function presentationLayoutLabel(value){
    return value === 'center' ? 'Layout: Center' : 'Layout: Wheel ' + value.charAt(0).toUpperCase() + value.slice(1);
  }

  function ensurePresentationStageCSS(){
    if(document.getElementById('twPresentationStageCSS')) return;
    var st = document.createElement('style');
    st.id = 'twPresentationStageCSS';
    st.textContent = [
      '.tw-presentationDock{position:fixed;left:50%;bottom:calc(14px + env(safe-area-inset-bottom,0px));transform:translateX(-50%);z-index:2147483000;display:flex;align-items:center;gap:9px;width:max-content;max-width:calc(100vw - 20px);box-sizing:border-box;padding:10px 56px 10px 12px;border:1px solid rgba(255,255,255,.24);border-radius:18px;background:rgba(31,18,48,.84);color:#fff8ee;box-shadow:0 16px 42px rgba(0,0,0,.32);backdrop-filter:blur(16px) saturate(1.18);-webkit-backdrop-filter:blur(16px) saturate(1.18);font-family:Fredoka,system-ui,sans-serif;}',
      '.tw-presentationDock button{appearance:none;min-height:42px;border:1px solid rgba(255,255,255,.18);border-radius:13px;padding:8px 12px;background:rgba(255,255,255,.12);color:#fff8ee;font:900 13px/1 Fredoka,system-ui,sans-serif;cursor:pointer;white-space:nowrap;}',
      '.tw-presentationDock button:hover,.tw-presentationDock button:focus-visible{background:rgba(255,255,255,.2);outline:none;}',
      '.tw-presentationDock .tw-presentationSpin{background:linear-gradient(135deg,#f77f00,#ff3d2e);color:#000;border-color:rgba(0,0,0,.18);padding-left:18px;padding-right:18px;}',
      '.tw-showSequence{display:flex;align-items:center;gap:7px;padding-right:9px;margin-right:2px;border-right:1px solid rgba(255,255,255,.22);}.tw-showSequence .tw-showNext{background:linear-gradient(135deg,#6d5dfc,#37b8ef);color:#fff;}.tw-showSequence button:disabled{opacity:.42;cursor:not-allowed;}.tw-showCounter{min-width:45px;text-align:center;font-size:12px;font-weight:950;color:#dbeafe;white-space:nowrap;}',
      '.tw-presentationDock.tw-showLaterStep .tw-presentationSizeLabel,.tw-presentationDock.tw-showLaterStep .tw-presentationSmaller,.tw-presentationDock.tw-showLaterStep .tw-presentationSizeRange,.tw-presentationDock.tw-showLaterStep .tw-presentationLarger,.tw-presentationDock.tw-showLaterStep .tw-presentationSizeValue,.tw-presentationDock.tw-showLaterStep .tw-presentationFit,.tw-presentationDock.tw-showLaterStep .tw-presentationLayout{display:none!important;}',
      '.tw-winnerModalActive .tw-showPresenterNext{position:absolute;right:14px;bottom:12px;z-index:8;border:0;background:transparent;color:rgba(65,45,91,.72);font:900 12px/1.2 Fredoka,system-ui,sans-serif;text-decoration:underline;text-underline-offset:3px;cursor:pointer;padding:7px 9px}.tw-winnerModalActive .tw-showPresenterNext:hover,.tw-winnerModalActive .tw-showPresenterNext:focus-visible{color:#4b2d78;outline:2px solid rgba(112,68,189,.22);border-radius:8px}',
      '.tw-showCurtain{position:fixed;z-index:2147483646;inset:0;display:grid;place-items:center;pointer-events:all;background:var(--tw-show-bg,#14102b);opacity:0;transition:opacity var(--tw-show-duration,800ms) cubic-bezier(.22,.61,.36,1);}.tw-showCurtain.is-active{opacity:1}.tw-showCurtain img{display:block;width:min(32vw,260px);height:min(32vw,260px);object-fit:contain;filter:drop-shadow(0 20px 38px rgba(0,0,0,.35));}.tw-showCurtain--vortex img{animation:twShowVortex var(--tw-show-duration,800ms) cubic-bezier(.22,.61,.36,1) both}.tw-showCurtain--zoom img{animation:twShowZoom var(--tw-show-duration,800ms) ease both}.tw-showCurtain--slide img{animation:twShowSlide var(--tw-show-duration,800ms) ease both}.tw-showCurtain--fade img{animation:twShowFade var(--tw-show-duration,800ms) ease both}@keyframes twShowVortex{from{transform:scale(.42) rotate(-160deg);opacity:0}to{transform:scale(1) rotate(0);opacity:1}}@keyframes twShowZoom{from{transform:scale(.35);opacity:0}to{transform:scale(1);opacity:1}}@keyframes twShowSlide{from{transform:translateX(-45vw);opacity:0}to{transform:translateX(0);opacity:1}}@keyframes twShowFade{from{opacity:0}to{opacity:1}}',
      '.tw-presentationSizeLabel{font-size:12px;font-weight:900;white-space:nowrap;}',
      '.tw-presentationSizeRange{width:clamp(130px,24vw,360px);accent-color:#f77f00;cursor:pointer;}',
      '.tw-presentationSizeValue{min-width:42px;font-size:12px;font-weight:900;text-align:center;}',
      '.tw-presentationDockClose{position:absolute!important;right:8px!important;top:50%!important;transform:translateY(-50%)!important;width:38px!important;min-width:38px!important;padding:0!important;font-size:21px!important;line-height:1!important;}',
      '.tw-presentationResizeHandle{position:absolute;right:-18px;bottom:-18px;z-index:80;width:42px;height:42px;border:2px solid rgba(255,255,255,.9);border-radius:14px;background:linear-gradient(135deg,#f77f00,#ff3d2e);box-shadow:0 8px 22px rgba(0,0,0,.3);cursor:nwse-resize;touch-action:none;}',
      '.tw-presentationResizeHandle::before{content:"";position:absolute;right:9px;bottom:9px;width:13px;height:13px;border-right:3px solid #000;border-bottom:3px solid #000;border-radius:1px;}',
      '.tw-inOverlay .tw-wheelStage{overflow:visible!important;}',
      '@media(max-width:700px){.tw-presentationDock{width:calc(100vw - 16px);max-width:calc(100vw - 16px);justify-content:flex-start;gap:7px;padding:7px 52px 7px 7px;overflow-x:auto;}.tw-presentationDock button{min-height:40px;padding:7px 9px;font-size:12px;}.tw-presentationSizeLabel,.tw-presentationSizeValue,.tw-presentationSmaller,.tw-presentationLarger,.tw-presentationFit{display:none!important;}.tw-presentationSizeRange{width:auto;min-width:0;flex:1 1 auto;}.tw-presentationResizeHandle{display:block!important;right:-6px;bottom:-6px;width:38px;height:38px;border-radius:12px;}.tw-showSequence{flex:0 0 auto;}}'
    ].join('');
    document.head.appendChild(st);
  }

  function ensureResponsiveWheelDefaultCSS(){
    if(document.getElementById('twResponsiveWheelDefaultCSS')) return;
    var st = document.createElement('style');
    st.id = 'twResponsiveWheelDefaultCSS';
    st.textContent = [
      '#toki-wheel-root{--tw-wheelSize:clamp(500px,46vw,850px);}',
      'body:not(.twStreamBody) #toki-wheel-root .tw-wheelStage{padding-top:18px!important;padding-bottom:22px!important;margin-top:0!important;margin-bottom:0!important;}',
      'body:not(.twStreamBody) #toki-wheel-root .tw-wheelStage::before,body:not(.twStreamBody) #toki-wheel-root .tw-wheelStage::after{display:none!important;}',
      'body:not(.twStreamBody) #toki-wheel-root .tw-wheelWrap{filter:drop-shadow(0 16px 22px rgba(17,12,31,.24)) drop-shadow(0 0 9px rgba(255,255,255,.28))!important;}',
      'body:not(.twStreamBody) #toki-wheel-root .tw-wheelWrap::before{display:block!important;inset:-7%!important;border-radius:50%!important;background:radial-gradient(circle,rgba(255,255,255,.32) 0%,rgba(255,255,255,.15) 41%,rgba(113,91,255,.08) 57%,transparent 73%)!important;filter:blur(13px)!important;opacity:.88!important;}',
      '#toki-wheel-root .tw-side{border:1px solid rgba(255,255,255,.18)!important;background:radial-gradient(circle at 12% 0%,rgba(126,83,255,.28),transparent 36%),radial-gradient(circle at 92% 100%,rgba(255,166,54,.14),transparent 37%),linear-gradient(145deg,rgba(16,19,38,.96),rgba(25,19,46,.94) 58%,rgba(10,16,31,.96))!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.19),inset 0 -1px 0 rgba(0,0,0,.45),0 24px 58px rgba(7,8,20,.34),0 0 0 1px rgba(94,67,181,.10)!important;color:#fff9ef!important;backdrop-filter:blur(22px) saturate(1.12)!important;-webkit-backdrop-filter:blur(22px) saturate(1.12)!important;}',
      '#toki-wheel-root .tw-side::before{width:360px!important;height:210px!important;top:-150px!important;background:radial-gradient(ellipse at center,rgba(255,202,85,.36),rgba(137,83,255,.16) 45%,transparent 74%)!important;filter:blur(18px)!important;opacity:.82!important;}',
      '#toki-wheel-root .tw-side::after{background:linear-gradient(118deg,transparent 0%,rgba(255,255,255,.10) 18%,transparent 34%),radial-gradient(circle at 8% 88%,rgba(91,203,255,.09),transparent 31%)!important;opacity:.72!important;}',
      '#toki-wheel-root .tw-sideTitle{border:1px solid rgba(255,255,255,.13)!important;background:linear-gradient(180deg,rgba(255,255,255,.10),rgba(255,255,255,.035))!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.13),0 12px 28px rgba(3,4,15,.24)!important;}',
      '#toki-wheel-root .tw-sideTitle .tw-h2{color:#fff9ef!important;text-shadow:0 2px 14px rgba(0,0,0,.42)!important;letter-spacing:-.02em!important;}',
      '#toki-wheel-root .tw-sideTitle .tw-h2::before{content:"\\2605"!important;color:#ffd85b!important;background:linear-gradient(180deg,rgba(255,216,91,.24),rgba(137,83,255,.18))!important;border-color:rgba(255,225,133,.24)!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.24),0 8px 18px rgba(2,3,13,.28),0 0 20px rgba(255,195,70,.13)!important;}',
      '#toki-wheel-root #twPinsList{border:1px solid rgba(255,255,255,.10)!important;background:linear-gradient(180deg,rgba(4,7,20,.36),rgba(255,255,255,.035))!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.07),inset 0 14px 28px rgba(0,0,0,.12)!important;color:#fff9ef!important;}',
      '#toki-wheel-root .tw-quickStickerPromo,#toki-wheel-root .tw-stickerDrops,#toki-wheel-root .tw-subscriptionDrops{position:relative!important;isolation:isolate!important;border:1px solid rgba(255,255,255,.16)!important;background:radial-gradient(circle at 8% 0%,rgba(124,76,255,.26),transparent 38%),radial-gradient(circle at 96% 105%,rgba(255,172,61,.15),transparent 35%),linear-gradient(145deg,rgba(17,20,40,.97),rgba(31,21,52,.95) 58%,rgba(10,16,31,.97))!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.17),0 22px 50px rgba(7,8,20,.28)!important;color:#fff9ef!important;}',
      '#toki-wheel-root .tw-quickStickerPromo::before,#toki-wheel-root .tw-stickerDrops::before,#toki-wheel-root .tw-subscriptionDrops::before{content:""!important;display:block!important;position:absolute!important;inset:0!important;pointer-events:none!important;border-radius:inherit!important;background:linear-gradient(118deg,transparent 3%,rgba(255,255,255,.09) 20%,transparent 36%)!important;opacity:.65!important;z-index:0!important;}',
      '#toki-wheel-root .tw-quickStickerPromo>* ,#toki-wheel-root .tw-stickerDrops>* ,#toki-wheel-root .tw-subscriptionDrops>*{position:relative!important;z-index:1!important;}',
      '#toki-wheel-root .tw-quickStickerPromoKicker,#toki-wheel-root .tw-stickerDropsKicker,#toki-wheel-root .tw-subscriptionDropsKicker{color:#ffd75a!important;letter-spacing:.14em!important;text-shadow:0 0 18px rgba(255,203,73,.18)!important;}',
      '#toki-wheel-root .tw-quickStickerPromoTitle,#toki-wheel-root .tw-stickerDropsTitle,#toki-wheel-root .tw-subscriptionDropsTitle{color:#fffaf1!important;text-shadow:0 3px 16px rgba(0,0,0,.36)!important;letter-spacing:-.025em!important;}',
      '#toki-wheel-root .tw-quickStickerPromoText,#toki-wheel-root .tw-stickerDropsText,#toki-wheel-root .tw-subscriptionDropsText{color:rgba(255,250,241,.80)!important;}',
      '#toki-wheel-root .tw-quickStickerPromoMedia,#toki-wheel-root .tw-stickerDropCard,#toki-wheel-root .tw-subscriptionDropCard{border:1px solid rgba(255,255,255,.15)!important;background:rgba(4,7,20,.42)!important;box-shadow:0 15px 34px rgba(2,3,13,.34),inset 0 1px 0 rgba(255,255,255,.10)!important;overflow:hidden!important;}',
      '#toki-wheel-root .tw-quickStickerPromoMedia{border-radius:18px!important;padding:5px!important;}',
      '#toki-wheel-root .tw-quickStickerPromoArt{border-radius:13px!important;}',
      '#toki-wheel-root .tw-stickerDropCard,#toki-wheel-root .tw-subscriptionDropCard{border-radius:20px!important;padding:5px!important;transition:transform .22s ease,box-shadow .22s ease!important;}',
      '#toki-wheel-root .tw-stickerDropCard:hover,#toki-wheel-root .tw-subscriptionDropCard:hover{transform:translateY(-3px)!important;box-shadow:0 21px 42px rgba(2,3,13,.42),0 0 24px rgba(126,76,255,.13)!important;}',
      '#toki-wheel-root .tw-subscriptionDropCard img,#toki-wheel-root .tw-stickerDropArt,#toki-wheel-root .tw-stickerDropArt img{border-radius:15px!important;}',
      '#toki-wheel-root .tw-quickStickerPromoBtn,#toki-wheel-root .tw-quickStickerPromoAll,#toki-wheel-root .tw-stickerDropsAll,#toki-wheel-root .tw-subscriptionDropsAll{border:1px solid rgba(255,227,132,.42)!important;background:linear-gradient(180deg,#ffe27a,#f3b936)!important;color:#21152f!important;font-weight:900!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.72),0 8px 20px rgba(3,4,15,.25)!important;}',
      '#toki-wheel-root .tw-quickStickerPromo,#toki-wheel-root .tw-stickerDrops,#toki-wheel-root .tw-subscriptionDrops{border-color:rgba(75,45,122,.14)!important;background:radial-gradient(circle at 4% 0%,rgba(124,76,255,.11),transparent 35%),radial-gradient(circle at 98% 105%,rgba(255,177,59,.13),transparent 35%),linear-gradient(145deg,rgba(255,255,255,.97),rgba(255,249,241,.96) 58%,rgba(248,244,255,.97))!important;box-shadow:inset 0 1px 0 #fff,0 20px 46px rgba(39,24,66,.15),0 3px 10px rgba(39,24,66,.07)!important;color:#291943!important;}',
      '#toki-wheel-root .tw-quickStickerPromo::before,#toki-wheel-root .tw-stickerDrops::before,#toki-wheel-root .tw-subscriptionDrops::before{background:linear-gradient(118deg,transparent 4%,rgba(255,255,255,.68) 20%,transparent 37%)!important;opacity:.72!important;}',
      '#toki-wheel-root .tw-quickStickerPromoKicker,#toki-wheel-root .tw-stickerDropsKicker,#toki-wheel-root .tw-subscriptionDropsKicker{color:#7650c7!important;text-shadow:none!important;}',
      '#toki-wheel-root .tw-quickStickerPromoTitle,#toki-wheel-root .tw-stickerDropsTitle,#toki-wheel-root .tw-subscriptionDropsTitle{color:#291943!important;text-shadow:none!important;}',
      '#toki-wheel-root .tw-quickStickerPromoText,#toki-wheel-root .tw-stickerDropsText,#toki-wheel-root .tw-subscriptionDropsText{color:#655a72!important;}',
      '#toki-wheel-root .tw-quickStickerPromoMedia,#toki-wheel-root .tw-stickerDropCard,#toki-wheel-root .tw-subscriptionDropCard{border-color:rgba(75,45,122,.13)!important;background:rgba(255,255,255,.76)!important;box-shadow:0 13px 30px rgba(42,25,72,.13),inset 0 1px 0 #fff!important;}',
      '#toki-wheel-root .tw-stickerDrops{padding-top:clamp(28px,3.8vw,40px)!important;}',
      '#toki-wheel-root .tw-stickerDropsRail{margin-top:20px!important;padding-top:6px!important;transition:opacity .34s cubic-bezier(.22,.61,.36,1),transform .34s cubic-bezier(.22,.61,.36,1),filter .34s cubic-bezier(.22,.61,.36,1)!important;}',
      '#toki-wheel-root .tw-stickerDropsRail.isChanging{opacity:0!important;transform:translateY(4px) scale(.998)!important;filter:blur(.5px)!important;}',
      '#toki-wheel-root .tw-stickerDropCard{animation-duration:.52s!important;animation-timing-function:cubic-bezier(.16,1,.3,1)!important;}',
      '#toki-wheel-root .tw-side{border-color:rgba(141,93,24,.20)!important;background:radial-gradient(circle at 50% -8%,rgba(255,213,112,.30),transparent 39%),linear-gradient(145deg,rgba(255,253,246,.98),rgba(249,239,215,.96) 58%,rgba(255,250,238,.98))!important;box-shadow:inset 0 1px 0 #fff,0 20px 48px rgba(79,52,18,.17),0 3px 9px rgba(79,52,18,.08)!important;color:#3d2b17!important;}',
      '#toki-wheel-root .tw-side::before{background:radial-gradient(ellipse at center,rgba(255,197,66,.32),rgba(255,235,174,.15) 48%,transparent 74%)!important;opacity:.76!important;}',
      '#toki-wheel-root .tw-side::after{background:linear-gradient(118deg,transparent 0%,rgba(255,255,255,.62) 18%,transparent 35%),radial-gradient(circle at 8% 88%,rgba(211,151,47,.08),transparent 31%)!important;}',
      '#toki-wheel-root .tw-sideTitle{border-color:rgba(141,93,24,.14)!important;background:linear-gradient(180deg,rgba(255,255,255,.74),rgba(255,248,229,.54))!important;box-shadow:inset 0 1px 0 #fff,0 10px 24px rgba(92,60,17,.10)!important;}',
      '#toki-wheel-root .tw-sideTitle .tw-h2{color:#3d2b17!important;text-shadow:none!important;}',
      '#toki-wheel-root .tw-sideTitle .tw-h2::before{color:#9b650f!important;background:linear-gradient(180deg,rgba(255,217,112,.48),rgba(255,248,222,.64))!important;border-color:rgba(155,101,15,.18)!important;box-shadow:inset 0 1px 0 #fff,0 7px 16px rgba(92,60,17,.12)!important;}',
      '#toki-wheel-root #twPinsList{border-color:rgba(141,93,24,.12)!important;background:linear-gradient(180deg,rgba(255,255,255,.66),rgba(255,247,225,.48))!important;box-shadow:inset 0 1px 0 #fff,inset 0 12px 24px rgba(124,81,16,.035)!important;color:#3d2b17!important;}',
      '#toki-wheel-root #twOptions+#twSpinExperience,#toki-wheel-root #twVortexAI+#twCustomize{margin-top:24px!important;}',
      '#toki-wheel-root .tw-quickStickerPromo,#toki-wheel-root .tw-stickerDrops,#toki-wheel-root .tw-subscriptionDrops{background:#fffaf2!important;background-image:none!important;border:1px solid #e7dcef!important;border-top:5px solid #8358d4!important;box-shadow:0 14px 34px rgba(46,28,72,.14)!important;color:#2d1d42!important;backdrop-filter:none!important;-webkit-backdrop-filter:none!important;}',
      '#toki-wheel-root .tw-quickSubscriptionPromo,#toki-wheel-root .tw-subscriptionDrops{border-top-color:#f4a62a!important;}',
      '#toki-wheel-root .tw-quickStickerPromo::before,#toki-wheel-root .tw-quickStickerPromo::after,#toki-wheel-root .tw-stickerDrops::before,#toki-wheel-root .tw-stickerDrops::after,#toki-wheel-root .tw-subscriptionDrops::before,#toki-wheel-root .tw-subscriptionDrops::after{content:none!important;display:none!important;background:none!important;}',
      '#toki-wheel-root .tw-quickStickerPromoKicker,#toki-wheel-root .tw-stickerDropsKicker,#toki-wheel-root .tw-subscriptionDropsKicker{color:#7044bd!important;text-shadow:none!important;}',
      '#toki-wheel-root .tw-quickStickerPromoTitle,#toki-wheel-root .tw-stickerDropsTitle,#toki-wheel-root .tw-subscriptionDropsTitle,#toki-wheel-root .tw-stickerDropName{color:#2d1d42!important;text-shadow:none!important;}',
      '#toki-wheel-root .tw-quickStickerPromoText,#toki-wheel-root .tw-stickerDropsText,#toki-wheel-root .tw-subscriptionDropsText,#toki-wheel-root .tw-stickerDropSub{color:#675d70!important;text-shadow:none!important;}',
      '#toki-wheel-root .tw-quickStickerPromoMedia,#toki-wheel-root .tw-stickerDropCard,#toki-wheel-root .tw-subscriptionDropCard{background:#fff!important;background-image:none!important;border:1px solid #e8e0ec!important;box-shadow:0 9px 22px rgba(46,28,72,.11)!important;}',
      '#toki-wheel-root .tw-side{background:#f5efff!important;background-image:none!important;border:1px solid #d9caee!important;border-top:5px solid #9a69e8!important;box-shadow:0 14px 34px rgba(51,31,82,.15)!important;color:#312044!important;backdrop-filter:none!important;-webkit-backdrop-filter:none!important;}',
      '#toki-wheel-root .tw-side::before,#toki-wheel-root .tw-side::after{content:none!important;display:none!important;background:none!important;}',
      '#toki-wheel-root .tw-sideTitle{background:#fff!important;background-image:none!important;border:1px solid #ded2ee!important;box-shadow:0 7px 18px rgba(51,31,82,.09)!important;}',
      '#toki-wheel-root .tw-sideTitle .tw-h2{color:#312044!important;text-shadow:none!important;}',
      '#toki-wheel-root .tw-sideTitle .tw-h2::before{color:#7044bd!important;background:#eee3ff!important;border-color:#d6c3f2!important;box-shadow:none!important;}',
      '#toki-wheel-root #twPinsList{background:#fff!important;background-image:none!important;border:1px solid #ded2ee!important;box-shadow:none!important;color:#312044!important;}',
      '@media(max-width:700px){#toki-wheel-root{--tw-wheelSize:min(94vw,560px);}body:not(.twStreamBody) #toki-wheel-root .tw-wheelWrap{width:min(var(--tw-wheelSize),calc(100vw - 24px - env(safe-area-inset-left,0px) - env(safe-area-inset-right,0px)))!important;height:min(var(--tw-wheelSize),calc(100vw - 24px - env(safe-area-inset-left,0px) - env(safe-area-inset-right,0px)))!important;}}'
    ].join('');
    document.head.appendChild(st);
  }
  ensureResponsiveWheelDefaultCSS();

  function presentationSafeMax(){
    var vw = Math.max(320, window.innerWidth || 320);
    var vh = Math.max(420, window.innerHeight || 420);
    var viewportRoom = vw - (vw <= 700 ? 28 : 44);
    var stageRoom = viewportRoom;
    try{
      var stageRect = R.wheelStage && R.wheelStage.getBoundingClientRect ? R.wheelStage.getBoundingClientRect() : null;
      if(stageRect && stageRect.width > 220) stageRoom = Math.max(220, stageRect.width - (vw <= 700 ? 24 : 18));
    }catch(_){ }
    var sideRoom = Math.min(viewportRoom, stageRoom);
    var verticalRoom = vh - (vw <= 700 ? 172 : 154);
    return Math.max(260, Math.min(sideRoom, verticalRoom));
  }

  function applyPresentationWheelSize(pct, save){
    if(!R.wheelWrap) return;
    pct = Math.max(45, Math.min(180, Math.round(Number(pct) || 100)));
    presentationSizePct = pct;
    var px = Math.round(presentationSafeMax() * pct / 100);
    R.wheelWrap.style.setProperty('width', px + 'px', 'important');
    R.wheelWrap.style.setProperty('height', px + 'px', 'important');
    R.wheelWrap.style.setProperty('max-width', 'none', 'important');
    R.wheelWrap.style.setProperty('max-height', 'none', 'important');
    if(R.wheelStage){
      R.wheelStage.style.setProperty('min-height', (px + 34) + 'px', 'important');
      R.wheelStage.style.setProperty('overflow', 'visible', 'important');
    }
    var dock = R.wrap && R.wrap.querySelector('.tw-presentationDock');
    if(dock){
      var range = dock.querySelector('.tw-presentationSizeRange');
      var value = dock.querySelector('.tw-presentationSizeValue');
      if(range) range.value = String(pct);
      if(value) value.textContent = pct + '%';
    }
    if(save){ try{ localStorage.setItem(PRESENTATION_SIZE_KEY, String(pct)); }catch(_){ } }
  }

  function clearPresentationWheelSize(){
    if(R.wheelWrap){
      ['width','height','max-width','max-height'].forEach(function(prop){ R.wheelWrap.style.removeProperty(prop); });
    }
    if(R.wheelStage){
      ['min-height','overflow'].forEach(function(prop){ R.wheelStage.style.removeProperty(prop); });
    }
  }

  function resetPresentationWheelSize(){
    presentationSizePct = 100;
    try{ localStorage.removeItem(PRESENTATION_SIZE_KEY); }catch(_){ }
    clearPresentationWheelSize();
  }

  function getActiveShowContext(){
    try{
      var url = new URL(window.location.href);
      var token = url.searchParams.get('stwl_show') || '';
      var step = parseInt(url.searchParams.get('stwl_step') || '0',10);
      if(!token) return null;
      var payload = U.safeJSONParse(localStorage.getItem(SHOW_SESSION_PREFIX + token) || '');
      if(!payload || (payload.schema !== 1 && payload.schema !== 2) || !Array.isArray(payload.items) || !payload.items.length) return null;
      step = Math.max(0,Math.min(payload.items.length-1,isFinite(step)?step:0));
      return { token:token, step:step, payload:payload };
    }catch(_){ return null; }
  }

  function goToShowStep(nextStep){
    var context = getActiveShowContext();
    if(!context) return;
    nextStep = Math.max(0,Math.min(context.payload.items.length-1,Number(nextStep)||0));
    var item = context.payload.items[nextStep];
    if(!item || !item.pagePath || !item.state) return;
    item.state.ui = item.state.ui || {};
    item.state.ui.overlay = true; item.state.ui.streamMode = false; item.state.ui.presentationDockClosed = 'no';
    context.payload.presentation={size:presentationSizePct,layout:presentationLayout};
    try{localStorage.setItem(SHOW_SESSION_PREFIX+context.token,U.safeJSONStringify(context.payload));}catch(_){ }
    showTransitionCurtain(context,true,function(){
      try{
        var nextState=U.clone(item.state)||item.state;
        nextState.ui=nextState.ui||{};nextState.ui.overlay=true;nextState.ui.streamMode=false;nextState.ui.presentationDockClosed='no';
        TW._showInPlaceSwitch=true;TW.state=nextState;TW.ensureState();normalizeSegments();
        var currentUrl=new URL(window.location.href);currentUrl.searchParams.set('tw_overlay','1');currentUrl.searchParams.set('stwl_show',context.token);currentUrl.searchParams.set('stwl_step',String(nextStep));window.history.replaceState(null,'',currentUrl.toString());
        if(R.modalBack)R.modalBack.hidden=true;if(R.modal){R.modal.hidden=true;R.modal.innerHTML='';}
        var oldDock=R.wrap&&R.wrap.querySelector('.tw-presentationDock');if(oldDock)oldDock.remove();
        TW.renderAll&&TW.renderAll();applyPresentationMode('overlay');ensurePresentationStageControls();
        if(TW.recenterWheel)TW.recenterWheel(false);
        TW._showInPlaceSwitch=false;var updated=getActiveShowContext();showTransitionCurtain(updated,false);
      }catch(error){
        TW._showInPlaceSwitch=false;
        try{console.warn('[STWL show] In-place wheel change failed; using safe page navigation.',error);}catch(_){ }
        var target=new URL(String(item.pagePath),window.location.origin);target.searchParams.set('tw_overlay','1');target.searchParams.set('stwl_show',context.token);target.searchParams.set('stwl_step',String(nextStep));window.location.href=target.pathname+target.search+target.hash;
      }
    });
  }

  function showTransitionCurtain(context,leaving,done){
    context=context||getActiveShowContext();if(!context){if(done)done();return;}
    var transition=context.payload.transition||{},style=String(transition.style||'vortex'),duration=Math.max(300,Math.min(2200,Number(transition.duration)||900));if(style==='none')style='still';
    var old=document.querySelector('.tw-showCurtain');
    if(!leaving&&old){old.style.setProperty('--tw-show-duration',duration+'ms');var revealStarted=false,started=Date.now();function revealWhenReady(){if(revealStarted)return;var ready=!!(R.wrap&&R.wrap.classList.contains('tw-inOverlay')&&R.wheelWrap&&R.wrap.querySelector('.tw-presentationDock'));if(!ready&&Date.now()-started<1800){requestAnimationFrame(revealWhenReady);return;}revealStarted=true;requestAnimationFrame(function(){requestAnimationFrame(function(){setTimeout(function(){old.classList.remove('is-active');old.style.opacity='0';setTimeout(function(){old.remove();},duration+80);},420);});});}revealWhenReady();return;}
    if(old)old.remove();
    var curtain=document.createElement('div');curtain.className='tw-showCurtain tw-showCurtain--'+style+(leaving?' is-entering':' is-leaving is-active');curtain.style.setProperty('--tw-show-bg',String(transition.bg||'#14102b'));curtain.style.setProperty('--tw-show-duration',duration+'ms');
    var image=document.createElement('img');image.alt='';image.src=String(transition.image||'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexsymbol.png?v=1776708669');curtain.appendChild(image);document.body.appendChild(curtain);
    if(leaving)requestAnimationFrame(function(){requestAnimationFrame(function(){curtain.classList.add('is-active');});});
    if(leaving)setTimeout(function(){if(done)done();},Math.max(120,Math.round(duration*.72)));else setTimeout(function(){curtain.classList.remove('is-active');setTimeout(function(){curtain.remove();},duration+80);},120);
  }

  function showDestinationStep(context,destination){
    if(destination==='repeat')return context.step;if(destination==='finish')return -2;if(destination==='next')return context.step<context.payload.items.length-1?context.step+1:-2;
    if(/^step:\d+$/.test(String(destination||'')))return Math.max(0,Math.min(context.payload.items.length-1,parseInt(String(destination).split(':')[1],10)||0));return -1;
  }

  function routeAfterShowWinner(){
    var context=getActiveShowContext();if(!context)return false;var route=(context.payload.routes||[])[context.step]||{mode:'manual'};if(route.mode==='manual')return false;
    var destination='next';
    if(route.mode==='target')destination=route.target||'next';
    else if(route.mode==='result'){var idx=TW.state&&TW.state._meta?TW.state._meta.lastWinnerIdx:-1,segment=(TW.state.segments||[])[idx]||{},key=idx+'|'+String(segment.label||'');destination=route.results&&route.results[key]||'next';}
    var next=showDestinationStep(context,destination);if(next===-2){showTransitionCurtain(context,true,function(){try{localStorage.removeItem(SHOW_SESSION_PREFIX+context.token);}catch(_){ }try{window.close();}catch(_){ }setTimeout(function(){if(!window.closed)window.location.href='/pages/dashboard';},100);});return true;}
    if(next>=0){goToShowStep(next);return true;}return false;
  }

  function ensureShowWinnerRouting(){
    if(TW._showRoutingObserver)return;TW._showRoutingObserver=true;
    var armed=false,routing=false;
    var observer=new MutationObserver(function(){var context=getActiveShowContext(),modal=R.modal;if(!context||!modal)return;if(!modal.hidden){armed=true;routing=false;var route=(context.payload.routes||[])[context.step]||{mode:'manual'};if(route.mode==='manual'&&!modal.querySelector('.tw-showPresenterNext')){var button=document.createElement('button');button.type='button';button.className='tw-showPresenterNext';button.textContent=context.step<context.payload.items.length-1?'Next wheel →':'Finish show';button.setAttribute('aria-label',button.textContent);button.onclick=function(event){event.preventDefault();event.stopPropagation();if(context.step<context.payload.items.length-1)goToShowStep(context.step+1);else{showTransitionCurtain(context,true,function(){try{localStorage.removeItem(SHOW_SESSION_PREFIX+context.token);}catch(_){ }try{window.close();}catch(_){ }setTimeout(function(){if(!window.closed)window.location.href='/pages/dashboard';},100);});}};modal.appendChild(button);}return;}if(armed&&!routing){armed=false;var closeRoute=(context.payload.routes||[])[context.step]||{mode:'manual'};if(closeRoute.mode==='manual')return;routing=true;setTimeout(function(){routeAfterShowWinner();},220);}});
    if(R.modal)observer.observe(R.modal,{attributes:true,attributeFilter:['hidden'],childList:true,subtree:true});
  }

  function ensureShowSequenceDock(dock){
    var context = getActiveShowContext();
    if(!dock || !context || dock.querySelector('.tw-showSequence')) return;
    var wrap=U.el('div',{class:'tw-showSequence','aria-label':'Show sequence controls'});
    var previous=U.el('button',{class:'tw-showPrevious',type:'button'},['Previous']);
    var counter=U.el('span',{class:'tw-showCounter',text:(context.step+1)+' / '+context.payload.items.length});
    var next=U.el('button',{class:'tw-showNext',type:'button'},[context.step<context.payload.items.length-1?'Next Wheel':'Finish Show']);
    previous.disabled=context.step===0;
    previous.onclick=function(){goToShowStep(context.step-1);};
    next.onclick=function(){
      if(context.step<context.payload.items.length-1) goToShowStep(context.step+1);
      else{
        showTransitionCurtain(context,true,function(){try{localStorage.removeItem(SHOW_SESSION_PREFIX+context.token);}catch(_){ }try{window.close();}catch(_){ }setTimeout(function(){if(!window.closed)window.location.href='/pages/dashboard';},100);});
      }
    };
    wrap.appendChild(previous);wrap.appendChild(counter);wrap.appendChild(next);dock.insertBefore(wrap,dock.firstChild);
  }

  function ensurePresentationStageControls(){
    if(!R.wrap || !R.wheelWrap) return;
    ensurePresentationStageCSS();
    var dock = R.wrap.querySelector('.tw-presentationDock');
    /* Rebuild the dock on every overlay entry; an old saved close must not hide it forever. */
    if(TW.state && TW.state.ui) TW.state.ui.presentationDockClosed = 'no';
    if(!dock){
      var spin = U.el('button',{class:'tw-presentationSpin',type:'button'},['Spin']);
      var smaller = U.el('button',{class:'tw-presentationSmaller',type:'button','aria-label':'Make wheel smaller'},['−']);
      var range = U.el('input',{class:'tw-presentationSizeRange',type:'range',min:'45',max:'180',step:'1',value:String(presentationSizePct),'aria-label':'Presentation wheel size'});
      var larger = U.el('button',{class:'tw-presentationLarger',type:'button','aria-label':'Make wheel larger'},['+']);
      var fit = U.el('button',{class:'tw-presentationFit',type:'button'},['Fit Screen']);
      var layout = U.el('button',{class:'tw-presentationLayout',type:'button'},[presentationLayoutLabel(presentationLayout)]);
      var closeDock = U.el('button',{class:'tw-presentationDockClose',type:'button','aria-label':'Close presentation size controls'},['×']);
      var value = U.el('span',{class:'tw-presentationSizeValue',text:presentationSizePct + '%'});
      dock = U.el('div',{class:'tw-presentationDock','aria-label':'Presentation stage controls'},[
        spin, U.el('span',{class:'tw-presentationSizeLabel',text:'Wheel size'}), smaller, range, larger, value, fit, layout, closeDock
      ]);
      spin.onclick = function(){ if(R.btnSpin && R.btnSpin.click) R.btnSpin.click(); else if(TW.startSpin) TW.startSpin({fromButton:true}); };
      smaller.onclick = function(){ applyPresentationWheelSize(presentationSizePct - 5, true); };
      larger.onclick = function(){ applyPresentationWheelSize(presentationSizePct + 5, true); };
      fit.onclick = function(){ applyPresentationWheelSize(100, true); };
      layout.onclick = function(){
        var values = ['left','center','right'];
        presentationLayout = values[(values.indexOf(presentationLayout) + 1) % values.length];
        try{ localStorage.setItem(PRESENTATION_LAYOUT_KEY, presentationLayout); }catch(_){ }
        applyPresentationArrangement();
        layout.textContent = presentationLayoutLabel(presentationLayout);
      };
      closeDock.onclick = function(ev){
        try{ ev.preventDefault(); ev.stopPropagation(); }catch(_){ }
        /* Close for this overlay visit only. It returns next time overlay opens. */
        TW.state.ui.presentationDockClosed = 'no';
        if(dock && dock.parentNode) dock.parentNode.removeChild(dock);
        var activeHandle = R.wheelWrap && R.wheelWrap.querySelector('.tw-presentationResizeHandle');
        if(activeHandle && activeHandle.parentNode) activeHandle.parentNode.removeChild(activeHandle);
      };
      range.addEventListener('input', function(){ applyPresentationWheelSize(range.value, false); });
      range.addEventListener('change', function(){ applyPresentationWheelSize(range.value, true); });
      R.wrap.appendChild(dock);
    }
    var showContext=getActiveShowContext();
    if(showContext&&showContext.step>0&&showContext.payload.presentation){presentationSizePct=Math.max(45,Math.min(180,Number(showContext.payload.presentation.size)||100));presentationLayout=String(showContext.payload.presentation.layout||'left');}
    if(showContext)dock.classList.toggle('tw-showLaterStep',showContext.step>0);
    ensureShowSequenceDock(dock);
    ensureShowWinnerRouting();
    // The presentation dock now fully replaces the old orange drag handle.
    var handle = R.wheelWrap.querySelector('.tw-presentationResizeHandle');
    if(handle && handle.parentNode) handle.parentNode.removeChild(handle);
    applyPresentationArrangement();
    var compact = false;
    try{ compact = !!(window.matchMedia && window.matchMedia('(max-width:1024px)').matches); }catch(_){ }
    applyPresentationWheelSize(compact ? 100 : presentationSizePct, false);
    if(!TW._showArrivalDone && getActiveShowContext()){
      TW._showArrivalDone=true;
      showTransitionCurtain(getActiveShowContext(),false);
    }
  }

  function removePresentationStageControls(){
    try{
      if(R.wrap){
        var dock = R.wrap.querySelector('.tw-presentationDock');
        if(dock && dock.parentNode) dock.parentNode.removeChild(dock);
      }
      if(R.wheelWrap){
        var handle = R.wheelWrap.querySelector('.tw-presentationResizeHandle');
        if(handle && handle.parentNode) handle.parentNode.removeChild(handle);
      }
      clearPresentationWheelSize();
      ['standard','left','center','right'].forEach(function(name){ if(R.wrap) R.wrap.classList.remove('tw-overlayLayout-' + name); });
      ['center','left','right','top'].forEach(function(name){ document.body.classList.remove('twWinnerPos-' + name); });
    }catch(_){ }
  }

  function vortexStickerAllowed(item){
    if(!item || !item.id) return false;
    if(!item.tier) return true;
    return !!(TW.access && TW.access.hasPlan && TW.access.hasPlan(item.tier));
  }

  TW.findStickerSuggestion = function(query, excludedIds){
    var lib = (TW.CONST && Array.isArray(TW.CONST.SEGMENT_IMAGE_LIBRARY)) ? TW.CONST.SEGMENT_IMAGE_LIBRARY : [];
    excludedIds = excludedIds || {};
    var stop = {the:1,and:1,for:1,with:1,from:1,into:1,your:1,this:1,that:1,game:1,idea:1};
    var words = String(query || '').toLowerCase().replace(/[^a-z0-9 ]+/g,' ').split(/\s+/).filter(function(word){ return word.length > 2 && !stop[word]; });
    if(!words.length) return null;
    var best = null, bestScore = 0;
    lib.forEach(function(item){
      if(!vortexStickerAllowed(item) || excludedIds[item.id]) return;
      var name = String(item.name || '').toLowerCase();
      var hay = (name + ' ' + String(item.tags || '')).toLowerCase();
      var score = 0;
      words.forEach(function(word){
        if(name === word || name.indexOf(word) !== -1) score += 6;
        else if(hay.indexOf(word) !== -1) score += 2;
      });
      if(score > bestScore){ bestScore = score; best = item; }
    });
    return bestScore >= 2 ? best : null;
  };

  TW.setSegments = function(labels, opts){
    opts = opts || {};
    labels = (labels||[]).map(function(s){ return (s||'').trim(); }).filter(Boolean);
    if(!labels.length) return;

    TW.pushUndo && TW.pushUndo();
    TW.state.segments = [];
    if(TW._closeColorPopover) TW._closeColorPopover();

    // addSegments pushes undo, so we bypass it by directly constructing entries
    normalizeSegments();
    var segs = TW.state.segments;
    var usedStickerIds = {};
    for(var i=0;i<labels.length;i++){
      if(segs.length >= (TW.CONST && TW.CONST.MAX_SEGMENTS ? TW.CONST.MAX_SEGMENTS : 1000)) break;
      var detail = opts.details && opts.details[i] ? opts.details[i] : {};
      var colors = Array.isArray(opts.colors) ? opts.colors : [];
      var chosenColor = colors.length ? colors[i % colors.length] : (TW.pickColorForIndex ? TW.pickColorForIndex(segs.length) : '#7a3cff');
      var hasStickerChoice = Object.prototype.hasOwnProperty.call(detail, 'useSticker');
      var sticker = hasStickerChoice ? (detail.useSticker && detail.stickerUrl ? { id:String(detail.stickerId || ''), url:String(detail.stickerUrl) } : null) : (opts.stickerMode === 'apply' ? TW.findStickerSuggestion(detail.stickerSearch, usedStickerIds) : null);
      if(sticker) usedStickerIds[sticker.id] = true;
      var suggestion = opts.stickerMode === 'suggest' ? TW.findStickerSuggestion(detail.stickerSearch, usedStickerIds) : null;
      if(suggestion) usedStickerIds[suggestion.id] = true;
      segs.push({
        label: labels[i],
        resultLabel: String(detail.resultLabel || detail.fullText || labels[i]).slice(0,55),
        fullText: String(detail.fullText || labels[i]),
        revealClue: String(detail.revealClue || '').slice(0,90),
        revealAnswer: String(detail.revealAnswer || '').slice(0,70),
        category: String(detail.category || ''),
        weight: Number(detail.weight || 1),
        color: chosenColor,
        tcolor: vortexTextColor(chosenColor),
        sliceImgId: sticker ? sticker.id : '',
        sliceImgUrl: sticker ? sticker.url : '',
        suggestedSliceImgId: suggestion ? suggestion.id : '',
        vortexWinner: opts.winnerExperience || null
      });
    }

    TW.renderAll && TW.renderAll();
    TW.saveSoon && TW.saveSoon();
  };

  TW.addSegmentsNoUndo = function(labels, opts){
    opts = opts || {};
    labels = (labels||[]).map(function(s){ return (s||'').trim(); }).filter(Boolean);
    if(!labels.length) return;
    normalizeSegments();
    var segs = TW.state.segments;
    var usedStickerIds = {};
    for(var i=0;i<labels.length;i++){
      if(segs.length >= (TW.CONST && TW.CONST.MAX_SEGMENTS ? TW.CONST.MAX_SEGMENTS : 1000)) break;
      var detail = opts.details && opts.details[i] ? opts.details[i] : {};
      var colors = Array.isArray(opts.colors) ? opts.colors : [];
      var chosenColor = colors.length ? colors[i % colors.length] : (TW.pickColorForIndex ? TW.pickColorForIndex(segs.length) : '#7a3cff');
      var hasStickerChoice = Object.prototype.hasOwnProperty.call(detail, 'useSticker');
      var sticker = hasStickerChoice ? (detail.useSticker && detail.stickerUrl ? { id:String(detail.stickerId || ''), url:String(detail.stickerUrl) } : null) : (opts.stickerMode === 'apply' ? TW.findStickerSuggestion(detail.stickerSearch, usedStickerIds) : null);
      if(sticker) usedStickerIds[sticker.id] = true;
      var suggestion = opts.stickerMode === 'suggest' ? TW.findStickerSuggestion(detail.stickerSearch, usedStickerIds) : null;
      if(suggestion) usedStickerIds[suggestion.id] = true;
      segs.push({
        label: labels[i],
        resultLabel: String(detail.resultLabel || detail.fullText || labels[i]).slice(0,55),
        fullText: String(detail.fullText || labels[i]),
        revealClue: String(detail.revealClue || '').slice(0,90),
        revealAnswer: String(detail.revealAnswer || '').slice(0,70),
        category: String(detail.category || ''),
        weight: Number(detail.weight || 1),
        color: chosenColor,
        tcolor: vortexTextColor(chosenColor),
        sliceImgId: sticker ? sticker.id : '',
        sliceImgUrl: sticker ? sticker.url : '',
        suggestedSliceImgId: suggestion ? suggestion.id : '',
        vortexWinner: opts.winnerExperience || null
      });
    }
    TW.renderAll && TW.renderAll();
    TW.saveSoon && TW.saveSoon();
  };


  // =========================================================
  // ✅ FIX: UNDO guard
  // =========================================================
  TW._undoGuard = TW._undoGuard || { lastT: 0 };
  TW.undo = function(){
    var now = Date.now();
    if(now - (TW._undoGuard.lastT||0) < 220) return;
    TW._undoGuard.lastT = now;

    var st = TW._undo && TW._undo.stack && TW._undo.stack.pop();
    if(!st) return;

    TW.state = st;
    TW.ensureState();
    TW.renderAll && TW.renderAll();
    TW.saveSoon();
  };

  // =========================================================
  // ✅ SAFARI “CLEAR BADGE” HARD FIX
  // =========================================================
  function forceClearCenterBadgeIfEmpty(){
    try{
      if(!R || !R.centerImg) return;

      var ui = (TW.state && TW.state.ui) ? TW.state.ui : {};
      var url = String(ui.centerBadgeUrl || '').trim();

      // only enforce when it SHOULD be cleared
      if(url) {
        try{ R.centerImg.style.opacity = ''; R.centerImg.style.display = ''; }catch(_){}
        return;
      }

      var img = R.centerImg;

      try{ img.removeAttribute('href'); }catch(_){}
      try{ img.removeAttribute('xlink:href'); }catch(_){}
      try{
        img.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '');
      }catch(_){}

      try{ img.style.opacity = '0'; img.style.pointerEvents = 'none'; }catch(_){}

      try{
        if(img && img.parentNode && img.cloneNode){
          var clone = img.cloneNode(true);
          try{ clone.removeAttribute('href'); }catch(_){}
          try{ clone.removeAttribute('xlink:href'); }catch(_){}
          try{ clone.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', ''); }catch(_){}
          try{ clone.style.opacity = '0'; clone.style.pointerEvents = 'none'; }catch(_){}
          img.parentNode.replaceChild(clone, img);
          R.centerImg = clone;
        }
      }catch(_){}
    }catch(_){}
  }

  // =========================================================
  // ✅ BADGE RESET FIX (real fix):
  // "Reset badge" must NEVER clear URL.
  // It must restore the CURRENT badge’s default geometry (scale/offX/offY)
  // captured when that badge was first set (or from preset load).
  // =========================================================
  function ensureBadgeBaselines(){
    try{
      TW.state.ui = TW.state.ui || {};
      if(!TW.state.ui.badgeBaselines || typeof TW.state.ui.badgeBaselines !== 'object'){
        TW.state.ui.badgeBaselines = {};
      }
    }catch(_){}
  }

  function badgeKeyFromUI(){
    try{
      var ui = TW.state && TW.state.ui ? TW.state.ui : {};
      return String(ui.centerBadgeUrl || '').trim();
    }catch(_){
      return '';
    }
  }

  function captureBaselineForCurrentBadge(force){
    try{
      ensureBadgeBaselines();
      var ui = TW.state && TW.state.ui ? TW.state.ui : {};
      var key = badgeKeyFromUI();
      if(!key) return;

      var map = ui.badgeBaselines;
      if(!force && map[key]) return;

      map[key] = {
        mask: String(ui.centerBadgeMask || ''),
        scale: (ui.centerBadgeScale != null && parseFloat(ui.centerBadgeScale) > 0) ? parseFloat(ui.centerBadgeScale) : 1,
        offX: (ui.centerBadgeOffX != null && isFinite(ui.centerBadgeOffX)) ? parseFloat(ui.centerBadgeOffX) : 0,
        offY: (ui.centerBadgeOffY != null && isFinite(ui.centerBadgeOffY)) ? parseFloat(ui.centerBadgeOffY) : 0
      };
    }catch(_){}
  }

  function applyBaselineForCurrentBadge(){
    try{
      ensureBadgeBaselines();
      TW.state.ui = TW.state.ui || {};
      var ui = TW.state.ui;
      var key = badgeKeyFromUI();
      if(!key) return;

      var b = ui.badgeBaselines && ui.badgeBaselines[key];
      if(!b){
        // if none exists yet, capture now and use it
        captureBaselineForCurrentBadge(true);
        b = ui.badgeBaselines && ui.badgeBaselines[key];
      }
      if(!b) return;

      // ✅ never touch centerBadgeUrl (THIS is the bug you described)
      ui.centerBadgeScale = (b.scale != null && b.scale > 0) ? b.scale : 1;
      ui.centerBadgeOffX  = isFinite(b.offX) ? b.offX : 0;
      ui.centerBadgeOffY  = isFinite(b.offY) ? b.offY : 0;
      if(R.rangeBadgeScale) R.rangeBadgeScale.value = String(ui.centerBadgeScale);

      // restore mask only if missing (don’t overwrite purposeful changes)
      if(!String(ui.centerBadgeMask || '') && b.mask){
        ui.centerBadgeMask = b.mask;
      }

      TW.renderWheel && TW.renderWheel();
      TW.saveSoon && TW.saveSoon();
    }catch(_){}
  }

  function patchResetBadgeButton(){
    try{
      // try refs first, then DOM text scan
      var btn = R.btnResetBadge || R.btnBadgeReset || null;

      if(!btn && R.wrap && R.wrap.querySelectorAll){
        var all = R.wrap.querySelectorAll('button');
        for(var i=0;i<all.length;i++){
          var t = (all[i].textContent || '').trim().toLowerCase();
          if(t === 'reset badge' || t === 'reset badge position' || t.indexOf('reset badge') !== -1){
            btn = all[i];
            break;
          }
        }
      }

      if(!btn || btn.__twResetBadgePatched) return;
      btn.__twResetBadgePatched = true;

      // IMPORTANT: do NOT call the original onclick (it clears the badge in some builds)
      btn.onclick = function(ev){
        try{
          ev && ev.preventDefault && ev.preventDefault();
          ev && ev.stopPropagation && ev.stopPropagation();
        }catch(_){}
        try{
          if(TW.pushUndo) TW.pushUndo();
          applyBaselineForCurrentBadge();
        }catch(_){}
      };
    }catch(_){}
  }

  // ✅ IMPORTANT: Part2 binds Reset Badge via addEventListener('click', ...)
  // so overriding onclick is NOT enough. Use a capture listener that stops
  // the original handler so the badge is never cleared/recentered.
  function installResetBadgeCapture(){
    try{
      if(TW._resetBadgeCaptureInstalled) return;
      TW._resetBadgeCaptureInstalled = true;

      document.addEventListener('click', function(ev){
        try{
          var t = ev && ev.target;
          if(!t) return;

          var btn = null;
          // clicks can hit inner spans
          if(t.tagName && String(t.tagName).toLowerCase() === 'button') btn = t;
          else if(t.closest) btn = t.closest('button');
          if(!btn) return;

          var txt = (btn.textContent || '').trim().toLowerCase();
          if(txt !== 'reset badge position' && txt !== 'reset badge' && txt.indexOf('reset badge') === -1) return;

          // stop the Part2 handler (which recenters + scale=1)
          try{ ev.preventDefault && ev.preventDefault(); }catch(_){ }
          try{ ev.stopPropagation && ev.stopPropagation(); }catch(_){ }
          try{ ev.stopImmediatePropagation && ev.stopImmediatePropagation(); }catch(_){ }

          try{ if(TW.pushUndo) TW.pushUndo(); }catch(_){ }
          applyBaselineForCurrentBadge();
        }catch(_){ }
      }, true);
    }catch(_){ }
  }

  // ✅ iOS: hot-apply volume changes to cached reusable audios
  // (some iOS builds are picky unless volume is set on the actual element).
  function installVolumeHotApply(){
    try{
      if(TW._volHotApplyInstalled) return;
      TW._volHotApplyInstalled = true;

      function hotApply(){
        try{
          var sv = getSpinVol();
          var wv = getWinVol();

          try{ if(TW._rt && TW._rt.spinAudio){ TW._rt.spinAudio.muted = false; TW._rt.spinAudio.defaultMuted = false; TW._rt.spinAudio.volume = sv; } }catch(_){ }
          try{ if(TW._rt && TW._rt.lastWinAudio){ TW._rt.lastWinAudio.muted = false; TW._rt.lastWinAudio.defaultMuted = false; TW._rt.lastWinAudio.volume = wv; } }catch(_){ }

          try{
            var map = TW._audCache && TW._audCache.byUrl;
            if(map){
              var spinUrl = String((((TW.CONST || {}).MAIN_SPIN_SOUND || {}).url) || '');
              var winUrl = '';
              try{
                var picked = ((TW.CONST.CELEBRATION_SOUNDS||[]).find(function(x){ return x.id === (TW.state.ui.winSoundId||'air_zing'); }) || (TW.CONST.CELEBRATION_SOUNDS||[])[0] || {});
                winUrl = String(picked.url || '');
              }catch(_){ }
              var preUrl = '';
              try{
                var pre = ((TW.CONST.PRESPIN_SOUNDS||[]).find(function(x){ return x.id === (TW.state.ui.spinSoundId||'retro_reactor'); }) || (TW.CONST.PRESPIN_SOUNDS||[])[0] || {});
                preUrl = String(pre.url || '');
              }catch(_){ }
              var retUrl = String((((TW.CONST || {}).RETURN_SOUND || {}).url) || '');

              Object.keys(map).forEach(function(k){
                var a = map[k];
                if(!a) return;
                try{ a.muted = false; a.defaultMuted = false; }catch(_){ }
                try{
                  if(String(k) === spinUrl || String(k) === preUrl || String(k) === retUrl){
                    a.volume = sv;
                  }else if(String(k) === winUrl){
                    a.volume = wv;
                  }
                }catch(_){ }
              });
            }
          }catch(_){ }
        }catch(_){ }
      }

      document.addEventListener('input', function(ev){
        try{
          var el = ev && ev.target;
          if(!el) return;
          if(el === R.rangeSpinVol || el === R.rangeWinVol){ hotApply(); return; }
          if(!(el.tagName && String(el.tagName).toLowerCase() === 'input')) return;
          if(String(el.type || '').toLowerCase() !== 'range') return;
          hotApply();
        }catch(_){ }
      }, true);

      document.addEventListener('change', function(ev){
        try{
          var el = ev && ev.target;
          if(el === R.rangeSpinVol || el === R.rangeWinVol) hotApply();
        }catch(_){ }
      }, true);

      setTimeout(hotApply, 0);
      setTimeout(hotApply, 250);
      setTimeout(hotApply, 900);
    }catch(_){ }
  }


  // Track when badge URL changes so we can baseline that badge once
  TW._lastBadgeUrlSeen = TW._lastBadgeUrlSeen || '';
  function observeBadgeUrlChanges(){
    try{
      var cur = badgeKeyFromUI();
      if(cur && cur !== TW._lastBadgeUrlSeen){
        TW._lastBadgeUrlSeen = cur;
        captureBaselineForCurrentBadge(false);
      }
      if(!cur){
        TW._lastBadgeUrlSeen = '';
      }
    }catch(_){}
  }

  // =========================================================
  // ✅ VOICE FIX (APPLE) — keep your TTS plumbing, but session-only ON/OFF
  // =========================================================
  var voices = [];
  var _primedSpeech = false;
  var _ttsReady = false;

  // 2026-05-09C VOICE SURGICAL FIX:
  // Apple WebKit often starts speaking without firing SpeechSynthesisUtterance.onstart.
  // If we run the Chrome/Android start watchdog on Apple, it can retry the same
  // utterance while the first one is already audible, creating the doubled/overlapped
  // voice the user heard. Android/Chrome still needs the watchdog for Default voice.
  function isAppleWebKitVoiceDevice(){
    try{
      var ua = String(navigator.userAgent || '');
      var platform = String(navigator.platform || '');
      var touchMac = platform === 'MacIntel' && navigator.maxTouchPoints > 1;
      return /iPad|iPhone|iPod/i.test(ua) || touchMac || (/Safari/i.test(ua) && /Apple/i.test(navigator.vendor || ''));
    }catch(_){ return false; }
  }

  function isAndroidVoiceDevice(){
    try{ return /Android/i.test(String(navigator.userAgent || '')); }catch(_){ return false; }
  }

  function findTopActionsHost(){
    try{
      if(!R.root || !R.root.querySelector) return null;
      return (
        R.root.querySelector('.tw-headerMoreMenu .tw-menuList') ||
        R.root.querySelector('.tw-header .tw-actions') ||
        R.root.querySelector('.tw-actions') ||
        null
      );
    }catch(_){
      return null;
    }
  }

  function findHeaderVoiceButtons(){
    var host = findTopActionsHost();
    if(!host || !host.querySelectorAll) return { host: host, btns: [] };

    var btns = [];
    var all = host.querySelectorAll('button');
    for(var i=0;i<all.length;i++){
      var t = (all[i].textContent || '').trim().toLowerCase();
      if(all[i].id === 'twVoiceToggle' || (all[i].classList && all[i].classList.contains('tw-voiceToggle')) || t.indexOf('voice:') === 0 || t === 'voice' || t.indexOf('voice ') === 0){
        btns.push(all[i]);
      }
    }
    return { host: host, btns: btns };
  }

  function loadVoices(){
    try{
      voices = window.speechSynthesis ? window.speechSynthesis.getVoices() : [];
    }catch(_){ voices = []; }

    if(R.selVoice){
      var sel = R.selVoice;
      var current = (TW.state && TW.state.ui && TW.state.ui.voiceName) ? TW.state.ui.voiceName : '';
      sel.innerHTML = '';
      sel.appendChild(U.el('option', { value:'', text:'Default device voice' }));
      voices.forEach(function(v){
        var opt = U.el('option', { value: v.name, text: v.name + (v.lang?(' ('+v.lang+')'):'') });
        sel.appendChild(opt);
      });
      sel.value = current;
      if(sel._twMenuSyncLabel) sel._twMenuSyncLabel();
    }
  }

  if(window.speechSynthesis){
    window.speechSynthesis.onvoiceschanged = loadVoices;
  }
  setTimeout(loadVoices, 200);

  function safeCancel(){
    try{
      if(!window.speechSynthesis) return;
      // 2026-05-08J: always clear the browser speech queue.
      // The previous _ttsReady guard let priming/test utterances stay queued,
      // which caused random winner phrases to fire when pressing Voice or Record.
      try{ TW._activeSpeechUtterId = (TW._activeSpeechUtterId || 0) + 1; }catch(_){}
      window.speechSynthesis.cancel();
    }catch(_){}
  }

  function primeSpeechSynthesis(force){
    if(_primedSpeech && !force) return;
    if(!window.speechSynthesis) return;

    if(!_primedSpeech) _primedSpeech = true;
    _ttsReady = true;

    // 2026-05-08J: Prime must never leave audible or meaningful text in the queue.
    // We only resume/load voices here. A tiny blank utterance is used once per
    // gesture to unlock iOS, then any later real speech starts from a clean queue.
    try{ window.speechSynthesis.resume(); }catch(_){}

    try{
      var u = new SpeechSynthesisUtterance(' ');
      u.volume = 0.001;
      u.rate = 1;
      u.pitch = 1;
      u.onend = function(){ _ttsReady = true; };
      u.onerror = function(){ _ttsReady = true; };
      window.speechSynthesis.speak(u);
    }catch(_){
      _ttsReady = true;
    }

    setTimeout(loadVoices, 50);
    setTimeout(loadVoices, 250);
  }

  // =========================================================
  // ✅ AUDIO BRIDGE (APPLE):
  // - "arm" resumes AudioContext on gesture (improves iOS playback reliability)
  // - also primes tiny silent audio element once
  // =========================================================
  TW.audioBridge = TW.audioBridge || (function(){
    var armed = false;
    var ctx = null;

    function arm(){
      if(armed) return;
      armed = true;

      // WebAudio resume (best iOS unlock)
      try{
        var AC = window.AudioContext || window.webkitAudioContext;
        if(AC){
          ctx = new AC();
          if(ctx && ctx.state === 'suspended'){
            ctx.resume().catch(function(){});
          }else if(ctx && ctx.resume){
            ctx.resume().catch(function(){});
          }

          // tiny silent tick
          try{
            var o = ctx.createOscillator();
            var g = ctx.createGain();
            g.gain.value = 0;
            o.connect(g); g.connect(ctx.destination);
            o.start(0);
            o.stop(ctx.currentTime + 0.02);
          }catch(_){}
        }
      }catch(_){}

      // HTMLAudio prime
      try{
        var a = new Audio();
        a.src = 'data:audio/mp3;base64,//uQZAAAAAAAAAAAAAAAAAAAAAAAWGluZwAAAA8AAAACAAACcQCA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA';
        a.muted = true;
        a.defaultMuted = true;
        a.volume = 0;
        a.play().then(function(){
          try{ a.pause(); a.currentTime = 0; }catch(_){}
        }).catch(function(){});
      }catch(_){}
    }

    return { arm: arm, _ctx: function(){ return ctx; } };
  })();

  // Prime on the FIRST user gesture anywhere (best iOS compatibility)
  function attachPrimeToGestures(){
    function oncePrime(){
      primeSpeechSynthesis(false);
      try{ TW.audioBridge && TW.audioBridge.arm && TW.audioBridge.arm(); }catch(_){}
      document.removeEventListener('pointerdown', oncePrime, true);
      document.removeEventListener('touchstart', oncePrime, true);
      document.removeEventListener('mousedown', oncePrime, true);
      document.removeEventListener('keydown', oncePrime, true);
    }
    document.addEventListener('pointerdown', oncePrime, true);
    document.addEventListener('touchstart', oncePrime, true);
    document.addEventListener('mousedown', oncePrime, true);
    document.addEventListener('keydown', oncePrime, true);
  }
  attachPrimeToGestures();

  document.addEventListener('visibilitychange', function(){
    try{
      if(document.visibilityState === 'visible'){
        // Do not re-prime audible speech plumbing unless Voice is actually on.
        // This avoids Apple replay/overlap when the page becomes visible again.
        if(isVoiceOn()){
          primeSpeechSynthesis(true);
          try{ TW.audioBridge && TW.audioBridge.arm && TW.audioBridge.arm(); }catch(_){}
        }
        setTimeout(loadVoices, 80);
      }
    }catch(_){}
  }, { passive:true });

  if(R.selVoice){
    R.selVoice.addEventListener('change', function(){
      primeSpeechSynthesis(true);
      TW.pushUndo();
      TW.state.ui.voiceName = R.selVoice.value || '';
      var v = voices.find(function(x){ return x.name === TW.state.ui.voiceName; });
      TW.state.ui.voiceURI = v ? (v.voiceURI || '') : '';
      TW.state.ui.voiceLang = v ? (v.lang || '') : '';
      TW.saveSoon();
    });
  }

  function buildRecordedPhraseAudio(force){
    try{
      TW.state.ui = TW.state.ui || {};
      var url = String(TW.state.ui.recordedPhraseDataUrl || '');
      if(!url) return null;

      if(!force && TW._recordedPhraseAudio && TW._recordedPhraseAudioUrl === url){
        return TW._recordedPhraseAudio;
      }

      var a = new Audio(url);
      a.preload = 'auto';
      a.playsInline = true;
      try{ a.setAttribute('playsinline', ''); a.setAttribute('webkit-playsinline', ''); }catch(_){ }

      TW._recordedPhraseAudio = a;
      TW._recordedPhraseAudioUrl = url;
      TW._recordedPhraseAudioArmed = false;
      return a;
    }catch(_){
      return null;
    }
  }

  TW.primeRecordedPhraseAudio = function(){
    try{
      var a = buildRecordedPhraseAudio(false);
      if(!a) return;
      try{ TW.audioBridge && TW.audioBridge.arm && TW.audioBridge.arm(); }catch(_){ }
      try{ a.pause(); }catch(_){ }
      try{ a.currentTime = 0; }catch(_){ }
      try{ a.muted = true; a.defaultMuted = true; a.volume = 0.00001; }catch(_){ }
      var p = a.play();
      if(p && p.then){
        p.then(function(){
          try{ a.pause(); }catch(_){ }
          try{ a.currentTime = 0; }catch(_){ }
          try{ a.muted = false; a.defaultMuted = false; }catch(_){ }
          TW._recordedPhraseAudioArmed = true;
        }).catch(function(){
          try{ a.muted = false; a.defaultMuted = false; }catch(_){ }
        });
      }else{
        setTimeout(function(){
          try{ a.pause(); }catch(_){ }
          try{ a.currentTime = 0; }catch(_){ }
          try{ a.muted = false; a.defaultMuted = false; }catch(_){ }
          TW._recordedPhraseAudioArmed = true;
        }, 60);
      }
    }catch(_){ }
  };

  function pickVoice(){
    var name = TW.state.ui.voiceName || '';
    var uri = TW.state.ui.voiceURI || '';
    var lang = TW.state.ui.voiceLang || '';

    var v = null;
    if(uri){
      v = voices.find(function(x){ return x.voiceURI === uri; }) || null;
    }
    if(!v && name){
      v = voices.find(function(x){ return x.name === name; }) || null;
    }
    if(!v && lang){
      v = voices.find(function(x){ return x.lang === lang; }) || null;
    }

    // APPLE VOICE SURGICAL FIX 2026-05-08I:
    // If the user has not chosen a voice yet, pick a real browser voice instead
    // of leaving SpeechSynthesisUtterance.voice empty. This makes the default
    // voice deterministic across Safari/Chrome/Windows.
    if(!v && voices && voices.length){
      // SURGICAL 2026-06-02: Samsung/Android Chrome often fails when the
      // utterance is left on the vague browser default. Prefer a real English
      // voice first, then the device default, then the first available voice.
      if(isAndroidVoiceDevice()){
        v = voices.find(function(x){ return x && /^en[-_]/i.test(x.lang || '') && /google|samsung|english/i.test((x.name || '') + ' ' + (x.voiceURI || '')); }) ||
            voices.find(function(x){ return x && /^en[-_]/i.test(x.lang || ''); }) ||
            voices.find(function(x){ return x && x.default; }) ||
            voices[0] || null;
      }else{
        v = voices.find(function(x){ return x && x.default; }) ||
            voices.find(function(x){ return x && /^en[-_]/i.test(x.lang || ''); }) ||
            voices[0] || null;
      }
    }
    return v;
  }

  function estimateSpeechMs(text){
    // Conservative fallback for Safari/iOS where onend can be flaky.
    var len = String(text || '').trim().length;
    return Math.min(5200, Math.max(900, 520 + (len * 75)));
  }

  function ensureVoicesThen(callback, attempt){
    attempt = attempt || 0;
    try{ loadVoices(); }catch(_){ }

    // If a specific voice was chosen, or voices are available, continue now.
    // If Default device voice is selected on Android/Chrome, wait briefly for
    // getVoices() to populate so we can assign a real default voice instead of
    // leaving utterance.voice empty.
    var hasChosenVoice = !!(TW.state && TW.state.ui && TW.state.ui.voiceName);
    if(hasChosenVoice || (voices && voices.length) || attempt >= (isAndroidVoiceDevice() ? 12 : 6)){
      callback();
      return;
    }

    var delay = isAndroidVoiceDevice() ? 260 : 140;
    setTimeout(function(){ ensureVoicesThen(callback, attempt + 1); }, delay);
  }

  function speakUtter(text, onend, _didRetry){
    text = String(text || '').trim();
    if(!text){ if(onend) onend(); return; }
    if(!window.speechSynthesis) return onend && onend();

    // 2026-05-09C ANDROID DEFAULT-VOICE FIX:
    // Samsung/Android Chrome may not speak while the dropdown remains on
    // "Default device voice" until getVoices() has populated. Wait a few short
    // beats for real voices before building the utterance. This avoids forcing
    // the user to choose a named voice manually.
    if(!_didRetry && (!voices || !voices.length) && !(TW.state && TW.state.ui && TW.state.ui.voiceName)){
      ensureVoicesThen(function(){ speakUtter(text, onend, true); }, 0);
      return;
    }

    _ttsReady = true;
    try{ window.speechSynthesis.resume(); }catch(_){ }

    try{
      var u = new SpeechSynthesisUtterance(text);

      // Token prevents old onend/onerror/watchdog callbacks from a cancelled
      // utterance from advancing a newer voice sequence.
      TW._activeSpeechUtterId = (TW._activeSpeechUtterId || 0) + 1;
      var utterId = TW._activeSpeechUtterId;
      function isCurrentUtter(){ return utterId === TW._activeSpeechUtterId; }

      u.volume = U.clamp(TW.state.ui.voiceVolume == null ? 0.85 : TW.state.ui.voiceVolume, 0, 1);

      var v = pickVoice();
      if(v){
        u.voice = v;
        if(v.lang) u.lang = v.lang;
      }else if(TW.state.ui.voiceLang){
        u.lang = TW.state.ui.voiceLang;
      }else{
        u.lang = (navigator.language && /^en/i.test(navigator.language)) ? navigator.language : 'en-US';
      }

      var finished = false;
      var fallbackTimer = null;
      var startWatchdog = null;
      var didStart = false;
      var startedAt = Date.now();
      var appleVoice = isAppleWebKitVoiceDevice();

      function reallyFinish(){
        if(finished || !isCurrentUtter()) return;
        finished = true;
        try{ clearTimeout(fallbackTimer); }catch(_){ }
        try{ clearTimeout(startWatchdog); }catch(_){ }
        if(onend) setTimeout(function(){ if(isCurrentUtter()) onend(); }, 220);
      }

      function finish(){
        if(finished || !isCurrentUtter()) return;

        try{
          if(window.speechSynthesis && window.speechSynthesis.speaking && (Date.now() - startedAt) < 9000){
            fallbackTimer = setTimeout(finish, 300);
            return;
          }
        }catch(_){ }

        reallyFinish();
      }

      u.onstart = function(){ if(isCurrentUtter()){ didStart = true; startedAt = Date.now(); } };
      u.onend = reallyFinish;
      u.onerror = function(){
        if(!isCurrentUtter()) return;
        try{ clearTimeout(fallbackTimer); }catch(_){ }
        try{ clearTimeout(startWatchdog); }catch(_){ }
        if(!_didRetry && !appleVoice){
          setTimeout(function(){
            if(!isCurrentUtter()) return;
            loadVoices();
            speakUtter(text, onend, true);
          }, 360);
          return;
        }
        reallyFinish();
      };

      fallbackTimer = setTimeout(finish, Math.max(estimateSpeechMs(text), appleVoice ? 2200 : 1600));
      window.speechSynthesis.speak(u);

      // Chrome/Android/Windows default voice sometimes accepts an utterance but
      // never starts it until voices are loaded. Keep this retry OFF on Apple,
      // because Apple may speak without onstart and the retry creates overlap.
      if(!_didRetry && !appleVoice){
        startWatchdog = setTimeout(function(){
          if(finished || didStart || !isCurrentUtter()) return;
          try{
            if(window.speechSynthesis && (window.speechSynthesis.speaking || window.speechSynthesis.pending)){
              // It is alive even if onstart did not fire. Do not duplicate it.
              return;
            }
          }catch(_){ }
          try{ clearTimeout(fallbackTimer); }catch(_){ }
          try{ window.speechSynthesis.cancel(); }catch(_){ }
          try{ loadVoices(); }catch(_){ }
          speakUtter(text, onend, true);
        }, isAndroidVoiceDevice() ? 1500 : 1100);
      }
    }catch(_){
      if(!_didRetry){
        setTimeout(function(){
          loadVoices();
          speakUtter(text, onend, true);
        }, 360);
        return;
      }
      if(onend) onend();
    }
  }

  function playRecordedPhrase(done){
    var url = TW.state.ui.recordedPhraseDataUrl || '';
    if(!url) return done();

    try{ TW.audioBridge && TW.audioBridge.arm && TW.audioBridge.arm(); }catch(_){ }

    try{
      var a = buildRecordedPhraseAudio(false);
      if(!a) return done();

      a.volume = U.clamp(TW.state.ui.voiceVolume == null ? 0.85 : TW.state.ui.voiceVolume, 0, 1);
      try{ a.muted = false; a.defaultMuted = false; }catch(_){ }

      var finished = false;
      var started = false;
      var retried = false;
      var hardTimer = null;

      function cleanupHandlers(){
        try{ a.onended = null; a.onerror = null; a.onplay = null; a.onplaying = null; }catch(_){ }
      }

      function finish(){
        if(finished) return;
        finished = true;
        try{ clearTimeout(hardTimer); }catch(_){ }
        cleanupHandlers();
        try{ a.pause(); }catch(_){ }
        try{ a.currentTime = 0; }catch(_){ }
        // Give iOS a tiny breath before starting speech synthesis.
        setTimeout(done, 180);
      }

      function abortAndContinue(){
        // If iOS refuses to play the recorded intro, do NOT let it drift in late
        // after the segment name. Stop it before continuing.
        if(finished) return;
        try{ a.pause(); }catch(_){ }
        try{ a.currentTime = 0; }catch(_){ }
        finish();
      }

      function markStarted(){ started = true; }

      a.onplay = markStarted;
      a.onplaying = markStarted;
      a.onended = finish;
      a.onerror = function(){
        if(started) finish();
        else abortAndContinue();
      };

      try{ a.pause(); }catch(_){ }
      try{ a.currentTime = 0; }catch(_){ }
      // Do not call load() immediately before play() on Safari. It can reset the
      // media pipeline and cause the segment speech to fire before the recording.

      function attemptPlay(){
        try{
          var p = a.play();
          if(p && p.then){
            p.then(function(){ started = true; }).catch(function(){
              if(retried){ abortAndContinue(); return; }
              retried = true;
              setTimeout(function(){
                try{ a.currentTime = 0; }catch(_){ }
                attemptPlay();
              }, 180);
            });
          }
        }catch(_){
          if(retried){ abortAndContinue(); return; }
          retried = true;
          setTimeout(attemptPlay, 180);
        }
      }

      attemptPlay();

      hardTimer = setTimeout(function(){
        if(started) finish();
        else abortAndContinue();
      }, 12000);
    }catch(_){
      done();
    }
  }

  function updateVoiceHeaderUI(){
    try{
      syncVoiceStateFromSession();
      var found = findHeaderVoiceButtons();
      var btns = found.btns || [];
      if(!btns.length) return;

      var keep = btns[btns.length - 1];

      for(var i=0;i<btns.length-1;i++){
        try{ btns[i].parentNode && btns[i].parentNode.removeChild(btns[i]); }catch(_){}
      }

      // 2026-05-08K: replace the surviving Voice button with a clone one time.
      // This removes older Part4 addEventListener handlers that can toggle a
      // second voice state behind our back. The Voice button must ONLY toggle
      // voice availability. It must never test-speak, replay the winner phrase,
      // or interfere with the recording controls.
      if(!keep.__twVoicePatchedClean){
        try{
          var clone = keep.cloneNode(true);
          clone.__twVoicePatchedClean = true;
          keep.parentNode && keep.parentNode.replaceChild(clone, keep);
          keep = clone;
        }catch(_){
          keep.__twVoicePatchedClean = true;
        }

        keep.onclick = function(ev){
          try{
            ev && ev.preventDefault && ev.preventDefault();
            ev && ev.stopPropagation && ev.stopPropagation();
          }catch(_){}

          try{
            TW._mediaPreferenceExplicit = true;
            var next = !isVoiceOn();

            // Toggling Voice must never speak anything. Turning OFF is now
            // cancel-only. Do not prime speech synthesis on OFF, because Safari
            // can flush a stale winner utterance when it is resumed/primed.
            stopAllVoiceNow();
            setVoiceOn(next);

            if(next){
              try{ TW.audioBridge && TW.audioBridge.arm && TW.audioBridge.arm(); }catch(_){}
              primeSpeechSynthesis(true);
              loadVoices();
              setTimeout(loadVoices, 80);
              setTimeout(loadVoices, 300);
              setTimeout(function(){ try{ safeCancel(); }catch(_){} }, 120);
            }else{
              setTimeout(stopAllVoiceNow, 0);
              setTimeout(stopAllVoiceNow, 80);
              setTimeout(stopAllVoiceNow, 220);
              setTimeout(stopAllVoiceNow, 500);
            }
            setTimeout(updateVoiceHeaderUI, 0);
          }catch(_){}
        };
      }

      var on = isVoiceOn();
      keep.textContent = '';
      keep.appendChild(U.el('span', { class:'tw-btnGlyph', text:'🗣️', 'aria-hidden':'true' }));
      keep.appendChild(U.el('span', { class:'tw-btnLabel', text:'Voice' }));
      try{ keep.classList.add('tw-voiceToggle'); }catch(_){}
      try{ keep.setAttribute('aria-pressed', on ? 'true' : 'false'); keep.title = on ? 'Voice is on' : 'Voice is off'; }catch(_){}
      if(on) keep.classList.add('isOn');
      else keep.classList.remove('isOn');

      R.btnVoiceToggle = keep;
    }catch(_){}
  }

  // =========================================================
  // ✅ SOUND TOGGLE (SESSION ONLY) — looks/feels like Voice toggle
  // - blocks: spin sound, celebration sound, and "segment back in" sound
  // - plus global hard-mute to catch bypassed audio paths
  // =========================================================
  function findHeaderSoundButtons(){
    var host = findTopActionsHost();
    if(!host || !host.querySelectorAll) return { host: host, btns: [] };

    var btns = [];
    var all = host.querySelectorAll('button');
    for(var i=0;i<all.length;i++){
      var t = (all[i].textContent || '').trim().toLowerCase();
      if((all[i].classList && all[i].classList.contains('tw-soundToggle')) || t.indexOf('sound:') === 0 || t === 'sound' || t.indexOf('sound ') === 0){
        btns.push(all[i]);
      }
    }
    return { host: host, btns: [] .concat(btns) };
  }

  // ✅ Prime the *exact* reusable audio instances used by the engine (Part4)
  // so iOS Chrome plays spin/win/return sounds on flick-to-spin immediately
  // after the user enables Sound.
  function primeWheelFxAudio(){
    try{
      if(!TW || !TW.CONST) return;
      TW._audCache = TW._audCache || { byUrl: Object.create(null) };
      var map = TW._audCache.byUrl;

      function pickPreSpinUrl(){
        try{
          var id = (TW.state && TW.state.ui && TW.state.ui.spinSoundId) ? TW.state.ui.spinSoundId : 'retro_reactor';
          var s = TW.CONST.PRESPIN_SOUNDS && (TW.CONST.PRESPIN_SOUNDS.find(function(x){ return x.id === id; }) || TW.CONST.PRESPIN_SOUNDS[0]);
          return s && s.url ? s.url : '';
        }catch(_){ return ''; }
      }

      function pickSpinUrl(){
        try{
          var s = TW.CONST && TW.CONST.MAIN_SPIN_SOUND;
          return (s && s.url) ? s.url : '';
        }catch(_){ return ''; }
      }

      function pickWinUrl(){
        try{
          var id = (TW.state && TW.state.ui && TW.state.ui.winSoundId) ? TW.state.ui.winSoundId : 'coin';
          var s = TW.CONST.CELEBRATION_SOUNDS && (TW.CONST.CELEBRATION_SOUNDS.find(function(x){ return x.id === id; }) || TW.CONST.CELEBRATION_SOUNDS[0]);
          return s && s.url ? s.url : '';
        }catch(_){ return ''; }
      }

      function pickReturnUrl(){
        try{
          var rs = TW.CONST.RETURN_SOUND;
          return (rs && rs.url) ? rs.url : '';
        }catch(_){ return ''; }
      }

      function primeUrl(url){
        if(!url) return;
        var a = map[url];
        if(!a){
          a = new Audio(url);
          a.preload = 'auto';
          map[url] = a;
        }
        /* Never reset or reload audio that currently owns audible playback. */
        try{ if(!a.paused && !a.ended) return; }catch(_){ }
        // ✅ Prime by loading into cache (no play()).
        // IMPORTANT: Do NOT leave the element muted/volume=0, or iOS may keep it silent.
        try{ a.currentTime = 0; }catch(_){ }
        try{ if(typeof a.load === 'function') a.load(); }catch(_){ }
      }

      // prime the core FX
      primeUrl(pickPreSpinUrl());
      primeUrl(pickSpinUrl());
      primeUrl(pickWinUrl());
      primeUrl(pickReturnUrl());
    }catch(_){ }
  }

  try{ TW.primeWheelFxAudio = primeWheelFxAudio; }catch(_){ }

  function ensureHeaderSoundToggle(){
    try{
      var host = findTopActionsHost();
      if(!host) return;

      var foundExisting = findHeaderSoundButtons();
      var existing = foundExisting.btns || [];
      for(var i=0;i<existing.length-1;i++){
        try{ existing[i].parentNode && existing[i].parentNode.removeChild(existing[i]); }catch(_){}
      }

      var btn = existing.length ? existing[existing.length-1] : null;

      // If no existing button, clone "Voice" button styling if present, otherwise create new.
      if(!btn){
        var vfound = findHeaderVoiceButtons();
        var vbtns = vfound.btns || [];
        var vbtn = vbtns.length ? vbtns[vbtns.length-1] : null;

        if(vbtn && vbtn.cloneNode){
          btn = vbtn.cloneNode(true);
          btn.textContent = TW.i18n && TW.i18n.t ? TW.i18n.t('Sound') : 'Sound';
          try{ btn.removeAttribute('id'); }catch(_){}
          btn.__twSoundCloned = true;
          host.appendChild(btn);
        }else{
          btn = U.el('button', { class:'tw-btn', type:'button' }, ['Sound']);
          host.appendChild(btn);
        }
      }

      if(!btn) return;

      if(!btn.__twSoundPatched){
        btn.__twSoundPatched = true;

        btn.onclick = function(ev){
          try{
            // ✅ iOS: unlock audio inside THIS exact click
            try{ TW.audioBridge && TW.audioBridge.arm && TW.audioBridge.arm(); }catch(_){}
          }catch(_){}

          try{
            TW._mediaPreferenceExplicit = true;
            var next = !isSoundOn();
            setSessionSoundFlag(next);

            if(next){
              // ✅ prime reusable FX audios within this same click gesture
              try{ primeWheelFxAudio(); }catch(_){ }
            }

            // ✅ HARD APPLY: immediately mute/unmute everything
            applySoundStateToAllAudio();

            setTimeout(ensureHeaderSoundToggle, 0);
          }catch(_){}

          try{
            ev && ev.preventDefault && ev.preventDefault();
            ev && ev.stopPropagation && ev.stopPropagation();
          }catch(_){}
        };
      }

      var on = isSoundOn();
      btn.textContent = '';
      btn.appendChild(U.el('span', { class:'tw-btnGlyph', text:'🔊', 'aria-hidden':'true' }));
      btn.appendChild(U.el('span', { class:'tw-btnLabel', text:'Sound' }));
      try{ btn.classList.add('tw-soundToggle'); }catch(_){}
      try{ btn.setAttribute('aria-pressed', on ? 'true' : 'false'); btn.title = on ? 'Sound is on' : 'Sound is off'; }catch(_){}
      if(on) btn.classList.add('isOn');
      else btn.classList.remove('isOn');

      R.btnSoundToggle = btn;
    }catch(_){}
  }

  // The first successful Spin-button gesture may start the complete experience.
  // After that, Sound and Voice are user preferences and must never be forced
  // back on by another click, flick, touchstart, or touchend.
  TW.enableSoundAndVoiceFromGesture = function(){
    try{
      if(TW._mediaFirstSpinHandled) return false;
      TW._mediaFirstSpinHandled = true;

      // A person may turn either control off before the first spin. Respect it.
      if(TW._mediaPreferenceExplicit){
        applySoundStateToAllAudio();
        try{ updateVoiceHeaderUI(); }catch(_){ }
        try{ ensureHeaderSoundToggle(); }catch(_){ }
        return false;
      }

      setSessionSoundFlag(true);
      setVoiceOn(true);
      applySoundStateToAllAudio();

      try{ TW.audioBridge && TW.audioBridge.arm && TW.audioBridge.arm(); }catch(_){ }

      // Match the successful OFF -> ON Voice-button path. This must remain
      // synchronous with the gesture for Apple speech synthesis.
      try{ stopAllVoiceNow(); }catch(_){ }
      try{ primeSpeechSynthesis(true); }catch(_){ }
      try{ loadVoices(); }catch(_){ }

      try{ updateVoiceHeaderUI(); }catch(_){ }
      try{ ensureHeaderSoundToggle(); }catch(_){ }
      return true;
    }catch(_){
      return false;
    }
  };

  // =========================================================
  // ✅ SOUND PLAYBACK PATCHES:
  // - enforce session sound toggle
  // - enforce spin/win volume reliably (especially iOS: set BEFORE play)
  // =========================================================
  function clamp01(v, d){
    v = (v == null) ? d : parseFloat(v);
    if(!isFinite(v)) v = d;
    if(v < 0) v = 0;
    if(v > 1) v = 1;
    return v;
  }

  function getSpinVol(){
    return clamp01(TW.state && TW.state.ui ? TW.state.ui.spinVolume : null, 0.55);
  }
  function getWinVol(){
    return clamp01(TW.state && TW.state.ui ? TW.state.ui.winVolume : null, 0.95);
  }

  function patchFunctionOnce(obj, name, wrapper){
    try{
      if(!obj || !name || !obj[name] || obj[name].__twPatched) return false;
      var orig = obj[name];
      var fn = wrapper(orig);
      fn.__twPatched = true;
      obj[name] = fn;
      return true;
    }catch(_){
      return false;
    }
  }

  function patchSoundFns(){
    // Keep the header toggle authoritative, but do not override the engine's
    // own Apple-safe playback path anymore. The hard mute gate now lives
    // inside the FX functions themselves (Part4), which fixes Safari cases
    // where sound kept playing even when the Sound toggle looked off.
    patchFunctionOnce(TW, 'playPreSpinSound', function(orig){
      return function(){
        if(!isSoundOn()) return;
        try{ return orig.apply(this, arguments); }catch(_){ }
      };
    });

    patchFunctionOnce(TW, 'playSpinSound', function(orig){
      return function(){
        if(!isSoundOn()) return;
        try{ return orig.apply(this, arguments); }catch(_){ }
      };
    });

    patchFunctionOnce(TW, 'playWinSound', function(orig){
      return function(){
        if(!isSoundOn()) return;
        try{ return orig.apply(this, arguments); }catch(_){ }
      };
    });

    patchFunctionOnce(TW, 'playCelebrationSound', function(orig){
      return function(){
        if(!isSoundOn()) return;
        try{ return orig.apply(this, arguments); }catch(_){ }
      };
    });

    patchFunctionOnce(TW, 'playSegmentInSound', function(orig){
      return function(){
        if(!isSoundOn()) return;
        try{ return orig.apply(this, arguments); }catch(_){ }
      };
    });

    patchFunctionOnce(TW, 'playSound', function(orig){
      return function(id, vol){
        if(!isSoundOn()) return;
        try{ return orig.call(this, id, vol); }catch(_){ }
      };
    });
  }

  // Winner X close -> "segment back in" sound
  function playSegmentBackInSound(){
    if(!isSoundOn()) return;
    try{ TW.audioBridge && TW.audioBridge.arm && TW.audioBridge.arm(); }catch(_){}

    try{
      if(typeof TW.playSegmentInSound === 'function'){
        TW.playSegmentInSound();
        return;
      }
    }catch(_){}

    try{
      if(typeof TW.playSound === 'function' && TW.state && TW.state.ui && TW.state.ui.segmentInSoundId){
        TW.playSound(TW.state.ui.segmentInSoundId, 0.9);
        return;
      }
    }catch(_){}
  }

  function bindWinnerCloseSound(){
    try{
      if(TW._winnerCloseSoundBound) return;
      TW._winnerCloseSoundBound = true;

      document.addEventListener('click', function(ev){
        try{
          var t = ev && ev.target;
          if(!t) return;

          var isX =
            (t.classList && (t.classList.contains('tw-x') || t.classList.contains('tw-winX') || t.classList.contains('tw-winnerX'))) ||
            (String(t.getAttribute && t.getAttribute('aria-label') || '').toLowerCase().indexOf('close') !== -1) ||
            (String(t.textContent || '').trim() === '×');

          if(!isX) return;

          var p = t.closest ? t.closest('.tw-winner, .tw-win, .tw-modal, .tw-popover, .tw-card') : null;
          if(!p) return;

          // If a “winner” area is open, play our segment return sound
          playSegmentBackInSound();
        }catch(_){}
      }, true);
    }catch(_){}
  }

  // =========================================================
  // ✅ HOTKEYS (OVERLAY ONLY):
  // E = End of Round Winner
  // U = Undo
  // M = Multi-pick panel
  // =========================================================
  function isTypingTarget(el){
    try{
      if(!el) return false;
      var tag = (el.tagName || '').toLowerCase();
      if(tag === 'input' || tag === 'textarea' || tag === 'select') return true;
      if(el.isContentEditable) return true;
    }catch(_){}
    return false;
  }

  function openMultiPickPanel(){
    try{
      if(typeof TW.openMultiPick === 'function'){ TW.openMultiPick(); return; }
      if(typeof TW.toggleMultiPick === 'function'){ TW.toggleMultiPick(true); return; }
      if(typeof TW.openMulti === 'function'){ TW.openMulti(); return; }

      var root = R.wrap || document;
      var btns = root.querySelectorAll('button');
      for(var i=0;i<btns.length;i++){
        var t = (btns[i].textContent || '').trim().toLowerCase();
        if(t.indexOf('multi') !== -1 && (t.indexOf('pick') !== -1 || t.indexOf('picker') !== -1 || t === 'multi')){
          btns[i].click();
          return;
        }
      }
    }catch(_){}
  }

  function bindHotkeys(){
    try{
      if(TW._hotkeysBound) return;
      TW._hotkeysBound = true;

      document.addEventListener('keydown', function(ev){
        try{
          if(!ev) return;
          if(!(TW.state && TW.state.ui && TW.state.ui.overlay)) return;
          if(isTypingTarget(document.activeElement)) return;

          var k = String(ev.key || '').toLowerCase();

          if(k === 'u'){
            ev.preventDefault();
            ev.stopPropagation();
            TW.undo && TW.undo();
            return;
          }

          if(k === 'm'){
            ev.preventDefault();
            ev.stopPropagation();
            openMultiPickPanel();
            return;
          }

          if(k === 'e'){
            ev.preventDefault();
            ev.stopPropagation();
            if(R.btnEndRound && !R.btnEndRound.hidden){
              R.btnEndRound.click();
              return;
            }
            try{
              primeSpeechSynthesis(true);
              var teams = TW.state.teams || [];
              if(!teams.length) return;

              var res = computeTopTeams();
              if(!res.top.length) return;

              var text = '';
              if(res.top.length === 1){
                text = 'End of round winner is ' + res.top[0] + ' with ' + res.max + ' points.';
              }else{
                text = 'It is a tie between ' + res.top.join(' and ') + ' with ' + res.max + ' points.';
              }
              TW.speakText && TW.speakText(text);
            }catch(_){}
            return;
          }
        }catch(_){}
      }, true);
    }catch(_){}
  }

  // =========================================================
  // ✅ Voice bridge
  // =========================================================
  TW.voiceBridge = (function(){
    var armed = false;
    function arm(){
      if(armed) return;
      armed = true;
      if(!window.speechSynthesis) return;

      try{
        // Silent primer only. Never speak a real word like "ok", because that
        // can leak as an unexpected voice on iOS/Safari.
        var u = new SpeechSynthesisUtterance(' ');
        u.volume = 0.001;
        u.rate = 1;
        u.pitch = 1;

        try{ window.speechSynthesis.resume(); }catch(_){}
        window.speechSynthesis.speak(u);
        setTimeout(function(){ try{ window.speechSynthesis.cancel(); }catch(_){} }, 80);
      }catch(_){}
    }
    return { arm: arm };
  })();

  TW.speakText = function(text){
    if(!isVoiceOn()) return;

    TW._voiceRunId = (TW._voiceRunId || 0) + 1;
    var runId = TW._voiceRunId;
    safeCancel();
    stopRecordedPhraseAudio();
    primeSpeechSynthesis(true);
    setTimeout(function(){
      if(runId !== TW._voiceRunId || !isVoiceOn()) return;
      safeCancel();
      speakUtter(String(text || '').trim());
    }, 90);
  };

  TW.speakWinner = function(winnerLabel){
    if(!isVoiceOn()) return;

    TW._voiceRunId = (TW._voiceRunId || 0) + 1;
    var runId = TW._voiceRunId;

    var winner = String(winnerLabel || '').trim();
    if(!winner) return;

    var phrase = (TW.state.ui.winnerPhrase || 'And the winner is').trim();
    var hasRec = !!(TW.state.ui.recordedPhraseDataUrl || '');

    // Start every winner announcement with a clean queue. This prevents the
    // Voice button, Test voice, recorder, or Safari primer from leaking an old
    // phrase into the real winner sequence.
    safeCancel();
    stopRecordedPhraseAudio();
    primeSpeechSynthesis(true);
    loadVoices();

    function stillCurrent(){
      return runId === TW._voiceRunId && isVoiceOn();
    }

    function saySegment(){
      if(!stillCurrent()) return;
      try{ window.speechSynthesis && window.speechSynthesis.resume && window.speechSynthesis.resume(); }catch(_){}
      safeCancel();
      setTimeout(function(){
        if(stillCurrent()) speakUtter(winner);
      }, 90);
    }

    function startSequence(){
      if(!stillCurrent()) return;
      safeCancel(); // clears only the silent primer before real speech starts

      if(hasRec){
        playRecordedPhrase(function(){
          if(!stillCurrent()) return;
          setTimeout(saySegment, 220);
        });
        return;
      }

      // 2026-05-08K: default/custom typed phrase + winner are now ONE utterance.
      // Safari was reordering or dropping the second utterance when phrase and
      // segment were spoken as two separate queued items. One utterance keeps
      // the order locked: phrase first, winner segment second.
      var full = phrase ? (phrase + '. ' + winner) : winner;
      speakUtter(full);
    }

    setTimeout(startSequence, 140);
  };

  if(R.btnTestVoice){
    R.btnTestVoice.addEventListener('click', function(){
      TW._voiceRunId = (TW._voiceRunId || 0) + 1;
      var runId = TW._voiceRunId;

      stopRecordedPhraseAudio();
      primeSpeechSynthesis(true);
      loadVoices();

      var hasRec = !!(TW.state.ui.recordedPhraseDataUrl || '');

      safeCancel();

      function stillCurrent(){ return runId === TW._voiceRunId; }
      function sayTestSegment(){ if(stillCurrent()) speakUtter('PLOT TWIST'); }

      if(hasRec){
        // 2026-05-09B APPLE RECORDED-VOICE OVERLAP FIX:
        // Do not silently prime/replay the same Audio object immediately before
        // testing. On iOS this can fire an early ended/play promise and make
        // “PLOT TWIST” speak over the recorded phrase.
        playRecordedPhrase(function(){ setTimeout(sayTestSegment, 220); });
      }else{
        // Match the real spin path exactly: typed/default phrase + segment in
        // one utterance so Safari cannot reorder or drop the segment.
        var phrase = (TW.state.ui.winnerPhrase || 'And the winner is').trim();
        var full = phrase ? (phrase + '. PLOT TWIST') : 'PLOT TWIST';
        speakUtter(full);
      }
    });
  }

  TW.resetAll = function(){
    if(!confirm('Reset wheel back to this page’s defaults?')) return;
    TW.pushUndo();

    TW.state = null;
    TW.ensureState();

    TW.state.segments = U.clone(TW.CONST.DEFAULT_SEGMENTS);
    TW.state.ui.title = 'WHEEL';
    TW.state.ui.desc = 'Spin to choose a winner.';
    TW.state.pins = [];
    TW.state.teams = [];
    TW.state.history = [];
    TW.state.ui.overlay = false;
    TW.state.ui.streamMode = false;
    TW.state.ui.presentationDockClosed = 'no';

    // Reset presentation-only wheel sizing and clear the Inventor Lab's
    // transient form/output state, neither of which lives in TW.state.
    resetPresentationWheelSize();
    try{
      if(R.aiTopic) R.aiTopic.value = '';
      if(R.aiOut) R.aiOut.value = '';
      if(R.aiCountCustom){ R.aiCountCustom.value = '6'; R.aiCountCustom.style.display = 'none'; }
      if(R.aiColorMode) R.aiColorMode.value = 'follow';
      if(R.aiStickerMode){ R.aiStickerMode.value = 'off'; if(R.aiStickerMode._twMenuSyncLabel) R.aiStickerMode._twMenuSyncLabel(); }
      if(R.aiApplyPlan) R.aiApplyPlan.value = 'replace';
      if(R.aiRevealMode) R.aiRevealMode.value = 'standard';
      if(R.aiPrizeExperience) R.aiPrizeExperience.value = 'standard';
      if(R.aiAudience) R.aiAudience.value = 'mixed';
      if(R.aiReadingLevel) R.aiReadingLevel.value = 'standard';
      [R.aiColorMode,R.aiStickerMode,R.aiApplyPlan,R.aiRevealMode,R.aiPrizeExperience,R.aiAudience,R.aiReadingLevel].forEach(function(select){
        if(select && select._twMenuSyncLabel) select._twMenuSyncLabel();
      });
      if(R.applyAIPresetDefaults) R.applyAIPresetDefaults(true);
      if(R.aiReview) R.aiReview.innerHTML = '';
      if(R.aiSuccess){ R.aiSuccess.innerHTML = ''; R.aiSuccess.setAttribute('hidden',''); }
      if(R.aiMsg) R.aiMsg.textContent = '';
      if(R.aiErr) R.aiErr.textContent = '';
      if(R.aiPromptCount) R.aiPromptCount.textContent = '0 / 300';
      R.aiLastWheelPackage = null;
      R.aiLastStickerIdeas = [];
      R.aiLastOutput = '';
      R.aiLastOutputAfter = '';
    }catch(_){ }

    TW.state.ui.fidgetSpeed = TW.state.ui.fidgetSpeed || 'normal';
    TW.state.ui.fidgetTickOn = TW.state.ui.fidgetTickOn || 'no';
    TW.state.ui.fidgetHapticsOn = TW.state.ui.fidgetHapticsOn || 'no';
    TW.state.ui.fidgetSnapOn = TW.state.ui.fidgetSnapOn || 'no';

    // ✅ session voice OFF on reset (and always defaults OFF on new tab)
    setVoiceOn(false);
    safeCancel();

    if(TW._pagePreset && TW._pagePreset.useAsReset){
      applyPresetToState(TW._pagePreset);
      // keep session voice OFF
      setVoiceOn(false);
    }

    syncOverlayCssVars();

    try{ history.replaceState(null, '', getBaseUrl()); }catch(_){}

    normalizeSegments();
    TW.renderAll && TW.renderAll();
    try{ TW.syncUIFromState && TW.syncUIFromState(); }catch(_){ }

    // SURGICAL 2026-07-11C: Reset should reset wheel visuals/settings only.
    // It must not restore a used weekly paid preview spin. Refresh the access
    // UI immediately after reset so locked paid wheels return to their locked
    // state, while free wheels, unlocked subscribers, spin trails, and challenge
    // previews continue to use their existing access rules.
    try{ TW.refreshAccessUI && TW.refreshAccessUI(); }catch(_){ }
    setTimeout(function(){ try{ TW.refreshAccessUI && TW.refreshAccessUI(); }catch(_){} }, 0);

    TW.saveSoon();

    setTimeout(updateVoiceHeaderUI, 0);
    setTimeout(ensureHeaderSoundToggle, 0);
    setTimeout(function(){ TW.updateSpinBizPreviews && TW.updateSpinBizPreviews(); }, 0);

    // ✅ baseline capture after reset rebuild
    setTimeout(function(){
      captureBaselineForCurrentBadge(true);
      observeBadgeUrlChanges();
    }, 0);

    // ✅ ensure badge cannot “ghost” after reset
    setTimeout(forceClearCenterBadgeIfEmpty, 0);
    setTimeout(forceClearCenterBadgeIfEmpty, 120);

    // ✅ if sound is OFF, hard-apply mute
    setTimeout(applySoundStateToAllAudio, 0);
  };

  // ---------- teams + points ----------
  TW.addTeam = function(name){
    name = (name||'').trim();
    if(!name) return;

    TW.pushUndo();
    TW.state.teams = TW.state.teams || [];
    if(TW.state.teams.some(function(t){ return (t.name||'').toLowerCase() === name.toLowerCase(); })){
      TW.renderTeams && TW.renderTeams();
      return;
    }
    TW.state.teams.push({ name: name, points: 0 });
    TW.renderTeams && TW.renderTeams();
    TW.saveSoon();
  };

  TW.resetPoints = function(){
    TW.pushUndo();
    (TW.state.teams||[]).forEach(function(t){ t.points = 0; });
    TW.renderTeams && TW.renderTeams();
    TW.saveSoon();
  };

  TW.clearTeams = function(){
    if(!confirm('Clear all teams/players?')) return;
    TW.pushUndo();
    TW.state.teams = [];
    TW.renderTeams && TW.renderTeams();
    TW.saveSoon();
  };

  // ---------- CSV download ----------
  TW.downloadCSV = function(){
    var rows = TW.state.history || [];
    if(!rows.length){
      alert('No history yet.');
      return;
    }
    var esc = function(v){
      var isRealNumber = (typeof v === 'number' && Number.isFinite(v));
      v = (v==null?'':String(v));
      // Prevent spreadsheet apps from treating customer-controlled cells as formulas.
      if(!isRealNumber && (/^[\t\r]/.test(v) || /^[ ]*[=+\-@]/.test(v))) v = "'" + v;
      if(/[,"\n]/.test(v)) v = '"' + v.replace(/"/g,'""') + '"';
      return v;
    };
    var csv = ['DateTime,Winner,Team,Points'];
    rows.forEach(function(r){
      csv.push([esc(r.ts), esc(r.label), esc(r.team||''), esc(r.points==null?'':r.points)].join(','));
    });
    var blob = new Blob([csv.join('\n')], { type:'text/csv;charset=utf-8' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    var safeTitle = '';
    try{ safeTitle = String((TW.state && TW.state.ui && TW.state.ui.title) || 'spin-the-wheel-lab').trim().toLowerCase(); }catch(_){ safeTitle = 'spin-the-wheel-lab'; }
    safeTitle = safeTitle.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 44) || 'spin-the-wheel-lab';
    a.download = 'spin-the-wheel-lab-' + safeTitle + '-history.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(function(){ URL.revokeObjectURL(url); }, 2000);
  };

  function computeTopTeams(){
    var teams = TW.state.teams || [];
    if(!teams.length) return { top:[], max:0 };
    var max = -Infinity;
    teams.forEach(function(t){
      var p = (t && t.points != null) ? parseFloat(t.points) : 0;
      if(!isFinite(p)) p = 0;
      if(p > max) max = p;
    });
    if(max === -Infinity) max = 0;

    var top = teams.filter(function(t){
      var p = (t && t.points != null) ? parseFloat(t.points) : 0;
      if(!isFinite(p)) p = 0;
      return p === max;
    }).map(function(t){ return t.name; });

    return { top: top, max: max };
  }

  function ensureEndRoundButton(){
    if(!R) return;

    if(!R.btnEndRound){
      var btn = U.el('button', { class:'tw-btn tw-btnGhost tw-btnIcon', type:'button', role:'menuitem' }, [
        U.el('span', { class:'tw-btnGlyph', text:'🏆' }),
        U.el('span', { text:'End of Round Winner' })
      ]);
      btn.style.marginTop = '0';
      btn.onclick = function(){
        primeSpeechSynthesis(true);

        var teams = TW.state.teams || [];
        if(!teams.length){
          alert('Add at least one team/player to use End of Round Winner.');
          return;
        }

        var res = computeTopTeams();
        if(!res.top.length){
          alert('No teams/players found.');
          return;
        }

        var text = '';
        if(res.top.length === 1){
          text = 'End of round winner is ' + res.top[0] + ' with ' + res.max + ' points.';
        }else{
          text = 'It is a tie between ' + res.top.join(' and ') + ' with ' + res.max + ' points.';
        }

        TW.speakText && TW.speakText(text);
      };

      var menuList = null;
      try{
        if(R.morePanel && R.morePanel.querySelector){
          menuList = R.morePanel.querySelector('.tw-menuList');
        }
      }catch(_){ }
      var parent = menuList || (R.btnUndo && R.btnUndo.parentNode) || null;
      if(parent){
        parent.appendChild(btn);
      }
      R.btnEndRound = btn;
    }

    try{
      var targetList = (R.morePanel && R.morePanel.querySelector) ? R.morePanel.querySelector('.tw-menuList') : null;
      if(targetList && R.btnEndRound.parentNode !== targetList){
        targetList.appendChild(R.btnEndRound);
      }
    }catch(_){ }

    R.btnEndRound.hidden = false;
  }

  (function patchRenderTeams(){
    if(TW._endRoundPatched) return;
    TW._endRoundPatched = true;

    var orig = TW.renderTeams;
    TW.renderTeams = function(){
      if(orig) orig();
      ensureEndRoundButton();
    };
  })();

  function prewarmWinnerModal(){
    try{
      if(!R || !R.modal || !R.modalBack || R.modal.__twPrewarmed) return;
      R.modalBack.hidden = false;
      R.modal.hidden = false;
      R.modal.style.visibility = 'hidden';
      R.modalBack.style.visibility = 'hidden';
      R.modal.innerHTML = '<div class="tw-modalTop"><h3 class="tw-modalTitle">Winner!</h3></div>';
      void R.modal.offsetHeight;
      R.modal.innerHTML = '';
      R.modal.hidden = true;
      R.modalBack.hidden = true;
      R.modal.style.visibility = '';
      R.modalBack.style.visibility = '';
      R.modal.__twPrewarmed = true;
    }catch(_){ }
  }

  // =========================================================
  // ✅ Recording phrase works on Apple (Safari) — mime pick
  // =========================================================
  function pickRecorderMime(){
    try{
      if(!window.MediaRecorder || !MediaRecorder.isTypeSupported) return '';
      var list = [
        'audio/mp4;codecs=mp4a.40.2',
        'audio/mp4',
        'audio/webm;codecs=opus',
        'audio/webm'
      ];
      for(var i=0;i<list.length;i++){
        if(MediaRecorder.isTypeSupported(list[i])) return list[i];
      }
    }catch(_){}
    return '';
  }

  var rec = null, chunks = [];
  function setRecUI(on){
    if(!R.btnRec || !R.btnStopRec) return;
    if(on){
      R.btnRec.hidden = true;
      R.btnStopRec.hidden = false;
    }else{
      R.btnRec.hidden = false;
      R.btnStopRec.hidden = true;
    }
  }

  if(R.btnRec && R.btnStopRec){
    R.btnRec.addEventListener('click', async function(){
      // Recording must start from silence. Do not let a previous phrase, test,
      // or recorded intro play underneath the new recording.
      try{ TW._voiceRunId = (TW._voiceRunId || 0) + 1; }catch(_){}
      try{ safeCancel(); }catch(_){}
      try{
        if(TW._recordedPhraseAudio){
          TW._recordedPhraseAudio.pause();
          TW._recordedPhraseAudio.currentTime = 0;
        }
      }catch(_){}
      if(!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia){
        alert('Mic not available in this browser.');
        return;
      }
      try{
        var stream = await navigator.mediaDevices.getUserMedia({ audio:true });
        chunks = [];

        var mime = pickRecorderMime();
        try{
          rec = mime ? new MediaRecorder(stream, { mimeType: mime }) : new MediaRecorder(stream);
        }catch(_){
          rec = new MediaRecorder(stream);
          mime = '';
        }

        rec.ondataavailable = function(e){ if(e.data && e.data.size) chunks.push(e.data); };
        rec.onstop = function(){
          try{ stream.getTracks().forEach(function(t){ t.stop(); }); }catch(_){}

          var blobType = mime || (chunks[0] && chunks[0].type) || 'audio/webm';
          var blob = new Blob(chunks, { type: blobType });

          var fr = new FileReader();
          fr.onload = function(){
            TW.pushUndo();
            TW.state.ui.recordedPhraseDataUrl = String(fr.result || '');
            TW.state.ui.winnerPhrase = '';
            TW.saveSoon();
            setRecUI(false);

            if(R.inWinnerPhrase && document.activeElement !== R.inWinnerPhrase){
              R.inWinnerPhrase.value = '';
            }

            alert('Recorded! It will play first, then ONLY the winner name will be spoken.');
          };
          fr.readAsDataURL(blob);
        };

        rec.start();
        setRecUI(true);
      }catch(e){
        alert('Mic permission denied or unavailable.');
      }
    });

    R.btnStopRec.addEventListener('click', function(){
      if(rec && rec.state !== 'inactive'){
        rec.stop();
      }
      setRecUI(false);
    });
  }

  if(R.btnClearRec){
    R.btnClearRec.addEventListener('click', function(){
      TW.pushUndo();
      TW.state.ui.recordedPhraseDataUrl = '';
      TW._recordedPhraseAudio = null;
      TW._recordedPhraseAudioUrl = '';
      TW._recordedPhraseAudioArmed = false;
      TW.saveSoon();
      alert('Recording cleared.');
    });
  }

  function svgPointFromClient(svg, clientX, clientY){
    try{
      var pt = svg.createSVGPoint();
      pt.x = clientX;
      pt.y = clientY;
      var m = svg.getScreenCTM();
      if(!m) return null;
      return pt.matrixTransform(m.inverse());
    }catch(_){
      return null;
    }
  }

  function bindBadgeDrag(){
    if(!R.wheelSvg) return;
    if(!R.centerImg) return;

    var svg = R.wheelSvg;
    var dragging = false;
    var start = null;
    var startOffX = 0;
    var startOffY = 0;

    function onDown(ev){
      if((TW.state.ui.centerBadgeEditOn||'no') !== 'yes') return;
      if(TW._rt && TW._rt.spinning) return;
      if(TW._fidget && TW._fidget.on) return;

      var tgt = ev.target;
      if(tgt !== R.centerImg) return;

      // baseline should exist for this badge (set when badge was chosen / loaded)
      captureBaselineForCurrentBadge(false);

      ev.preventDefault();
      ev.stopPropagation();

      dragging = true;
      try{ tgt.setPointerCapture && tgt.setPointerCapture(ev.pointerId); }catch(_){}

      start = svgPointFromClient(svg, ev.clientX, ev.clientY);
      startOffX = parseFloat(TW.state.ui.centerBadgeOffX || 0) || 0;
      startOffY = parseFloat(TW.state.ui.centerBadgeOffY || 0) || 0;
    }

    function onMove(ev){
      if(!dragging) return;
      if((TW.state.ui.centerBadgeEditOn||'no') !== 'yes') return;
      if(TW._rt && TW._rt.spinning) return;
      if(TW._fidget && TW._fidget.on) return;

      ev.preventDefault();
      ev.stopPropagation();

      var p = svgPointFromClient(svg, ev.clientX, ev.clientY);
      if(!p || !start) return;

      var dx = p.x - start.x;
      var dy = p.y - start.y;

      TW.state.ui.centerBadgeOffX = startOffX + dx;
      TW.state.ui.centerBadgeOffY = startOffY + dy;

      TW.renderWheel && TW.renderWheel();
      TW.saveSoon && TW.saveSoon();
    }

    function onUp(ev){
      if(!dragging) return;
      dragging = false;
      start = null;
      try{ (ev.target && ev.target.releasePointerCapture) && ev.target.releasePointerCapture(ev.pointerId); }catch(_){}
    }

    if(!TW._badgeDragBound){
      TW._badgeDragBound = true;
      svg.addEventListener('pointerdown', onDown, { passive:false });
      svg.addEventListener('pointermove', onMove, { passive:false });
      svg.addEventListener('pointerup', onUp, { passive:true });
      svg.addEventListener('pointercancel', onUp, { passive:true });
    }
  }

  // =========================================================
  // ✅ Image picker viewport safety + Featured Images button
  // =========================================================
  function forcePopupViewportSafe(node){
    try{
      if(!node || !node.style) return;

      var isPopover = node.classList && node.classList.contains('tw-popover');
      var isModal   = node.classList && node.classList.contains('tw-modal');
      if(!isPopover && !isModal) return;

      node.style.maxHeight = 'min(52vh, calc(100vh - 18px - env(safe-area-inset-top,0px) - env(safe-area-inset-bottom,0px)))';
      node.style.overflowY = 'auto';
      node.style.overflowX = 'hidden';
      node.style.webkitOverflowScrolling = 'touch';
      node.style.overscrollBehavior = 'contain';

      if(isPopover){
        node.style.maxWidth = 'calc(100vw - 24px - env(safe-area-inset-left,0px) - env(safe-area-inset-right,0px))';
      }

      try{
        var bodies = node.querySelectorAll('.tw-popBody, .tw-popoverBody, .tw-modalBody, .tw-body, .body, .content');
        for(var i=0;i<bodies.length;i++){
          var b = bodies[i];
          if(!b || !b.style) continue;
          b.style.maxHeight = 'inherit';
          b.style.overflowY = 'auto';
          b.style.webkitOverflowScrolling = 'touch';
        }
      }catch(_){}
    }catch(_){}
  }

  function ensureFeaturedImagesButton(container){
    try{
      if(!container || !container.querySelectorAll) return;
      var oldButtons = container.querySelectorAll('[data-tw-featured-btn="1"]');
      for(var i=0;i<oldButtons.length;i++){
        if(oldButtons[i] && oldButtons[i].parentNode) oldButtons[i].parentNode.removeChild(oldButtons[i]);
      }
    }catch(_){}
  }

  function bootPopupObserver(){
    try{
      if(TW._popupObsBound) return;
      TW._popupObsBound = true;

      var obs = new MutationObserver(function(muts){
        for(var i=0;i<muts.length;i++){
          var m = muts[i];
          if(!m.addedNodes) continue;
          for(var j=0;j<m.addedNodes.length;j++){
            var n = m.addedNodes[j];
            if(!n || !n.querySelectorAll) continue;

            if(n.classList && (n.classList.contains('tw-popover') || n.classList.contains('tw-modal'))){
              forcePopupViewportSafe(n);
              ensureFeaturedImagesButton(n);
            }

            var pops = n.querySelectorAll('.tw-popover, .tw-modal');
            for(var k=0;k<pops.length;k++){
              forcePopupViewportSafe(pops[k]);
              ensureFeaturedImagesButton(pops[k]);
            }
          }
        }
      });

      obs.observe(document.documentElement || document.body, { childList:true, subtree:true });

      setTimeout(function(){
        try{
          var exist = document.querySelectorAll('.tw-popover, .tw-modal');
          for(var i=0;i<exist.length;i++){
            forcePopupViewportSafe(exist[i]);
            ensureFeaturedImagesButton(exist[i]);
          }
        }catch(_){}
      }, 150);
    }catch(_){}
  }

  bootPopupObserver();

  function ensureFeaturedBtnInOptionsPanel(){
    try{
      var host =
        (R && R.optDetails) ||
        document.querySelector('#twOptions') ||
        document.querySelector('.tw-options') ||
        document.querySelector('.tw-panelOptions') ||
        null;

      if(host) ensureFeaturedImagesButton(host);
    }catch(_){}
  }

  setTimeout(ensureFeaturedBtnInOptionsPanel, 0);
  setTimeout(ensureFeaturedBtnInOptionsPanel, 250);

  // =========================================================
  // ✅ Keep overlay pruning + voice + sound button stable across re-renders
  // + ✅ enforce iOS clear-badge after each render
  // + ✅ watch badge URL changes for baseline capture
  // + ✅ apply sound mute state after renders (hard fix)
  // =========================================================
  (function patchRenderAll(){
    if(TW._renderAllPatched_forVoiceSoundOverlay) return;
    TW._renderAllPatched_forVoiceSoundOverlay = true;

    var orig = TW.renderAll;
    TW.renderAll = function(){
      if(orig) orig();

      updateVoiceHeaderUI();
      ensureHeaderSoundToggle();
      ensureFeaturedBtnInOptionsPanel();

      if(TW.state && TW.state.ui && TW.state.ui.overlay){
        TW.applyOverlay && TW.applyOverlay(true);
      }

      patchResetBadgeButton();

      // badge cleanup + baseline watch
      observeBadgeUrlChanges();
      forceClearCenterBadgeIfEmpty();

      // hard-apply audio mute state
      applySoundStateToAllAudio();
      try{ TW.refreshAccessUI && TW.refreshAccessUI(); }catch(_){ }
    };
  })();

  (function patchRenderWheel(){
    if(TW._renderWheelPatched_forClearBadge) return;
    TW._renderWheelPatched_forClearBadge = true;

    var orig = TW.renderWheel;
    TW.renderWheel = function(){
      if(orig) orig();

      observeBadgeUrlChanges();
      forceClearCenterBadgeIfEmpty();
      applySoundStateToAllAudio();
    };
  })();

  // =========================================================
  // ✅ BOOT LOAD
  // =========================================================
  (async function bootLoad(){
    TW._pagePreset = readPagePreset();
  if(TW._pagePreset && Array.isArray(TW._pagePreset.palette) && TW._pagePreset.palette.length){
    applyPresetToConstPalette(TW._pagePreset);
  }

    var usedHash = await applyVaultLinkIfAny();
    if(!usedHash) usedHash = applyHashIfAny();
    var usedDashboard = false;
    var usedLocal = false;

    if(!usedHash){
      var active = consumeDashboardActiveState();
      if(active && active._migrationError){
        showWheelMigrationError('dashboard', active._migrationError);
        return;
      }
      if(active && active.state && active.state.segments){
        TW.state = active.state;
        usedDashboard = true;
      }
    }

    if(!usedHash && !usedDashboard){
      var local = loadLocal();
      if(local && local.segments){
        try{
          var localMigration = migrateWheelState(local);
          TW.state = localMigration.state;
          usedLocal = true;
        }catch(localMigrationError){
          showWheelMigrationError('local', localMigrationError);
          return;
        }
      }
    }

    /* Strict branded-page mode: a missing/malformed preset must fail visibly.
       Never allow ensureState() to manufacture the engine demo wheel here. */
    if(window.TOKI_REQUIRE_PAGE_PRESET !== false &&
       !(TW._pagePreset && Array.isArray(TW._pagePreset.segments) && TW._pagePreset.segments.length >= 2)){
      var strictRoot = document.getElementById('toki-wheel-root');
      if(strictRoot) strictRoot.innerHTML = '<div class="tw-homeLoadError" role="alert"><strong>Wheel temporarily unavailable</strong><span>The custom wheel preset could not be loaded. Please refresh to try again.</span></div>';
      try{ console.error('Spin the Wheel Lab stopped initialization because the required page preset was unavailable.'); }catch(_){}
      return;
    }

    TW.ensureState();
    TW.state._meta = TW.state._meta && typeof TW.state._meta === 'object' ? TW.state._meta : {};
    TW.state._meta.wheelSchemaVersion = WHEEL_SCHEMA_VERSION;
    // Voice button state is session-only. Local/dashboard/hash wheel state may
    // contain an old value, so force it back to this session's flag before render.
    syncVoiceStateFromSession();

    // ✅ If presetRev changed, auto-apply preset immediately (no Reset needed)
    if(!usedHash && usedLocal && TW._pagePreset && TW._pagePreset.presetRev){
      try{
        var curRev = (((TW.state||{}).ui||{})._presetRev) ? String(TW.state.ui._presetRev) : '';
        var nextRev = String(TW._pagePreset.presetRev || '');
        if(nextRev && curRev !== nextRev){
          applyPresetToState(TW._pagePreset);
          usedLocal = false;
        }
      }catch(_){ }
    }

    if(!usedHash && usedLocal && TW._pagePreset){
      try{
        var engineDefaults = TW.CONST.DEFAULT_SEGMENTS || [];
        var hasPresetSegs = Array.isArray(TW._pagePreset.segments) && TW._pagePreset.segments.length;

        if(hasPresetSegs && segmentsEqualLoose(TW.state.segments || [], engineDefaults)){
          applyPresetToState(TW._pagePreset);
          usedLocal = false;
        }
      }catch(_){}
    }

    if(!usedHash && !usedDashboard && !usedLocal && TW._pagePreset){
      applyPresetToState(TW._pagePreset);
    }

    // A dashboard-opened or shared wheel is an explicit visitor choice and
    // must not be overwritten by a page preset marked as forced.
    if(!usedHash && !usedDashboard && TW._pagePreset && TW._pagePreset.force){
      applyPresetToState(TW._pagePreset);
    }

    TW.state.ui = TW.state.ui || {};
    if(!TW.state.ui.fidgetSpeed) TW.state.ui.fidgetSpeed = 'normal';
    if(!TW.state.ui.fidgetTickOn) TW.state.ui.fidgetTickOn = 'no';
    if(!TW.state.ui.fidgetHapticsOn) TW.state.ui.fidgetHapticsOn = 'no';
    if(!TW.state.ui.fidgetSnapOn) TW.state.ui.fidgetSnapOn = 'no';
    if(TW.state.ui.streamMode == null) TW.state.ui.streamMode = false;

    try{
      var qs = new URLSearchParams(window.location.search || '');
      var twMode = String(qs.get('m') || qs.get('tw_mode') || '').toLowerCase();
      var wantsOverlayOnLoad = (qs.get('tw_overlay') === '1' || qs.get('overlay') === '1' || twMode === 'overlay');
      if(wantsOverlayOnLoad && overlayAutoOpenAllowed()){
        TW.state.ui.overlay = true;
        TW.state.ui.streamMode = false;
      }else{
        // SURGICAL 2026-06-02/03: do not let a previously saved Overlay state
        // or stale homepage URL flag auto-open on normal homepage visits.
        TW.state.ui.overlay = false;
        TW.state.ui.streamMode = false;
        if(wantsOverlayOnLoad && !overlayAutoOpenAllowed()) clearOverlayUrlFlags();
      }
    }catch(_){ }

    // ✅ overlay css var
    syncOverlayCssVars();

    TW.challenge = getChallengeMetaFromUrl();
    applyChallengeModeUi();

    normalizeSegments();

    // ✅ patch sound fn gates + volumes
    patchSoundFns();

    // ✅ winner close sound (segment back in)
    bindWinnerCloseSound();

    // ✅ hotkeys overlay-only
    bindHotkeys();

    // ✅ baseline map setup + initial baseline capture for current badge (if any)
    ensureBadgeBaselines();
    captureBaselineForCurrentBadge(false);
    observeBadgeUrlChanges();

    // ✅ apply initial hard-mute state (Sound defaults OFF each tab)
    applySoundStateToAllAudio();

    TW.renderAll && TW.renderAll();
    applyChallengeModeUi();
    // Make the explicitly opened dashboard state the current working copy on
    // this page so a later refresh does not fall back to an older local wheel.
    if(usedDashboard) save();
    if(usedDashboard){
      TW.track && TW.track('wheel_restore_success', {
        source:'dashboard',
        segment_count:Array.isArray(TW.state && TW.state.segments) ? TW.state.segments.length : 0
      });
    }
    setupLocalRetentionUI();

    // If opened from a clean encrypted overlay link, apply the actual
    // presentation classes after the normal render exists.
    if(TW.state && TW.state.ui && TW.state.ui.overlay){
      try{ applyPresentationMode('overlay'); }catch(_){}
    }

    setTimeout(function(){
      applyChallengeModeUi();
      if(TW.state && TW.state.ui && TW.state.ui.overlay){
        try{ applyPresentationMode('overlay'); }catch(_){}
      }
      ensureEndRoundButton();
      prewarmWinnerModal();
      updateVoiceHeaderUI();
      ensureHeaderSoundToggle();
      ensureFeaturedBtnInOptionsPanel();
      patchResetBadgeButton();
      installResetBadgeCapture();
      installVolumeHotApply();

      if(TW.state && TW.state.ui && TW.state.ui.overlay){
        overlayEnforceOnlyTopWheelPins();
        fixOverlayLayout();
      }

      captureBaselineForCurrentBadge(false);
      observeBadgeUrlChanges();

      forceClearCenterBadgeIfEmpty();
      applySoundStateToAllAudio();
    }, 0);

    TW.bindSpin && TW.bindSpin();

    // ✅ iOS: ensure audio unlock is armed by the time user touches wheel
    // Safari activation is intentionally left for the first real wheel gesture.



  // =========================================================
  // SURGICAL 2026-04-26D
  // - Keep Exit button present after delayed overlay/streamer layout passes.
  // - Strongly prime all wheel FX audio on Apple touch/flick gestures.
  //   This fixes first flick-to-spin cases where only the main spin sound plays.
  // =========================================================
  (function installPresentationAndAppleAudioPatch(){
    function isAppleMobileLike(){
      try{
        var ua = navigator.userAgent || '';
        return /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      }catch(_){ return false; }
    }

    function collectWheelFxUrls(){
      var urls = [];
      function add(url){
        url = String(url || '');
        if(url && urls.indexOf(url) < 0) urls.push(url);
      }
      try{ add(TW.CONST && TW.CONST.MAIN_SPIN_SOUND && TW.CONST.MAIN_SPIN_SOUND.url); }catch(_){ }
      try{ add(TW.CONST && TW.CONST.RETURN_SOUND && TW.CONST.RETURN_SOUND.url); }catch(_){ }
      try{
        var id = (TW.state && TW.state.ui && TW.state.ui.spinSoundId) ? TW.state.ui.spinSoundId : 'retro_reactor';
        var pre = TW.CONST && TW.CONST.PRESPIN_SOUNDS || [];
        for(var i=0;i<pre.length;i++){
          if(pre[i] && pre[i].id === id) add(pre[i].url);
        }
        if(pre[0]) add(pre[0].url);
      }catch(_){ }
      try{
        var wid = (TW.state && TW.state.ui && TW.state.ui.winSoundId) ? TW.state.ui.winSoundId : 'air_zing';
        var wins = TW.CONST && TW.CONST.CELEBRATION_SOUNDS || [];
        for(var j=0;j<wins.length;j++){
          if(wins[j] && wins[j].id === wid) add(wins[j].url);
        }
        if(wins[0]) add(wins[0].url);
      }catch(_){ }
      return urls;
    }

    var __twLastApplePrimeAt = 0;

    function hardPrimeWheelFxAudio(){
      /* .load() on a playing cached Audio element creates the brief dropout
         users heard while touching, scrolling, or repositioning the wheel. */
      if(TW && TW._rt && (TW._rt.spinning || TW._rt.preSpinTO || TW._rt.lockTeaseBusy)) return;
      try{
        if(typeof primeWheelFxAudio === 'function') primeWheelFxAudio();
      }catch(_){ }

      // Apple ghost-audio surgical fix: never call play() on the real wheel FX
      // merely to prime them. The normal cache/load primer above remains intact,
      // while actual requested playback continues through the existing engine.
      if(isAppleMobileLike()) return;
      try{
        // Throttle hard priming. iOS can emit several gesture events for one tap,
        // and repeated play() calls can leak audible ticks.
        var nowPrime = Date.now();
        if(nowPrime - __twLastApplePrimeAt < 900) return;
        __twLastApplePrimeAt = nowPrime;
        TW._audCache = TW._audCache || { byUrl:Object.create(null) };
        var map = TW._audCache.byUrl || (TW._audCache.byUrl = Object.create(null));
        var urls = collectWheelFxUrls();
        for(var i=0;i<urls.length;i++){
          (function(url){
            var a = map[url];
            if(!a){
              a = new Audio(url);
              a.preload = 'auto';
              try{ a.setAttribute('playsinline',''); a.setAttribute('webkit-playsinline',''); }catch(_){ }
              map[url] = a;
            }
            try{ if(typeof a.load === 'function') a.load(); }catch(_){ }

            // Apple surgical fix: priming must never pause a real sound that starts
            // moments later from the same tap/flick. Each prime gets a token; real
            // playback in Part4 clears that token before calling play().
            var token = Date.now() + '-' + Math.random();
            try{ a.__twApplePrimeToken = token; a.__twApplePriming = true; }catch(_){ }
            // Prime with real mute, not near-zero volume. Near-zero volume can leak
            // on iOS when several gesture events arrive together.
            try{ a.muted = true; a.defaultMuted = true; a.volume = 0; }catch(_){ }

            var p = null;
            try{ p = a.play(); }catch(_){ }
            function restore(){
              try{
                if(a.__twApplePrimeToken !== token || a.__twApplePriming === false) return;
              }catch(_){ }
              try{ a.pause(); }catch(_){ }
              try{ a.currentTime = 0; }catch(_){ }
              try{ a.muted = false; a.defaultMuted = false; }catch(_){ }
              try{ a.volume = 1; }catch(_){ }
              try{ a.__twApplePrimed = true; a.__twApplePriming = false; a.__twApplePrimeToken = 0; }catch(_){ }
            }
            if(p && p.then) p.then(function(){ setTimeout(restore, 35); }).catch(restore);
            else setTimeout(restore, 55);
            setTimeout(restore, 220);
            setTimeout(restore, 650);
          })(urls[i]);
        }
      }catch(_){ }
    }

    // Expose a stronger version without breaking existing callers.
    try{ TW.primeWheelFxAudio = hardPrimeWheelFxAudio; }catch(_){ }

    // Capture-phase gesture priming covers flick-to-spin before the engine pointer handlers run.
    if(!TW.__twAppleFlickPrimeBound){
      TW.__twAppleFlickPrimeBound = true;
      ['pointerdown','touchstart','mousedown'].forEach(function(evt){
        try{
          document.addEventListener(evt, function(ev){
            try{
              var t = ev && ev.target;
              var insideWheel = t && t.closest && (t.closest('#toki-wheel-root') || t.closest('#twWheelWrap') || t.closest('#twSpin') || t.closest('#twMulti') || t.closest('.tw-wheelStage') || t.closest('.tw-wheelSvg'));
              if(!insideWheel) return;
              if(TW.audioBridge && TW.audioBridge.arm) TW.audioBridge.arm();
              hardPrimeWheelFxAudio();
              if(TW.voiceBridge && TW.voiceBridge.arm) TW.voiceBridge.arm();
            }catch(_){ }
          }, { passive:true, capture:true });
        }catch(_){ }
      });
    }

    // Some delayed layout passes remove or cover the exit pill. Re-assert it after mode changes.
    function reassertExit(){
      try{
        if(!(TW.state && TW.state.ui && TW.state.ui.overlay)) return;
        var btn = R.wrap && R.wrap.querySelector && R.wrap.querySelector('.tw-presentationExit');
        if(!btn && typeof ensurePresentationExitButton === 'function') btn = ensurePresentationExitButton();
        if(btn){
          btn.hidden = false;
          btn.style.display = 'block';
          btn.style.visibility = 'visible';
          btn.style.pointerEvents = 'auto';
          btn.style.zIndex = '2147483500';
        }
      }catch(_){ }
    }
    try{ window.addEventListener('resize', reassertExit, { passive:true }); }catch(_){ }
    try{ window.addEventListener('orientationchange', function(){ setTimeout(reassertExit, 120); }, { passive:true }); }catch(_){ }
    setTimeout(reassertExit, 120);
    setTimeout(reassertExit, 650);
  })();


  // =========================================================
  // SURGICAL 2026-04-28B - Apple/mobile menu + image picker tap guard
  // Prevent custom select/image/sticker menu taps from bubbling into Shopify/theme
  // link handlers. Image popovers are appended to document.body, not inside
  // #toki-wheel-root, so the previous guard missed them.
  // =========================================================
  (function installAppleMenuNavigationGuard(){
    if(TW.__twAppleMenuNavigationGuardC) return;
    TW.__twAppleMenuNavigationGuardC = true;

    function isWheelMenuTapTarget(t){
      try{
        return !!(t && t.closest && (
          t.closest('#toki-wheel-root .tw-menuPanel') ||
          t.closest('#toki-wheel-root .tw-menuOption') ||
          t.closest('#toki-wheel-root .tw-selectMenu') ||
          t.closest('#toki-wheel-root .tw-selectWrap') ||
          t.closest('#toki-wheel-root .tw-stickerTile') ||
          t.closest('#toki-wheel-root .tw-stickerGrid') ||
          t.closest('#toki-wheel-root .tw-palBtn') ||
          t.closest('#toki-wheel-root .tw-popover') ||
          t.closest('.tw-menuPanel') ||
          t.closest('.tw-menuOption') ||
          t.closest('.tw-selectMenu') ||
          t.closest('.tw-selectWrap') ||
          t.closest('.tw-popover') ||
          t.closest('.tw-palBtn') ||
          t.closest('.tw-stickerTile') ||
          t.closest('.tw-stickerGrid') ||
          t.closest('.tw-planPillTile')
        ));
      }catch(_){ return false; }
    }

    function hasWheelContext(t){
      try{
        if(!t || !t.closest) return false;
        return !!(
          t.closest('#toki-wheel-root') ||
          t.closest('.tw-popover') ||
          t.closest('.tw-menuPanel') ||
          t.closest('.tw-modal')
        );
      }catch(_){ return false; }
    }

    ['touchstart','touchend','pointerdown','pointerup','click'].forEach(function(evt){
      try{
        document.addEventListener(evt, function(ev){
          try{
            var t = ev && ev.target;
            if(!hasWheelContext(t) || !isWheelMenuTapTarget(t)) return;

            // Prevent only real links from navigating/reloading inside Apple popovers.
            // Do NOT preventDefault on buttons/options: that was blocking mobile taps
            // and breaking the image/sticker dropdown on Safari.
            var a = t.closest && t.closest('a[href]');
            if(a && String(a.getAttribute('href') || '').trim()){
              ev.preventDefault && ev.preventDefault();
            }
          }catch(_){ }
        }, { capture:true, passive:false });

        document.addEventListener(evt, function(ev){
          try{
            var t = ev && ev.target;
            if(!hasWheelContext(t) || !isWheelMenuTapTarget(t)) return;
            var tag = String((t.tagName || '')).toLowerCase();
            if(tag === 'input' || tag === 'textarea' || tag === 'select') return;
            // Let the actual wheel button/tile handler run first, then stop Shopify
            // wrappers from seeing the same tap as a page/card navigation.
            ev.stopPropagation && ev.stopPropagation();
          }catch(_){ }
        }, { capture:false, passive:false });
      }catch(_){ }
    });
  })();

    setTimeout(bindBadgeDrag, 80);
    setTimeout(bindBadgeDrag, 300);

    setTimeout(forceClearCenterBadgeIfEmpty, 120);
    setTimeout(forceClearCenterBadgeIfEmpty, 420);
  })();
})();

/* =========================================================
   QUICK TWEAKS DISCOVERY PANELS — 2026-10-13
   Compact all-packs gateway + purpose-built Vortex Pro feature.
   ========================================================= */
(function installQuickTweaksDiscoveryStyles(){
  if(document.getElementById('tw-quick-discovery-1013')) return;
  var style = document.createElement('style');
  style.id = 'tw-quick-discovery-1013';
  style.textContent = [
    '#toki-wheel-root .tw-quickAllPacksPromo{position:relative;isolation:isolate;display:grid;grid-template-columns:minmax(150px,220px) minmax(0,1fr) auto;align-items:center;gap:18px;width:100%;margin-top:18px;padding:16px 18px;border:1px solid rgba(64,18,104,.14);border-left:5px solid #7044bd;border-radius:22px;background:linear-gradient(115deg,#fff8ee 0%,#fff 62%,#f2eaff 100%);box-shadow:0 13px 30px rgba(64,18,104,.11),inset 0 1px 0 #fff;color:#2d1d42;overflow:hidden}',
    '#toki-wheel-root .tw-quickAllPacksPreview{display:grid;grid-template-columns:repeat(3,1fr);gap:6px;min-width:0}',
    '#toki-wheel-root .tw-quickAllPacksPreview img{display:block;width:100%;aspect-ratio:16/10;object-fit:cover;border-radius:9px;border:1px solid rgba(64,18,104,.12);box-shadow:0 5px 12px rgba(64,18,104,.10)}',
    '#toki-wheel-root .tw-quickAllPacksCopy{min-width:0}',
    '#toki-wheel-root .tw-quickAllPacksKicker{margin-bottom:5px;color:#7044bd;font-size:10px;font-weight:950;line-height:1;letter-spacing:.13em;text-transform:uppercase}',
    '#toki-wheel-root .tw-quickAllPacksTitle{color:#401268;font-size:18px;font-weight:950;line-height:1.12}',
    '#toki-wheel-root .tw-quickAllPacksText{margin-top:5px;color:#675d70;font-size:12px;font-weight:650;line-height:1.38}',
    '#toki-wheel-root .tw-quickAllPacksBtn{display:inline-flex;align-items:center;justify-content:center;min-width:172px;min-height:42px;padding:9px 16px;border:1px solid rgba(64,18,104,.22);border-radius:999px;background:linear-gradient(135deg,#7044bd,#532592);color:#fff8ee;font:inherit;font-size:12px;font-weight:950;line-height:1.1;cursor:pointer;box-shadow:inset 0 1px 0 rgba(255,255,255,.28),0 8px 18px rgba(64,18,104,.18);transition:transform .18s ease,filter .18s ease}',
    '#toki-wheel-root .tw-quickAllPacksBtn:hover{transform:translateY(-2px);filter:brightness(1.05)}',

    '#toki-wheel-root .tw-vortexProFeature{position:relative;isolation:isolate;display:grid;grid-template-columns:minmax(0,1.35fr) minmax(230px,.65fr);align-items:stretch;gap:20px;width:100%;margin-top:18px;border:1px solid rgba(255,255,255,.17);border-top:5px solid #e8b944;border-radius:26px;background:radial-gradient(circle at 88% 18%,rgba(91,192,235,.24),transparent 32%),radial-gradient(circle at 18% 105%,rgba(204,0,126,.22),transparent 40%),linear-gradient(135deg,#11091d 0%,#2a1242 52%,#173f75 100%);box-shadow:0 20px 45px rgba(17,9,29,.25),0 0 35px rgba(91,192,235,.16),inset 0 1px 0 rgba(255,255,255,.18);color:#fff8ee;overflow:hidden}',
    '#toki-wheel-root .tw-vortexProFeatureCopy{position:relative;z-index:2;padding:clamp(20px,3vw,30px)}',
    '#toki-wheel-root .tw-vortexProFeatureKicker{display:inline-flex;align-items:center;min-height:27px;padding:0 12px;border:1px solid rgba(255,224,132,.34);border-radius:999px;background:linear-gradient(135deg,#e4b43d,#bd8012);color:#fff8ee;font-size:10px;font-weight:950;line-height:1;letter-spacing:.14em;box-shadow:inset 0 1px 0 rgba(255,255,255,.30),0 7px 17px rgba(0,0,0,.18)}',
    '#toki-wheel-root .tw-vortexProFeatureTitle{margin-top:12px;color:#fff8ee;font-size:clamp(24px,3vw,35px);font-weight:950;line-height:1.02;letter-spacing:-.025em;text-shadow:0 3px 15px rgba(0,0,0,.28)}',
    '#toki-wheel-root .tw-vortexProFeatureText{max-width:650px;margin-top:9px;color:rgba(255,248,238,.82);font-size:14px;font-weight:600;line-height:1.48}',
    '#toki-wheel-root .tw-vortexProFeaturePills{display:flex;flex-wrap:wrap;gap:7px;margin-top:15px}',
    '#toki-wheel-root .tw-vortexProFeaturePills span{display:inline-flex;align-items:center;min-height:29px;padding:6px 10px;border:1px solid rgba(255,255,255,.14);border-radius:999px;background:rgba(255,255,255,.08);color:#fff8ee;font-size:11px;font-weight:800;line-height:1.15;box-shadow:inset 0 1px 0 rgba(255,255,255,.08)}',
    '#toki-wheel-root .tw-vortexProFeatureAction{display:flex;align-items:center;gap:13px;flex-wrap:wrap;margin-top:18px}',
    '#toki-wheel-root .tw-vortexProFeaturePrice{color:#ffe394;font-size:13px;font-weight:950;letter-spacing:.02em}',
    '#toki-wheel-root .tw-vortexProFeatureBtn{display:inline-flex;align-items:center;justify-content:center;min-width:165px;min-height:42px;padding:9px 17px;border:1px solid rgba(255,231,158,.40);border-radius:999px;background:linear-gradient(135deg,#e4b43d,#bd8012);color:#fff8ee;font:inherit;font-size:12px;font-weight:950;line-height:1.1;cursor:pointer;box-shadow:inset 0 1px 0 rgba(255,255,255,.35),0 9px 21px rgba(0,0,0,.20);transition:transform .18s ease,filter .18s ease}',
    '#toki-wheel-root .tw-vortexProFeatureBtn:hover{transform:translateY(-2px);filter:brightness(1.06)}',
    '#toki-wheel-root .tw-vortexProFeatureArt{position:relative;z-index:1;display:flex;align-items:center;justify-content:center;min-height:260px;padding:18px;background:linear-gradient(135deg,rgba(255,255,255,.04),rgba(255,255,255,.10));overflow:hidden}',
    '#toki-wheel-root .tw-vortexProFeatureArt::before{content:"";position:absolute;width:260px;aspect-ratio:1;border-radius:50%;background:radial-gradient(circle,rgba(232,185,68,.23),rgba(91,192,235,.12) 48%,transparent 70%);filter:blur(8px)}',
    '#toki-wheel-root .tw-vortexProFeatureArt img{position:relative;z-index:1;display:block;width:100%;max-width:330px;height:auto;max-height:245px;object-fit:contain;border-radius:17px;filter:drop-shadow(0 15px 28px rgba(0,0,0,.30))}',
    '#toki-wheel-root .tw-quickAllPacksBtn:focus-visible,#toki-wheel-root .tw-vortexProFeatureBtn:focus-visible{outline:3px solid #5bc0eb;outline-offset:3px}',
    '@media(max-width:780px){#toki-wheel-root .tw-quickAllPacksPromo{grid-template-columns:1fr;gap:12px;padding:15px}#toki-wheel-root .tw-quickAllPacksPreview{max-width:330px}#toki-wheel-root .tw-quickAllPacksBtn{width:min(100%,220px)}#toki-wheel-root .tw-vortexProFeature{grid-template-columns:1fr}#toki-wheel-root .tw-vortexProFeatureArt{grid-row:1;min-height:0;padding:14px 16px 0;background:transparent}#toki-wheel-root .tw-vortexProFeatureArt img{max-width:280px;max-height:180px}#toki-wheel-root .tw-vortexProFeatureCopy{padding:18px}#toki-wheel-root .tw-vortexProFeatureTitle{font-size:27px}}',
    '@media(prefers-reduced-motion:reduce){#toki-wheel-root .tw-quickAllPacksBtn,#toki-wheel-root .tw-vortexProFeatureBtn{transition:none}}',
    '#toki-wheel-root .tw-quickAllPacksFull{box-sizing:border-box;width:100%;max-width:none;margin-top:18px}',
    '#toki-wheel-root .tw-quickAllPacksFull .tw-labPackChoiceGrid{grid-template-columns:repeat(3,minmax(0,1fr));width:100%}',
    '#toki-wheel-root .tw-quickAllPacksFull .tw-labPackChoiceCard{width:100%;max-width:none}',
    '#toki-wheel-root .tw-bottomVortexPromo{box-sizing:border-box;width:100%;max-width:none;margin-top:24px}',
    '#toki-wheel-root .tw-bottomVortexPromo .tw-subscriptionChoiceGrid{grid-template-columns:minmax(0,1fr)!important;width:100%;max-width:none}',
    '#toki-wheel-root .tw-bottomVortexPromo .tw-subscriptionChoiceCard{width:100%!important;max-width:none!important}',
    '#toki-wheel-root .tw-bottomVortexPromo .tw-subscriptionChoiceMedia{width:100%!important;min-width:0}',
    '#toki-wheel-root .tw-bottomVortexPromo .tw-subscriptionChoiceMedia img{display:block;width:100%!important;max-width:none!important;height:auto!important;object-fit:contain}',
    '@media(max-width:980px){#toki-wheel-root .tw-quickAllPacksFull .tw-labPackChoiceGrid{grid-template-columns:repeat(2,minmax(0,1fr))}}',
    '@media(max-width:640px){#toki-wheel-root .tw-quickAllPacksFull .tw-labPackChoiceGrid{grid-template-columns:1fr}}'
  ].join('');
  document.head.appendChild(style);
})();

/* 2026-09-13: clearer accordion discovery headers. */
(function installPanelDiscoveryHeaders0913(){
  var style=document.createElement('style');
  style.id='tw-panel-discovery-0913';
  style.textContent=[
    '#toki-wheel-root .tw-panelSummary{display:grid!important;grid-template-columns:50px minmax(0,1fr) 50px!important;align-items:center!important;gap:12px!important;box-sizing:border-box!important;height:82px!important;min-height:82px!important;max-height:82px!important;padding:10px 16px!important;cursor:pointer!important;}',
    '#toki-wheel-root .tw-panelSummary::-webkit-details-marker{display:none!important;}',
    '#toki-wheel-root .tw-panelHeaderIcon{display:block!important;width:46px!important;height:46px!important;object-fit:contain!important;filter:drop-shadow(0 6px 10px rgba(36,13,70,.20))!important;}',
    '#toki-wheel-root .tw-panelHeaderCopy{position:relative!important;display:grid!important;align-content:center!important;gap:4px!important;min-width:0!important;}',
    '#toki-wheel-root .tw-panelHeaderSubtext{color:var(--tw-headerText,var(--tw-white,#fff8ee))!important;-webkit-text-fill-color:currentColor!important;opacity:.78!important;font-size:12px!important;font-weight:750!important;line-height:1.3!important;}',
    '#toki-wheel-root .tw-panelProBadge{position:absolute!important;right:0!important;top:50%!important;display:grid!important;place-items:center!important;width:62px!important;height:62px!important;transform:translateY(-50%)!important;isolation:isolate!important;}',
    '#toki-wheel-root .tw-panelProBadge::before{content:""!important;position:absolute!important;z-index:-1!important;inset:-9px!important;border-radius:50%!important;background:radial-gradient(circle,rgba(255,207,83,.48) 0%,rgba(255,91,190,.25) 42%,transparent 74%)!important;filter:blur(5px)!important;}',
    '#toki-wheel-root .tw-panelProIcon{display:block!important;width:58px!important;height:58px!important;object-fit:contain!important;filter:drop-shadow(0 0 7px rgba(247,190,70,.55)) drop-shadow(0 7px 11px rgba(36,13,70,.28))!important;}',
    '#toki-wheel-root .tw-panelHeaderCopy:has(.tw-panelProBadge){padding-right:70px!important;}',
    '#toki-wheel-root .tw-panelPushButton{display:block!important;width:48px!important;height:48px!important;object-fit:contain!important;transition:transform .2s ease,filter .2s ease!important;filter:drop-shadow(0 7px 10px rgba(36,13,70,.24))!important;}',
    '#toki-wheel-root .tw-panelSummary:hover .tw-panelPushButton{transform:translateY(-2px) scale(1.04)!important;filter:drop-shadow(0 10px 13px rgba(36,13,70,.32))!important;}',
    '#toki-wheel-root details[open]>.tw-panelSummary .tw-panelPushButton{transform:scale(1.03)!important;filter:drop-shadow(0 0 8px rgba(20,201,138,.82)) drop-shadow(0 0 18px rgba(0,150,105,.58)) drop-shadow(0 7px 10px rgba(15,78,55,.28))!important;}',
    '#toki-wheel-root .tw-sideTitle .tw-h2::before{content:none!important;display:none!important;}',
    '#toki-wheel-root .tw-vaultTrophy{width:46px!important;height:46px!important;object-fit:contain!important;font-size:0!important;}',
    'body:not(.twStreamBody) #toki-wheel-root .tw-wheelMeta{align-items:flex-start!important;}',
    'body:not(.twStreamBody) #toki-wheel-root .tw-wheelMetaText .tw-titles{gap:3px!important;}',
    'body:not(.twStreamBody) #toki-wheel-root .tw-wheelMeta .tw-title{margin:0!important;font-size:clamp(18px,2.1vw,27px)!important;line-height:1!important;}',
    'body:not(.twStreamBody) #toki-wheel-root .tw-wheelMeta .tw-subtitle{margin:0!important;font-size:clamp(11px,1.1vw,14px)!important;line-height:1.2!important;}',
    'body:not(.twStreamBody) #toki-wheel-root .tw-wheelMetaActions{align-self:flex-start!important;margin-top:0!important;padding:0!important;gap:7px!important;}',
    'body:not(.twStreamBody) #toki-wheel-root .tw-wheelMetaActions .tw-settingsButton,body:not(.twStreamBody) #toki-wheel-root .tw-wheelMetaActions #twDashboardSave{width:34px!important;min-width:34px!important;max-width:34px!important;height:34px!important;min-height:34px!important;max-height:34px!important;padding:0!important;border:0!important;border-radius:8px!important;background:transparent!important;box-shadow:none!important;-webkit-box-shadow:none!important;backdrop-filter:none!important;-webkit-backdrop-filter:none!important;}',
    'body:not(.twStreamBody) #toki-wheel-root .tw-wheelMetaActions .tw-settingsButton:hover,body:not(.twStreamBody) #toki-wheel-root .tw-wheelMetaActions .tw-settingsButton:focus-visible,body:not(.twStreamBody) #toki-wheel-root .tw-wheelMetaActions #twDashboardSave:hover,body:not(.twStreamBody) #toki-wheel-root .tw-wheelMetaActions #twDashboardSave:focus-visible{background:rgba(255,255,255,.07)!important;box-shadow:0 0 14px rgba(91,192,235,.22)!important;}',
    'body:not(.twStreamBody) #toki-wheel-root .tw-wheelMetaActions .tw-mainActionIcon{width:25px!important;height:25px!important;}',
    '@media(max-width:640px){#toki-wheel-root .tw-panelSummary{grid-template-columns:44px minmax(0,1fr) 44px!important;gap:9px!important;height:76px!important;min-height:76px!important;max-height:76px!important;padding:8px 12px!important;}#toki-wheel-root .tw-panelHeaderIcon{width:40px!important;height:40px!important;}#toki-wheel-root .tw-panelPushButton{width:42px!important;height:42px!important;}#toki-wheel-root .tw-panelHeaderSubtext{font-size:10px!important;}#toki-wheel-root .tw-panelProBadge{width:50px!important;height:50px!important;}#toki-wheel-root .tw-panelProIcon{width:47px!important;height:47px!important;}#toki-wheel-root .tw-panelHeaderCopy:has(.tw-panelProBadge){padding-right:55px!important;}}',
    '@media(prefers-reduced-motion:reduce){#toki-wheel-root .tw-panelPushButton{transition:none!important;}}'
  ].join('');
  document.head.appendChild(style);
})();

/* 2026-08-15: tap-to-spin, first-spin cue, compact Lab CTA, and mobile invite composer. */
(function installTapSpinAndMobilePolish0815(){
  if(window.__twTapSpin0815)return;window.__twTapSpin0815=true;
  var TW=window.TokiWheel;if(!TW)return;var R=TW.refs||{},FIRST='tokiWheelHasSpunV1';
  function hasSpun(){try{return localStorage.getItem(FIRST)==='yes';}catch(_){return false;}}
  function syncLabel(){var b=(TW.refs&&TW.refs.btnSpin)||document.getElementById('twSpin');if(b){var label=hasSpun()?'Spin':'Spin the wheel';b.textContent=TW.i18n&&TW.i18n.t?TW.i18n.t(label):label;}}
  syncLabel();setTimeout(syncLabel,250);setTimeout(syncLabel,1200);

  var cue=null,cueTimer=0,CUE='tokiTapSpinCueSeenV1';
  function removeCue(){if(cueTimer)clearTimeout(cueTimer);cueTimer=0;if(cue&&cue.parentNode)cue.parentNode.removeChild(cue);cue=null;}
  function freeVisitor(){var p=TW.access&&TW.access.getUserPlan?TW.access.getUserPlan():'free';return p==='free';}
  function cueSeen(){try{return localStorage.getItem(CUE)==='yes';}catch(_){return false;}}
  function markCueSeen(){try{localStorage.setItem(CUE,'yes');}catch(_){} }
  function showCue(){
    if(cueSeen()||!freeVisitor()||!R.wheelWrap||cue)return;
    cue=document.createElement('div');cue.className='tw-tapSpinCue';cue.textContent='Tap to spin';
    R.wheelWrap.appendChild(cue);cueTimer=setTimeout(function(){markCueSeen();removeCue();},7000);
  }
  if(R.wheelWrap&&'IntersectionObserver' in window){var cueObserver=new IntersectionObserver(function(entries){if(entries.some(function(x){return x.isIntersecting&&x.intersectionRatio>=.28;})){cueObserver.disconnect();setTimeout(showCue,350);}},{threshold:[.28]});cueObserver.observe(R.wheelWrap);}else setTimeout(showCue,900);
  document.addEventListener('toki:wheel-first-spin',function(){markCueSeen();removeCue();syncLabel();});

  var tap=null;
  if(R.wheelWrap){
    R.wheelWrap.addEventListener('pointerdown',function(e){
      if(e.button!=null&&e.button!==0)return;
      /* The controls are nested inside wheelWrap on some mobile layouts.
         Never intercept a genuine Spin/control press. */
      if(e.target&&e.target.closest&&e.target.closest('button,input,textarea,select,a,[role="button"],summary')){tap=null;return;}
      if((TW._rt&&TW._rt.spinning)||(TW.state&&TW.state.ui&&TW.state.ui.centerBadgeEditOn==='yes'))return;
      tap={id:e.pointerId,x:e.clientX,y:e.clientY,t:performance.now(),moved:false};
    },true);
    R.wheelWrap.addEventListener('pointermove',function(e){if(tap&&tap.id===e.pointerId&&Math.hypot(e.clientX-tap.x,e.clientY-tap.y)>10)tap.moved=true;},true);
    R.wheelWrap.addEventListener('pointerup',function(e){
      if(!tap||tap.id!==e.pointerId)return;var held=performance.now()-tap.t,spin=!tap.moved&&held<520&&!(TW._fidget&&TW._fidget.on);tap=null;if(!spin)return;
      TW._flickUnlockedBySpin=true;markCueSeen();removeCue();
      /* Run the exact function used by the Spin button while this native
         pointer-up gesture is still active; no synthetic click is involved. */
      if(TW.activateSpinFromGesture)TW.activateSpinFromGesture();
    },true);
    R.wheelWrap.addEventListener('pointercancel',function(){tap=null;},true);
  }

  var st=document.createElement('style');st.id='tw-polish-0815';st.textContent=[
    '#toki-wheel-root .tw-wheelWrap{position:relative;cursor:pointer}',
    '#toki-wheel-root .tw-tapSpinCue{position:absolute!important;z-index:2147481000!important;left:50%!important;top:50%!important;transform:translate(-50%,-50%);pointer-events:none!important;padding:9px 15px;border:1px solid rgba(255,255,255,.68);border-radius:999px;background:rgba(20,12,35,.88);color:#fff;font:900 14px/1 Fredoka,system-ui,sans-serif;letter-spacing:.03em;box-shadow:0 8px 24px rgba(0,0,0,.32);animation:twTapCuePulse 1s ease 3,twTapCueRest 4s 3s linear forwards}',
    '@keyframes twTapCuePulse{0%,100%{transform:translate(-50%,-50%) scale(1);opacity:.82}50%{transform:translate(-50%,-50%) scale(1.1);opacity:1}}@keyframes twTapCueRest{from{opacity:.88}to{opacity:.88}}',
    '#toki-wheel-root.tw-challengeMode .tw-wheelCard>.tw-challengeBanner{display:block!important;position:relative!important;z-index:12!important;width:100%!important;max-width:none!important;margin:0 0 12px!important;order:-10!important}',
    '#toki-wheel-root #twVortexAI .tw-aiPremiumNotice .tw-aiPreviewCta.tw-btnPrimary,#toki-wheel-root #twSpinExperience .tw-creativeLabLockNotice.tw-aiPremiumNotice .tw-aiPreviewCta.tw-btnPrimary,#toki-wheel-root #twSpinBiz .tw-bizLockNotice .tw-aiPreviewCta.tw-btnPrimary{box-sizing:border-box!important;width:auto!important;min-width:210px!important;max-width:100%!important;height:46px!important;min-height:46px!important;padding:0 22px!important;font-size:14px!important;line-height:1!important}',
    '#toki-wheel-root .tw-modal.tw-challengeComposerMobile{box-sizing:border-box!important;overflow-y:auto!important;overscroll-behavior:contain!important;scroll-padding:76px 0 48px!important;margin:0!important;animation:none!important;transition:none!important}',
    '#toki-wheel-root .tw-modal.tw-challengeComposerMobile .tw-input{font-size:16px!important;scroll-margin-top:76px!important;scroll-margin-bottom:48px!important}',
    '@media(max-width:700px){#toki-wheel-root .tw-modal.tw-challengeComposerMobile{left:8px!important;right:8px!important;top:max(8px,env(safe-area-inset-top,0px))!important;bottom:auto!important;transform:none!important;width:auto!important;max-height:calc(100dvh - 16px - env(safe-area-inset-top,0px))!important}}',
    '@media(prefers-reduced-motion:reduce){#toki-wheel-root .tw-tapSpinCue{animation:none!important}}'
  ].join('');document.head.appendChild(st);
})();

/* Completed-tour handoff: keep customization discoverable without continuing
   to advertise a tour, and arm one post-spin sharing prompt for free users. */
(function installCustomizationTourCompletionHandoff0813(){
  function applyEvergreenCopy(){
    var button=document.querySelector('#toki-wheel-root .tw-wheelCard .tw-startEditing');
    if(!button)return false;
    var kicker=button.querySelector('.tw-startEditingKicker');
    var title=button.querySelector('.tw-startEditingCopy strong');
    var copy=button.querySelector('.tw-startEditingCopy small');
    if(kicker&&kicker.textContent!=='KEEP CREATING')kicker.textContent='KEEP CREATING';
    if(title&&title.textContent!=='Customize even more')title.textContent='Customize even more';
    if(copy&&copy.textContent!=='Update choices, colors, stickers, sounds, and wheel details anytime')copy.textContent='Update choices, colors, stickers, sounds, and wheel details anytime';
    return true;
  }
  function isComplete(){try{return localStorage.getItem('tokiCustomizationTourV1')==='completed';}catch(_){return false;}}
  if(isComplete())setTimeout(applyEvergreenCopy,0);
  document.addEventListener('click',function(event){
    var button=event.target&&event.target.closest&&event.target.closest('.tw-tourAction');
    if(!button||String(button.textContent||'').toLowerCase().indexOf('spin')<0)return;
    try{localStorage.setItem('tokiCustomizationTourShareV1','pending');}catch(_){}
    setTimeout(applyEvergreenCopy,40);
  },true);
  var observer=new MutationObserver(function(){if(isComplete()&&applyEvergreenCopy())observer.disconnect();});
  var root=document.getElementById('toki-wheel-root');if(root)observer.observe(root,{childList:true,subtree:true});
  var style=document.createElement('style');style.textContent='.tw-tourStep:not(.isDone) .tw-tourStepIcon{font-size:0!important;border:2px solid rgba(255,255,255,.28);background:rgba(255,255,255,.04)!important;box-sizing:border-box}.tw-customTour.isCelebrating .tw-tourStep.isCurrent .tw-tourStepIcon{font-size:18px!important;border-color:rgba(68,204,139,.62);background:rgba(68,204,139,.25)!important;color:#bfffdc!important}.tw-customTour.isCelebrating .tw-tourStep.isCurrent .tw-tourStepIcon::after{content:"✓"}.tw-tourSharePulse{animation:twTourSharePulse .72s ease-in-out infinite!important;position:relative!important;z-index:3!important}@keyframes twTourSharePulse{50%{transform:translateY(-2px) scale(1.045);box-shadow:0 0 0 6px rgba(255,63,157,.18),0 0 28px rgba(32,201,220,.62)}}@media(prefers-reduced-motion:reduce){.tw-tourSharePulse{animation:none!important;box-shadow:0 0 0 5px rgba(255,63,157,.2)!important}}';document.head.appendChild(style);
})();

/* Normalize tour status marks after the legacy tour style: status boxes never
   inherit step artwork, and both transient/final checks are truly centered. */
(function installTourStatusMarkFix0813(){
  var style=document.createElement('style');
  style.textContent='.tw-tourStepIcon{font-size:0!important;display:grid!important;place-items:center!important;text-align:center!important;line-height:1!important}.tw-tourStep.isDone .tw-tourStepIcon::after,.tw-customTour.isCelebrating .tw-tourStep.isCurrent .tw-tourStepIcon::after{content:"\\2713";display:block;font:950 18px/1 system-ui,sans-serif;text-align:center}.tw-tourStep:not(.isDone) .tw-tourStepIcon{font-size:0!important}.tw-customTour.isCelebrating .tw-tourStep.isCurrent .tw-tourStepIcon{font-size:0!important}';
  document.head.appendChild(style);
})();

(function installShareDiscoveryPromptStyle0813(){
  var style=document.createElement('style');
  style.textContent='.tw-shareDiscoveryPrompt{width:min(390px,calc(100vw - 24px))!important}.tw-shareDiscoveryNote{margin:2px 0 14px;padding:12px 13px;border:1px solid rgba(255,255,255,.14);border-radius:14px;background:rgba(255,255,255,.07);color:rgba(255,248,238,.78);font-size:11px;line-height:1.4;font-weight:700}.tw-shareDiscoveryAction{width:100%!important;min-height:44px!important;border-radius:999px!important;background:linear-gradient(135deg,#cc007e,#7044bd)!important;color:#fff!important;font-weight:950!important}@media(max-width:640px){.tw-shareDiscoveryPrompt{max-height:48dvh!important;overflow:auto!important}}';
  document.head.appendChild(style);
})();

/* Final icon system. Decorates by semantic refs/labels so later button clones
   (notably Sound and Voice) retain the supplied artwork. */
(function installWheelAndTourIcons0813(){
  var URL={
    gear:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/mainpagegearicon.png?v=1789229389',
    plus:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/mainpageplusicon.png?v=1789387078',
    reset:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/gearreseticon.png?v=1789229918',
    share:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/gearshareicon.png?v=1789229850',
    voice:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/gearvoiceicon.png?v=1789229699',
    eliminate:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/geareliminateicon.png?v=1789230075',
    end:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/gearendofroundwinnericon.png?v=1789230161',
    sound:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/gearsoundicon.png?v=1789229632',
    overlay:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/gearoverlayicon.png?v=1789229784',
    builder:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/tourbuildericon.png?v=1789230263',
    color:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/tourcoloricon.png?v=1789228750',
    sticker:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/tourstickericon.png?v=1789228831',
    countdown:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/tourcountdownicon.png?v=1789228899',
    toursound:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/toursoundicon.png?v=1789228991',
    tourvoice:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/tourvoiceicon.png?v=1789229110',
    spin:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/tourspinicon.png?v=1789229170'
  };
  function icon(button,url,cls){if(!button||!url)return;var old=button.querySelector('.tw-btnGlyph,.tw-settingsGlyph,.tw-mainActionIcon,.tw-gearMenuIcon'),img=old&&old.tagName==='IMG'?old:document.createElement('img');img.className=cls||'tw-gearMenuIcon';if(img.src!==url)img.src=url;img.alt='';img.setAttribute('aria-hidden','true');if(old&&old!==img)old.replaceWith(img);else if(!old)button.insertBefore(img,button.firstChild);}
  function liveMenuButton(label){var buttons=document.querySelectorAll('#toki-wheel-root .tw-headerMoreMenu .tw-menuList button');label=String(label||'').toLowerCase();for(var i=0;i<buttons.length;i++){if(String(buttons[i].textContent||'').toLowerCase().indexOf(label)>=0)return buttons[i];}return null;}
  function decorate(){var TW=window.TokiWheel,R=TW&&TW.refs;if(!R)return;icon(R.btnMore,URL.gear,'tw-mainActionIcon');icon(R.btnDashboardSave,URL.plus,'tw-mainActionIcon');icon(R.btnResetAllTop,URL.reset);icon(R.btnShare,URL.share);icon(R.btnVoiceSettings||R.btnVoiceToggle,URL.voice);icon(R.btnElimTop,URL.eliminate);icon(R.btnEndRound,URL.end);icon(R.btnSoundSettings||R.btnSoundToggle,URL.sound);icon(R.btnOverlay,URL.overlay);document.querySelectorAll('#toki-wheel-root .tw-startEditingIcon img').forEach(function(img){if(img.src!==URL.builder)img.src=URL.builder;});var hero=document.querySelector('.tw-customTour:not(.tw-shareDiscoveryPrompt) .tw-tourHeroIcon'),title=document.querySelector('.tw-customTour:not(.tw-shareDiscoveryPrompt) .tw-tourTitle');if(hero&&title){var text=String(title.textContent||'').toLowerCase(),src=text.indexOf('color')>=0?URL.color:text.indexOf('sticker')>=0?URL.sticker:text.indexOf('countdown')>=0?URL.countdown:text.indexOf('sound')>=0?URL.toursound:text.indexOf('voice')>=0?URL.tourvoice:text.indexOf('spin')>=0?URL.spin:URL.builder,current=hero.querySelector('img');if(!current||current.src!==src)hero.innerHTML='<img src="'+src+'" alt="" aria-hidden="true">';}try{if(localStorage.getItem('tokiCustomizationTourV1')==='completed'){document.querySelectorAll('#toki-wheel-root .tw-startEditing').forEach(function(button){var k=button.querySelector('.tw-startEditingKicker'),t=button.querySelector('.tw-startEditingCopy strong'),c=button.querySelector('.tw-startEditingCopy small');if(k&&k.textContent!=='KEEP CREATING')k.textContent='KEEP CREATING';if(t&&t.textContent!=='Customize even more')t.textContent='Customize even more';if(c&&c.textContent!=='Update choices, colors, stickers, sounds, and wheel details anytime')c.textContent='Update choices, colors, stickers, sounds, and wheel details anytime';});}}catch(_){}}
  decorate();var root=document.getElementById('toki-wheel-root');if(root)new MutationObserver(decorate).observe(root,{childList:true,subtree:true});new MutationObserver(decorate).observe(document.body,{childList:true,subtree:true});
  var style=document.createElement('style');style.textContent='.tw-mainActionIcon{display:block!important;width:22px!important;height:22px!important;object-fit:contain!important}.tw-gearMenuIcon{display:block!important;flex:0 0 24px!important;width:24px!important;height:24px!important;object-fit:contain!important}.tw-tourHeroIcon img{display:block!important;width:30px!important;height:30px!important;object-fit:contain!important}.tw-shareDiscoveryPills{display:flex;flex-wrap:wrap;gap:7px;margin:0 0 14px}.tw-shareDiscoveryPills span{padding:6px 9px;border:1px solid rgba(255,255,255,.14);border-radius:999px;background:rgba(255,255,255,.08);color:#d9fbff;font-size:10px;font-weight:900}';document.head.appendChild(style);
})();

/* Final live-menu repair: Dashboard's legacy plus is a separate label, while
   Voice is cloned after initial refs are captured. Resolve both from live DOM. */
(function installLiveHeaderIconRepair0813(){
  var plusUrl='https://cdn.shopify.com/s/files/1/0709/3675/6398/files/mainpageplusicon.png?v=1789387078';
  var voiceUrl='https://cdn.shopify.com/s/files/1/0709/3675/6398/files/gearvoiceicon.png?v=1789229699';
  function make(url,cls){var img=document.createElement('img');img.className=cls;img.src=url;img.alt='';img.setAttribute('aria-hidden','true');return img;}
  function repair(){
    var plus=document.getElementById('twDashboardSave');
    if(plus){plus.querySelectorAll('.tw-btnLabel').forEach(function(node){node.remove();});if(!plus.querySelector('img.tw-mainActionIcon'))plus.insertBefore(make(plusUrl,'tw-mainActionIcon'),plus.firstChild);}
    var buttons=document.querySelectorAll('#toki-wheel-root .tw-headerMoreMenu .tw-menuList button');
    for(var i=0;i<buttons.length;i++){
      if(String(buttons[i].textContent||'').toLowerCase().indexOf('voice')<0)continue;
      var old=buttons[i].querySelector('.tw-btnGlyph,.tw-gearMenuIcon');
      if(old&&old.tagName==='IMG'){if(old.src!==voiceUrl)old.src=voiceUrl;old.className='tw-gearMenuIcon';}
      else if(old)old.replaceWith(make(voiceUrl,'tw-gearMenuIcon'));
      else buttons[i].insertBefore(make(voiceUrl,'tw-gearMenuIcon'),buttons[i].firstChild);
      break;
    }
  }
  repair();var root=document.getElementById('toki-wheel-root');if(root)new MutationObserver(repair).observe(root,{childList:true,subtree:true});
  var style=document.createElement('style');style.textContent='.tw-shareDiscoveryPills{justify-content:center!important;text-align:center!important}.tw-shareDiscoveryPills span{text-align:center!important}';document.head.appendChild(style);
})();

/* Must remain last: authoritative lab spacing, Inventor navy lighting, and Apple tablet unclipping. */
(function installLabAndAppleFinish0810(){
  if(window.__twLabAndAppleFinish0810) return;
  window.__twLabAndAppleFinish0810 = true;
  var style = document.createElement('style');
  style.id = 'tw-lab-and-apple-finish-0810';
  style.textContent = [
    /* Use one shared major-panel gap on both sides of the paid labs. */
    '#toki-wheel-root #twOptions{margin-bottom:32px!important;}',
    '#toki-wheel-root #twOptions+#twSpinExperience{margin-top:0!important;}',
    '#toki-wheel-root #twVortexAI{margin-bottom:32px!important;}',
    '#toki-wheel-root #twVortexAI+#twCustomize{margin-top:0!important;}',

    /* Creator and Inventor share one exact panel shell. No Inventor-only blue survives. */
    '#toki-wheel-root #twVortexAI,#toki-wheel-root #twSpinExperience{border-color:rgba(255,255,255,.24)!important;filter:none!important;-webkit-filter:none!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.30),inset 0 -1px 0 rgba(0,0,0,.08),inset 0 0 26px rgba(255,66,205,.09),0 15px 30px rgba(62,13,80,.18),0 0 18px rgba(255,66,205,.18)!important;-webkit-box-shadow:inset 0 1px 0 rgba(255,255,255,.30),inset 0 -1px 0 rgba(0,0,0,.08),inset 0 0 26px rgba(255,66,205,.09),0 15px 30px rgba(62,13,80,.18),0 0 18px rgba(255,66,205,.18)!important;}',
    '#toki-wheel-root #twVortexAI::before,#toki-wheel-root #twSpinExperience::before{background:transparent!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.10),inset 0 0 20px rgba(255,66,205,.07)!important;}',
    '#toki-wheel-root #twVortexAI::after,#toki-wheel-root #twSpinExperience::after{background:linear-gradient(115deg,rgba(255,255,255,.13),rgba(255,255,255,0) 30%,rgba(255,93,214,.08) 68%,rgba(255,255,255,.10))!important;}',
    '#toki-wheel-root #twVortexAI>.tw-accordSummary,#toki-wheel-root #twSpinExperience>.tw-accordSummary{border-color:rgba(255,255,255,.22)!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.20),inset 0 -1px 0 rgba(0,0,0,.08)!important;-webkit-box-shadow:inset 0 1px 0 rgba(255,255,255,.20),inset 0 -1px 0 rgba(0,0,0,.08)!important;}',
    '#toki-wheel-root #twVortexAI>.tw-accordSummary::before,#toki-wheel-root #twSpinExperience>.tw-accordSummary::before{content:""!important;display:block!important;width:142px!important;height:100px!important;right:-18px!important;top:-30px!important;opacity:.82!important;background:radial-gradient(ellipse,rgba(255,104,219,.30),transparent 72%)!important;filter:blur(5px)!important;-webkit-filter:blur(5px)!important;}',
    '#toki-wheel-root #twVortexAI .tw-planPillPro,#toki-wheel-root #twVortexAI .tw-planPill{overflow:visible!important;background:transparent!important;box-shadow:none!important;-webkit-box-shadow:none!important;filter:none!important;-webkit-filter:none!important;}',
    '#toki-wheel-root #twVortexAI .tw-planPillPro img,#toki-wheel-root #twVortexAI .tw-planPill img,#toki-wheel-root #twVortexAI img[src*="vortexproglassesicon"]{overflow:visible!important;background:transparent!important;box-shadow:none!important;-webkit-box-shadow:none!important;filter:none!important;-webkit-filter:none!important;}',

    /* Safari/iPadOS can promote the wheel card into a square clipping layer. Remove clipping from every ancestor. */
    '@supports(-webkit-touch-callout:none){@media(max-width:1366px){html:not(.twStreamHtml) body:not(.twStreamBody) #toki-wheel-root,html:not(.twStreamHtml) body:not(.twStreamBody) #toki-wheel-root .tw-wrap,html:not(.twStreamHtml) body:not(.twStreamBody) #toki-wheel-root .tw-main,html:not(.twStreamHtml) body:not(.twStreamBody) #toki-wheel-root .tw-wheelCard,html:not(.twStreamHtml) body:not(.twStreamBody) #toki-wheel-root .tw-wheelCard.tw-card,html:not(.twStreamHtml) body:not(.twStreamBody) #toki-wheel-root .tw-wheelMeta,html:not(.twStreamHtml) body:not(.twStreamBody) #toki-wheel-root .tw-wheelMetaActions{overflow:visible!important;clip-path:none!important;-webkit-clip-path:none!important;mask:none!important;-webkit-mask:none!important;contain:none!important;}html:not(.twStreamHtml) body:not(.twStreamBody) #toki-wheel-root .tw-main{padding-top:8px!important;}html:not(.twStreamHtml) body:not(.twStreamBody) #toki-wheel-root .tw-wheelCard,html:not(.twStreamHtml) body:not(.twStreamBody) #toki-wheel-root .tw-wheelCard.tw-card{isolation:auto!important;padding-top:max(var(--tw-pad),calc(12px + env(safe-area-inset-top,0px)))!important;}html:not(.twStreamHtml) body:not(.twStreamBody) #toki-wheel-root .tw-wheelMeta{position:relative!important;z-index:40!important;min-height:42px!important;}html:not(.twStreamHtml) body:not(.twStreamBody) #toki-wheel-root .tw-wheelMetaActions,html:not(.twStreamHtml) body:not(.twStreamBody) #toki-wheel-root .tw-wheelMetaActions .tw-settingsButton,html:not(.twStreamHtml) body:not(.twStreamBody) #toki-wheel-root .tw-wheelMetaActions #twDashboardSave{position:relative!important;z-index:42!important;transform:none!important;-webkit-transform:none!important;clip-path:none!important;-webkit-clip-path:none!important;}html:not(.twStreamHtml) body:not(.twStreamBody){overflow-x:hidden!important;}}}'
  ].join('');
  document.head.appendChild(style);
})();

/* 2026-08-05 regression repair: menu shell, voice glyph, and overlay/vault parity.
   Kept as a final presentation-only guard so the labs, studio, science, and
   winner functionality above continue to own their behavior. */
(function installPresentationParityRepair0805(){
  if(window.__twPresentationParityRepair0805) return;
  window.__twPresentationParityRepair0805 = true;
  var style = document.createElement('style');
  style.id = 'tw-presentation-parity-repair-0805';
  style.textContent = [
    '#toki-wheel-root .tw-headerMoreMenu{box-sizing:border-box!important;overflow:hidden!important;background:var(--tw-black,#11131b)!important;max-height:calc(100dvh - 24px)!important;box-shadow:0 18px 46px rgba(0,0,0,.52)!important;}',
    '#toki-wheel-root .tw-headerMoreMenu .tw-menuList{box-sizing:border-box!important;width:100%!important;max-height:calc(100dvh - 26px)!important;overflow-x:hidden!important;overflow-y:auto!important;padding:10px!important;gap:8px!important;background:transparent!important;}',
    '#toki-wheel-root .tw-headerMoreMenu .tw-menuList>button.tw-btn{box-sizing:border-box!important;width:100%!important;margin:0!important;}',
    '#toki-wheel-root .tw-headerMoreMenu .tw-voiceToggle .tw-btnGlyph{display:inline-flex!important;width:19px!important;min-width:19px!important;font-size:0!important;overflow:visible!important;}',
    '#toki-wheel-root .tw-headerMoreMenu .tw-voiceToggle .tw-btnGlyph::before{content:"\\1F5E3\\FE0F"!important;display:inline-block!important;font-size:17px!important;line-height:1!important;}',
    '#toki-wheel-root .tw-presentationExit{top:calc(4px + env(safe-area-inset-top,0px))!important;right:calc(8px + env(safe-area-inset-right,0px))!important;}',
    '#toki-wheel-root .tw-vaultRebuilt .tw-vaultBody{box-sizing:border-box!important;padding:14px 16px 16px!important;}',
    '#toki-wheel-root .tw-vaultRebuilt .tw-vaultBody .tw-pinItem{box-sizing:border-box!important;width:auto!important;margin-left:0!important;margin-right:0!important;}',
    '#toki-wheel-root .tw-inOverlay .tw-vaultRebuilt,#toki-wheel-root .tw-inOverlay .tw-vaultRebuilt.tw-accord{box-shadow:none!important;-webkit-box-shadow:none!important;filter:none!important;-webkit-filter:none!important;}',
    '#toki-wheel-root .tw-wrap:not(.tw-inOverlay):not(.tw-streamMode) .tw-vaultRebuilt #twPinsList{box-sizing:border-box!important;padding:14px 16px 16px!important;}#toki-wheel-root .tw-wrap:not(.tw-inOverlay):not(.tw-streamMode) .tw-vaultRebuilt #twPinsList:empty{padding:0!important;}#toki-wheel-root .tw-wrap:not(.tw-inOverlay):not(.tw-streamMode) .tw-vaultRebuilt #twPinsList .tw-pinItem{box-sizing:border-box!important;width:auto!important;margin-left:0!important;margin-right:0!important;}',
    '#toki-wheel-root .tw-inOverlay:not(.tw-streamMode) .tw-wheelMeta{box-sizing:border-box!important;width:100%!important;padding:9px 12px 0 8px!important;overflow:visible!important;}#toki-wheel-root .tw-inOverlay:not(.tw-streamMode) .tw-wheelMetaActions{position:relative!important;right:auto!important;margin-top:0!important;margin-right:2px!important;transform:none!important;}',
    '@media(max-width:1024px){html.twOverlayHtml,body.twOverlayBody{width:100%!important;max-width:100%!important;height:100%!important;overflow:hidden!important;background:var(--tw-ovBack,#12121a)!important;}#toki-wheel-root .tw-wrap.tw-inOverlay:not(.tw-streamMode){box-sizing:border-box!important;width:100vw!important;max-width:100vw!important;height:100dvh!important;min-height:0!important;max-height:100dvh!important;overflow-x:hidden!important;overflow-y:auto!important;-webkit-overflow-scrolling:touch!important;}#toki-wheel-root .tw-inOverlay:not(.tw-streamMode) .tw-main{box-sizing:border-box!important;width:100%!important;max-width:none!important;height:auto!important;min-height:0!important;max-height:none!important;overflow:visible!important;align-content:start!important;padding:18px 12px calc(34px + env(safe-area-inset-bottom,0px))!important;}#toki-wheel-root .tw-inOverlay:not(.tw-streamMode) .tw-wheelCard,#toki-wheel-root .tw-inOverlay:not(.tw-streamMode) .tw-wheelCard.tw-card{box-sizing:border-box!important;width:100%!important;max-width:none!important;overflow:visible!important;}#toki-wheel-root .tw-inOverlay:not(.tw-streamMode) .tw-wheelStage,#toki-wheel-root .tw-inOverlay:not(.tw-streamMode) .tw-wheelWrap,#toki-wheel-root .tw-inOverlay:not(.tw-streamMode) #twWheelWrap{overflow:visible!important;}#toki-wheel-root .tw-inOverlay:not(.tw-streamMode) .tw-wheelWrap,#toki-wheel-root .tw-inOverlay:not(.tw-streamMode) #twWheelWrap{width:min(var(--tw-wheelSize),calc(100% - 44px))!important;max-width:calc(100% - 44px)!important;margin-left:auto!important;margin-right:auto!important;}#toki-wheel-root .tw-inOverlay:not(.tw-streamMode) .tw-vaultRebuilt,#toki-wheel-root .tw-inOverlay:not(.tw-streamMode) .tw-vaultRebuilt.tw-accord{display:block!important;visibility:visible!important;opacity:1!important;position:relative!important;inset:auto!important;transform:none!important;grid-area:vault!important;order:2!important;box-sizing:border-box!important;width:100%!important;max-width:none!important;min-height:90px!important;height:auto!important;max-height:none!important;margin:0!important;overflow:hidden!important;}#toki-wheel-root .tw-inOverlay:not(.tw-streamMode) .tw-vaultRebuilt .tw-vaultHeader,#toki-wheel-root .tw-inOverlay:not(.tw-streamMode) .tw-vaultRebuilt .tw-vaultBody{display:flex!important;visibility:visible!important;opacity:1!important;}#toki-wheel-root .tw-inOverlay:not(.tw-streamMode) .tw-vaultRebuilt .tw-vaultBody{flex-direction:column!important;max-height:none!important;overflow:visible!important;}}'
  ].join('');
  document.head.appendChild(style);
})();

/* =========================================================
   BUSINESS CAMPAIGN LAB — 2026-08-03
   Additive shared-engine panel. It manages three wheel states
   while leaving every existing wheel feature and preset intact.
   ========================================================= */
(function(){
  'use strict';
  if(window.__twBusinessCampaignLab0803) return;
  window.__twBusinessCampaignLab0803 = true;

  var attempts = 0;
  var saveTimer = 0;
  function clone(value){
    try{
      var TW = window.TokiWheel;
      if(TW && TW.util && TW.util.clone) return TW.util.clone(value);
      return JSON.parse(JSON.stringify(value));
    }catch(_){ return value; }
  }
  function clean(value, fallback){
    value = String(value == null ? '' : value).trim();
    return value || fallback;
  }
  function storageKey(){
    var path = String((window.location && window.location.pathname) || 'wheel').toLowerCase().replace(/[^a-z0-9]+/g,'-');
    var preset = window.TOKI_WHEEL_PRESET || window.TokiWheelPreset || {};
    var title = clean(preset.title, 'wheel').toLowerCase().replace(/[^a-z0-9]+/g,'-');
    return 'toki_business_campaign_lab_v1:' + path + ':' + title;
  }
  function readSaved(){
    try{ var raw = localStorage.getItem(storageKey()); return raw ? JSON.parse(raw) : null; }catch(_){ return null; }
  }
  function writeSaved(payload){
    try{ localStorage.setItem(storageKey(), JSON.stringify(payload)); return true; }catch(_){ return false; }
  }
  function make(tag, attrs, children){
    var node = document.createElement(tag), key;
    attrs = attrs || {};
    for(key in attrs){
      if(!Object.prototype.hasOwnProperty.call(attrs,key)) continue;
      if(key === 'class') node.className = attrs[key];
      else if(key === 'text') node.textContent = attrs[key];
      else if(key === 'html') node.innerHTML = attrs[key];
      else node.setAttribute(key, attrs[key]);
    }
    (children || []).forEach(function(child){ if(child) node.appendChild(child); });
    return node;
  }
  function init(){
    var TW = window.TokiWheel;
    var root = document.getElementById('toki-wheel-root');
    var inventor = document.getElementById('twVortexAI');
    var creator = document.getElementById('twSpinExperience');
    var studio = document.getElementById('twCustomize');
    if(!TW || !TW.state || !TW.renderAll || !root || !inventor || !creator || !studio){
      if(attempts++ < 160) setTimeout(init,75);
      return;
    }
    if(document.getElementById('twBusinessCampaign')) return;

    var saved = readSaved();
    var active = saved && saved.active >= 0 && saved.active < 3 ? saved.active : 0;
    var wheelCount = saved && saved.wheelCount >= 1 && saved.wheelCount <= 3 ? saved.wheelCount : 3;
    if(active>=wheelCount)active=wheelCount-1;
    var engaged = false;
    var campaignName = clean(saved && saved.name, 'My Business Campaign');
    var originalState = clone(TW.state);
    var originalPalette = TW.CONST && Array.isArray(TW.CONST.PALETTE) ? TW.CONST.PALETTE.slice() : [];
    var originalRootTheme = {background:root.style.background||'',headerText:root.style.getPropertyValue('--twHeaderText')||''};
    var defaults = [
      { eyebrow:'DISCOVER', name:'Wheel 1 · Discovery', title:'DISCOVER WHAT FITS TODAY', desc:'Start with a mood, need, preference, or occasion.' },
      { eyebrow:'MATCH', name:'Wheel 2 · Recommendation', title:'FIND YOUR MATCH', desc:'Recommend a product, service, style, or menu item.' },
      { eyebrow:'RETURN', name:'Wheel 3 · Reward', title:'UNLOCK YOUR RETURN-VISIT PERK', desc:'Finish with a controlled offer or reason to return.' }
    ];
    var states = [];
    var names = [];
    var selectedWheels = saved && saved.selectedWheels ? saved.selectedWheels.slice(0,3) : ['', '', ''];
    var library = [
      {id:'spice-shuffle',name:'Spice Shuffle',url:'https://spinthewheellab.com/pages/spice-shuffle',icon:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/spiceshuffleicon.png?v=1769618063',bg:'#3B2A1F',text:'#1FA6A1',badge:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/spiceshufflevortex.png?v=1772203973',segments:[['YOUR CHOICE','#6FCF97','black'],['SWEET TREAT','#4A4A4A','white'],['SNACK TIME','#F6E6A8','black'],['DRINK PICK','#F2994A','black'],['BONUS BITE','#8E3B6F','black'],['CARRY OUT','#D94C3D','black']]},
      {id:'neon-bite',name:'Neon Bite',url:'https://spinthewheellab.com/pages/neon-bite',icon:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/neonbiteicon.png?v=1769616715',bg:'#8E2A24',text:'#FFF6E5',badge:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/neonbitevortex.png?v=1772199970',segments:[['HOT DOGS','#8B5A2B','black'],['TACOS','#E6C15A','black'],['PASTA','#3FA9F5','black'],['SALAD','#C7352D','black'],['BURGERS','#1F2A44','white'],['SUSHI','#4CC9A6','black']]},
      {id:'daily-brew',name:'Daily Brew',url:'https://spinthewheellab.com/pages/daily-brew',icon:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/dailybrewicon.png?v=1769618049',bg:'#3B2416',text:'#D6B58A',badge:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/dailybrewvortex.png?v=1772200622',segments:[['COFFEE','#5A3A24','white'],['WATER','#D6B58A','black'],['TEA','#C94A7A','white'],['SODA','#E8DDCF','black'],['JUICE','#4B2C5E','white'],['MILK','#9B9A95','white']]},
      {id:'batter-blast',name:'Batter Blast',url:'https://spinthewheellab.com/pages/batter-blast',icon:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/batterbursticon.png?v=1775238112',bg:'#FF6B81',text:'#EED9C4',badge:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/batterburstvortex.png?v=1772900111',segments:[['SPICE','#F28482','black'],['LEMON','#E8D5C4','black'],['CHOCOLATE','#F9C74F','black'],['MARBLE','#A0E7E5','black'],['BUTTER','#8D6E63','black'],['CARROT','#F7B267','black'],['WHITE','#C77DFF','black'],['RED VELVET','#FCD5CE','black']]},
      {id:'pizza-picker',name:'Pizza Picker',url:'https://spinthewheellab.com/pages/pizza-picker',icon:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/pizzapickericon.png?v=1782569604',bg:'#7CB342',text:'#FFF3E0',badge:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/pizzapickervortex.png?v=1774534892',segments:[['MUSHROOMS','#E8D5B7','black'],['BACON','#B94A48','white'],['JALAPEÑOS','#33691E','white'],['MOZZARELLA','#FFF8E1','black'],['RED ONIONS','#8E44AD','white'],['PINEAPPLE','#FDD835','black'],['PEPPERONI','#C62828','white'],['BASIL','#2E7D32','white']]},
      {id:'midway-munch',name:'Midway Munch',url:'https://spinthewheellab.com/pages/midway-munch',icon:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/midwaymunchicon.png?v=1782505051',bg:'#F6B7D8',text:'#2C57B8',badge:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/midwaymunchvortex.png?v=1782505049',segments:[['CORN DOG','#C9262D','black'],['CANDY','#14C8C4','black'],['FUNNEL CAKE','#D89B17','black'],['LEMONADE','#2C57B8','white'],['POPCORN','#D7C5FF','black'],['PRETZEL','#8A1F2B','white'],['PIZZA SLICE','#FFF4D9','black'],['CARAMEL','#F6B7D8','black']]}
    ];
    var colorFamilies=[
      {name:'Bright & Bold',description:'High-energy contrast designed to command attention and create immediate visual impact.',colors:['#FFFFFF','#6EC6FF','#0B8A44','#FFD23C','#222222']},
      {name:'Playful & Fun',description:'A friendly, energetic mix with lively variety and an approachable personality.',colors:['#FFF4D9','#F6C517','#F47B20','#E6433B','#C61F2B']},
      {name:'Warm & Sunny',description:'Golden, earthy warmth that feels welcoming, appetizing, and comfortably familiar.',colors:['#FF3D2E','#C62828','#FFA62B','#E65100','#FFD84D']},
      {name:'Soft & Sweet',description:'Gentle pastels with an emotional, caring quality and a softly expressive finish.',colors:['#FF6B81','#FF8FA3','#F28482','#FFA69E','#F7B267']},
      {name:'Cool & Fresh',description:'Clean, contemporary blue-green tones that communicate freshness and clarity.',colors:['#2F6B3C','#3E8B46','#6A9E3B','#7CCB4A','#9DBB73']},
      {name:'Calm & Neutral',description:'Balanced, lower-intensity color relationships suited to clear and composed experiences.',colors:['#F4C430','#0066FF','#FFD23F','#6E7B8B','#4AFF68']},
      {name:'Deep & Moody',description:'Rich, cinematic color with depth, drama, and a distinctive premium atmosphere.',colors:['#4B3FAF','#6C4FD3','#A15EFF','#D14BE8','#9EDB2F']}
    ];
    var wheelFamilies={
      'spice-shuffle':['Warm & Sunny','Calm & Neutral','Playful & Fun'],
      'neon-bite':['Bright & Bold','Deep & Moody'],
      'daily-brew':['Deep & Moody','Calm & Neutral'],
      'batter-blast':['Soft & Sweet','Playful & Fun'],
      'pizza-picker':['Cool & Fresh','Warm & Sunny','Bright & Bold'],
      'midway-munch':['Playful & Fun','Soft & Sweet','Cool & Fresh']
    };
    library.forEach(function(wheel){wheel.families=wheelFamilies[wheel.id]||['Calm & Neutral'];wheel.family=wheel.families[0];});
    function freshState(index){
      var state = clone(originalState);
      state.ui = state.ui || {};
      if(index > 0){
        state.ui.title = defaults[index].title;
        state.ui.desc = defaults[index].desc;
      }
      state.history = [];
      state.pins = [];
      state._meta = { lastWinnerIdx:-1 };
      if(index === 2){
        state.ui.spinBizPopup = 'yes';
        state.ui.spinBizPopupHeadline = 'Your perk is ready!';
        state.ui.spinBizPopupMessage = 'Save this reward for your next visit.';
        state.ui.spinBizPopupButton = 'Claim perk';
      }
      return state;
    }
    function findWheel(id){
      for(var index=0;index<library.length;index++) if(library[index].id===id) return library[index];
      return null;
    }
    function stateFromWheel(wheel,index){
      var state=freshState(index);
      state.ui=state.ui||{};
      state.ui.title=wheel.name.toUpperCase();
      state.ui.desc='Built by Professor Vortex — Customized by You';
      state.ui.centerBadgeUrl=wheel.badge;
      state.ui.pageBg=wheel.bg;state.ui.overlayBg=wheel.bg;state.ui.overlayBg2=wheel.bg;
      state.ui.headerTextColor=wheel.text;state.ui.businessWheelId=wheel.id;
      state.ui.businessPalette=[wheel.bg,wheel.text].concat(wheel.segments.map(function(s){return s[1];}));
      state.segments=wheel.segments.map(function(s){return {label:s[0],weight:1,color:s[1],tcolor:s[2],sliceImgId:''};});
      return state;
    }
    function applyTheme(state){
      var ui=state&&state.ui||{};
      if(ui.pageBg) root.style.background=ui.pageBg;
      if(ui.headerTextColor) root.style.setProperty('--twHeaderText',ui.headerTextColor);
      if(ui.businessPalette && TW.CONST) TW.CONST.PALETTE=ui.businessPalette.slice();
    }
    function restoreNativeTheme(){
      var preset=TW._pagePreset||window.TOKI_WHEEL_PRESET||window.TokiWheelPreset||{};
      root.style.background=preset.pageBg!=null?String(preset.pageBg):originalRootTheme.background;
      if(preset.headerTextColor!=null) root.style.setProperty('--twHeaderText',String(preset.headerTextColor));
      else if(originalRootTheme.headerText) root.style.setProperty('--twHeaderText',originalRootTheme.headerText);
      else root.style.removeProperty('--twHeaderText');
      if(TW.CONST&&Array.isArray(preset.palette)&&preset.palette.length)TW.CONST.PALETTE=preset.palette.slice();
      else if(TW.CONST&&originalPalette.length)TW.CONST.PALETTE=originalPalette.slice();
    }
    function nativeStateFromPagePreset(){
      var state=clone(originalState),preset=TW._pagePreset||window.TOKI_WHEEL_PRESET||window.TokiWheelPreset||{};
      state=state||{};state.ui=state.ui||{};
      ['title','desc','centerBadgeUrl','centerBadgeMask','centerBadgeScale','centerBadgeOffX','centerBadgeOffY','spinSoundId','winSoundId','confettiOn','countdownOn','countdownSec','overlayBg','overlayBg2'].forEach(function(key){if(preset[key]!=null)state.ui[key]=preset[key];});
      if(preset.requiredPlan!=null)state.ui.requiredPlan=String(preset.requiredPlan);
      if(preset.presetRev!=null)state.ui._presetRev=String(preset.presetRev);
      if(preset.pageBg!=null)state.ui.pageBg=String(preset.pageBg);
      if(preset.headerTextColor!=null)state.ui.headerTextColor=String(preset.headerTextColor);
      delete state.ui.businessWheelId;delete state.ui.businessPalette;
      if(Array.isArray(preset.segments)){
        var imageLibrary=TW.CONST&&Array.isArray(TW.CONST.SEGMENT_IMAGE_LIBRARY)?TW.CONST.SEGMENT_IMAGE_LIBRARY:[];
        state.segments=preset.segments.map(function(segment,index){
          segment=segment||{};var sliceUrl=segment.sliceImgUrl!=null?String(segment.sliceImgUrl||'').trim():'';
          if(!sliceUrl&&segment.sliceImgId){for(var imageIndex=0;imageIndex<imageLibrary.length;imageIndex++){if(String(imageLibrary[imageIndex]&&imageLibrary[imageIndex].id||'').trim()===String(segment.sliceImgId).trim()){sliceUrl=String(imageLibrary[imageIndex].url||'').trim();break;}}}
          var palette=Array.isArray(preset.palette)&&preset.palette.length?preset.palette:(TW.CONST&&TW.CONST.PALETTE||['#ffffff']);
          return {label:segment.label!=null?String(segment.label).toUpperCase():'',weight:segment.weight!=null&&parseFloat(segment.weight)>0?parseFloat(segment.weight):1,color:segment.color!=null?String(segment.color):palette[index%palette.length],tcolor:String(segment.tcolor||'white').toLowerCase()==='black'?'black':'white',sliceImgUrl:sliceUrl,textureId:String(segment.textureId||''),textureUrl:U.safeImageSource?U.safeImageSource(segment.textureUrl||''):String(segment.textureUrl||'')};
        }).slice(0,TW.CONST&&TW.CONST.MAX_SEGMENTS||1000);
      }
      return state;
    }
    for(var i=0;i<3;i++){
      states[i] = saved && saved.states && saved.states[i] ? saved.states[i] : freshState(i);
      names[i] = clean(saved && saved.stepNames && saved.stepNames[i], defaults[i].name);
    }

    var hasVortexProAccess = !!(TW.access && TW.access.hasPlan && TW.access.hasPlan('vortex_pro'));
    var hasVortexAccess = !!(TW.access && TW.access.hasPlan && TW.access.hasPlan('vortex_pro'));
    var details = make('details',{ class:'tw-accord', id:'twBusinessCampaign' });
    var creatorSummary = creator.querySelector('.tw-accordSummary');
    var summary = creatorSummary ? creatorSummary.cloneNode(true) : make('summary',{ class:'tw-accordSummary' });
    var summaryTitle = summary.querySelector('.tw-accordTitle');
    if(summaryTitle) summaryTitle.textContent='Brand Kit';
    var summaryIcon = summary.querySelector('img');
    if(summaryIcon) summaryIcon.alt='Vortex Pro';
    var intro = make('div',{ class:'tw-businessIntro' },[
      make('strong',{ text:'Build one connected customer journey.' }),
      make('span',{ text:'Select a wheel here, then use the normal Quick Tweaks, Creator Lab, Inventor Lab, stickers, colors, sounds, and effects to edit it.' })
    ]);
    var nameLabel = make('label',{ class:'tw-businessField' },[
      make('span',{ text:'Campaign name' })
    ]);
    var nameInput = make('input',{ class:'tw-input tw-businessName', type:'text', maxlength:'80', value:campaignName, 'aria-label':'Business campaign name' });
    nameLabel.appendChild(nameInput);
    var libraryTitle = make('div',{ class:'tw-businessLibraryTitle' },[
      make('strong',{text:'Choose your three wheel visuals'}),
      make('span',{text:'Browse coordinated business campaigns or select each wheel one by one.'})
    ]);
    var openLibraryButton=make('button',{class:'tw-btn tw-btnPrimary tw-businessOpenLibrary',type:'button',text:'Browse Campaign Wheels'});
    var selectedStrip=make('div',{class:'tw-businessSelectedStrip','aria-label':'Selected campaign wheels'});
    var returnNativeButton=make('button',{class:'tw-btn tw-businessReturnNative',type:'button',text:'Return to This Page’s Wheel'});
    var individualTitle=make('div',{class:'tw-businessLibraryTitle tw-businessIndividualTitle'},[
      make('strong',{text:'Choose an individual wheel'}),
      make('span',{text:'Select Wheel 1, 2, or 3 below, then choose its visual.'})
    ]);
    var openIndividualButton=make('button',{class:'tw-btn tw-btnPrimary tw-businessOpenIndividual',type:'button',text:'Browse Individual Wheels'});
    var setBar = make('div',{class:'tw-businessSetBar'});
    var campaignSets=[
      {category:'Customer Journey',name:'Discover, Match & Reward',ids:['spice-shuffle','neon-bite','daily-brew']},
      {category:'Food & Hospitality',name:'Taste, Choose & Treat',ids:['daily-brew','pizza-picker','batter-blast']},
      {category:'Engagement & Loyalty',name:'Play, Win & Return',ids:['midway-munch','spice-shuffle','neon-bite']},
      {category:'Customer Journey',name:'Discover & Match',ids:['spice-shuffle','neon-bite']},
      {category:'Engagement & Loyalty',name:'Play & Reward',ids:['midway-munch','daily-brew']},
      {category:'Food & Hospitality',name:'Single Featured Choice',ids:['pizza-picker']}
    ];
    campaignSets.forEach(function(set){
      var button=make('button',{class:'tw-businessSet tw-stickerTile',type:'button','data-campaign-category':set.category},[
        make('img',{class:'tw-stickerImg',src:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/threewheelcampaigniconexample.png?v=1785770559',alt:''}),
        make('span',{text:set.name})
      ]);
      button.addEventListener('click',function(){ applySet(set.ids); campaignPicker.hidden=true; });setBar.appendChild(button);
    });
    var searchInput=make('input',{class:'tw-input tw-businessSearch',type:'search',placeholder:'Search wheel visuals…','aria-label':'Search business wheel visuals'});
    var libraryGrid=make('div',{class:'tw-palette tw-businessLibraryGrid'});
    library.forEach(function(wheel){
      var tile=make('button',{class:'tw-businessLibraryTile tw-stickerTile',type:'button','data-wheel-id':wheel.id,'data-category':'Food & Drink Wheel','data-color-families':wheel.families.join('|')},[
        make('img',{class:'tw-stickerImg',src:wheel.icon,alt:''}),make('span',{text:wheel.name}),make('small',{class:'tw-businessWheelFamily',text:wheel.families.join(' · ')})
      ]);
      tile.addEventListener('click',function(){ chooseWheel(wheel); });libraryGrid.appendChild(tile);
    });
    var suggestedWheelIds=[];
    var categories=['All Wheels','Suggested Wheels','Name Picker Wheel','Decision Wheel','Prize Wheel','Food & Drink Wheel','Education Wheel','Fitness Wheel','Game/Challenge Wheel','Holiday Wheel','International Wheel','Kids Rewards Wheel','Number Picker Wheel','Sports Wheel','Legendary Wheel'];
    var activeCategory='All Wheels';
    var categoryNav=make('div',{class:'tw-stickerCategoryNav tw-businessCategoryNav',role:'tablist','aria-label':'Individual wheel categories'});
    categories.forEach(function(category,index){
      var categoryButton=make('button',{class:'tw-stickerCategoryBtn'+(index===0?' isActive':''),type:'button',role:'tab','aria-selected':index===0?'true':'false',text:category});
      categoryButton.addEventListener('click',function(){
        activateCategory(category);
      });
      categoryNav.appendChild(categoryButton);
    });
    function activateCategory(category){activeCategory=category;Array.prototype.forEach.call(categoryNav.children,function(button){var selected=button.textContent===category;button.classList.toggle('isActive',selected);button.setAttribute('aria-selected',selected?'true':'false');});filterLibrary();}
    var activeColorFamily='All Color Families';
    var familyPanel=make('section',{class:'tw-businessFamilyPanel','aria-label':'Wheel color families'});
    familyPanel.appendChild(make('div',{class:'tw-businessFamilyHeading'},[make('strong',{text:'Browse by color family'}),make('span',{text:'Choose a visual direction, then browse every wheel below.'})]));
    var familyGrid=make('div',{class:'tw-businessFamilyGrid'});
    function familySwatches(colors){var swatches=make('span',{class:'tw-businessFamilySwatches','aria-hidden':'true'});colors.forEach(function(color){var swatch=make('i');swatch.style.background=color;swatches.appendChild(swatch);});return swatches;}
    colorFamilies.forEach(function(family){
      var card=make('button',{class:'tw-businessFamilyCard',type:'button','aria-pressed':'false'},[familySwatches(family.colors),make('strong',{text:family.name}),make('small',{text:family.description})]);
      card.addEventListener('click',function(event){event.stopPropagation();activeColorFamily=activeColorFamily===family.name?'All Color Families':family.name;Array.prototype.forEach.call(familyGrid.children,function(item){var selected=item===card&&activeColorFamily===family.name;item.classList.toggle('is-active',selected);item.setAttribute('aria-pressed',selected?'true':'false');});suggestedWheelIds=activeColorFamily==='All Color Families'?[]:library.filter(function(wheel){return wheel.families.indexOf(activeColorFamily)!==-1;}).map(function(wheel){return wheel.id;});activateCategory(activeColorFamily==='All Color Families'?'All Wheels':'Suggested Wheels');});
      familyGrid.appendChild(card);
    });
    familyPanel.appendChild(familyGrid);
    var suggestionPanel=make('section',{class:'tw-businessSuggestionPanel'});
    var suggestionCopy=make('div',{class:'tw-businessSuggestionCopy'});
    var suggestionGrid=make('div',{class:'tw-businessSuggestionGrid'});
    var viewAllSuggestionsButton=make('button',{class:'tw-btn tw-businessViewSuggestions',type:'button',hidden:'',text:'View All Suggested Wheels'});
    viewAllSuggestionsButton.addEventListener('click',function(event){event.stopPropagation();activeColorFamily='All Color Families';Array.prototype.forEach.call(familyGrid.children,function(item){item.classList.remove('is-active');item.setAttribute('aria-pressed','false');});activateCategory('Suggested Wheels');wheelPicker.scrollTop=Math.max(0,categoryNav.offsetTop-12);});
    suggestionPanel.appendChild(suggestionCopy);suggestionPanel.appendChild(suggestionGrid);suggestionPanel.appendChild(viewAllSuggestionsButton);
    var noResults=make('div',{class:'tw-mini tw-businessNoResults',hidden:'',text:'More wheels in this category can be added as their page snippets are connected.'});
    function filterLibrary(){
      var query=String(searchInput.value||'').toLowerCase(),visible=0;
      Array.prototype.forEach.call(libraryGrid.children,function(tile){var families=String(tile.getAttribute('data-color-families')||'').split('|'),wheelId=tile.getAttribute('data-wheel-id'),categoryMismatch=activeCategory!=='All Wheels'&&activeCategory!=='Suggested Wheels'&&tile.getAttribute('data-category')!==activeCategory,suggestionMismatch=activeCategory==='Suggested Wheels'&&suggestedWheelIds.indexOf(wheelId)===-1;tile.hidden=(tile.textContent.toLowerCase().indexOf(query)===-1)||categoryMismatch||suggestionMismatch||(activeColorFamily!=='All Color Families'&&families.indexOf(activeColorFamily)===-1);if(!tile.hidden)visible++;});
      noResults.textContent=activeCategory==='Suggested Wheels'?'Select a color family above or choose an earlier campaign wheel to create smart suggestions.':'More wheels in this category can be added as their page snippets are connected.';
      noResults.hidden=visible!==0;
    }
    function refreshSuggestions(){
      suggestionGrid.innerHTML='';var first=findWheel(selectedWheels[0]),second=findWheel(selectedWheels[1]),families=[];
      if(activeColorFamily!=='All Color Families')families=[activeColorFamily];
      else if(active===1&&first)families=first.families.slice();
      else if(active===2){if(first)first.families.forEach(function(family){if(families.indexOf(family)===-1)families.push(family);});if(second)second.families.forEach(function(family){if(families.indexOf(family)===-1)families.push(family);});}
      if(!families.length){suggestedWheelIds=[];suggestionCopy.innerHTML='<strong>Smart color matches</strong><span>Select the first wheel or choose a color family to receive coordinated suggestions.</span>';suggestionPanel.classList.add('is-empty');viewAllSuggestionsButton.hidden=true;if(activeCategory==='Suggested Wheels')activateCategory('All Wheels');return;}
      suggestionPanel.classList.remove('is-empty');suggestionCopy.innerHTML='<strong>Smart matches for Wheel '+(active+1)+'</strong><span>Recommendations based on '+families.join(', ')+'.</span>';
      var matches=library.filter(function(wheel){return wheel.families.some(function(family){return families.indexOf(family)!==-1;})&&selectedWheels.indexOf(wheel.id)===-1;}).sort(function(a,b){var aScore=a.families.filter(function(family){return families.indexOf(family)!==-1;}).length,bScore=b.families.filter(function(family){return families.indexOf(family)!==-1;}).length;return bScore-aScore;});
      if(!matches.length)matches=library.filter(function(wheel){return selectedWheels.indexOf(wheel.id)===-1;}).slice(0,3);
      suggestedWheelIds=matches.map(function(wheel){return wheel.id;});viewAllSuggestionsButton.hidden=false;
      matches.slice(0,4).forEach(function(wheel){var tile=make('button',{class:'tw-businessSuggestionTile',type:'button'},[make('img',{src:wheel.icon,alt:''}),make('span',{text:wheel.name}),make('small',{text:wheel.families.join(' · ')})]);tile.addEventListener('click',function(){chooseWheel(wheel);});suggestionGrid.appendChild(tile);});
    }
    searchInput.addEventListener('input',filterLibrary);
    var campaignCategoryNav=make('div',{class:'tw-stickerCategoryNav tw-businessCategoryNav',role:'group','aria-label':'Three-wheel campaign categories'});
    ['All','Customer Journey','Food & Hospitality','Engagement & Loyalty'].forEach(function(category,index){
      var button=make('button',{class:'tw-stickerCategoryBtn'+(index===0?' isActive':''),type:'button','aria-pressed':index===0?'true':'false',text:category});
      button.addEventListener('click',function(event){event.stopPropagation();Array.prototype.forEach.call(campaignCategoryNav.children,function(item){var selected=item===button;item.classList.toggle('isActive',selected);item.setAttribute('aria-pressed',selected?'true':'false');});Array.prototype.forEach.call(setBar.children,function(tile){tile.hidden=category!=='All'&&tile.getAttribute('data-campaign-category')!==category;});});
      campaignCategoryNav.appendChild(button);
    });
    function makeWorkspaceButton(picker,label){
      var button=make('button',{class:'tw-stickerExpandBtn',type:'button','aria-expanded':'false',text:'Expand '+label+' Workspace'});
      button.addEventListener('click',function(event){event.stopPropagation();var expanded=!picker.classList.contains('isExpanded');picker.classList.toggle('isExpanded',expanded);button.setAttribute('aria-expanded',expanded?'true':'false');button.textContent=expanded?'Compact '+label+' Workspace':'Expand '+label+' Workspace';placeBusinessPicker(picker,expanded?null:(picker===campaignPicker?openLibraryButton:openIndividualButton));});
      return button;
    }
    var campaignPicker=make('div',{class:'tw-popover tw-imagePopover tw-businessWheelPopover tw-businessCampaignPicker',hidden:''},[campaignCategoryNav]);
    var campaignExpand=makeWorkspaceButton(campaignPicker,'Campaign');campaignPicker.appendChild(campaignExpand);campaignPicker.appendChild(setBar);
    var wheelPicker=make('div',{class:'tw-popover tw-imagePopover tw-businessWheelPopover tw-businessIndividualPicker',hidden:''},[suggestionPanel,familyPanel,searchInput,categoryNav]);
    var wheelExpand=makeWorkspaceButton(wheelPicker,'Wheel');wheelPicker.appendChild(wheelExpand);wheelPicker.appendChild(libraryGrid);wheelPicker.appendChild(noResults);
    function placeBusinessPicker(picker,anchor){
      if(picker.classList.contains('isExpanded')&&(window.innerWidth||0)>=800){var expandedWidth=Math.min(1060,Math.max(700,(window.innerWidth||1100)-32));picker.style.width=expandedWidth+'px';picker.style.maxWidth=expandedWidth+'px';picker.style.left=Math.max(12,Math.round(((window.innerWidth||expandedWidth)-expandedWidth)/2))+'px';picker.style.top='16px';return;}
      if(!anchor)return;var rect=anchor.getBoundingClientRect(),width=Math.min(660,Math.max(320,(window.innerWidth||900)-24));picker.style.width=width+'px';picker.style.maxWidth=width+'px';picker.style.left=Math.max(12,Math.min(rect.left,(window.innerWidth||900)-width-12))+'px';picker.style.top=Math.max(12,Math.min(rect.bottom+8,(window.innerHeight||700)-Math.min(620,picker.scrollHeight||520)-12))+'px';
    }
    function bindBusinessPicker(button,picker){
      button.addEventListener('click',function(event){event.stopPropagation();campaignPicker.hidden=picker!==campaignPicker;wheelPicker.hidden=picker!==wheelPicker;if(picker===wheelPicker)refreshSuggestions();picker.hidden=false;placeBusinessPicker(picker,button);});
      picker.addEventListener('click',function(event){event.stopPropagation();});
    }
    bindBusinessPicker(openLibraryButton,campaignPicker);bindBusinessPicker(openIndividualButton,wheelPicker);
    document.addEventListener('click',function(){campaignPicker.hidden=true;wheelPicker.hidden=true;});
    function repositionBusinessPickers(){if(!campaignPicker.hidden)placeBusinessPicker(campaignPicker,openLibraryButton);if(!wheelPicker.hidden)placeBusinessPicker(wheelPicker,openIndividualButton);}
    window.addEventListener('resize',repositionBusinessPickers,{passive:true});window.addEventListener('scroll',repositionBusinessPickers,{passive:true});
    var countControl=make('div',{class:'tw-businessCountControl'},[make('span',{text:'Campaign wheels'})]);
    var countButtons=[];
    [1,2,3].forEach(function(count){var button=make('button',{class:'tw-businessCountButton'+(count===wheelCount?' is-active':''),type:'button','aria-pressed':count===wheelCount?'true':'false',text:count+'×'});button.addEventListener('click',function(){setWheelCount(count,true);});countButtons.push(button);countControl.appendChild(button);});
    var trail = make('div',{ class:'tw-businessTrail', role:'tablist', 'aria-label':'Business campaign wheels' });
    var stepButtons = [];
    var stepInputs = [];
    for(i=0;i<3;i++){
      (function(index){
        var button = make('button',{ class:'tw-businessStep', type:'button', role:'tab', 'aria-selected':'false' },[
          make('span',{ class:'tw-businessStepNumber', text:String(index+1) }),
          make('span',{ class:'tw-businessStepCopy' },[
            make('small',{ text:defaults[index].eyebrow }),
            make('strong',{ text:names[index] })
          ]),
          make('span',{ class:'tw-businessStepStatus', text:'Ready' })
        ]);
        button.addEventListener('click',function(){ switchStep(index); });
        stepButtons.push(button);
        trail.appendChild(button);
      })(i);
    }
    var renameGrid = make('div',{ class:'tw-businessRenameGrid' });
    for(i=0;i<3;i++){
      (function(index){
        var input = make('input',{ class:'tw-input', type:'text', maxlength:'42', value:names[index], 'aria-label':'Name for campaign wheel '+(index+1) });
        input.addEventListener('input',function(){
          if(!hasVortexProAccess){ openBrandUpsell('vortex_pro'); input.value=names[index]; return; }
          names[index] = clean(input.value, defaults[index].name);
          var strong = stepButtons[index].querySelector('strong');
          if(strong) strong.textContent = names[index];
          scheduleSave();
        });
        stepInputs.push(input);
        renameGrid.appendChild(make('label',{ class:'tw-businessField' },[make('span',{ text:'Wheel '+(index+1)+' name' }),input]));
      })(i);
    }
    var brandKitDetails=make('details',{class:'tw-businessBrandKit'});
    var brandKitSummary=make('summary',{text:'Brand Kit · Colors, Logo & AI'});
    var brandNameInput=make('input',{class:'tw-input',type:'text',maxlength:'80',placeholder:'Brand name'});
    var brandPrompt=make('textarea',{class:'tw-textarea',rows:'3',maxlength:'500',placeholder:'Describe the brand, audience, feeling, products, and visual personality…'});
    var moodPrompt=make('textarea',{class:'tw-textarea',rows:'3',maxlength:'500',placeholder:'Describe the matching mood you want for one wheel or the full three-wheel campaign…'});
    var brandImageLabel=make('label',{class:'tw-businessField tw-businessBrandImage'},[make('span',{text:'Brand image or logo'})]);
    var brandImage=make('input',{class:'tw-input',type:'file',accept:'image/jpeg,image/png,image/webp,image/gif','aria-label':'Choose a brand image or logo for private palette analysis'});
    brandImageLabel.appendChild(brandImage);
    var removeBrandImageButton=make('button',{class:'tw-btn tw-businessRemoveImage',type:'button',text:'Remove Image'});
    var brandImagePreview=make('div',{class:'tw-businessBrandPreview',hidden:''},[make('img',{alt:'Brand image preview'}),make('div',{class:'tw-businessBrandPreviewCopy'},[make('span',{text:'Brand image ready for private palette analysis'}),removeBrandImageButton])]);
    var brandColors=make('div',{class:'tw-businessBrandColors'}),brandColorInputs=[],brandHexInputs=[],brandColorLocks=[];
    var starterPalette=(TW.CONST&&TW.CONST.PALETTE&&TW.CONST.PALETTE.length?TW.CONST.PALETTE:['#2FB7A3','#FFF8EE','#401268','#CC007E']);
    function normalizeBrandHex(value){value=String(value||'').trim().toUpperCase();if(value.charAt(0)!=='#')value='#'+value;return /^#[0-9A-F]{6}$/.test(value)?value:'';}
    function setBrandColor(index,value){var hex=normalizeBrandHex(value);if(!hex)return false;brandColorInputs[index].value=hex;brandHexInputs[index].value=hex;return true;}
    for(i=0;i<20;i++){
      (function(index){
        var value=starterPalette[index%starterPalette.length];
        var colorInput=make('input',{type:'color',value:value,'aria-label':'Choose brand color '+(index+1)});
        var hexInput=make('input',{class:'tw-businessHex',type:'text',value:String(value).toUpperCase(),maxlength:'7',spellcheck:'false','aria-label':'Hex code for brand color '+(index+1)});
        var lockButton=make('button',{class:'tw-businessColorLock',type:'button','aria-pressed':'false','aria-label':'Lock brand color '+(index+1),title:'Keep this color during AI changes',text:'Lock'});
        var card=make('div',{class:'tw-businessColorCard'},[colorInput,hexInput,lockButton]);
        colorInput.addEventListener('input',function(){hexInput.value=String(colorInput.value).toUpperCase();});
        hexInput.addEventListener('change',function(){if(!setBrandColor(index,hexInput.value)){hexInput.value=String(colorInput.value).toUpperCase();brandStatus.textContent='Use a six-digit hex code such as #2FB7A3.';}});
        lockButton.addEventListener('click',function(){brandColorLocks[index]=!brandColorLocks[index];lockButton.classList.toggle('is-locked',brandColorLocks[index]);lockButton.setAttribute('aria-pressed',brandColorLocks[index]?'true':'false');lockButton.textContent=brandColorLocks[index]?'Locked':'Lock';});
        brandColorInputs.push(colorInput);brandHexInputs.push(hexInput);brandColorLocks.push(false);brandColors.appendChild(card);
      })(i);
    }
    var saveBrandButton=make('button',{class:'tw-btn tw-btnPrimary',type:'button',text:'Save Brand Kit'});
    var brandReplaceSegments=false;
    var keepSegmentsButton=make('button',{class:'tw-btn is-active',type:'button','aria-pressed':'true',text:'Keep Segments & Stickers'});
    var replaceSegmentsButton=make('button',{class:'tw-btn',type:'button','aria-pressed':'false',text:'Replace with 6 Choices'});
    function setBrandSegmentMode(replace){brandReplaceSegments=replace;keepSegmentsButton.classList.toggle('is-active',!replace);replaceSegmentsButton.classList.toggle('is-active',replace);keepSegmentsButton.setAttribute('aria-pressed',replace?'false':'true');replaceSegmentsButton.setAttribute('aria-pressed',replace?'true':'false');}
    keepSegmentsButton.addEventListener('click',function(){setBrandSegmentMode(false);});replaceSegmentsButton.addEventListener('click',function(){setBrandSegmentMode(true);});
    var brandSegmentMode=make('div',{class:'tw-businessBrandMode'},[keepSegmentsButton,replaceSegmentsButton]);
    var applyBrandButton=make('button',{class:'tw-btn',type:'button',text:'Apply Brand Colors to This Wheel'});
    var applyCampaignBrandButton=make('button',{class:'tw-btn',type:'button',text:'Apply Brand Colors to '+wheelCount+' Wheel'+(wheelCount===1?'':'s')});
    var analyzeBrandButton=make('button',{class:'tw-btn',type:'button',text:'Curate Brand Palette with AI'});
    var curateMoodButton=make('button',{class:'tw-btn',type:'button',text:'Curate Palette from Wheel Mood'});
    var remixButton=make('button',{class:'tw-btn',type:'button',text:'Remix Unlocked Colors'});
    var contrastButton=make('button',{class:'tw-btn',type:'button',text:'Boost Contrast'});
    var softenButton=make('button',{class:'tw-btn',type:'button',text:'Soften Palette'});
    var reportPaletteButton=make('button',{class:'tw-btn tw-btnReport',type:'button',text:'Report Palette AI Issue'});
    var thinkingPanel=make('div',{class:'tw-aiThinking tw-businessAiThinking',hidden:'',role:'status','aria-live':'polite'},[make('img',{class:'tw-aiThinkingIcon',src:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/spinbusinessaithinkingicon.png?v=1786029000',alt:'Palette AI is thinking'}),make('span',{class:'tw-aiThinkingText',text:'Palette AI is thinking…'})]);
    var professorReview=make('div',{class:'tw-aiDoctor tw-businessPaletteProfessor'},[make('div',{class:'tw-aiDoctorTitle',text:'WHEEL PROFESSOR'}),make('div',{class:'tw-aiDoctorText',text:'After generation, Wheel Professor will cross-check brand fit, energy, color separation, locked colors, and spinner readiness here.'})]);
    var legalNotice=make('details',{class:'tw-businessAiNotice'},[make('summary',{text:'Brand & AI notice'}),make('p',{text:'Only upload images you have permission to use. Your brand inputs and prepared image are sent to the palette service to create your result; AI suggestions may be imperfect. Review color contrast, accessibility, and brand or trademark requirements before publishing.'})]);
    var brandStatus=make('div',{class:'tw-businessBrandStatus',role:'status','aria-live':'polite',style:'font-size:12px;line-height:1.4;opacity:.88;',text:'Brand Kit and Palette AI tools are available with Vortex Pro.'});
    var brandKitBody=make('div',{class:'tw-businessBrandBody'},[
      brandNameInput,brandPrompt,brandImageLabel,brandImagePreview,make('div',{class:'tw-businessBrandLabel',text:'20-COLOR BRAND PALETTE · ENTER HEX CODES OR PICK COLORS · LOCK FAVORITES'}),brandColors,make('div',{class:'tw-businessBrandLabel',text:'SEGMENTS AND STICKERS'}),brandSegmentMode,
      make('div',{class:'tw-toolbar'},[saveBrandButton,applyBrandButton]),
      make('div',{class:'tw-businessBrandLabel',text:'MATCHING WHEEL MOOD'}),moodPrompt,
      make('div',{class:'tw-toolbar'},[analyzeBrandButton,curateMoodButton]),make('div',{class:'tw-businessBrandLabel',text:'COLOR DIRECTIONS'}),make('div',{class:'tw-toolbar tw-businessAiDirections'},[remixButton,contrastButton,softenButton]),professorReview,reportPaletteButton,brandStatus,legalNotice
    ]);
    brandKitDetails.appendChild(brandKitSummary);brandKitDetails.appendChild(brandKitBody);
    var saveButton = make('button',{ class:'tw-btn tw-btnPrimary', type:'button', text:'Save 3-Wheel Campaign' });
    var exportButton = make('button',{ class:'tw-btn', type:'button', text:'Export Campaign Backup' });
    var resetButton = make('button',{ class:'tw-btn tw-btnDanger', type:'button', text:'Start Fresh' });
    var actions = make('div',{ class:'tw-toolbar tw-businessActions' },[saveButton,exportButton,resetButton]);
    var status = make('div',{ class:'tw-mini tw-businessStatus', text:'All three wheels are stored together in this browser.' });
    var future = make('div',{ class:'tw-businessFuture' },[
      make('span',{ class:'tw-businessFutureBadge', text:'DASHBOARD READY' }),
      make('span',{ text:'A later business dashboard can connect campaign plays, completions, claims, redemptions, and return visits to this three-wheel campaign.' })
    ]);
    var lockNotice = make('div',{class:'tw-businessLockNotice'},[
      make('strong',{text:'Vortex Pro subscription required'}),
      make('span',{text:'Brand Kit saving and application are included with Vortex Pro.'})
    ]);
    var unlockButton=make('button',{class:'tw-btn tw-btnPrimary',type:'button',text:'View Vortex Pro'});
    unlockButton.addEventListener('click',function(){ openBrandUpsell('vortex_pro'); });
    lockNotice.appendChild(unlockButton);
    var workspace = make('div',{class:'tw-businessWorkspace'},[brandKitDetails]);
    var body = make('div',{ class:'tw-accordBody tw-businessBody' },[workspace]);
    details.appendChild(summary);
    details.appendChild(body);
    brandKitDetails.classList.add('tw-brandKitInQuickTweaks');
    if(TW.refs && TW.refs.optBody){
      var quickInsertBefore = TW.refs.quickStickerPromo || TW.refs.quickSubscriptionPromo || null;
      TW.refs.optBody.insertBefore(brandKitDetails, quickInsertBefore);
    }
    document.body.appendChild(thinkingPanel);

    function openBrandUpsell(requiredPlan){
      requiredPlan = requiredPlan === 'vortex_pro' ? 'vortex_pro' : 'vortex_pro';
      if(TW.openPlanUpsell) TW.openPlanUpsell(requiredPlan,{
        title:requiredPlan === 'vortex_pro' ? 'Unlock Palette AI' : 'Unlock Brand Kit',
        message:requiredPlan === 'vortex_pro' ? 'Use Vortex Pro to create and refine brand palettes with AI.' : 'Use Vortex Pro to save and apply your reusable Brand Kit.'
      });
    }
    function currentBrandKit(){return {schemaVersion:2,name:clean(brandNameInput.value,'My Brand'),prompt:String(brandPrompt.value||''),moodPrompt:String(moodPrompt.value||''),colors:brandColorInputs.map(function(input){return input.value;}),locked:brandColorLocks.slice(),updatedAt:new Date().toISOString()};}
    function loadBrandKit(){
      try{var kit=JSON.parse(localStorage.getItem('toki_brand_kit_v1')||'null');if(!kit)return;brandNameInput.value=kit.name||'';brandPrompt.value=kit.prompt||'';moodPrompt.value=kit.moodPrompt||'';(kit.colors||[]).slice(0,20).forEach(function(color,index){setBrandColor(index,color);});(kit.locked||[]).slice(0,20).forEach(function(locked,index){brandColorLocks[index]=Boolean(locked);var button=brandColors.children[index]&&brandColors.children[index].querySelector('.tw-businessColorLock');if(button){button.classList.toggle('is-locked',brandColorLocks[index]);button.setAttribute('aria-pressed',brandColorLocks[index]?'true':'false');button.textContent=brandColorLocks[index]?'Locked':'Lock';}});brandStatus.textContent='Saved Brand Kit loaded for this browser.';}catch(_){}
    }
    function saveBrandKit(){
      if(!hasVortexProAccess){openBrandUpsell('vortex_pro');return false;}
      try{localStorage.setItem('toki_brand_kit_v1',JSON.stringify(currentBrandKit()));brandStatus.textContent='Brand Kit saved. It can load on other wheel pages in this browser.';return true;}catch(_){brandStatus.textContent='This browser could not save the Brand Kit.';return false;}
    }
    function applyBrandPalette(allWheels){
      if(!hasVortexProAccess){openBrandUpsell('vortex_pro');return;}
      var colors=currentBrandKit().colors;
      function applyCustomPaletteState(state){
        state=clone(state);state.ui=state.ui||{};state.ui.pageBg='#4A5568';state.ui.overlayBg='#4A5568';state.ui.overlayBg2='#4A5568';state.ui.headerTextColor='#FFF8EE';state.ui.businessPalette=colors.slice();state.ui.businessWheelId='custom-palette';
        var everyThird=[];for(var colorIndex=0;colorIndex<6;colorIndex++)everyThird.push(colors[(colorIndex*3)%colors.length]);
        if(brandReplaceSegments)state.segments=everyThird.map(function(color,index){return {label:'CHOICE '+(index+1),weight:1,color:color,tcolor:'black',sliceImgUrl:''};});
        else state.segments=(state.segments||[]).map(function(segment,index){segment=clone(segment);segment.color=everyThird[index%everyThird.length];return segment;});
        return state;
      }
      TW.state=applyCustomPaletteState(TW.state);
      if(TW.CONST)TW.CONST.PALETTE=colors.slice();applyTheme(TW.state);if(TW.ensureState)TW.ensureState();if(TW.syncUIFromState)TW.syncUIFromState();TW.renderAll();saveBrandKit();brandStatus.textContent='Brand colors applied to this wheel. '+(brandReplaceSegments?'Segments were replaced with six general choices.':'Existing segment labels and stickers were preserved.');
    }
    var paletteAiSession=null;
    var paletteAiBusy=false;
    var paletteAiLast={requestId:'',paletteName:'',rationale:'',colors:[],action:'',imageSupplied:false};
    function paletteAiMessage(error,fallback){
      if(error&&error.message)return String(error.message);
      return fallback||'Palette AI could not complete this request.';
    }
    function setPaletteAiBusy(busy){
      paletteAiBusy=busy;
      analyzeBrandButton.disabled=busy;
      curateMoodButton.disabled=busy;
      remixButton.disabled=busy;contrastButton.disabled=busy;softenButton.disabled=busy;
      analyzeBrandButton.setAttribute('aria-busy',busy?'true':'false');
      curateMoodButton.setAttribute('aria-busy',busy?'true':'false');
      thinkingPanel.hidden=!busy;
    }
    function fileToDataUrl(file){
      return new Promise(function(resolve,reject){
        var reader=new FileReader();
        reader.onload=function(){resolve(String(reader.result||''));};
        reader.onerror=function(){reject(new Error('The brand image could not be read.'));};
        reader.readAsDataURL(file);
      });
    }
    function loadImageElement(dataUrl){
      return new Promise(function(resolve,reject){
        var image=new Image();
        image.onload=function(){resolve(image);};
        image.onerror=function(){reject(new Error('The selected brand image could not be opened.'));};
        image.src=dataUrl;
      });
    }
    async function prepareBrandImageForAi(){
      var file=brandImage.files&&brandImage.files[0];
      if(!file)return '';
      var allowed=['image/jpeg','image/png','image/webp','image/gif'];
      if(allowed.indexOf(String(file.type||'').toLowerCase())===-1)throw new Error('Choose a JPG, PNG, WebP, or GIF brand image.');
      if(file.size>12*1024*1024)throw new Error('Choose a brand image smaller than 12 MB.');
      var original=await fileToDataUrl(file);
      var image=await loadImageElement(original);
      var longest=Math.max(image.naturalWidth||image.width||1,image.naturalHeight||image.height||1);
      var scale=Math.min(1,1200/longest);
      var width=Math.max(1,Math.round((image.naturalWidth||image.width||1)*scale));
      var height=Math.max(1,Math.round((image.naturalHeight||image.height||1)*scale));
      var canvas=document.createElement('canvas');canvas.width=width;canvas.height=height;
      var context=canvas.getContext('2d',{alpha:false});
      if(!context)throw new Error('This browser could not prepare the brand image.');
      context.fillStyle='#FFFFFF';context.fillRect(0,0,width,height);context.drawImage(image,0,0,width,height);
      var quality=.86,dataUrl=canvas.toDataURL('image/jpeg',quality);
      while(dataUrl.length>2700000&&quality>.5){quality-=.08;dataUrl=canvas.toDataURL('image/jpeg',quality);}
      if(dataUrl.length>2800000)throw new Error('The brand image is still too large after preparation. Try a smaller image.');
      return dataUrl;
    }
    brandImage.addEventListener('change',function(){var file=brandImage.files&&brandImage.files[0],img=brandImagePreview.querySelector('img');if(!file){brandImagePreview.hidden=true;img.removeAttribute('src');return;}fileToDataUrl(file).then(function(url){img.src=url;brandImagePreview.hidden=false;}).catch(function(error){brandImagePreview.hidden=true;brandStatus.textContent=paletteAiMessage(error);});});
    removeBrandImageButton.addEventListener('click',function(){brandImage.value='';var img=brandImagePreview.querySelector('img');img.removeAttribute('src');brandImagePreview.hidden=true;brandStatus.textContent='Brand image removed. Your saved colors and brand details were kept.';});
    function renderPaletteProfessor(data){
      var quality=data&&data.quality||{},checks=quality.checks||{},items=[];
      items.push(checks.locksPreserved===false?'Locked colors need review.':'Locked colors preserved.');
      items.push(checks.spinnerSeparation===false?'Some neighboring colors may blend on a wheel.':'Neighboring wheel colors are visibly separated.');
      items.push(checks.funEnergy===false?'The palette may still feel too quiet for this brief.':'Energy and saturation fit a playful modern spinner.');
      if(quality.transformCheck&&quality.transformCheck.required)items.push(quality.transformCheck.passed?'The requested color change is clearly visible.':'The requested color change was lighter than expected.');
      professorReview.querySelector('.tw-aiDoctorText').textContent=(quality.notes||'Professor cross-check complete.')+' '+items.join(' ');
      professorReview.classList.toggle('has-warning',checks.spinnerSeparation===false||checks.funEnergy===false||(quality.transformCheck&&quality.transformCheck.passed===false));
    }
    function openBusinessAiLimit(limitType){
      var monthly=limitType==='monthly',old=document.querySelector('.tw-businessAiLimit');if(old&&old.parentNode)old.parentNode.removeChild(old);
      var back=make('div',{class:'tw-aiLimitBack tw-businessAiLimit',role:'dialog','aria-modal':'true','aria-label':monthly?'Monthly Palette AI limit reached':'Daily Palette AI limit reached'}),card=make('div',{class:'tw-aiLimitCard tw-businessAiLimitCard'}),close=make('button',{class:'tw-aiLimitX',type:'button','aria-label':'Close AI limit message',text:'×'});
      card.appendChild(close);card.appendChild(make('img',{class:'tw-aiLimitImg',src:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/spinbusinessaithinkingicon.png?v=1786029000',alt:''}));card.appendChild(make('strong',{text:monthly?'Monthly Palette AI limit reached':'Daily Palette AI limit reached'}));card.appendChild(make('p',{text:monthly?'Your monthly palette allowance will refresh at the start of your next usage month. Your saved Brand Kit and locked colors are still available.':'Your daily palette allowance will refresh tomorrow. You can still edit hex codes, lock colors, save, and apply your Brand Kit.'}));
      function shut(){if(back.parentNode)back.parentNode.removeChild(back);}close.onclick=shut;back.addEventListener('click',function(event){if(event.target===back)shut();});back.appendChild(card);document.body.appendChild(back);
    }
    async function getPaletteAiSession(){
      if(paletteAiSession&&paletteAiSession.token&&paletteAiSession.expiresAt>Date.now()+30000)return paletteAiSession;
      var response=await fetch('/apps/business-lab-palette/session',{method:'GET',credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store'});
      var data;
      try{data=await response.json();}catch(_){data=null;}
      if(!response.ok||!data||!data.token){throw new Error(data&&data.error?data.error:'Sign in to your Vortex Pro account and try again.');}
      if(data.plan!=='vortex_pro'){openBrandUpsell('vortex_pro');throw new Error('Vortex Pro is required to use Palette AI.');}
      paletteAiSession={token:String(data.token),expiresAt:Date.now()+(Number(data.expiresIn||900)*1000)};
      return paletteAiSession;
    }
    async function curateBrandPalette(focus){
      if(!hasVortexAccess){openBrandUpsell('vortex_pro');return;}
      if(paletteAiBusy)return;
      var kit=currentBrandKit();
      if(!String(kit.prompt||'').trim()&&!String(kit.moodPrompt||'').trim()&&!kit.colors.length){brandStatus.textContent='Add a brand description, wheel mood, or starting colors first.';return;}
      setPaletteAiBusy(true);
      brandStatus.textContent='Securely verifying your Vortex Pro account…';
      try{
        var session=await getPaletteAiSession();
        var preparedImage='';
        if(brandImage.files&&brandImage.files[0]){
          brandStatus.textContent='Preparing your brand image for private AI analysis…';
          preparedImage=await prepareBrandImageForAi();
        }
        brandStatus.textContent='Palette AI is analyzing your brand and curating 20 coordinated wheel colors…';
        var mood=String(kit.moodPrompt||'').trim();
        if(focus==='mood'&&mood)mood='Prioritize this wheel mood: '+mood;
        var response=await fetch('https://stwl-brand-palette-ai.johnniedropmx.workers.dev/palette',{
          method:'POST',
          mode:'cors',
          cache:'no-store',
          headers:{Authorization:'Bearer '+session.token,'Content-Type':'application/json'},
          body:JSON.stringify({brandName:kit.name,brandDescription:kit.prompt,mood:mood,existingColors:kit.colors,lockedColors:kit.colors.filter(function(_,index){return brandColorLocks[index];}),lockedSlots:kit.colors.map(function(color,index){return brandColorLocks[index]?{position:index+1,color:color}:null;}).filter(Boolean),action:focus,brandImage:preparedImage})
        });
        var data;
        try{data=await response.json();}catch(_){data=null;}
        if(response.status===401){paletteAiSession=null;}
        if(response.status===429){
          var limitType=data&&data.limitType==='monthly'?'monthly':'daily';
          openBusinessAiLimit(limitType);
          throw new Error(limitType==='monthly'?'Monthly AI limit reached.':'Daily AI limit reached.');
        }
        if(!response.ok||!data||data.ok!==true){throw new Error(data&&data.error?data.error:'Palette AI could not create this palette.');}
        if(!Array.isArray(data.colors)||data.colors.length!==20){throw new Error('Palette AI returned an incomplete palette. Please try again.');}
        data.colors.forEach(function(color,index){if(!brandColorLocks[index])setBrandColor(index,color);});
        paletteAiLast={requestId:String(data.requestId||''),paletteName:String(data.paletteName||'Custom Brand Palette'),rationale:String(data.rationale||''),colors:data.colors.slice(0,20),action:focus==='mood'?'Wheel mood palette':'Brand palette',imageSupplied:Boolean(preparedImage)};
        renderPaletteProfessor(data);
        saveBrandKit();
        var usage=data.usage||{};
        var usageText=Number.isFinite(Number(usage.dayCount))?' · '+usage.dayCount+' of '+usage.dayLimit+' used today':'';
        brandStatus.textContent=(data.paletteName||'Custom Brand Palette')+' — '+(data.rationale||'20 coordinated colors are ready.')+usageText+'. Choose an Apply button when you are ready to update the wheel.';
      }catch(error){
        brandStatus.textContent=paletteAiMessage(error);
      }finally{
        setPaletteAiBusy(false);
      }
    }
    var paletteReportOverlay=make('div',{class:'tw-reportOverlay',role:'dialog','aria-modal':'true','aria-label':'Report a Palette AI issue'});
    var paletteReportCard=make('div',{class:'tw-reportCard'});
    var paletteReportClose=make('button',{class:'tw-reportClose',type:'button',text:'×',title:'Close report form','aria-label':'Close report form'});
    var paletteReportType=make('select',{class:'tw-input'},[
      make('option',{value:'Palette AI Issue',text:'Palette AI Issue'}),
      make('option',{value:'Colors do not match the brand',text:'Colors do not match the brand'}),
      make('option',{value:'Image colors were misunderstood',text:'Image colors were misunderstood'}),
      make('option',{value:'Palette lacks contrast',text:'Palette lacks contrast'}),
      make('option',{value:'Repeated or weak colors',text:'Repeated or weak colors'}),
      make('option',{value:'Unsafe or strange output',text:'Unsafe or strange output'}),
      make('option',{value:'AI did not respond',text:'AI did not respond'}),
      make('option',{value:'Other',text:'Other'})
    ]);
    var paletteReportMessage=make('textarea',{class:'tw-textarea',maxlength:'2000',placeholder:'Tell the Lab what went wrong and what you expected instead.',spellcheck:'true'});
    var paletteReportConsent=make('input',{type:'checkbox'});
    var paletteReportOutput=make('textarea',{class:'tw-textarea tw-reportResult tw-reportReadonly',readonly:'true',spellcheck:'false'});
    var paletteReportStatus=make('div',{class:'tw-reportStatus'});
    var paletteReportCancel=make('button',{class:'tw-btn',type:'button',text:'Cancel'});
    var paletteReportSend=make('button',{class:'tw-btn tw-btnPrimary',type:'button',text:'Send to the Lab'});
    var paletteReportMiniBrand=make('p',{class:'tw-reportMiniValue',text:'Captured when available'});
    var paletteReportMiniAction=make('p',{class:'tw-reportMiniValue',text:'Captured when available'});
    var paletteReportMiniImage=make('p',{class:'tw-reportMiniValue',text:'No image'});
    var paletteReportMiniPage=make('p',{class:'tw-reportMiniValue',text:'This page'});
    var paletteReportHead=make('div',{class:'tw-reportHead'},[
      make('div',{class:'tw-reportHeadCopy'},[
        make('p',{class:'tw-reportEyebrow',text:'SPIN THE WHEEL LAB'}),
        make('h3',{class:'tw-reportTitle',text:'Report a Palette AI Issue'}),
        make('p',{class:'tw-reportIntro',text:'Something strange in the color lab? Tell Professor Vortex what happened. The latest request ID and limited palette details will be attached automatically.'})
      ]),paletteReportClose
    ]);
    var paletteReportBody=make('div',{class:'tw-reportBody'},[
      make('div',{class:'tw-reportGrid'},[make('div',{class:'tw-field'},[make('label',{text:'What kind of issue?'}),paletteReportType])]),
      make('div',{style:'height:14px;'}),
      make('div',{class:'tw-field tw-field--mainIssue'},[make('label',{text:'What should we fix?'}),paletteReportMessage,make('p',{class:'tw-reportTiny',text:'Example: The image has warm orange and cream colors, but the palette came back mostly blue.'})]),
      make('div',{class:'tw-reportNotice'},[make('strong',{text:'Please do not include sensitive information. '}),document.createTextNode('Do not send passwords, payment details, government IDs, medical information, or private information about another person. Your uploaded image is never attached to this report.')]),
      make('label',{class:'tw-reportConsent'},[paletteReportConsent,make('span',{},[document.createTextNode('I have reviewed the '),make('a',{href:'https://spinthewheellab.com/pages/legal-lab',target:'_blank',rel:'noopener noreferrer',text:'Legal Lab'}),document.createTextNode(', consent to sending this report and its listed diagnostic details, and confirm that I have not included sensitive information.')])]),
      make('div',{class:'tw-reportContextGrid'},[
        make('div',{class:'tw-reportMiniCard'},[make('p',{class:'tw-reportMiniLabel',text:'Brand'}),paletteReportMiniBrand]),
        make('div',{class:'tw-reportMiniCard'},[make('p',{class:'tw-reportMiniLabel',text:'Action'}),paletteReportMiniAction]),
        make('div',{class:'tw-reportMiniCard'},[make('p',{class:'tw-reportMiniLabel',text:'Image analyzed'}),paletteReportMiniImage]),
        make('div',{class:'tw-reportMiniCard'},[make('p',{class:'tw-reportMiniLabel',text:'Page'}),paletteReportMiniPage])
      ]),
      make('div',{style:'height:14px;'}),
      make('div',{class:'tw-field'},[make('label',{text:'AI palette included with this report'}),paletteReportOutput,make('p',{class:'tw-reportTiny',text:'Review the captured palette before sending. Your uploaded image, full brand description, email, customer tags, and access snapshot are not included.'})])
    ]);
    var paletteReportFoot=make('div',{class:'tw-reportFoot'},[paletteReportStatus,paletteReportCancel,paletteReportSend]);
    paletteReportCard.appendChild(make('img',{class:'tw-reportRepairman',src:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexrepairman.png?v=1777572295',alt:'Professor Vortex repairman',loading:'lazy'}));
    paletteReportCard.appendChild(paletteReportHead);paletteReportCard.appendChild(paletteReportBody);paletteReportCard.appendChild(paletteReportFoot);paletteReportOverlay.appendChild(paletteReportCard);document.body.appendChild(paletteReportOverlay);
    function closePaletteReport(){paletteReportOverlay.style.display='none';paletteReportSend.disabled=false;paletteReportCard.classList.remove('is-sending');}
    function openPaletteReport(){
      if(!hasVortexAccess){openBrandUpsell('vortex_pro');return;}
      var kit=currentBrandKit();
      paletteReportType.value='Palette AI Issue';paletteReportMessage.value='';paletteReportConsent.checked=false;paletteReportStatus.textContent='';
      paletteReportMiniBrand.textContent=kit.name||'My Brand';paletteReportMiniAction.textContent=paletteAiLast.action||'No completed request yet';paletteReportMiniImage.textContent=paletteAiLast.imageSupplied?'Yes — image not attached':'No';paletteReportMiniPage.textContent=location.hostname+location.pathname;
      paletteReportOutput.value=paletteAiLast.requestId?JSON.stringify({paletteName:paletteAiLast.paletteName,rationale:paletteAiLast.rationale,colors:paletteAiLast.colors},null,2):'No completed Palette AI result is available yet.';
      paletteReportOverlay.style.display='flex';
    }
    async function sendPaletteReport(){
      var notes=String(paletteReportMessage.value||'').trim();
      if(!notes){paletteReportStatus.textContent='Add a quick note before sending.';paletteReportMessage.focus();return;}
      if(!paletteReportConsent.checked){paletteReportStatus.textContent='Please review and check the consent box before sending.';paletteReportConsent.focus();return;}
      paletteReportStatus.textContent='Repairman Vortex is checking the color dials…';paletteReportSend.disabled=true;paletteReportCard.classList.add('is-sending');
      try{
        var session=await getPaletteAiSession();var kit=currentBrandKit();
        var response=await fetch('https://stwl-brand-palette-ai.johnniedropmx.workers.dev/report',{method:'POST',mode:'cors',cache:'no-store',headers:{Authorization:'Bearer '+session.token,'Content-Type':'application/json'},body:JSON.stringify({notes:notes,issueType:paletteReportType.value,requestId:paletteAiLast.requestId,consent:true,palette:{brandName:kit.name,action:paletteAiLast.action,paletteName:paletteAiLast.paletteName,rationale:paletteAiLast.rationale,colors:paletteAiLast.colors,imageSupplied:paletteAiLast.imageSupplied,pagePath:location.pathname||'/',viewport:String(window.innerWidth||0)+'×'+String(window.innerHeight||0),language:navigator.language||''},userAgent:navigator.userAgent||''})});
        var data;try{data=await response.json();}catch(_){data=null;}
        if(response.status===401)paletteAiSession=null;
        if(!response.ok||!data||data.ok!==true)throw new Error(data&&data.error?data.error:'The report could not be sent.');
        paletteReportStatus.textContent='Message sent. Professor Vortex is checking the color dials.';setTimeout(closePaletteReport,1000);
      }catch(error){paletteReportStatus.textContent='Something jammed in the machine. '+paletteAiMessage(error);paletteReportSend.disabled=false;paletteReportCard.classList.remove('is-sending');}
    }
    reportPaletteButton.addEventListener('click',openPaletteReport);paletteReportClose.addEventListener('click',closePaletteReport);paletteReportCancel.addEventListener('click',closePaletteReport);paletteReportSend.addEventListener('click',sendPaletteReport);paletteReportOverlay.addEventListener('click',function(event){if(event.target===paletteReportOverlay)closePaletteReport();});
    function refreshSelected(){
      selectedStrip.innerHTML='';
      for(var selectedIndex=0;selectedIndex<wheelCount;selectedIndex++){
        var wheel=findWheel(selectedWheels[selectedIndex]),isCustom=selectedWheels[selectedIndex]==='custom-palette';
        selectedStrip.appendChild(make('div',{class:'tw-businessSelectedCard'+(selectedIndex===active?' is-active':'')},[
          wheel?make('img',{src:wheel.icon,alt:''}):make('span',{class:'tw-businessSelectedEmpty',text:isCustom?'6':String(selectedIndex+1)}),
          make('small',{text:wheel?wheel.name:(isCustom?'Custom Palette':(selectedIndex===0?'This page’s wheel':'Wheel '+(selectedIndex+1)))})
        ]));
      }
    }

    function engage(){
      if(!hasVortexProAccess) return;
      if(engaged) return;
      engaged = true;
      if(!saved) states[0] = clone(TW.state);
      TW.state = clone(states[active]);
      applyTheme(TW.state);
      if(TW.ensureState) TW.ensureState();
      if(TW.syncUIFromState) TW.syncUIFromState();
      TW.renderAll();
      if(TW.refreshAccessUI) TW.refreshAccessUI();
      status.textContent = saved ? 'Saved three-wheel campaign loaded.' : 'Wheel 1 now uses this wheel as its starting point.';
    }
    function capture(){
      if(!engaged) return;
      states[active] = clone(TW.state);
      campaignName = clean(nameInput.value,'My Business Campaign');
    }
    function payload(){
      capture();
      return { schemaVersion:3, name:campaignName, wheelCount:wheelCount, active:active, stepNames:names.slice(0,wheelCount), selectedWheels:selectedWheels.slice(0,wheelCount), states:states.slice(0,wheelCount), updatedAt:new Date().toISOString() };
    }
    function saveAll(message){
      var ok = writeSaved(payload());
      status.textContent = ok ? (message || 'Campaign saved. All three wheels are stored together in this browser.') : 'This browser could not save the campaign.';
      status.classList.toggle('is-success',ok);
      return ok;
    }
    function scheduleSave(){
      clearTimeout(saveTimer);
      status.textContent = 'Unsaved campaign changes…';
      status.classList.remove('is-success');
      saveTimer = setTimeout(function(){ saveAll(); },700);
    }
    function refreshTabs(){
      selectedStrip.style.setProperty('--tw-business-wheel-count',wheelCount);trail.style.setProperty('--tw-business-wheel-count',wheelCount);renameGrid.style.setProperty('--tw-business-wheel-count',wheelCount);
      stepButtons.forEach(function(button,index){
        var enabled=index<wheelCount;button.hidden=!enabled;if(stepInputs[index]&&stepInputs[index].parentNode)stepInputs[index].parentNode.hidden=!enabled;
        var selected = index === active;
        button.classList.toggle('is-active',selected);
        button.setAttribute('aria-selected',selected?'true':'false');
        var stateLabel = button.querySelector('.tw-businessStepStatus');
        if(stateLabel) stateLabel.textContent = selected ? 'Editing' : 'Ready';
      });
      countButtons.forEach(function(button,index){var selected=index+1===wheelCount;button.classList.toggle('is-active',selected);button.setAttribute('aria-pressed',selected?'true':'false');});
      saveButton.textContent='Save '+wheelCount+'-Wheel Campaign';
      applyCampaignBrandButton.textContent='Apply Brand Colors to '+wheelCount+' Wheel'+(wheelCount===1?'':'s');
      status.textContent=wheelCount===1?'This campaign uses one wheel.':'This campaign uses '+wheelCount+' wheels.';
    }
    function setWheelCount(count,shouldSave){
      count=Math.max(1,Math.min(3,parseInt(count,10)||1));if(count===wheelCount){refreshTabs();return;}
      capture();wheelCount=count;if(active>=wheelCount){active=wheelCount-1;TW.state=clone(states[active]);applyTheme(TW.state);if(TW.ensureState)TW.ensureState();if(TW.syncUIFromState)TW.syncUIFromState();TW.renderAll();}
      refreshTabs();refreshSelected();refreshSuggestions();if(shouldSave)saveAll('Campaign updated to '+wheelCount+' wheel'+(wheelCount===1?'':'s')+'.');
    }
    function switchStep(index){
      if(!hasVortexProAccess){openBrandUpsell('vortex_pro');return;}
      if(index>=wheelCount)return;
      engage();
      if(index === active){ refreshTabs(); return; }
      capture();
      active = index;
      TW.state = clone(states[active]);
      applyTheme(TW.state);
      if(TW.ensureState) TW.ensureState();
      if(TW.syncUIFromState) TW.syncUIFromState();
      TW.renderAll();
      if(TW.refreshAccessUI) TW.refreshAccessUI();
      refreshTabs();
      refreshSelected();
      refreshSuggestions();
      saveAll('Wheel '+(active+1)+' is ready to edit.');
    }
    function chooseWheel(wheel){
      if(!hasVortexProAccess){openBrandUpsell('vortex_pro');return;}
      engage();
      states[active]=stateFromWheel(wheel,active);selectedWheels[active]=wheel.id;
      TW.state=clone(states[active]);applyTheme(TW.state);
      if(TW.ensureState)TW.ensureState();if(TW.syncUIFromState)TW.syncUIFromState();TW.renderAll();
      refreshTabs();saveAll(wheel.name+' is now Wheel '+(active+1)+'. Its background and text colors are active.');
      refreshSelected();
      refreshSuggestions();
      wheelPicker.hidden=true;
    }
    function applySet(ids){
      if(!hasVortexProAccess){openBrandUpsell('vortex_pro');return;}
      engage();
      wheelCount=Math.max(1,Math.min(3,ids.length));
      ids.forEach(function(id,index){var wheel=findWheel(id);if(wheel){states[index]=stateFromWheel(wheel,index);selectedWheels[index]=id;}});
      active=0;TW.state=clone(states[0]);applyTheme(TW.state);
      if(TW.ensureState)TW.ensureState();if(TW.syncUIFromState)TW.syncUIFromState();TW.renderAll();refreshTabs();
      saveAll('Three-wheel visual set applied. You can still replace any wheel individually.');
      refreshSelected();
    }
    function returnToNativeWheel(){
      if(!hasVortexProAccess){openBrandUpsell('vortex_pro');return;}
      engage();var nativeState=nativeStateFromPagePreset();states[active]=clone(nativeState);selectedWheels[active]='';TW.state=clone(nativeState);restoreNativeTheme();
      if(TW.ensureState)TW.ensureState();if(TW.syncUIFromState)TW.syncUIFromState();TW.renderAll();refreshTabs();refreshSelected();saveAll('Returned Wheel '+(active+1)+' to this page’s native wheel.');
    }
    function exportCampaign(){
      engage();
      var data = payload();
      var blob = new Blob([JSON.stringify(data,null,2)],{type:'application/json'});
      var url = URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.download = campaignName.toLowerCase().replace(/[^a-z0-9]+/g,'-')+'-business-campaign.json';
      document.body.appendChild(link);
      link.click();
      setTimeout(function(){ URL.revokeObjectURL(url); if(link.parentNode)link.parentNode.removeChild(link); },50);
      status.textContent = 'Campaign backup downloaded.';
    }
    function resetCampaign(){
      engage();
      if(!window.confirm('Start this campaign fresh from the wheel on this page? Your current campaign will be replaced.')) return;
      var nativeState=nativeStateFromPagePreset();
      for(var index=0;index<3;index++){ states[index]=clone(nativeState);selectedWheels[index]='';names[index]=defaults[index].name;stepInputs[index].value=names[index]; }
      active=0;campaignName='My Business Campaign';nameInput.value=campaignName;
      TW.state=clone(nativeState);restoreNativeTheme();if(TW.ensureState)TW.ensureState();if(TW.syncUIFromState)TW.syncUIFromState();TW.renderAll();refreshTabs();saveAll('Fresh campaign started from this page’s wheel.');
      refreshSelected();
    }
    nameInput.addEventListener('input',function(){if(!hasVortexProAccess){openBrandUpsell('vortex_pro');nameInput.value=campaignName;return;}scheduleSave();});
    saveButton.addEventListener('click',function(){ if(!hasVortexProAccess){openBrandUpsell('vortex_pro');return;}engage(); saveAll('Three-wheel campaign saved.'); });
    exportButton.addEventListener('click',function(){if(!hasVortexProAccess){openBrandUpsell('vortex_pro');return;}exportCampaign();});
    resetButton.addEventListener('click',function(){if(!hasVortexProAccess){openBrandUpsell('vortex_pro');return;}resetCampaign();});
    returnNativeButton.addEventListener('click',returnToNativeWheel);
    saveBrandButton.addEventListener('click',saveBrandKit);applyBrandButton.addEventListener('click',function(){applyBrandPalette(false);});analyzeBrandButton.addEventListener('click',function(){curateBrandPalette('brand');});curateMoodButton.addEventListener('click',function(){curateBrandPalette('mood');});remixButton.addEventListener('click',function(){curateBrandPalette('remix');});contrastButton.addEventListener('click',function(){curateBrandPalette('contrast');});softenButton.addEventListener('click',function(){curateBrandPalette('soften');});

    TW.brandKit = {
      get:function(){ return clone(currentBrandKit()); },
      save:saveBrandKit,
      apply:function(){ return applyBrandPalette(false); }
    };
    loadBrandKit();
  }
  // Homepage Custom Liquid can finish loading after Shopify has rebuilt its
  // section. Expose the existing idempotent initializer for that loader only.
  window.__twInitBusinessCampaignLab = init;
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();

/* =========================================================
   SURGICAL 2026-07-20C — requested design-only alignment
   Scope only: Winners Vault and internal promotional cards.
   Consolidates/removes prior 07-20 overrides so older styling
   cannot compete below Spin Science. No logic or links changed.
========================================================= */
(function installRequestedDesignAlignment0720C(){
  if(window.__twRequestedDesignAlignment0720C) return;
  window.__twRequestedDesignAlignment0720C = true;
  var css = [
    /* WINNERS VAULT — exact shared accordion/card glass system; wheel snippet owns text color. */
    '#toki-wheel-root .tw-side{position:relative!important;isolation:isolate!important;overflow:hidden!important;box-sizing:border-box!important;padding:var(--tw-pad)!important;border-radius:var(--tw-premium-panel-radius)!important;border:1px solid var(--tw-border)!important;background:linear-gradient(180deg,rgba(255,255,255,.08),rgba(255,255,255,.03)),var(--tw-surface)!important;background-clip:padding-box!important;-webkit-background-clip:padding-box!important;box-shadow:var(--tw-shadow)!important;-webkit-box-shadow:var(--tw-shadow)!important;color:inherit!important;backdrop-filter:none!important;-webkit-backdrop-filter:none!important;}',
    '#toki-wheel-root .tw-side::before{content:""!important;display:block!important;position:absolute!important;inset:0!important;z-index:0!important;border-radius:inherit!important;pointer-events:none!important;background:transparent!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.10)!important;}',
    '#toki-wheel-root .tw-side::after{content:none!important;display:none!important;}',
    '#toki-wheel-root .tw-side>*{position:relative!important;z-index:1!important;}',
    '#toki-wheel-root .tw-sideTitle{min-height:0!important;margin:0 0 10px!important;padding:0!important;border:0!important;border-radius:0!important;background:transparent!important;box-shadow:none!important;-webkit-box-shadow:none!important;color:inherit!important;}',
    '#toki-wheel-root .tw-sideTitle .tw-h2{display:inline-flex!important;align-items:center!important;gap:7px!important;margin:0!important;padding:0!important;color:inherit!important;font-size:clamp(17px,2.1vw,20px)!important;line-height:1.05!important;font-weight:900!important;letter-spacing:0!important;text-shadow:none!important;}',
    '#toki-wheel-root .tw-sideTitle .tw-h2::before{content:"🏆"!important;display:inline-block!important;position:static!important;width:auto!important;height:auto!important;border:0!important;border-radius:0!important;background:none!important;box-shadow:none!important;font-size:.88em!important;line-height:1!important;}',
    '#toki-wheel-root .tw-sideTitle .tw-btn{min-width:0!important;min-height:34px!important;height:34px!important;padding:0 12px!important;border-radius:999px!important;background:rgba(255,255,255,.08)!important;border:1px solid var(--tw-border)!important;color:inherit!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.12)!important;-webkit-box-shadow:inset 0 1px 0 rgba(255,255,255,.12)!important;font-size:12px!important;}',
    '#toki-wheel-root #twPinsList{min-height:0!important;padding:0!important;border:0!important;border-radius:0!important;background:transparent!important;box-shadow:none!important;-webkit-box-shadow:none!important;color:inherit!important;}',
    '#toki-wheel-root #twPinsList .tw-pinItem{background:rgba(255,255,255,.08)!important;border:1px solid var(--tw-border)!important;border-radius:15px!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.10),0 7px 16px rgba(0,0,0,.10)!important;color:inherit!important;}',
    '#toki-wheel-root #twPinsList .tw-pinName,#toki-wheel-root #twPinsList .tw-pinMeta{color:inherit!important;}',

    /* SHARED CREAM AD SHELL — card-relative lighting stays anchored at every width. */
    '#toki-wheel-root #twOptions .tw-quickStickerPromo,#toki-wheel-root .tw-stickerDrops,#toki-wheel-root .tw-subscriptionDrops,#toki-wheel-root .tw-subscriptionChoicePanel{position:relative!important;isolation:isolate!important;overflow:hidden!important;background:#FFF8EE!important;background-image:none!important;border:1px solid rgba(74,43,103,.13)!important;border-radius:26px!important;box-shadow:0 18px 42px rgba(46,28,72,.13),inset 0 1px 0 rgba(255,255,255,.82)!important;-webkit-box-shadow:0 18px 42px rgba(46,28,72,.13),inset 0 1px 0 rgba(255,255,255,.82)!important;color:#2d1d42!important;backdrop-filter:none!important;-webkit-backdrop-filter:none!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromo>*,#toki-wheel-root .tw-stickerDrops>*,#toki-wheel-root .tw-subscriptionDrops>*,#toki-wheel-root .tw-subscriptionChoicePanel>*{position:relative!important;z-index:2!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromo::before,#toki-wheel-root .tw-stickerDrops::before,#toki-wheel-root .tw-subscriptionDrops::before,#toki-wheel-root .tw-subscriptionChoicePanel::before{content:""!important;display:block!important;position:absolute!important;z-index:0!important;width:58%!important;min-width:250px!important;max-width:520px!important;aspect-ratio:1!important;right:-18%!important;top:-62%!important;border-radius:50%!important;pointer-events:none!important;filter:blur(28px)!important;opacity:.78!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromo::after,#toki-wheel-root .tw-stickerDrops::after,#toki-wheel-root .tw-subscriptionDrops::after,#toki-wheel-root .tw-subscriptionChoicePanel::after{content:""!important;display:block!important;position:absolute!important;z-index:1!important;inset:0!important;border-radius:inherit!important;pointer-events:none!important;background:linear-gradient(118deg,transparent 3%,rgba(255,255,255,.55) 18%,transparent 33%)!important;transform:translateX(-125%)!important;animation:twPremiumAdSweep 9.5s ease-in-out infinite!important;opacity:.52!important;}',

    /* LAB PACKS — pink identity, cream pill text, Choose Your Lab button construction. */
    '#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo),#toki-wheel-root .tw-stickerDrops{border-top:5px solid #e84fae!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo)::before,#toki-wheel-root .tw-stickerDrops::before{background:radial-gradient(circle,rgba(244,92,180,.42) 0%,rgba(232,79,174,.18) 44%,transparent 72%)!important;}',
    '#toki-wheel-root .tw-quickStickerPromoKicker,#toki-wheel-root .tw-stickerDropsKicker{display:inline-flex!important;align-items:center!important;width:max-content!important;min-height:25px!important;padding:0 11px!important;border-radius:999px!important;background:linear-gradient(180deg,#f266ba,#d9409f)!important;border:1px solid rgba(153,31,105,.15)!important;color:#FFF8EE!important;text-shadow:none!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.34),0 7px 15px rgba(174,45,123,.18)!important;letter-spacing:.14em!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromoMedia,#toki-wheel-root .tw-stickerDropCard{background:#FFF8EE!important;border:1px solid rgba(181,61,133,.13)!important;box-shadow:0 11px 25px rgba(116,38,85,.10),inset 0 1px 0 rgba(255,255,255,.82)!important;}',

    /* One shared button geometry, typography and depth — matching Choose Your Lab. */
    '#toki-wheel-root .tw-subscriptionChoiceBtn,#toki-wheel-root .tw-quickStickerPromoBtn,#toki-wheel-root .tw-quickStickerPromoAll,#toki-wheel-root .tw-stickerDropsAll,#toki-wheel-root .tw-stickerDropBtn,#toki-wheel-root .tw-stickerDropMini,#toki-wheel-root .tw-subscriptionDropsAll{margin-top:10px!important;min-height:36px!important;height:auto!important;padding:8px 13px!important;border-radius:999px!important;font:inherit!important;font-size:12px!important;font-weight:950!important;line-height:1.15!important;cursor:pointer!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.38),0 6px 14px rgba(47,30,67,.13)!important;-webkit-box-shadow:inset 0 1px 0 rgba(255,255,255,.38),0 6px 14px rgba(47,30,67,.13)!important;}',
    '#toki-wheel-root .tw-quickStickerPromoBtn,#toki-wheel-root .tw-quickStickerPromoAll,#toki-wheel-root .tw-stickerDropsAll,#toki-wheel-root .tw-stickerDropBtn,#toki-wheel-root .tw-stickerDropMini{background:linear-gradient(180deg,#f266ba,#d9409f)!important;color:#FFF8EE!important;border:1px solid rgba(153,31,105,.16)!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceBtn:hover,#toki-wheel-root .tw-quickStickerPromoBtn:hover,#toki-wheel-root .tw-quickStickerPromoAll:hover,#toki-wheel-root .tw-stickerDropsAll:hover,#toki-wheel-root .tw-stickerDropBtn:hover,#toki-wheel-root .tw-stickerDropMini:hover,#toki-wheel-root .tw-subscriptionDropsAll:hover{transform:translateY(-1px)!important;filter:brightness(1.04)!important;}',

    /* VORTEX PRO / UPGRADE LAB — single-plan gold premium treatment. */
    '#toki-wheel-root .tw-subscriptionChoicePanel,#toki-wheel-root .tw-subscriptionDrops{border-top:5px solid #8157d1!important;}',
    '#toki-wheel-root .tw-subscriptionChoicePanel::before,#toki-wheel-root .tw-subscriptionDrops::before{background:radial-gradient(circle,rgba(142,105,221,.38) 0%,rgba(129,87,209,.16) 45%,transparent 72%)!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceKicker,#toki-wheel-root .tw-subscriptionDropsKicker{color:#7044bd!important;text-shadow:none!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard,#toki-wheel-root .tw-subscriptionDropCard{position:relative!important;isolation:isolate!important;overflow:hidden!important;background:#FFF8EE!important;border:1px solid rgba(74,43,103,.13)!important;box-shadow:0 12px 28px rgba(45,27,67,.11),inset 0 1px 0 rgba(255,255,255,.82)!important;-webkit-box-shadow:0 12px 28px rgba(45,27,67,.11),inset 0 1px 0 rgba(255,255,255,.82)!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard::before,#toki-wheel-root .tw-subscriptionDropCard::before{content:""!important;display:block!important;position:absolute!important;z-index:0!important;width:56%!important;min-width:170px!important;max-width:340px!important;aspect-ratio:1!important;right:-18%!important;top:-58%!important;border-radius:50%!important;pointer-events:none!important;filter:blur(22px)!important;opacity:.75!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard>*,#toki-wheel-root .tw-subscriptionDropCard>*{position:relative!important;z-index:1!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard.isvortexPro,#toki-wheel-root .tw-subscriptionDropCard.isvortexPro{border-top:5px solid #8157d1!important;background:#FFF8EE!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard.isvortexPro::before,#toki-wheel-root .tw-subscriptionDropCard.isvortexPro::before{background:radial-gradient(circle,rgba(145,102,225,.42) 0%,rgba(129,87,209,.16) 45%,transparent 72%)!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard.isvortexPro,#toki-wheel-root .tw-subscriptionDropCard.isvortexPro{border-top:5px solid #e3a425!important;background:#FFF8EE!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard.isvortexPro::before,#toki-wheel-root .tw-subscriptionDropCard.isvortexPro::before{background:radial-gradient(circle,rgba(255,208,83,.46) 0%,rgba(227,164,37,.18) 45%,transparent 72%)!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceMedia{background:#FFF8EE!important;}',
    '#toki-wheel-root .isvortexPro .tw-subscriptionChoiceBtn,#toki-wheel-root .tw-subscriptionDropsAll{background:linear-gradient(180deg,#8f69dd,#7449c5)!important;color:#FFF8EE!important;border:1px solid rgba(82,47,145,.18)!important;}',
    '#toki-wheel-root .isvortexPro .tw-subscriptionChoiceBtn{background:linear-gradient(180deg,#ffd96b,#e8ad2f)!important;color:#3a270d!important;border:1px solid rgba(142,94,12,.17)!important;}',

    /* Below Spin Science inherits the same type, spacing, artwork and card system. */
    '#toki-wheel-root .tw-stickerDrops,#toki-wheel-root .tw-subscriptionDrops{border-radius:26px!important;padding:clamp(18px,3.5vw,30px)!important;}',
    '#toki-wheel-root .tw-stickerDropsTitle,#toki-wheel-root .tw-subscriptionDropsTitle,#toki-wheel-root .tw-stickerDropName{color:#2d1d42!important;text-shadow:none!important;}',
    '#toki-wheel-root .tw-stickerDropsText,#toki-wheel-root .tw-subscriptionDropsText,#toki-wheel-root .tw-stickerDropSub{color:#675d70!important;text-shadow:none!important;}',
    '#toki-wheel-root .tw-subscriptionDropCard{padding:6px!important;border-radius:20px!important;}',
    '#toki-wheel-root .tw-subscriptionDropCard img{display:block!important;width:100%!important;height:auto!important;object-fit:contain!important;border-radius:14px!important;background:transparent!important;}',

    /* Preserve preview lock stacking from the previous surgical pass. */
    '#toki-wheel-root .tw-wheelCard{isolation:isolate!important;}',

    '@supports (-webkit-touch-callout:none){body:not(.twStreamBody) #toki-wheel-root .tw-side{border:1px solid var(--tw-border)!important;background:linear-gradient(180deg,rgba(255,255,255,.08),rgba(255,255,255,.03)),var(--tw-surface)!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.16),inset 0 -1px 0 rgba(0,0,0,.12)!important;-webkit-box-shadow:inset 0 1px 0 rgba(255,255,255,.16),inset 0 -1px 0 rgba(0,0,0,.12)!important;}}',
    '@media(max-width:640px){#toki-wheel-root .tw-sideTitle .tw-h2{font-size:17px!important;}#toki-wheel-root #twOptions .tw-quickStickerPromo::before,#toki-wheel-root .tw-stickerDrops::before,#toki-wheel-root .tw-subscriptionDrops::before,#toki-wheel-root .tw-subscriptionChoicePanel::before{width:72%!important;right:-24%!important;top:-48%!important;filter:blur(22px)!important;}#toki-wheel-root .tw-subscriptionChoiceCard::before,#toki-wheel-root .tw-subscriptionDropCard::before{width:68%!important;right:-24%!important;top:-42%!important;}}',
    '@media(prefers-reduced-motion:reduce){#toki-wheel-root #twOptions .tw-quickStickerPromo::after,#toki-wheel-root .tw-stickerDrops::after,#toki-wheel-root .tw-subscriptionDrops::after,#toki-wheel-root .tw-subscriptionChoicePanel::after{animation:none!important;transform:none!important;opacity:.16!important;}}'
  ].join('');
  var style = document.createElement('style');
  style.id = 'tw-requested-design-alignment-0720c';
  style.textContent = css;
  document.head.appendChild(style);
})();
 
/* =========================================================
   SURGICAL 2026-07-20F â€” three-pack showcase + blue plan system
========================================================= */
(function installLabPackShowcaseAndBluePlans0720F(){
  if(window.__twLabPackShowcaseAndBluePlans0720F) return;
  window.__twLabPackShowcaseAndBluePlans0720F = true;
  var style = document.createElement('style');
  style.id = 'tw-lab-pack-showcase-blue-plans-0720f';
  style.textContent = [
    /* Three-product Lab Packs showcase. */
    '#toki-wheel-root .tw-labPackChoicePanel{position:relative!important;isolation:isolate!important;overflow:hidden!important;margin-top:clamp(30px,5vw,52px)!important;padding:clamp(18px,3vw,26px)!important;border-radius:26px!important;border:1px solid rgba(112,42,92,.13)!important;border-top:5px solid #f24fa7!important;background:#FFF8EE!important;background-image:none!important;box-shadow:0 19px 44px rgba(50,25,67,.14),0 0 38px rgba(242,79,167,.22),inset 0 1px 0 #FFFFFF!important;color:#2d1d42!important;}',
    '#toki-wheel-root .tw-labPackChoicePanel::before{content:""!important;position:absolute!important;z-index:0!important;width:clamp(250px,42vw,520px)!important;aspect-ratio:1!important;right:clamp(-190px,-14vw,-82px)!important;top:clamp(-220px,-18vw,-105px)!important;border-radius:50%!important;pointer-events:none!important;background:radial-gradient(circle,rgba(255,91,181,.34) 0%,rgba(242,79,167,.14) 44%,transparent 72%)!important;filter:blur(clamp(18px,3vw,32px))!important;opacity:.72!important;}',
    '#toki-wheel-root .tw-labPackChoicePanel>*{position:relative!important;z-index:1!important;}',
    '#toki-wheel-root .tw-labPackChoiceHead{display:flex!important;align-items:flex-end!important;justify-content:space-between!important;gap:14px!important;margin-bottom:18px!important;padding-bottom:15px!important;border-bottom:1px solid rgba(112,42,92,.11)!important;}',
    '#toki-wheel-root .tw-labPackChoiceKicker{display:inline-flex!important;align-items:center!important;min-height:27px!important;padding:0 12px!important;border-radius:999px!important;background:linear-gradient(180deg,#ff72bd,#df3e9b)!important;border:1px solid rgba(183,35,118,.18)!important;color:#FFFFFF!important;-webkit-text-fill-color:#FFFFFF!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.42),0 7px 16px rgba(178,44,119,.15)!important;font-size:11px!important;line-height:1!important;font-weight:950!important;letter-spacing:.14em!important;}',
    '#toki-wheel-root .tw-labPackChoiceTitle{margin-top:8px!important;color:#2d1d42!important;font-size:clamp(20px,2.6vw,27px)!important;line-height:1.05!important;font-weight:950!important;letter-spacing:-.025em!important;}',
    '#toki-wheel-root .tw-labPackChoiceGrid{display:grid!important;grid-template-columns:repeat(3,minmax(0,1fr))!important;gap:14px!important;opacity:1!important;transform:translateY(0) scale(1)!important;filter:none!important;transition:opacity .26s ease,transform .34s cubic-bezier(.2,.8,.2,1),filter .26s ease!important;}',
    '#toki-wheel-root .tw-labPackChoiceGrid.isChanging{opacity:0!important;transform:translateY(9px) scale(.992)!important;filter:blur(3px)!important;}',
    '#toki-wheel-root .tw-labPackChoiceCard{position:relative!important;isolation:isolate!important;overflow:hidden!important;display:flex!important;flex-direction:column!important;border-radius:18px!important;background:#FFFFFF!important;border:1px solid rgba(112,42,92,.12)!important;box-shadow:0 10px 23px rgba(50,25,67,.10),inset 0 1px 0 #FFFFFF!important;transition:transform .28s cubic-bezier(.2,.8,.2,1),box-shadow .28s ease!important;}',
    '#toki-wheel-root .tw-labPackChoiceCard::before{content:""!important;position:absolute!important;z-index:0!important;width:180px!important;height:180px!important;right:-90px!important;top:-105px!important;border-radius:50%!important;background:radial-gradient(circle,rgba(255,96,184,.20),transparent 70%)!important;pointer-events:none!important;}',
    '#toki-wheel-root .tw-labPackChoiceCard>*{position:relative!important;z-index:1!important;}',
    '#toki-wheel-root .tw-labPackChoiceCard:hover{transform:translateY(-4px)!important;box-shadow:0 16px 31px rgba(50,25,67,.15),0 0 20px rgba(242,79,167,.12),inset 0 1px 0 #FFFFFF!important;}',
    '#toki-wheel-root .tw-labPackChoiceMedia{display:flex!important;align-items:center!important;justify-content:center!important;padding:6px!important;background:#FFFFFF!important;border-bottom:1px solid rgba(112,42,92,.09)!important;overflow:hidden!important;}',
    '#toki-wheel-root .tw-labPackChoiceMedia img{display:block!important;width:100%!important;height:auto!important;max-width:100%!important;border-radius:12px!important;object-fit:contain!important;transition:transform .5s cubic-bezier(.2,.8,.2,1),filter .3s ease!important;}',
    '#toki-wheel-root .tw-labPackChoiceCard:hover .tw-labPackChoiceMedia img{transform:scale(1.025)!important;filter:saturate(1.05)!important;}',
    '#toki-wheel-root .tw-labPackChoiceCopy{display:flex!important;flex:1 1 auto!important;flex-direction:column!important;align-items:flex-start!important;padding:13px!important;}',
    '#toki-wheel-root .tw-labPackChoicePlan{color:#c52f87!important;font-size:10px!important;font-weight:950!important;letter-spacing:.12em!important;text-transform:uppercase!important;}',
    '#toki-wheel-root .tw-labPackChoiceCardTitle{margin-top:4px!important;color:#291943!important;font-size:16px!important;line-height:1.12!important;font-weight:950!important;}',
    '#toki-wheel-root .tw-labPackChoiceText{margin-top:6px!important;color:#675d70!important;font-size:12px!important;line-height:1.42!important;font-weight:700!important;}',
    '#toki-wheel-root .tw-labPackChoiceSamples{display:flex!important;gap:6px!important;margin-top:10px!important;min-height:30px!important;}',
    '#toki-wheel-root .tw-labPackChoiceSamples img{width:30px!important;height:30px!important;object-fit:contain!important;border-radius:9px!important;background:#fff8fc!important;border:1px solid rgba(190,46,131,.11)!important;box-shadow:0 4px 9px rgba(84,35,72,.09)!important;}',
    '#toki-wheel-root .tw-labPackChoiceBtn,#toki-wheel-root .tw-labPackChoiceAll{display:inline-flex!important;align-items:center!important;justify-content:center!important;min-height:36px!important;padding:8px 13px!important;border:0!important;border-radius:999px!important;background:linear-gradient(180deg,#ff72bd,#df3e9b)!important;color:#FFFFFF!important;-webkit-text-fill-color:#FFFFFF!important;font:inherit!important;font-size:12px!important;font-weight:950!important;cursor:pointer!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.55),0 6px 14px rgba(143,35,100,.18)!important;transition:transform .18s ease,filter .18s ease,box-shadow .18s ease!important;}',
    '#toki-wheel-root .tw-labPackChoiceBtn{margin-top:auto!important;}',
    '#toki-wheel-root .tw-labPackChoiceBtn:hover,#toki-wheel-root .tw-labPackChoiceAll:hover{transform:translateY(-2px)!important;filter:brightness(1.04) saturate(1.04)!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.58),0 9px 18px rgba(143,35,100,.22)!important;}',

    /* Choose Your Lab: dark-blue top, labels, and complementary lighting. */
    '#toki-wheel-root .tw-subscriptionChoicePanel{border-top-color:#173f75!important;box-shadow:0 18px 42px rgba(30,41,72,.14),0 0 38px rgba(32,87,153,.20),inset 0 1px 0 rgba(255,255,255,.82)!important;}',
    '#toki-wheel-root .tw-subscriptionChoicePanel::before{background:radial-gradient(circle,rgba(44,101,173,.30) 0%,rgba(23,63,117,.13) 45%,transparent 72%)!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceKicker,#toki-wheel-root .tw-subscriptionChoicePlan{color:#173f75!important;-webkit-text-fill-color:#173f75!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard.isvortexPro{border-top-color:#245b9b!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard.isvortexPro::before{background:radial-gradient(circle,rgba(50,113,188,.31) 0%,rgba(23,63,117,.12) 45%,transparent 72%)!important;}',
    '#toki-wheel-root .isvortexPro .tw-subscriptionChoiceBtn{background:linear-gradient(180deg,#2f6fb4,#173f75)!important;color:#FFFFFF!important;-webkit-text-fill-color:#FFFFFF!important;border-color:rgba(19,54,102,.20)!important;}',
    '@media(max-width:980px){#toki-wheel-root .tw-labPackChoiceGrid{grid-template-columns:1fr!important;}#toki-wheel-root .tw-labPackChoiceCard:nth-child(3){grid-column:auto!important;max-width:none!important;justify-self:stretch!important;width:100%!important;}}',
    '@media(max-width:620px){#toki-wheel-root .tw-labPackChoicePanel{padding:16px!important;border-radius:22px!important;}#toki-wheel-root .tw-labPackChoiceHead{display:block!important;}#toki-wheel-root .tw-labPackChoiceAll{margin-top:12px!important;}#toki-wheel-root .tw-labPackChoiceGrid{grid-template-columns:1fr!important;}#toki-wheel-root .tw-labPackChoiceCard:nth-child(3){grid-column:auto!important;max-width:none!important;}#toki-wheel-root .tw-labPackChoiceMedia{padding:5px!important;}}',
    '@media(prefers-reduced-motion:reduce){#toki-wheel-root .tw-labPackChoiceGrid,#toki-wheel-root .tw-labPackChoiceCard,#toki-wheel-root .tw-labPackChoiceMedia img{transition:none!important;}#toki-wheel-root .tw-labPackChoiceGrid.isChanging{filter:none!important;}}'
  ].join('');
  document.head.appendChild(style);
})();

/* Final Choose Your Lab color guard after historical runtime styles. */
(function installBluePlanColorGuard0720G(){
  if(window.__twBluePlanColorGuard0720G) return;
  window.__twBluePlanColorGuard0720G = true;
  var style = document.createElement('style');
  style.id = 'tw-blue-plan-color-guard-0720g';
  style.textContent = [
    '#toki-wheel-root .tw-subscriptionChoicePanel{border-top-color:#173f75!important;box-shadow:0 18px 42px rgba(30,41,72,.14),0 0 38px rgba(32,87,153,.20),inset 0 1px 0 rgba(255,255,255,.82)!important;}',
    '#toki-wheel-root .tw-subscriptionChoicePanel::before{background:radial-gradient(circle,rgba(44,101,173,.30) 0%,rgba(23,63,117,.13) 45%,transparent 72%)!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceKicker,#toki-wheel-root .tw-subscriptionChoicePlan{color:#173f75!important;-webkit-text-fill-color:#173f75!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard.isvortexPro{border-top-color:#245b9b!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard.isvortexPro::before{background:radial-gradient(circle,rgba(50,113,188,.31) 0%,rgba(23,63,117,.12) 45%,transparent 72%)!important;}',
    '#toki-wheel-root .isvortexPro .tw-subscriptionChoiceBtn{background:linear-gradient(180deg,#2f6fb4,#173f75)!important;color:#FFFFFF!important;-webkit-text-fill-color:#FFFFFF!important;border-color:rgba(19,54,102,.20)!important;}'
  ].join('');
  document.head.appendChild(style);
})();

/* =========================================================
   SURGICAL 2026-07-20D â€” true component rebuild
   Mounted legacy shelves are gone. The lower ads are fresh instances of
   the Quick Tweaks builders; Winners Vault now uses accordion glass markup.
========================================================= */
(function installTrueComponentRebuild0720D(){
  if(window.__twTrueComponentRebuild0720D) return;
  window.__twTrueComponentRebuild0720D = true;
  var css = [
    /* Vault: exact utility accordion glass, without legacy card chrome. */
    '#toki-wheel-root .tw-vaultRebuilt{width:100%!important;margin:0!important;padding:0!important;border-radius:var(--tw-radius)!important;border:1px solid var(--tw-border)!important;background:linear-gradient(180deg,rgba(255,255,255,.08),rgba(255,255,255,.03)),var(--tw-surface)!important;background-color:transparent!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.17),0 10px 24px rgba(4,37,48,.12)!important;color:var(--tw-text)!important;backdrop-filter:blur(14px) saturate(1.08)!important;-webkit-backdrop-filter:blur(14px) saturate(1.08)!important;overflow:hidden!important;}',
    '#toki-wheel-root .tw-vaultRebuilt::before,#toki-wheel-root .tw-vaultRebuilt::after{content:none!important;display:none!important;}',
    '#toki-wheel-root .tw-vaultHeader{display:flex!important;align-items:center!important;justify-content:space-between!important;gap:var(--tw-gapSm)!important;min-height:0!important;margin:0!important;padding:var(--tw-pad)!important;border:0!important;border-radius:0!important;background:transparent!important;box-shadow:none!important;}',
    '#toki-wheel-root .tw-vaultTitle{display:inline-flex!important;align-items:center!important;gap:8px!important;margin:0!important;padding:0!important;color:var(--twHeaderText,var(--tw-headerText,#FFF8EE))!important;-webkit-text-fill-color:currentColor!important;font-size:clamp(17px,2.1vw,20px)!important;line-height:1.08!important;font-weight:900!important;letter-spacing:.6px!important;text-transform:uppercase!important;text-shadow:none!important;}',
    '#toki-wheel-root .tw-vaultTitle::before,#toki-wheel-root .tw-vaultTitle::after{content:none!important;display:none!important;}',
    '#toki-wheel-root .tw-vaultTrophy{display:inline-block!important;width:auto!important;height:auto!important;padding:0!important;border:0!important;background:none!important;box-shadow:none!important;font-size:1em!important;line-height:1!important;filter:drop-shadow(0 4px 7px rgba(70,40,0,.28)) drop-shadow(0 0 10px rgba(255,204,75,.25))!important;}',
    '#toki-wheel-root .tw-vaultHeader .tw-btn{min-width:0!important;min-height:38px!important;height:38px!important;padding:0 14px!important;border-radius:999px!important;background:rgba(255,255,255,.10)!important;border:1px solid rgba(255,255,255,.18)!important;color:#FFF8EE!important;-webkit-text-fill-color:#FFF8EE!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.13),0 7px 15px rgba(2,23,33,.13)!important;font-size:12px!important;text-shadow:none!important;}',
    '#toki-wheel-root .tw-vaultBody{min-height:0!important;margin:0!important;padding:var(--tw-pad)!important;border-top:1px solid rgba(255,255,255,.12)!important;border-radius:0!important;background:transparent!important;box-shadow:none!important;color:inherit!important;}',

    /* Exact Quick Tweaks Lab Pack card, now mounted below Spin Science. */
    '#toki-wheel-root .tw-lowerQuickClonePacks{position:relative!important;isolation:isolate!important;overflow:hidden!important;margin-top:clamp(30px,5vw,52px)!important;padding:18px!important;border-radius:26px!important;border:1px solid rgba(74,43,103,.13)!important;border-top:5px solid #8157d1!important;background:#FFF8EE!important;background-image:none!important;box-shadow:0 18px 42px rgba(46,28,72,.13),inset 0 1px 0 rgba(255,255,255,.82)!important;color:#2d1d42!important;backdrop-filter:none!important;-webkit-backdrop-filter:none!important;}',
    '#toki-wheel-root .tw-lowerQuickClonePacks>*{position:relative!important;z-index:2!important;}',
    '#toki-wheel-root .tw-lowerQuickClonePacks::before{content:""!important;display:block!important;position:absolute!important;z-index:0!important;width:clamp(240px,42vw,520px)!important;aspect-ratio:1!important;right:clamp(-190px,-14vw,-80px)!important;top:clamp(-220px,-18vw,-100px)!important;border-radius:50%!important;pointer-events:none!important;background:radial-gradient(circle,rgba(153,104,232,.34) 0%,rgba(129,87,209,.16) 43%,transparent 72%)!important;filter:blur(clamp(18px,3vw,34px))!important;opacity:.72!important;}',
    '#toki-wheel-root .tw-lowerQuickClonePacks::after{content:""!important;display:block!important;position:absolute!important;z-index:1!important;inset:0!important;border-radius:inherit!important;pointer-events:none!important;background:linear-gradient(118deg,transparent 2%,rgba(255,255,255,.58) 17%,transparent 32%)!important;transform:translateX(-125%)!important;animation:twPremiumAdSweep 9.5s ease-in-out infinite!important;opacity:.58!important;}',
    '#toki-wheel-root .tw-lowerQuickClonePacks .tw-quickStickerPromoMedia{background:#FFF8EE!important;border:1px solid rgba(101,66,142,.13)!important;box-shadow:0 11px 25px rgba(57,35,82,.11),inset 0 1px 0 rgba(255,255,255,.82)!important;}',
    '#toki-wheel-root .tw-lowerQuickClonePacks .tw-quickStickerPromoKicker{color:#7044bd!important;-webkit-text-fill-color:#7044bd!important;text-shadow:none!important;}',
    '#toki-wheel-root .tw-lowerQuickClonePacks .tw-quickStickerPromoTitle{color:#2d1d42!important;-webkit-text-fill-color:#2d1d42!important;text-shadow:none!important;}',
    '#toki-wheel-root .tw-lowerQuickClonePacks .tw-quickStickerPromoText{color:#675d70!important;-webkit-text-fill-color:#675d70!important;text-shadow:none!important;}',

    /* Exact Choose Your Lab instance gets only lower-section spacing. */
    '#toki-wheel-root .tw-lowerQuickClonePlans{margin-top:clamp(30px,5vw,52px)!important;}',
    '@media(max-width:640px){#toki-wheel-root .tw-vaultTitle{font-size:17px!important;}#toki-wheel-root .tw-lowerQuickClonePacks,#toki-wheel-root .tw-lowerQuickClonePlans{margin-top:30px!important;}#toki-wheel-root .tw-lowerQuickClonePacks::before{right:-155px!important;top:-165px!important;opacity:.60!important;}}',
    '@media(prefers-reduced-motion:reduce){#toki-wheel-root .tw-lowerQuickClonePacks::after{animation:none!important;transform:none!important;opacity:.18!important;}}'
  ].join('');
  var style = document.createElement('style');
  style.id = 'tw-true-component-rebuild-0720d';
  style.textContent = css;
  document.head.appendChild(style);
})();

/* =========================================================
   SURGICAL 2026-07-20B â€” premium cream ad system + native vault
   Scope only: Winners Vault, Quick Tweaks internal ads, ad shelves
   below Spin Science, and preview-overlay stacking.
========================================================= */
(function installPremiumCreamAdSystem0720B(){
  if(window.__twPremiumCreamAdSystem0720B) return;
  window.__twPremiumCreamAdSystem0720B = true;
  var css = [
    /* WINNERS VAULT â€” return to the native panel glass and typography. */
    '#toki-wheel-root .tw-side{position:relative!important;overflow:hidden!important;padding:10px 14px 14px!important;border-radius:var(--tw-premium-panel-radius)!important;border:1px solid var(--tw-border)!important;background:linear-gradient(180deg,rgba(255,255,255,.08),rgba(255,255,255,.03)),var(--tw-surface)!important;background-image:linear-gradient(180deg,rgba(255,255,255,.08),rgba(255,255,255,.03))!important;box-shadow:var(--tw-shadow)!important;color:var(--tw-text)!important;backdrop-filter:blur(14px) saturate(1.08)!important;-webkit-backdrop-filter:blur(14px) saturate(1.08)!important;}',
    '#toki-wheel-root .tw-side::before{content:""!important;display:block!important;position:absolute!important;inset:0!important;pointer-events:none!important;border-radius:inherit!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.10)!important;background:none!important;}',
    '#toki-wheel-root .tw-side::after{content:none!important;display:none!important;}',
    '#toki-wheel-root .tw-sideTitle{min-height:0!important;margin-bottom:10px!important;padding:0!important;border:0!important;background:transparent!important;box-shadow:none!important;}',
    '#toki-wheel-root .tw-sideTitle .tw-h2{display:inline-flex!important;align-items:center!important;gap:7px!important;margin:0!important;padding:0!important;color:inherit!important;font-size:clamp(17px,2.1vw,20px)!important;line-height:1!important;font-weight:900!important;letter-spacing:0!important;text-shadow:none!important;}',
    '#toki-wheel-root .tw-sideTitle .tw-h2::before{content:"ðŸ†"!important;display:inline-block!important;width:auto!important;height:auto!important;border:0!important;border-radius:0!important;background:none!important;box-shadow:none!important;font-size:.88em!important;line-height:1!important;}',
    '#toki-wheel-root .tw-sideTitle .tw-btn{min-width:0!important;min-height:34px!important;height:34px!important;padding:0 12px!important;border-radius:999px!important;background:rgba(255,248,238,.10)!important;border:1px solid rgba(255,248,238,.18)!important;color:inherit!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.10)!important;font-size:12px!important;}',
    '#toki-wheel-root .tw-sideTitle .tw-btn:hover{transform:translateY(-1px)!important;background:rgba(255,248,238,.15)!important;}',
    '#toki-wheel-root #twPinsList{min-height:0!important;padding:0!important;border:0!important;border-radius:0!important;background:transparent!important;box-shadow:none!important;color:inherit!important;}',
    '#toki-wheel-root #twPinsList .tw-pinItem{background:#FFF8EE!important;border:1px solid rgba(72,45,92,.13)!important;border-radius:15px!important;box-shadow:0 7px 16px rgba(28,18,39,.10)!important;color:#30203d!important;}',
    '#toki-wheel-root #twPinsList .tw-pinName{color:#30203d!important;}',
    '#toki-wheel-root #twPinsList .tw-pinMeta{color:#786c80!important;}',

    /* SHARED PREMIUM CREAM CARD â€” responsive lighting uses percentages/clamp. */
    '#toki-wheel-root #twOptions .tw-quickStickerPromo,#toki-wheel-root .tw-stickerDrops,#toki-wheel-root .tw-subscriptionDrops,#toki-wheel-root .tw-subscriptionChoicePanel{position:relative!important;isolation:isolate!important;overflow:hidden!important;background:#FFF8EE!important;background-image:none!important;border:1px solid rgba(74,43,103,.13)!important;box-shadow:0 18px 42px rgba(46,28,72,.13),inset 0 1px 0 rgba(255,255,255,.82)!important;color:#2d1d42!important;backdrop-filter:none!important;-webkit-backdrop-filter:none!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromo>* ,#toki-wheel-root .tw-stickerDrops>* ,#toki-wheel-root .tw-subscriptionDrops>* ,#toki-wheel-root .tw-subscriptionChoicePanel>*{position:relative!important;z-index:2!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromo::before,#toki-wheel-root .tw-stickerDrops::before,#toki-wheel-root .tw-subscriptionDrops::before,#toki-wheel-root .tw-subscriptionChoicePanel::before{content:""!important;display:block!important;position:absolute!important;z-index:0!important;width:clamp(240px,42vw,520px)!important;aspect-ratio:1!important;right:clamp(-190px,-14vw,-80px)!important;top:clamp(-220px,-18vw,-100px)!important;border-radius:50%!important;pointer-events:none!important;filter:blur(clamp(18px,3vw,34px))!important;opacity:.72!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromo::after,#toki-wheel-root .tw-stickerDrops::after,#toki-wheel-root .tw-subscriptionDrops::after,#toki-wheel-root .tw-subscriptionChoicePanel::after{content:""!important;display:block!important;position:absolute!important;z-index:1!important;inset:0!important;border-radius:inherit!important;pointer-events:none!important;background:linear-gradient(118deg,transparent 2%,rgba(255,255,255,.58) 17%,transparent 32%)!important;transform:translateX(-125%)!important;animation:twPremiumAdSweep 9.5s ease-in-out infinite!important;opacity:.58!important;}',

    /* LAB PACKS â€” purple treatment and plan-style flat buttons. */
    '#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo),#toki-wheel-root .tw-stickerDrops{border-top:5px solid #8157d1!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo)::before,#toki-wheel-root .tw-stickerDrops::before{background:radial-gradient(circle,rgba(153,104,232,.34) 0%,rgba(129,87,209,.16) 43%,transparent 72%)!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromoMedia,#toki-wheel-root .tw-stickerDropCard{background:#FFF8EE!important;border:1px solid rgba(101,66,142,.13)!important;box-shadow:0 11px 25px rgba(57,35,82,.11),inset 0 1px 0 rgba(255,255,255,.82)!important;}',
    '#toki-wheel-root .tw-quickStickerPromoBtn,#toki-wheel-root .tw-quickStickerPromoAll,#toki-wheel-root .tw-stickerDropsAll,#toki-wheel-root .tw-stickerDropBtn,#toki-wheel-root .tw-stickerDropMini{min-height:40px!important;border-radius:999px!important;background:linear-gradient(180deg,#8f69dd,#7449c5)!important;color:#FFF8EE!important;border:1px solid rgba(82,47,145,.18)!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.38),0 7px 16px rgba(79,48,128,.18)!important;font-weight:950!important;}',
    '#toki-wheel-root .tw-quickStickerPromoBtn:hover,#toki-wheel-root .tw-quickStickerPromoAll:hover,#toki-wheel-root .tw-stickerDropsAll:hover,#toki-wheel-root .tw-stickerDropBtn:hover,#toki-wheel-root .tw-stickerDropMini:hover{transform:translateY(-1px)!important;filter:brightness(1.04)!important;}',

    /* QUICK TWEAKS PLAN CARD — Vortex Pro gold. */
    '#toki-wheel-root .tw-subscriptionChoicePanel{border-top:5px solid #8157d1!important;}',
    '#toki-wheel-root .tw-subscriptionChoicePanel::before{background:radial-gradient(circle,rgba(142,105,221,.28) 0%,rgba(129,87,209,.12) 45%,transparent 72%)!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard{position:relative!important;isolation:isolate!important;overflow:hidden!important;background:#FFF8EE!important;border:1px solid rgba(74,43,103,.13)!important;box-shadow:0 12px 28px rgba(45,27,67,.11),inset 0 1px 0 rgba(255,255,255,.82)!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard::before{content:""!important;position:absolute!important;z-index:0!important;width:clamp(150px,26vw,300px)!important;aspect-ratio:1!important;right:clamp(-120px,-9vw,-55px)!important;top:clamp(-135px,-10vw,-62px)!important;border-radius:50%!important;pointer-events:none!important;filter:blur(clamp(12px,2vw,24px))!important;opacity:.72!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard>*{position:relative!important;z-index:1!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard.isvortexPro{border-top:5px solid #8157d1!important;background:#FFF8EE!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard.isvortexPro::before{background:radial-gradient(circle,rgba(145,102,225,.35) 0%,rgba(129,87,209,.14) 45%,transparent 72%)!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard.isvortexPro{border-top:5px solid #e3a425!important;background:#FFF8EE!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard.isvortexPro::before{background:radial-gradient(circle,rgba(255,208,83,.40) 0%,rgba(227,164,37,.16) 45%,transparent 72%)!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceMedia{background:#FFF8EE!important;}',
    '#toki-wheel-root .isvortexPro .tw-subscriptionChoiceBtn{background:linear-gradient(180deg,#8f69dd,#7449c5)!important;color:#FFF8EE!important;border:1px solid rgba(82,47,145,.18)!important;}',
    '#toki-wheel-root .isvortexPro .tw-subscriptionChoiceBtn{background:linear-gradient(180deg,#ffd96b,#e8ad2f)!important;color:#3a270d!important;border:1px solid rgba(142,94,12,.17)!important;}',

    /* ADS BELOW SPIN SCIENCE â€” same exact system as Quick Tweaks. */
    '#toki-wheel-root .tw-stickerDrops,#toki-wheel-root .tw-subscriptionDrops{border-radius:30px!important;}',
    '#toki-wheel-root .tw-subscriptionDrops{border-top:5px solid #8157d1!important;}',
    '#toki-wheel-root .tw-subscriptionDrops::before{background:radial-gradient(circle,rgba(145,102,225,.29) 0%,rgba(129,87,209,.12) 45%,transparent 72%)!important;}',
    '#toki-wheel-root .tw-stickerDropsKicker,#toki-wheel-root .tw-subscriptionDropsKicker{color:#7044bd!important;text-shadow:none!important;}',
    '#toki-wheel-root .tw-stickerDropsTitle,#toki-wheel-root .tw-subscriptionDropsTitle,#toki-wheel-root .tw-stickerDropName{color:#2d1d42!important;text-shadow:none!important;}',
    '#toki-wheel-root .tw-stickerDropsText,#toki-wheel-root .tw-subscriptionDropsText,#toki-wheel-root .tw-stickerDropSub{color:#675d70!important;text-shadow:none!important;}',
    '#toki-wheel-root .tw-subscriptionDropCard{position:relative!important;isolation:isolate!important;overflow:hidden!important;padding:6px!important;border-radius:20px!important;background:#FFF8EE!important;border:1px solid rgba(70,42,99,.13)!important;box-shadow:0 12px 28px rgba(45,27,67,.11),inset 0 1px 0 rgba(255,255,255,.82)!important;}',
    '#toki-wheel-root .tw-subscriptionDropCard::before{content:""!important;display:block!important;position:absolute!important;z-index:0!important;width:clamp(190px,30vw,360px)!important;aspect-ratio:1!important;right:clamp(-145px,-10vw,-65px)!important;top:clamp(-155px,-11vw,-75px)!important;border-radius:50%!important;pointer-events:none!important;filter:blur(clamp(14px,2.5vw,28px))!important;opacity:.70!important;}',
    '#toki-wheel-root .tw-subscriptionDropCard img{position:relative!important;z-index:1!important;border-radius:14px!important;}',
    '#toki-wheel-root .tw-subscriptionDropCard.isvortexPro{border-top:6px solid #8157d1!important;background:#FFF8EE!important;}',
    '#toki-wheel-root .tw-subscriptionDropCard.isvortexPro::before{background:radial-gradient(circle,rgba(145,102,225,.36) 0%,rgba(129,87,209,.14) 45%,transparent 72%)!important;}',
    '#toki-wheel-root .tw-subscriptionDropCard.isvortexPro{border-top:6px solid #e3a425!important;background:#FFF8EE!important;}',
    '#toki-wheel-root .tw-subscriptionDropCard.isvortexPro::before{background:radial-gradient(circle,rgba(255,208,83,.42) 0%,rgba(227,164,37,.16) 45%,transparent 72%)!important;}',
    '#toki-wheel-root .tw-subscriptionDropsAll{background:linear-gradient(180deg,#8f69dd,#7449c5)!important;color:#FFF8EE!important;border:1px solid rgba(82,47,145,.18)!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.38),0 7px 16px rgba(79,48,128,.18)!important;}',

    /* PREVIEW USED OVERLAY â€” the entire lock layer must paint over Spin. */
    '#toki-wheel-root .tw-wheelCard{isolation:isolate!important;}',

    '@media(max-width:640px){#toki-wheel-root #twOptions .tw-quickStickerPromo::before,#toki-wheel-root .tw-stickerDrops::before,#toki-wheel-root .tw-subscriptionDrops::before,#toki-wheel-root .tw-subscriptionChoicePanel::before{right:-155px!important;top:-165px!important;opacity:.60!important;}#toki-wheel-root .tw-sideTitle .tw-h2{font-size:17px!important;}#toki-wheel-root .tw-subscriptionChoiceCard::before{right:-95px!important;top:-105px!important;}#toki-wheel-root .tw-subscriptionDropCard::before{right:-115px!important;top:-125px!important;}}',
    '@media(prefers-reduced-motion:reduce){#toki-wheel-root #twOptions .tw-quickStickerPromo::after,#toki-wheel-root .tw-stickerDrops::after,#toki-wheel-root .tw-subscriptionDrops::after,#toki-wheel-root .tw-subscriptionChoicePanel::after{animation:none!important;transform:none!important;opacity:.18!important;}}'
  ].join('');
  var style = document.createElement('style');
  style.id = 'tw-premium-cream-ads-0720b';
  style.textContent = css;
  document.head.appendChild(style);
})();

/* =========================================================
   SURGICAL 2026-07-20C â€” rebuilt lower cream ads + vault fix
   Quick Tweaks is intentionally not selected or restyled here.
   Visual only: no wheel, access, rotation, or link behavior changes.
========================================================= */
(function installLowerCreamRebuildAndVaultFix0720C(){
  if(window.__twLowerCreamRebuildAndVaultFix0720C) return;
  window.__twLowerCreamRebuildAndVaultFix0720C = true;
  var css = [
    /* Winners Vault: the same transparent panel glass as the accordions. */
    '#toki-wheel-root .tw-side{position:relative!important;isolation:isolate!important;overflow:hidden!important;padding:var(--tw-pad)!important;border-radius:var(--tw-radius)!important;border:1px solid var(--tw-border)!important;background:linear-gradient(180deg,rgba(255,255,255,.08),rgba(255,255,255,.03)),var(--tw-surface)!important;background-color:transparent!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.17),0 10px 24px rgba(4,37,48,.12)!important;color:var(--tw-text)!important;backdrop-filter:blur(14px) saturate(1.08)!important;-webkit-backdrop-filter:blur(14px) saturate(1.08)!important;}',
    '#toki-wheel-root .tw-side::before{content:""!important;display:block!important;position:absolute!important;inset:0!important;z-index:0!important;pointer-events:none!important;border-radius:inherit!important;background:none!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.10)!important;}',
    '#toki-wheel-root .tw-side::after{content:none!important;display:none!important;}',
    '#toki-wheel-root .tw-side>*{position:relative!important;z-index:1!important;}',
    '#toki-wheel-root .tw-sideTitle{min-height:0!important;margin:0 0 12px!important;padding:2px 0 12px!important;border:0!important;border-radius:0!important;background:transparent!important;box-shadow:none!important;overflow:visible!important;}',
    '#toki-wheel-root .tw-sideTitle .tw-h2{display:inline-flex!important;align-items:center!important;gap:8px!important;margin:0!important;padding:0!important;color:var(--twHeaderText,var(--tw-headerText,#FFF8EE))!important;-webkit-text-fill-color:currentColor!important;font-size:clamp(17px,2.1vw,20px)!important;line-height:1.08!important;font-weight:900!important;letter-spacing:.01em!important;text-transform:uppercase!important;text-shadow:none!important;}',
    '#toki-wheel-root .tw-sideTitle .tw-h2::before{content:"\\1F3C6"!important;display:inline-block!important;position:static!important;width:auto!important;height:auto!important;padding:0!important;border:0!important;border-radius:0!important;background:none!important;box-shadow:none!important;filter:drop-shadow(0 4px 7px rgba(70,40,0,.28)) drop-shadow(0 0 10px rgba(255,204,75,.25))!important;font-size:1em!important;line-height:1!important;}',
    /* Clear is an independent utility control and never inherits snippet color. */
    '#toki-wheel-root .tw-sideTitle .tw-btn{min-width:0!important;min-height:38px!important;height:38px!important;padding:0 14px!important;border-radius:999px!important;background:rgba(255,255,255,.10)!important;border:1px solid rgba(255,255,255,.18)!important;color:#FFF8EE!important;-webkit-text-fill-color:#FFF8EE!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.13),0 7px 15px rgba(2,23,33,.13)!important;font-size:12px!important;text-shadow:none!important;}',
    '#toki-wheel-root #twPinsList{min-height:0!important;padding:0!important;border:0!important;border-radius:0!important;background:transparent!important;box-shadow:none!important;color:inherit!important;}',

    /* Complete reset/rebuild of only the two areas below Spin Science. */
    '#toki-wheel-root .tw-rebuiltCreamAd{--tw-rebuildGlow:255,78,181;position:relative!important;isolation:isolate!important;overflow:hidden!important;margin-top:clamp(30px,5vw,52px)!important;padding:clamp(20px,3.5vw,32px)!important;border-radius:26px!important;border:1px solid rgba(74,43,103,.13)!important;border-top:5px solid #ff57b5!important;background:#FFFFFF!important;background-color:#FFFFFF!important;background-image:none!important;box-shadow:0 18px 42px rgba(46,28,72,.13),0 0 38px rgba(255,78,181,.24),inset 0 1px 0 #FFFFFF!important;color:#2d1d42!important;backdrop-filter:none!important;-webkit-backdrop-filter:none!important;}',
    '#toki-wheel-root .tw-rebuiltCreamAdUpgrade{--tw-rebuildGlow:145,102,225;border-top-color:#8157d1!important;box-shadow:0 18px 42px rgba(46,28,72,.13),0 0 38px rgba(145,102,225,.25),inset 0 1px 0 #FFFFFF!important;}',
    '#toki-wheel-root .tw-rebuiltCreamAd>*{position:relative!important;z-index:2!important;}',
    '#toki-wheel-root .tw-rebuiltCreamAd::before,#toki-wheel-root .tw-rebuiltCreamAd::after{content:none!important;display:none!important;background:none!important;animation:none!important;}',
    '#toki-wheel-root .tw-rebuiltCreamAd .tw-stickerDropsHead,#toki-wheel-root .tw-rebuiltCreamAd .tw-subscriptionDropsHead{padding:0 0 16px!important;margin:0 0 20px!important;border-bottom:1px solid rgba(74,43,103,.11)!important;background:#FFFFFF!important;background-image:none!important;}',
    '#toki-wheel-root .tw-rebuiltCreamAd .tw-stickerDropsKicker,#toki-wheel-root .tw-rebuiltCreamAd .tw-subscriptionDropsKicker{display:inline-flex!important;align-items:center!important;min-height:27px!important;padding:0 12px!important;border-radius:999px!important;color:#FFF8EE!important;-webkit-text-fill-color:#FFF8EE!important;border:1px solid rgba(255,255,255,.35)!important;text-shadow:none!important;}',
    '#toki-wheel-root .tw-rebuiltCreamAdPacks .tw-stickerDropsKicker{background:linear-gradient(180deg,#ff6fbd,#d43dd1)!important;}',
    '#toki-wheel-root .tw-rebuiltCreamAdUpgrade .tw-subscriptionDropsKicker{background:linear-gradient(180deg,#a975ff,#7045df)!important;}',
    '#toki-wheel-root .tw-rebuiltCreamAd .tw-stickerDropsTitle,#toki-wheel-root .tw-rebuiltCreamAd .tw-subscriptionDropsTitle,#toki-wheel-root .tw-rebuiltCreamAd .tw-stickerDropName{color:#2d1d42!important;-webkit-text-fill-color:#2d1d42!important;text-shadow:none!important;}',
    '#toki-wheel-root .tw-rebuiltCreamAd .tw-stickerDropsText,#toki-wheel-root .tw-rebuiltCreamAd .tw-subscriptionDropsText,#toki-wheel-root .tw-rebuiltCreamAd .tw-stickerDropSub{color:#675d70!important;-webkit-text-fill-color:#675d70!important;text-shadow:none!important;}',
    '#toki-wheel-root .tw-rebuiltCreamAd .tw-stickerDropCard,#toki-wheel-root .tw-rebuiltCreamAd .tw-subscriptionDropCard{position:relative!important;overflow:hidden!important;padding:6px!important;border-radius:20px!important;border:1px solid rgba(74,43,103,.13)!important;border-top:1px solid rgba(74,43,103,.13)!important;background:#FFFFFF!important;background-color:#FFFFFF!important;background-image:none!important;box-shadow:0 11px 25px rgba(57,35,82,.11),inset 0 1px 0 #FFFFFF!important;}',
    '#toki-wheel-root .tw-rebuiltCreamAd .tw-subscriptionDropCard::before,#toki-wheel-root .tw-rebuiltCreamAd .tw-subscriptionDropCard::after,#toki-wheel-root .tw-rebuiltCreamAd .tw-stickerDropCard::before,#toki-wheel-root .tw-rebuiltCreamAd .tw-stickerDropCard::after{content:none!important;display:none!important;}',
    '#toki-wheel-root .tw-rebuiltCreamAd .tw-stickerDropArt{background:#FFFFFF!important;}',
    '#toki-wheel-root .tw-rebuiltCreamAd .tw-stickerDropsAll,#toki-wheel-root .tw-rebuiltCreamAd .tw-subscriptionDropsAll,#toki-wheel-root .tw-rebuiltCreamAd .tw-stickerDropBtn,#toki-wheel-root .tw-rebuiltCreamAd .tw-stickerDropMini{min-height:40px!important;height:40px!important;padding:0 17px!important;border-radius:999px!important;background:linear-gradient(180deg,#8f69dd,#7449c5)!important;color:#FFF8EE!important;-webkit-text-fill-color:#FFF8EE!important;border:1px solid rgba(82,47,145,.18)!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.38),0 7px 16px rgba(79,48,128,.18)!important;font-weight:950!important;text-shadow:none!important;}',
    '@media(max-width:640px){#toki-wheel-root .tw-side{padding:var(--tw-padSm)!important;}#toki-wheel-root .tw-sideTitle .tw-h2{font-size:17px!important;}#toki-wheel-root .tw-rebuiltCreamAd{padding:18px!important;border-radius:22px!important;}}'
  ].join('');
  var style = document.createElement('style');
  style.id = 'tw-lower-cream-rebuild-vault-fix-0720c';
  style.textContent = css;
  document.head.appendChild(style);
})();

/* Final vault parity guard: placed after every historical runtime stylesheet. */
(function installVaultParityGuard0720E(){
  if(window.__twVaultParityGuard0720E) return;
  window.__twVaultParityGuard0720E = true;
  var style = document.createElement('style');
  style.id = 'tw-vault-parity-guard-0720e';
  style.textContent = [
    '#toki-wheel-root .tw-vaultRebuilt{width:100%!important;margin:0!important;padding:0!important;border-radius:var(--tw-radius)!important;border:1px solid var(--tw-border)!important;background:linear-gradient(180deg,rgba(255,255,255,.08),rgba(255,255,255,.03)),var(--tw-surface)!important;background-color:transparent!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.17),0 10px 24px rgba(4,37,48,.12)!important;color:var(--tw-text)!important;backdrop-filter:blur(14px) saturate(1.08)!important;-webkit-backdrop-filter:blur(14px) saturate(1.08)!important;overflow:hidden!important;}',
    '#toki-wheel-root .tw-vaultRebuilt::before,#toki-wheel-root .tw-vaultRebuilt::after{content:none!important;display:none!important;}',
    '#toki-wheel-root .tw-vaultHeader{display:flex!important;align-items:center!important;justify-content:space-between!important;gap:var(--tw-gapSm)!important;min-height:0!important;margin:0!important;padding:var(--tw-pad)!important;border:0!important;border-radius:0!important;background:transparent!important;box-shadow:none!important;}',
    '#toki-wheel-root .tw-vaultTitle{display:inline-flex!important;align-items:center!important;gap:8px!important;margin:0!important;padding:0!important;color:var(--twHeaderText,var(--tw-headerText,#FFF8EE))!important;-webkit-text-fill-color:currentColor!important;font-size:clamp(17px,2.1vw,20px)!important;line-height:1.08!important;font-weight:900!important;letter-spacing:.6px!important;text-transform:uppercase!important;text-shadow:none!important;}',
    '#toki-wheel-root .tw-vaultTitle::before,#toki-wheel-root .tw-vaultTitle::after{content:none!important;display:none!important;}',
    '#toki-wheel-root .tw-vaultTrophy{display:inline-block!important;position:static!important;width:auto!important;height:auto!important;padding:0!important;border:0!important;background:none!important;box-shadow:none!important;font-size:1em!important;line-height:1!important;filter:drop-shadow(0 4px 7px rgba(70,40,0,.28)) drop-shadow(0 0 10px rgba(255,204,75,.25))!important;}',
    '#toki-wheel-root .tw-vaultHeader .tw-btn{min-width:0!important;min-height:38px!important;height:38px!important;padding:0 14px!important;border-radius:999px!important;background:rgba(255,255,255,.10)!important;border:1px solid rgba(255,255,255,.18)!important;color:#FFF8EE!important;-webkit-text-fill-color:#FFF8EE!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.13),0 7px 15px rgba(2,23,33,.13)!important;font-size:12px!important;text-shadow:none!important;}',
    '#toki-wheel-root .tw-vaultBody{min-height:0!important;margin:0!important;padding:var(--tw-pad)!important;border-top:1px solid rgba(255,255,255,.12)!important;border-radius:0!important;background:transparent!important;box-shadow:none!important;color:inherit!important;}',
    '#toki-wheel-root .tw-inOverlay .tw-vaultRebuilt{order:2!important;display:block!important;visibility:visible!important;opacity:1!important;}',
    '#toki-wheel-root .tw-lowerQuickClonePacks{position:relative!important;isolation:isolate!important;overflow:hidden!important;background:#FFF8EE!important;background-color:#FFF8EE!important;background-image:none!important;border:1px solid rgba(74,43,103,.13)!important;border-top:5px solid #8157d1!important;box-shadow:0 18px 42px rgba(46,28,72,.13),0 0 34px rgba(129,87,209,.22),inset 0 1px 0 #FFFFFF!important;backdrop-filter:none!important;-webkit-backdrop-filter:none!important;color:#2d1d42!important;}',
    '#toki-wheel-root .tw-lowerQuickClonePacks::before,#toki-wheel-root .tw-lowerQuickClonePacks::after{content:none!important;display:none!important;background:none!important;animation:none!important;}'
  ].join('');
  document.head.appendChild(style);
})();

/* Must remain last: protects the requested dark-blue Choose Your Lab palette. */
(function installFinalBluePlanGuard0720H(){
  if(window.__twFinalBluePlanGuard0720H) return;
  window.__twFinalBluePlanGuard0720H = true;
  var style = document.createElement('style');
  style.id = 'tw-final-blue-plan-guard-0720h';
  style.textContent = [
    '#toki-wheel-root .tw-subscriptionChoicePanel{border-top-color:#173f75!important;box-shadow:0 18px 42px rgba(30,41,72,.14),0 0 38px rgba(32,87,153,.20),inset 0 1px 0 rgba(255,255,255,.82)!important;}',
    '#toki-wheel-root .tw-subscriptionChoicePanel::before{background:radial-gradient(circle,rgba(44,101,173,.30) 0%,rgba(23,63,117,.13) 45%,transparent 72%)!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceKicker,#toki-wheel-root .tw-subscriptionChoicePlan{color:#173f75!important;-webkit-text-fill-color:#173f75!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard.isvortexPro{border-top-color:#245b9b!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard.isvortexPro::before{background:radial-gradient(circle,rgba(50,113,188,.31) 0%,rgba(23,63,117,.12) 45%,transparent 72%)!important;}',
    '#toki-wheel-root .isvortexPro .tw-subscriptionChoiceBtn{background:linear-gradient(180deg,#2f6fb4,#173f75)!important;color:#FFFFFF!important;-webkit-text-fill-color:#FFFFFF!important;border-color:rgba(19,54,102,.20)!important;}'
  ].join('');
  document.head.appendChild(style);
})();

/* Final coordinated polish: Quick Tweaks parity + banner highlight sweep. */
(function installCoordinatedAdPolish0720I(){
  if(window.__twCoordinatedAdPolish0720I) return;
  window.__twCoordinatedAdPolish0720I = true;
  var style = document.createElement('style');
  style.id = 'tw-coordinated-ad-polish-0720i';
  style.textContent = [
    /* Legacy plan classes inherit the Vortex Pro premium treatment. */
    '#toki-wheel-root .isvortexPro .tw-subscriptionChoiceBtn{background:linear-gradient(180deg,#8f69dd,#7449c5)!important;color:#FFF8EE!important;-webkit-text-fill-color:#FFF8EE!important;border:1px solid rgba(82,47,145,.18)!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.38),0 7px 16px rgba(79,48,128,.18)!important;}',

    /* More breathing room beneath Lab Pack details and samples. */
    '#toki-wheel-root .tw-labPackChoiceBtn{margin-top:16px!important;}',

    /* Quick Tweaks Lab Packs now shares the lower showcase pink language. */
    '#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo){position:relative!important;isolation:isolate!important;overflow:hidden!important;border:1px solid rgba(112,42,92,.13)!important;border-top:5px solid #f24fa7!important;background:#FFF8EE!important;background-image:none!important;box-shadow:0 16px 36px rgba(50,25,67,.13),0 0 32px rgba(242,79,167,.19),inset 0 1px 0 #FFFFFF!important;color:#2d1d42!important;backdrop-filter:none!important;-webkit-backdrop-filter:none!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo)::before{content:""!important;display:block!important;position:absolute!important;z-index:0!important;width:clamp(220px,34vw,420px)!important;aspect-ratio:1!important;right:clamp(-155px,-11vw,-70px)!important;top:clamp(-175px,-14vw,-85px)!important;border-radius:50%!important;pointer-events:none!important;background:radial-gradient(circle,rgba(255,91,181,.31) 0%,rgba(242,79,167,.13) 44%,transparent 72%)!important;filter:blur(clamp(16px,2.5vw,28px))!important;opacity:.68!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo)>*{position:relative!important;z-index:1!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromoKicker{display:inline-flex!important;align-items:center!important;min-height:27px!important;padding:0 12px!important;border-radius:999px!important;background:linear-gradient(180deg,#ff72bd,#df3e9b)!important;border:1px solid rgba(183,35,118,.18)!important;color:#FFFFFF!important;-webkit-text-fill-color:#FFFFFF!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.42),0 7px 16px rgba(178,44,119,.15)!important;text-shadow:none!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromoBtn,#toki-wheel-root #twOptions .tw-quickStickerPromoAll{display:inline-flex!important;align-items:center!important;justify-content:center!important;min-height:36px!important;height:36px!important;padding:8px 13px!important;border:0!important;border-radius:999px!important;background:linear-gradient(180deg,#ff72bd,#df3e9b)!important;color:#FFFFFF!important;-webkit-text-fill-color:#FFFFFF!important;font-size:12px!important;font-weight:950!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.55),0 6px 14px rgba(143,35,100,.18)!important;transition:transform .18s ease,filter .18s ease,box-shadow .18s ease!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromoBtn:hover,#toki-wheel-root #twOptions .tw-quickStickerPromoAll:hover{transform:translateY(-2px)!important;filter:brightness(1.04) saturate(1.04)!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.58),0 9px 18px rgba(143,35,100,.22)!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromoMedia,#toki-wheel-root #twOptions .tw-quickStickerPromoCopy{transition:opacity .34s ease,transform .42s cubic-bezier(.2,.8,.2,1),filter .34s ease!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromo.isChanging .tw-quickStickerPromoMedia{opacity:0!important;transform:translateY(7px) scale(.992)!important;filter:blur(2px)!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromo.isChanging .tw-quickStickerPromoCopy{opacity:0!important;transform:translateY(5px)!important;}',

    /* Smooth banner highlight travels across every coordinated ad family. */
    '#toki-wheel-root .tw-quickStickerPromoMedia,#toki-wheel-root .tw-labPackChoiceMedia,#toki-wheel-root .tw-subscriptionChoiceMedia{position:relative!important;isolation:isolate!important;overflow:hidden!important;}',
    '#toki-wheel-root .tw-quickStickerPromoMedia::before,#toki-wheel-root .tw-labPackChoiceMedia::before,#toki-wheel-root .tw-subscriptionChoiceMedia::before{content:""!important;display:block!important;position:absolute!important;z-index:3!important;inset:-20% auto -20% -55%!important;width:38%!important;pointer-events:none!important;background:linear-gradient(100deg,transparent 0%,rgba(255,255,255,.12) 25%,rgba(255,255,255,.62) 50%,rgba(255,255,255,.12) 75%,transparent 100%)!important;transform:skewX(-14deg) translateX(0)!important;animation:twCoordinatedBannerSweep 8.2s cubic-bezier(.2,.7,.2,1) infinite!important;opacity:.76!important;}',
    '#toki-wheel-root .tw-labPackChoiceCard:nth-child(2) .tw-labPackChoiceMedia::before,#toki-wheel-root .tw-subscriptionChoiceCard:nth-child(2) .tw-subscriptionChoiceMedia::before{animation-delay:1.15s!important;}',
    '#toki-wheel-root .tw-labPackChoiceCard:nth-child(3) .tw-labPackChoiceMedia::before{animation-delay:2.3s!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard{transition:transform .28s cubic-bezier(.2,.8,.2,1),box-shadow .28s ease,filter .28s ease!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard:hover{transform:translateY(-4px)!important;filter:saturate(1.03)!important;}',
    '@keyframes twCoordinatedBannerSweep{0%,56%{transform:skewX(-14deg) translateX(0);opacity:0;}62%{opacity:.76;}78%{transform:skewX(-14deg) translateX(430%);opacity:.56;}84%,100%{transform:skewX(-14deg) translateX(430%);opacity:0;}}',
    '@media(prefers-reduced-motion:reduce){#toki-wheel-root .tw-quickStickerPromoMedia::before,#toki-wheel-root .tw-labPackChoiceMedia::before,#toki-wheel-root .tw-subscriptionChoiceMedia::before{animation:none!important;display:none!important;}#toki-wheel-root #twOptions .tw-quickStickerPromoMedia,#toki-wheel-root #twOptions .tw-quickStickerPromoCopy,#toki-wheel-root .tw-subscriptionChoiceCard{transition:none!important;}}'
  ].join('');
  document.head.appendChild(style);
})();

/* Final visual parity: Choose Your Lab matches Lab Packs presence. */
(function installChooseLabPresenceParity0720J(){
  if(window.__twChooseLabPresenceParity0720J) return;
  window.__twChooseLabPresenceParity0720J = true;
  var style = document.createElement('style');
  style.id = 'tw-choose-lab-presence-parity-0720j';
  style.textContent = [
    '#toki-wheel-root .tw-subscriptionChoicePanel{position:relative!important;isolation:isolate!important;overflow:hidden!important;padding:clamp(18px,3vw,26px)!important;border-radius:26px!important;border:1px solid rgba(31,65,112,.14)!important;border-top:5px solid #173f75!important;background:#FFF8EE!important;background-image:none!important;box-shadow:0 19px 44px rgba(30,41,72,.15),0 0 44px rgba(35,91,159,.28),inset 0 1px 0 #FFFFFF!important;color:#2d1d42!important;}',
    '#toki-wheel-root .tw-subscriptionChoicePanel::before{content:""!important;display:block!important;position:absolute!important;z-index:0!important;width:clamp(270px,46vw,570px)!important;aspect-ratio:1!important;right:clamp(-185px,-13vw,-75px)!important;top:clamp(-215px,-17vw,-92px)!important;border-radius:50%!important;pointer-events:none!important;background:radial-gradient(circle,rgba(61,126,204,.43) 0%,rgba(35,91,159,.20) 42%,rgba(23,63,117,.07) 58%,transparent 73%)!important;filter:blur(clamp(16px,2.8vw,30px))!important;opacity:.88!important;}',
    '#toki-wheel-root .tw-subscriptionChoicePanel>*{position:relative!important;z-index:2!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceHead{display:flex!important;align-items:flex-end!important;justify-content:space-between!important;gap:14px!important;margin:0 0 18px!important;padding:0 0 15px!important;border-bottom:1px solid rgba(31,65,112,.12)!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceKicker{color:#173f75!important;-webkit-text-fill-color:#173f75!important;font-size:11px!important;line-height:1!important;font-weight:950!important;letter-spacing:.14em!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceTitle{margin-top:8px!important;color:#2d1d42!important;font-size:clamp(20px,2.6vw,27px)!important;line-height:1.05!important;font-weight:950!important;letter-spacing:-.025em!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceGrid{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:14px!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard{position:relative!important;isolation:isolate!important;overflow:hidden!important;display:flex!important;flex-direction:column!important;grid-template-columns:none!important;align-items:stretch!important;border-radius:18px!important;background:#FFFFFF!important;border:1px solid rgba(31,65,112,.12)!important;box-shadow:0 10px 23px rgba(30,41,72,.11),inset 0 1px 0 #FFFFFF!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard.isvortexPro{border-top:5px solid #8157d1!important;background:#FFFFFF!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard.isvortexPro{border-top:5px solid #e3a425!important;background:#FFFFFF!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceMedia{display:flex!important;align-items:center!important;justify-content:center!important;width:100%!important;min-height:0!important;padding:6px!important;background:#FFFFFF!important;border-bottom:1px solid rgba(31,65,112,.09)!important;overflow:hidden!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceMedia img{display:block!important;width:100%!important;height:auto!important;max-width:100%!important;object-fit:contain!important;border-radius:12px!important;transition:transform .5s cubic-bezier(.2,.8,.2,1),filter .3s ease!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard:hover .tw-subscriptionChoiceMedia img{transform:scale(1.025)!important;filter:saturate(1.05)!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCopy{display:flex!important;flex:1 1 auto!important;flex-direction:column!important;align-items:flex-start!important;justify-content:flex-start!important;padding:13px!important;}',
    '#toki-wheel-root .tw-subscriptionChoicePlan{color:#173f75!important;-webkit-text-fill-color:#173f75!important;font-size:10px!important;font-weight:950!important;letter-spacing:.12em!important;text-transform:uppercase!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCardTitle{margin-top:4px!important;color:#291943!important;font-size:16px!important;line-height:1.12!important;font-weight:950!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceText{margin-top:6px!important;color:#675d70!important;font-size:12px!important;line-height:1.42!important;font-weight:700!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceBtn{margin-top:16px!important;min-height:36px!important;padding:8px 13px!important;border-radius:999px!important;font-size:12px!important;font-weight:950!important;}',
    '#toki-wheel-root .isvortexPro .tw-subscriptionChoiceBtn{background:linear-gradient(180deg,#8f69dd,#7449c5)!important;color:#FFF8EE!important;-webkit-text-fill-color:#FFF8EE!important;border:1px solid rgba(82,47,145,.18)!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.38),0 7px 16px rgba(79,48,128,.18)!important;}',
    '#toki-wheel-root .isvortexPro .tw-subscriptionChoiceBtn{background:linear-gradient(180deg,#ffd96b,#e8ad2f)!important;color:#3a270d!important;-webkit-text-fill-color:#3a270d!important;border:1px solid rgba(142,94,12,.17)!important;}',
    '@media(max-width:760px){#toki-wheel-root .tw-subscriptionChoiceGrid{grid-template-columns:1fr!important;}#toki-wheel-root .tw-subscriptionChoicePanel{padding:16px!important;border-radius:22px!important;}#toki-wheel-root .tw-subscriptionChoiceHead{display:block!important;}}'
  ].join('');
  document.head.appendChild(style);
})();

/* SURGICAL 2026-07-21: animate the free-spin sign when the shared preview lock appears. */
(function(){
  'use strict';
  var KEY = 'tokiFreeSpinLockSignLitV1';
  window.TOKI_WHEEL = window.TOKI_WHEEL || {};
  window.TOKI_WHEEL.activateFreeSpinSign = function(lock){
    var sign = lock && lock.querySelector ? lock.querySelector('.tw-freeSign') : null;
    if(!sign || sign.dataset.twSignStarted === '1') return;
    sign.dataset.twSignStarted = '1';
    var reduced = false;
    try{ reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }catch(_){ }
    var alreadyLit = false;
    try{ alreadyLit = window.sessionStorage.getItem(KEY) === 'true'; }catch(_){ }
    if(reduced || alreadyLit){ sign.classList.add('isLit'); return; }
    try{ window.sessionStorage.setItem(KEY,'true'); }catch(_){ }
    var onImage = sign.querySelector('.tw-freeSignImageOn');
    function begin(){
      sign.classList.remove('isActivating');
      void sign.offsetWidth;
      sign.classList.add('isActivating');
      window.setTimeout(function(){ sign.classList.remove('isActivating'); sign.classList.add('isLit'); },2200);
    }
    if(!onImage || (onImage.complete && onImage.naturalWidth > 0)){ begin(); }
    else{
      onImage.addEventListener('load',begin,{once:true});
      onImage.addEventListener('error',begin,{once:true});
      window.setTimeout(begin,1400);
    }
  };
})();
setTimeout(function(){ try{ window.TOKI_WHEEL && window.TOKI_WHEEL.refreshAccessUI && window.TOKI_WHEEL.refreshAccessUI(); }catch(_){ } }, 80);

/* Must remain last: overlay uses the exact normal-mode wheel/vault geometry. */
(function installExactOverlayVaultParity0723(){
  if(window.__twExactOverlayVaultParity0723) return;
  window.__twExactOverlayVaultParity0723 = true;
  var style = document.createElement('style');
  style.id = 'tw-exact-overlay-vault-parity-0723';
  style.textContent = [
    '#toki-wheel-root .tw-inOverlay .tw-main{display:grid!important;grid-template-columns:1fr 360px!important;gap:20px!important;align-items:stretch!important;width:min(var(--tw-maxw),calc(100% - 32px))!important;max-width:var(--tw-maxw)!important;margin:0 auto!important;border-radius:0!important;}',
    '#toki-wheel-root .tw-inOverlay .tw-wheelCard{order:0!important;align-self:auto!important;min-width:0!important;}',
    '#toki-wheel-root .tw-inOverlay .tw-vaultRebuilt,#toki-wheel-root .tw-inOverlay .tw-vaultRebuilt.tw-accord{order:0!important;position:relative!important;inset:auto!important;transform:none!important;width:auto!important;max-width:calc(100% - 4px)!important;max-height:none!important;min-height:0!important;height:auto!important;margin:0!important;padding:0!important;align-self:auto!important;overflow:hidden!important;border-radius:22px!important;}',
    '#toki-wheel-root .tw-inOverlay .tw-vaultRebuilt .tw-vaultBody:not(:empty){max-height:none!important;overflow:visible!important;}',
    '@media(max-width:980px){#toki-wheel-root .tw-inOverlay .tw-main{grid-template-columns:1fr!important;gap:20px!important;align-items:stretch!important;}#toki-wheel-root .tw-inOverlay .tw-vaultRebuilt,#toki-wheel-root .tw-inOverlay .tw-vaultRebuilt.tw-accord{width:auto!important;max-width:calc(100% - 4px)!important;margin:0!important;padding:0!important;border-radius:22px!important;overflow:hidden!important;}}'
  ].join('');
  document.head.appendChild(style);
})();

/* Must remain last: 2026-07-27 sticker workspace and Lab Pack visual polish. */
(function installStickerWorkspacePolish0727(){
  if(window.__twStickerWorkspacePolish0727) return;
  window.__twStickerWorkspacePolish0727 = true;
  var style = document.createElement('style');
  style.id = 'tw-sticker-workspace-polish-0727';
  style.textContent = [
    '#toki-wheel-root .tw-quickStickerPromoInner{opacity:1!important;transform:translateY(0) scale(1)!important;filter:none!important;transition:opacity .58s cubic-bezier(.22,.61,.36,1),transform .58s cubic-bezier(.22,.61,.36,1),filter .58s cubic-bezier(.22,.61,.36,1)!important;}',
    '#toki-wheel-root .tw-quickStickerPromo.isChanging .tw-quickStickerPromoInner{opacity:0!important;transform:translateY(7px) scale(.994)!important;filter:blur(1.5px) saturate(.96)!important;}',
    '#toki-wheel-root .tw-quickStickerPromo.isChanging .tw-quickStickerPromoMedia,#toki-wheel-root .tw-quickStickerPromo.isChanging .tw-quickStickerPromoCopy{opacity:1!important;transform:none!important;filter:none!important;}',
    '#toki-wheel-root .tw-labPackChoiceGrid{opacity:1!important;transform:translateY(0) scale(1)!important;filter:none!important;transition:opacity .62s cubic-bezier(.22,.61,.36,1),transform .62s cubic-bezier(.22,.61,.36,1),filter .62s cubic-bezier(.22,.61,.36,1)!important;}',
    '#toki-wheel-root .tw-labPackChoiceGrid.isChanging{opacity:0!important;transform:translateY(8px) scale(.994)!important;filter:blur(1.5px) saturate(.96)!important;}',
    '#toki-wheel-root .tw-quickStickerPromoSamples,#toki-wheel-root .tw-labPackChoiceSamples{display:grid!important;grid-template-columns:repeat(6,minmax(0,1fr))!important;gap:6px!important;align-items:center!important;}',
    '#toki-wheel-root .tw-quickStickerPromoSamples img,#toki-wheel-root .tw-labPackChoiceSamples img{width:100%!important;height:auto!important;aspect-ratio:1/1!important;min-width:0!important;object-fit:contain!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo) .tw-quickStickerPromoKicker,#toki-wheel-root .tw-labPackChoiceKicker{color:#FFF8EE!important;-webkit-text-fill-color:#FFF8EE!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo) .tw-quickStickerPromoTitle,#toki-wheel-root .tw-labPackChoiceTitle{color:#67206f!important;-webkit-text-fill-color:#67206f!important;text-shadow:none!important;}',
    '#toki-wheel-root .tw-labPackChoiceCardTitle{color:#8d245f!important;-webkit-text-fill-color:#8d245f!important;text-shadow:none!important;}',
    '#toki-wheel-root .tw-labPackChoicePlan{color:#d60082!important;-webkit-text-fill-color:#d60082!important;text-shadow:none!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo) .tw-quickStickerPromoText,#toki-wheel-root .tw-labPackChoiceText{color:#675d70!important;-webkit-text-fill-color:#675d70!important;text-shadow:none!important;}',
    '@media(max-width:480px){#toki-wheel-root .tw-quickStickerPromoSamples,#toki-wheel-root .tw-labPackChoiceSamples{grid-template-columns:repeat(4,minmax(0,1fr))!important;}}',
    '@media(prefers-reduced-motion:reduce){#toki-wheel-root .tw-quickStickerPromoInner,#toki-wheel-root .tw-labPackChoiceGrid{transition:none!important;transform:none!important;filter:none!important;}}'
  ].join('');
  document.head.appendChild(style);
})();

/* Must remain last: release-candidate palette, ad, sharing, and overlay polish. */
(function installReleaseCandidatePolish0730(){
  if(window.__twReleaseCandidatePolish0730) return;
  window.__twReleaseCandidatePolish0730 = true;
  var style = document.createElement('style');
  style.id = 'tw-release-candidate-polish-0730';
  style.textContent = [
    '#toki-wheel-root{--tw-release-purple:#401268;--tw-release-pink:#cc007e;--tw-release-cream:#fff8ee;}',

    /* A shared premium ad language: cream paper, subtle lab grid, pink/purple linework. */
    '#toki-wheel-root .tw-quickStickerPromo,#toki-wheel-root .tw-labPackChoicePanel,#toki-wheel-root .tw-subscriptionChoicePanel{position:relative!important;isolation:isolate!important;overflow:hidden!important;border:1px solid rgba(64,18,104,.16)!important;border-top:5px solid var(--tw-release-pink)!important;background-color:var(--tw-release-cream)!important;background-image:linear-gradient(rgba(64,18,104,.045) 1px,transparent 1px),linear-gradient(90deg,rgba(64,18,104,.045) 1px,transparent 1px),radial-gradient(circle at 100% 0%,rgba(204,0,126,.16),transparent 35%),radial-gradient(circle at 0% 100%,rgba(64,18,104,.12),transparent 37%)!important;background-size:24px 24px,24px 24px,auto,auto!important;box-shadow:0 18px 45px rgba(64,18,104,.16),inset 0 1px 0 #fff!important;color:var(--tw-release-purple)!important;}',
    '#toki-wheel-root .tw-quickStickerPromo::after,#toki-wheel-root .tw-labPackChoicePanel::after,#toki-wheel-root .tw-subscriptionChoicePanel::after{content:""!important;position:absolute!important;right:-38px!important;bottom:-38px!important;width:118px!important;height:118px!important;border:2px solid rgba(204,0,126,.16)!important;border-radius:50%!important;box-shadow:0 0 0 18px rgba(64,18,104,.045),0 0 0 36px rgba(204,0,126,.035)!important;pointer-events:none!important;z-index:0!important;}',
    '#toki-wheel-root .tw-quickStickerPromo>*,#toki-wheel-root .tw-labPackChoicePanel>*,#toki-wheel-root .tw-subscriptionChoicePanel>*{position:relative!important;z-index:1!important;}',
    '#toki-wheel-root .tw-quickStickerPromoKicker,#toki-wheel-root .tw-labPackChoiceKicker,#toki-wheel-root .tw-subscriptionChoiceKicker,#toki-wheel-root .tw-labPackChoicePlan{display:inline-flex!important;width:max-content!important;max-width:100%!important;padding:6px 10px!important;border-radius:999px!important;background:var(--tw-release-pink)!important;color:var(--tw-release-cream)!important;-webkit-text-fill-color:var(--tw-release-cream)!important;letter-spacing:.12em!important;text-shadow:none!important;}',
    '#toki-wheel-root .tw-quickStickerPromoTitle,#toki-wheel-root .tw-labPackChoiceTitle,#toki-wheel-root .tw-subscriptionChoiceTitle,#toki-wheel-root .tw-labPackChoiceCardTitle,#toki-wheel-root .tw-subscriptionChoiceCardTitle{color:var(--tw-release-purple)!important;-webkit-text-fill-color:var(--tw-release-purple)!important;text-shadow:none!important;}',
    '#toki-wheel-root .tw-quickStickerPromoText,#toki-wheel-root .tw-labPackChoiceText,#toki-wheel-root .tw-subscriptionChoiceText{color:#675d70!important;-webkit-text-fill-color:#675d70!important;}',
    '#toki-wheel-root .tw-quickStickerPromoMedia,#toki-wheel-root .tw-labPackChoiceMedia,#toki-wheel-root .tw-subscriptionChoiceMedia{cursor:pointer!important;border:1px solid rgba(64,18,104,.15)!important;background:#fff!important;box-shadow:0 12px 27px rgba(64,18,104,.13)!important;}',
    '#toki-wheel-root .tw-quickStickerPromoMedia:focus-visible,#toki-wheel-root .tw-labPackChoiceMedia:focus-visible,#toki-wheel-root .tw-subscriptionChoiceMedia:focus-visible{outline:3px solid var(--tw-release-pink)!important;outline-offset:3px!important;}',
    '#toki-wheel-root .tw-labPackChoiceCard,#toki-wheel-root .tw-subscriptionChoiceCard{border:1px solid rgba(64,18,104,.14)!important;border-top:4px solid var(--tw-release-purple)!important;background:rgba(255,255,255,.92)!important;box-shadow:0 12px 28px rgba(64,18,104,.12)!important;}',
    '#toki-wheel-root .tw-quickStickerPromoBtn,#toki-wheel-root .tw-quickStickerPromoAll,#toki-wheel-root .tw-labPackChoiceBtn,#toki-wheel-root .tw-labPackChoiceAll,#toki-wheel-root .tw-subscriptionChoiceBtn{min-height:42px!important;border:1px solid rgba(64,18,104,.2)!important;border-radius:999px!important;background:linear-gradient(135deg,var(--tw-release-pink),#a80068)!important;color:var(--tw-release-cream)!important;-webkit-text-fill-color:var(--tw-release-cream)!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.3),0 8px 19px rgba(204,0,126,.2)!important;font-weight:950!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard:nth-child(even) .tw-subscriptionChoiceBtn{background:linear-gradient(135deg,#5d2b89,var(--tw-release-purple))!important;}',

    /* Vortex controls now use the same wheel button system instead of flat white controls. */
    '#toki-wheel-root #twVortexAI .tw-btn{min-height:44px!important;padding:9px 17px!important;border:1px solid rgba(64,18,104,.2)!important;border-radius:999px!important;background:linear-gradient(180deg,#f3eafa,#e7d8f3)!important;color:var(--tw-release-purple)!important;-webkit-text-fill-color:var(--tw-release-purple)!important;box-shadow:inset 0 1px 0 #fff,0 7px 16px rgba(64,18,104,.12)!important;font-weight:950!important;}',
    '#toki-wheel-root #twVortexAI .tw-btnPrimary{background:linear-gradient(135deg,var(--tw-release-pink),#a80068)!important;color:var(--tw-release-cream)!important;-webkit-text-fill-color:var(--tw-release-cream)!important;}',
    '#toki-wheel-root #twVortexAI .tw-btnSurprise,#toki-wheel-root #twVortexAI .tw-btnRefine{background:linear-gradient(135deg,#5d2b89,var(--tw-release-purple))!important;color:var(--tw-release-cream)!important;-webkit-text-fill-color:var(--tw-release-cream)!important;}',

    /* Consistent share buttons; popup appearance remains independent of winner themes. */
    '#toki-wheel-root .tw-modal .tw-btn{min-height:46px!important;padding:10px 20px!important;border-radius:999px!important;font-size:14px!important;font-weight:950!important;}',
    '#toki-wheel-root .tw-modal .tw-btnPrimary{background:linear-gradient(135deg,var(--tw-release-pink),#a80068)!important;color:var(--tw-release-cream)!important;-webkit-text-fill-color:var(--tw-release-cream)!important;}',
    '#toki-wheel-root .tw-modal .tw-btn:not(.tw-btnPrimary){border:1px solid rgba(64,18,104,.2)!important;background:linear-gradient(180deg,#f3eafa,#e7d8f3)!important;color:var(--tw-release-purple)!important;-webkit-text-fill-color:var(--tw-release-purple)!important;}',
    '#toki-wheel-root .tw-shareInvitePrimary{width:min(100%,280px)!important;justify-content:center!important;}',
    '#toki-wheel-root #twFairness .tw-fairnessNotice{margin:12px 0 0!important;}',

    /* Overlay defaults mirror the normal wheel/vault grid and never stretch the vault. */
    '#toki-wheel-root .tw-inOverlay .tw-main{grid-template-columns:minmax(0,1fr) minmax(300px,360px)!important;gap:20px!important;align-items:start!important;}',
    '#toki-wheel-root .tw-inOverlay .tw-wheelCard{order:1!important;align-self:start!important;}',
    '#toki-wheel-root .tw-inOverlay .tw-vaultRebuilt,#toki-wheel-root .tw-inOverlay .tw-vaultRebuilt.tw-accord{order:2!important;width:100%!important;max-width:360px!important;align-self:start!important;height:auto!important;min-height:0!important;margin:0!important;}',
    '#toki-wheel-root .tw-inOverlay.tw-overlayLayout-center .tw-main{grid-template-columns:1fr!important;}',
    '#toki-wheel-root .tw-inOverlay.tw-overlayLayout-center .tw-wheelCard{width:min(100%,980px)!important;margin-inline:auto!important;}',
    '#toki-wheel-root .tw-inOverlay.tw-overlayLayout-center .tw-vaultRebuilt{max-width:520px!important;margin-inline:auto!important;}',
    '#toki-wheel-root .tw-inOverlay.tw-overlayLayout-right .tw-wheelCard{order:2!important;}',
    '#toki-wheel-root .tw-inOverlay.tw-overlayLayout-right .tw-vaultRebuilt{order:1!important;}',
    'body.twOverlayBody.twWinnerPos-left .tw-modalBack{justify-content:flex-start!important;align-items:center!important;padding-left:clamp(12px,5vw,72px)!important;}',
    'body.twOverlayBody.twWinnerPos-right .tw-modalBack{justify-content:flex-end!important;align-items:center!important;padding-right:clamp(12px,5vw,72px)!important;}',
    'body.twOverlayBody.twWinnerPos-top .tw-modalBack{justify-content:center!important;align-items:flex-start!important;padding-top:clamp(12px,6vh,70px)!important;}',
    '@media(max-width:980px){#toki-wheel-root .tw-inOverlay .tw-main,#toki-wheel-root .tw-inOverlay.tw-overlayLayout-center .tw-main,#toki-wheel-root .tw-inOverlay.tw-overlayLayout-right .tw-main{grid-template-columns:1fr!important;align-items:start!important;}#toki-wheel-root .tw-inOverlay .tw-wheelCard,#toki-wheel-root .tw-inOverlay.tw-overlayLayout-right .tw-wheelCard{order:1!important;width:100%!important;}#toki-wheel-root .tw-inOverlay .tw-vaultRebuilt,#toki-wheel-root .tw-inOverlay.tw-overlayLayout-right .tw-vaultRebuilt{order:2!important;width:100%!important;max-width:none!important;margin:0!important;align-self:start!important;}}',
    '@media(max-width:700px){#toki-wheel-root .tw-presentationDock{overflow-x:auto!important;scrollbar-width:thin!important;}.tw-presentationDock .tw-presentationLayout,.tw-presentationDock .tw-presentationWinner{display:inline-flex!important;}}'
  ].join('');
  document.head.appendChild(style);
})();

/* Must remain last: corrected launch palette and ad hierarchy. */
(function installLaunchSystemCorrection0730B(){
  if(window.__twLaunchSystemCorrection0730B) return;
  window.__twLaunchSystemCorrection0730B = true;
  var style = document.createElement('style');
  style.id = 'tw-launch-system-correction-0730b';
  style.textContent = [
    /* One semantic button system: glass neutral, purple action, blue spin, orange undo, coral destructive. */
    '#toki-wheel-root button.tw-btn{min-height:42px;border:1px solid rgba(64,18,104,.20);border-radius:999px;background:linear-gradient(180deg,rgba(255,255,255,.92),rgba(239,230,247,.92));color:#401268;-webkit-text-fill-color:#401268;box-shadow:inset 0 1px 0 rgba(255,255,255,.92),0 7px 16px rgba(64,18,104,.12);font-weight:900;}',
    '#toki-wheel-root button.tw-btnPrimary{background:linear-gradient(135deg,#5d2b89,#401268);border-color:rgba(49,10,84,.32);color:#fff8ee;-webkit-text-fill-color:#fff8ee;box-shadow:inset 0 1px 0 rgba(255,255,255,.25),0 8px 18px rgba(64,18,104,.22);}',
    '#toki-wheel-root #twSpin{background:linear-gradient(135deg,#2577c8,#15549b)!important;border-color:#124a89!important;color:#fff8ee!important;-webkit-text-fill-color:#fff8ee!important;}',
    '#toki-wheel-root #twUndo{background:linear-gradient(135deg,#ffad38,#f27616)!important;border-color:#d85f0d!important;color:#351801!important;-webkit-text-fill-color:#351801!important;}',
    '#toki-wheel-root button.tw-btnDanger:not(#twUndo){background:linear-gradient(135deg,#ef6c55,#d94d3f);border-color:#c84034;color:#fff8ee;-webkit-text-fill-color:#fff8ee;}',
    '#toki-wheel-root button.tw-btn:disabled{opacity:.52!important;filter:saturate(.65)!important;cursor:not-allowed!important;}',

    /* Lab Packs use the calmer Quick Tweaks purple with genuinely white pill copy. */
    '#toki-wheel-root .tw-labPackChoicePanel,#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo){border-top-color:#401268!important;}',
    '#toki-wheel-root .tw-labPackChoiceHead,#toki-wheel-root .tw-subscriptionChoiceHead{border-bottom:0!important;padding-bottom:0!important;}',
    '#toki-wheel-root .tw-labPackChoiceKicker,#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo) .tw-quickStickerPromoKicker,#toki-wheel-root .tw-subscriptionChoiceKicker{display:inline-flex!important;align-items:center!important;width:max-content!important;min-height:27px!important;padding:0 12px!important;border:1px solid rgba(64,18,104,.22)!important;border-radius:999px!important;background:#7044bd!important;background-image:none!important;color:#fff8ee!important;-webkit-text-fill-color:#fff8ee!important;-webkit-background-clip:border-box!important;background-clip:border-box!important;text-shadow:none!important;opacity:1!important;filter:none!important;font-size:11px!important;line-height:1!important;font-weight:950!important;letter-spacing:.14em!important;}',
    '#toki-wheel-root .tw-labPackChoicePlan{color:#fff8ee!important;-webkit-text-fill-color:#fff8ee!important;background:#7044bd!important;padding:6px 10px!important;border:1px solid rgba(64,18,104,.18)!important;border-radius:999px!important;}',
    '#toki-wheel-root .tw-labPackChoiceCard{border-top:5px solid #401268!important;}',

    /* Subscription family returns to dark blue, while each plan keeps its own identity. */
    '#toki-wheel-root .tw-subscriptionChoicePanel,#toki-wheel-root #twOptions .tw-quickSubscriptionPromo{border-top-color:#173f75!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard.isvortexPro{border-top:5px solid #8157d1!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard.isvortexPro{border-top:5px solid #d29a20!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard.isvortexPro .tw-subscriptionChoiceBtn{background:linear-gradient(135deg,#9168dc,#7143bd)!important;border-color:#6335aa!important;color:#fff8ee!important;-webkit-text-fill-color:#fff8ee!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceCard.isvortexPro .tw-subscriptionChoiceBtn{background:linear-gradient(135deg,#e4b43d,#bd8012)!important;border-color:#a96d0b!important;color:#fff8ee!important;-webkit-text-fill-color:#fff8ee!important;}',
    '#toki-wheel-root .tw-subscriptionChoiceHead{margin-bottom:14px!important;}',

    /* No divider or stray rule immediately above any ad banner. */
    '#toki-wheel-root .tw-quickStickerPromoMedia,#toki-wheel-root .tw-labPackChoiceMedia,#toki-wheel-root .tw-subscriptionChoiceMedia{border-top:0!important;}',
    '#toki-wheel-root .tw-labPackChoiceHead + .tw-labPackChoiceGrid,#toki-wheel-root .tw-subscriptionChoiceHead + .tw-subscriptionChoiceGrid{border-top:0!important;}',

    /* Keep the restored overlay tools easy to find. */
    '#toki-wheel-root .tw-presentationDock{display:flex!important;visibility:visible!important;opacity:1!important;}'
  ].join('');
  document.head.appendChild(style);
})();

/* Must remain last: final semantic controls, overlay placement, and pill legibility. */
(function installLaunchInteractionCorrection0730C(){
  if(window.__twLaunchInteractionCorrection0730C) return;
  window.__twLaunchInteractionCorrection0730C = true;
  var style = document.createElement('style');
  style.id = 'tw-launch-interaction-correction-0730c';
  style.textContent = [
    /* Original Spin the Wheel Lab action colors, applied consistently. */
    '#toki-wheel-root button.tw-btn,#toki-wheel-root .tw-modal button.tw-btn{box-sizing:border-box!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;min-height:44px!important;padding:9px 14px!important;border:1px solid rgba(64,18,104,.20)!important;border-radius:999px!important;background:linear-gradient(180deg,#fffdf8,#eee4f5)!important;color:#401268!important;-webkit-text-fill-color:#401268!important;box-shadow:inset 0 1px 0 #fff,0 7px 16px rgba(64,18,104,.12)!important;font-size:13px!important;line-height:1.1!important;font-weight:900!important;text-align:center!important;}',
    '#toki-wheel-root button.tw-btnPrimary,#toki-wheel-root .tw-modal button.tw-btnPrimary,#toki-wheel-root #twVortexAI button.tw-btnPrimary{background:linear-gradient(180deg,#5BC0EB 0%,#43afd8 100%)!important;border-color:rgba(30,118,154,.32)!important;color:#1f1f1f!important;-webkit-text-fill-color:#1f1f1f!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.48),0 9px 19px rgba(67,175,216,.23)!important;}',
    '#toki-wheel-root button.tw-btnSecondary,#toki-wheel-root button.tw-btnRefine,#toki-wheel-root #twVortexAI button.tw-btnRefine{background:linear-gradient(180deg,#7BC96F 0%,#66b85c 100%)!important;border-color:rgba(54,132,43,.30)!important;color:#1f1f1f!important;-webkit-text-fill-color:#1f1f1f!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.44),0 9px 19px rgba(102,184,92,.22)!important;}',
    '#toki-wheel-root button.tw-btnDanger,#toki-wheel-root #twUndo,#toki-wheel-root #twVortexAI button.tw-btnSurprise{background:linear-gradient(180deg,#E86A2E 0%,#d15f25 100%)!important;border-color:rgba(157,65,23,.32)!important;color:#1f1f1f!important;-webkit-text-fill-color:#1f1f1f!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.32),0 9px 19px rgba(209,95,37,.22)!important;}',
    '#toki-wheel-root button.tw-bigBtn{min-height:56px!important;padding:13px 16px!important;font-size:16px!important;}',
    '#toki-wheel-root button.tw-bizTinyBtn{min-height:36px!important;padding:7px 11px!important;font-size:12px!important;}',

    /* The four always-visible header utilities remain glass, including +. */
    '#toki-wheel-root .tw-headerUtility button.tw-btn,#toki-wheel-root .tw-headerUtility button.tw-btnGhost,#toki-wheel-root .tw-headerUtility button.tw-btnPremium{min-width:44px!important;min-height:44px!important;background:linear-gradient(180deg,rgba(255,248,238,.16),rgba(255,248,238,.08))!important;border-color:rgba(255,255,255,.24)!important;color:#fff8ee!important;-webkit-text-fill-color:#fff8ee!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.16),0 8px 18px rgba(15,10,25,.24)!important;backdrop-filter:blur(10px) saturate(1.08)!important;-webkit-backdrop-filter:blur(10px) saturate(1.08)!important;}',
    '#toki-wheel-root .tw-headerMoreMenu .tw-menuList>button.tw-btn{width:100%!important;min-height:44px!important;}',
    '#toki-wheel-root .tw-headerMoreMenu .tw-menuList>button.tw-btn:nth-child(1),#toki-wheel-root .tw-headerMoreMenu .tw-menuList>button.tw-btn:nth-child(2){background:linear-gradient(180deg,#5BC0EB,#43afd8)!important;color:#1f1f1f!important;-webkit-text-fill-color:#1f1f1f!important;}',
    '#toki-wheel-root .tw-headerMoreMenu .tw-menuList>button.tw-btn:nth-child(4){background:linear-gradient(180deg,#7BC96F,#66b85c)!important;color:#1f1f1f!important;-webkit-text-fill-color:#1f1f1f!important;}',
    '#toki-wheel-root .tw-headerMoreMenu .tw-menuList>button.tw-btn.tw-eliminateToggle.isOn[aria-pressed="true"]{background:linear-gradient(180deg,#fff 0%,#dffcff 100%)!important;border-color:#22d3ee!important;color:#111827!important;-webkit-text-fill-color:#111827!important;box-shadow:0 0 0 2px #fff,0 0 0 6px rgba(34,211,238,.42),0 0 24px rgba(34,211,238,.72),inset 0 1px 0 #fff!important;transform:translateY(-1px)!important;}',

    /* Both Lab Pack pills are purple with cream-white text, regardless of old gradient-text rules. */
    '#toki-wheel-root .tw-labPackChoiceKicker,#toki-wheel-root .tw-labPackChoicePlan,#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo) .tw-quickStickerPromoKicker{display:inline-flex!important;align-items:center!important;width:max-content!important;min-height:27px!important;padding:0 12px!important;border:1px solid rgba(64,18,104,.22)!important;border-radius:999px!important;background:#7044bd!important;background-color:#7044bd!important;background-image:none!important;color:#fff8ee!important;-webkit-text-fill-color:#fff8ee!important;-webkit-background-clip:border-box!important;background-clip:border-box!important;text-shadow:none!important;opacity:1!important;font-size:11px!important;line-height:1!important;font-weight:950!important;letter-spacing:.12em!important;}',
    '#toki-wheel-root .tw-labPackChoiceKicker *,#toki-wheel-root .tw-labPackChoicePlan *,#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo) .tw-quickStickerPromoKicker *{color:#fff8ee!important;-webkit-text-fill-color:#fff8ee!important;}',

    /* Explicit grid areas make Wheel Left and Wheel Right unambiguous. */
    '#toki-wheel-root .tw-inOverlay.tw-overlayLayout-left .tw-main{grid-template-columns:minmax(0,1fr) minmax(300px,360px)!important;grid-template-areas:"wheel vault"!important;}',
    '#toki-wheel-root .tw-inOverlay.tw-overlayLayout-right .tw-main{grid-template-columns:minmax(300px,360px) minmax(0,1fr)!important;grid-template-areas:"vault wheel"!important;}',
    '#toki-wheel-root .tw-inOverlay.tw-overlayLayout-left .tw-wheelCard,#toki-wheel-root .tw-inOverlay.tw-overlayLayout-right .tw-wheelCard{grid-area:wheel!important;order:initial!important;}',
    '#toki-wheel-root .tw-inOverlay.tw-overlayLayout-left .tw-vaultRebuilt,#toki-wheel-root .tw-inOverlay.tw-overlayLayout-right .tw-vaultRebuilt{grid-area:vault!important;order:initial!important;}',
    '#toki-wheel-root .tw-inOverlay.tw-overlayLayout-center .tw-main{grid-template-areas:"wheel" "vault"!important;}',
    '#toki-wheel-root .tw-inOverlay.tw-overlayLayout-center .tw-wheelCard{grid-area:wheel!important;}',
    '#toki-wheel-root .tw-inOverlay.tw-overlayLayout-center .tw-vaultRebuilt{grid-area:vault!important;}',

    /* Winner positioning moves the fixed winner modal itself, not its backdrop. */
    'body.twOverlayBody.twWinnerPos-center #toki-wheel-root .tw-modal.tw-winnerModalActive{left:50%!important;top:50%!important;right:auto!important;transform:translate(-50%,-50%)!important;}',
    'body.twOverlayBody.twWinnerPos-left #toki-wheel-root .tw-modal.tw-winnerModalActive{left:clamp(180px,25vw,420px)!important;top:50%!important;right:auto!important;transform:translate(-50%,-50%)!important;}',
    'body.twOverlayBody.twWinnerPos-right #toki-wheel-root .tw-modal.tw-winnerModalActive{left:auto!important;right:clamp(14px,5vw,72px)!important;top:50%!important;transform:translateY(-50%)!important;}',
    'body.twOverlayBody.twWinnerPos-top #toki-wheel-root .tw-modal.tw-winnerModalActive{left:50%!important;right:auto!important;top:clamp(18px,6vh,70px)!important;transform:translateX(-50%)!important;}',
    '@media(max-width:980px){#toki-wheel-root .tw-inOverlay.tw-overlayLayout-left .tw-main,#toki-wheel-root .tw-inOverlay.tw-overlayLayout-right .tw-main,#toki-wheel-root .tw-inOverlay.tw-overlayLayout-center .tw-main{grid-template-columns:1fr!important;grid-template-areas:"wheel" "vault"!important;}body.twOverlayBody #toki-wheel-root .tw-modal.tw-winnerModalActive{left:50%!important;right:auto!important;max-width:calc(100vw - 28px)!important;}body.twOverlayBody.twWinnerPos-left #toki-wheel-root .tw-modal.tw-winnerModalActive,body.twOverlayBody.twWinnerPos-right #toki-wheel-root .tw-modal.tw-winnerModalActive{top:50%!important;transform:translate(-50%,-50%)!important;}body.twOverlayBody.twWinnerPos-top #toki-wheel-root .tw-modal.tw-winnerModalActive{top:18px!important;transform:translateX(-50%)!important;}}'
  ].join('');
  document.head.appendChild(style);
})();

/* Must remain last: centered winners, compact overlay, reliable idle pulse, Lab Pack repair. */
(function installFinalInteractionRepair0730D(){
  if(window.__twFinalInteractionRepair0730D) return;
  window.__twFinalInteractionRepair0730D = true;
  var style = document.createElement('style');
  style.id = 'tw-final-interaction-repair-0730d';
  style.textContent = [
    /* Restore the compact three-button proportions. */
    '#toki-wheel-root .tw-controls button.tw-btn,#toki-wheel-root .tw-controls button.tw-bigBtn,#toki-wheel-root #twSpin,#toki-wheel-root #twMulti,#toki-wheel-root #twUndo{min-height:48px!important;height:48px!important;padding:9px 13px!important;font-size:15px!important;}',
    '#toki-wheel-root #twSpin{font-size:16px!important;}',
    '@media(max-width:700px){#toki-wheel-root .tw-controls button.tw-btn,#toki-wheel-root .tw-controls button.tw-bigBtn,#toki-wheel-root #twSpin,#toki-wheel-root #twMulti,#toki-wheel-root #twUndo{min-height:44px!important;height:44px!important;padding:8px 11px!important;font-size:14px!important;}}',

    /* Inventor Clear is neutral; Surprise Me is deliberately playful pink. */
    '#toki-wheel-root #twVortexAI button.tw-btnDanger{background:linear-gradient(180deg,#fffdf8,#eee4f5)!important;border-color:rgba(64,18,104,.20)!important;color:#401268!important;-webkit-text-fill-color:#401268!important;box-shadow:inset 0 1px 0 #fff,0 7px 16px rgba(64,18,104,.12)!important;}',
    '#toki-wheel-root #twVortexAI button.tw-btnSurprise{background:linear-gradient(135deg,#ef4ba6,#cc007e)!important;border-color:#a80068!important;color:#fff8ee!important;-webkit-text-fill-color:#fff8ee!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.32),0 9px 20px rgba(204,0,126,.23)!important;}',

    /* One cross-device button-body pulse. Old pulse/halo definitions remain neutralized. */
    '@keyframes twReliableIdlePulse0730D{0%,100%{transform:scale(1);filter:brightness(1);box-shadow:inset 0 1px 0 rgba(255,255,255,.48),0 8px 18px rgba(67,175,216,.20);}50%{transform:scale(1.035);filter:brightness(1.055);box-shadow:inset 0 1px 0 rgba(255,255,255,.58),0 11px 25px rgba(67,175,216,.38);}}',
    '#toki-wheel-root button#twSpin.tw-spinIdlePulse:not(:disabled){animation:twReliableIdlePulse0730D 2.65s ease-in-out infinite!important;-webkit-animation:twReliableIdlePulse0730D 2.65s ease-in-out infinite!important;transform-origin:center!important;will-change:transform,filter,box-shadow!important;}',
    '#toki-wheel-root button#twSpin:not(.tw-spinIdlePulse),#toki-wheel-root .tw-spinning~.tw-controls button#twSpin{animation:none!important;-webkit-animation:none!important;transform:none!important;}',
    '@media(prefers-reduced-motion:reduce){#toki-wheel-root button#twSpin.tw-spinIdlePulse:not(:disabled){animation:twReliableIdlePulse0730D 4s ease-in-out infinite!important;-webkit-animation:twReliableIdlePulse0730D 4s ease-in-out infinite!important;}}',

    /* Subtle offset Vortex constellation texture across both Lab Pack placements. */
    '#toki-wheel-root .tw-labPackChoicePanel,#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo){background-color:#fff8ee!important;background-image:radial-gradient(circle,rgba(64,18,104,.105) 0 1.25px,transparent 1.6px),radial-gradient(circle,rgba(204,0,126,.075) 0 1px,transparent 1.4px),radial-gradient(circle,rgba(91,192,235,.08) 0 1.7px,transparent 2.1px),radial-gradient(circle at 100% 0%,rgba(204,0,126,.12),transparent 36%),radial-gradient(circle at 0 100%,rgba(64,18,104,.09),transparent 38%)!important;background-size:34px 38px,73px 67px,131px 113px,auto,auto!important;background-position:4px 7px,18px 23px,47px 31px,0 0,0 0!important;background-repeat:repeat,repeat,repeat,no-repeat,no-repeat!important;}',

    /* Belt-and-suspenders pill styling; JS below also sets these as inline-important. */
    '#toki-wheel-root .tw-labPackChoiceKicker,#toki-wheel-root .tw-labPackChoicePlan,#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo) .tw-quickStickerPromoKicker{background:#7044bd!important;background-image:none!important;color:#fff8ee!important;-webkit-text-fill-color:#fff8ee!important;text-shadow:none!important;}',

    /* Tablet and phone overlays are automatically centered and intentionally tool-free. */
    '@media(max-width:1024px){#toki-wheel-root .tw-inOverlay .tw-main{grid-template-columns:1fr!important;grid-template-areas:"wheel" "vault"!important;}#toki-wheel-root .tw-inOverlay .tw-wheelCard{grid-area:wheel!important;width:100%!important;margin-inline:auto!important;}#toki-wheel-root .tw-inOverlay .tw-vaultRebuilt{grid-area:vault!important;width:100%!important;max-width:none!important;}#toki-wheel-root .tw-presentationDock{display:none!important;}}'
  ].join('');
  document.head.appendChild(style);

  function forceLabPackPills(){
    var root = document.getElementById('toki-wheel-root');
    if(!root) return;
    root.querySelectorAll('.tw-labPackChoiceKicker,.tw-labPackChoicePlan,#twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo) .tw-quickStickerPromoKicker').forEach(function(el){
      el.style.setProperty('background', '#7044bd', 'important');
      el.style.setProperty('background-image', 'none', 'important');
      el.style.setProperty('color', '#fff8ee', 'important');
      el.style.setProperty('-webkit-text-fill-color', '#fff8ee', 'important');
      el.style.setProperty('text-shadow', 'none', 'important');
    });
  }
  forceLabPackPills();
  var root = document.getElementById('toki-wheel-root');
  if(root && window.MutationObserver){
    var queued = false;
    new MutationObserver(function(){
      if(queued) return;
      queued = true;
      requestAnimationFrame(function(){ queued = false; forceLabPackPills(); });
    }).observe(root,{childList:true,subtree:true});
  }
})();

/* Must remain last: no-flash/header/Apple/select/sample final corrections. */
(function installFinalParityRepair0730E(){
  if(window.__twFinalParityRepair0730E) return;
  window.__twFinalParityRepair0730E = true;
  var style = document.createElement('style');
  style.id = 'tw-final-parity-repair-0730e';
  style.textContent = [
    /* Restore the original compact utility row and one typography baseline. */
    '#toki-wheel-root .tw-headerUtility .tw-actionsCompact button.tw-btn,#toki-wheel-root .tw-headerUtility .tw-actionsCompact button.tw-btnHeaderMini{box-sizing:border-box!important;width:100%!important;height:44px!important;min-height:44px!important;max-height:44px!important;padding:0 12px!important;font-size:14px!important;line-height:1!important;font-weight:900!important;letter-spacing:.1px!important;}',
    '#toki-wheel-root .tw-headerUtility .tw-actionsCompact button.tw-btn>span,#toki-wheel-root .tw-headerUtility .tw-actionsCompact button.tw-btnHeaderMini>span{font:inherit!important;font-size:inherit!important;line-height:1!important;}',
    '#toki-wheel-root .tw-headerUtility .tw-soundToggle.isOn,#toki-wheel-root .tw-headerUtility .tw-voiceToggle.isOn,#toki-wheel-root .tw-headerUtility .tw-soundToggle.isOn>span,#toki-wheel-root .tw-headerUtility .tw-voiceToggle.isOn>span{color:#1f1f1f!important;-webkit-text-fill-color:#1f1f1f!important;text-shadow:none!important;}',
    '@media(max-width:640px){#toki-wheel-root .tw-headerUtility .tw-actionsCompact button.tw-btn,#toki-wheel-root .tw-headerUtility .tw-actionsCompact button.tw-btnHeaderMini{height:40px!important;min-height:40px!important;max-height:40px!important;padding:0 10px!important;font-size:12px!important;}}',

    /* The panel owns the grid; sample tiles own an opaque clean surface. */
    '#toki-wheel-root .tw-quickStickerPromoSamples,#toki-wheel-root .tw-labPackChoiceSamples{background:#fff8ee!important;background-image:none!important;border-radius:12px!important;}',
    '#toki-wheel-root .tw-quickStickerPromoSamples img,#toki-wheel-root .tw-labPackChoiceSamples img{background:#fff8ee!important;background-image:none!important;border-radius:9px!important;}',

    /* Every native and enhanced dropdown reads from the left. */
    '#toki-wheel-root select.tw-select,#toki-wheel-root .tw-select,#toki-wheel-root .tw-modal select,#toki-wheel-root .tw-popover select{text-align:left!important;text-align-last:left!important;}',
    '#toki-wheel-root button.tw-selectMenu,#toki-wheel-root .tw-selectMenu{justify-content:flex-start!important;text-align:left!important;}',
    '#toki-wheel-root .tw-selectMenuLabel{display:block!important;flex:1 1 auto!important;text-align:left!important;}',
    '#toki-wheel-root .tw-selectMenuCaret{margin-left:auto!important;margin-right:0!important;}',
    '#toki-wheel-root .tw-selectOptions,#toki-wheel-root .tw-selectOption,#toki-wheel-root [role="option"]{text-align:left!important;justify-content:flex-start!important;}',

    /* Inventor clear is intentionally orange; its preview CTA exactly matches Creator Lab. */
    '#toki-wheel-root #twVortexAI button.tw-btnDanger{background:linear-gradient(180deg,#E86A2E,#d15f25)!important;border-color:rgba(157,65,23,.32)!important;color:#1f1f1f!important;-webkit-text-fill-color:#1f1f1f!important;}',
    '#toki-wheel-root #twVortexAI .tw-aiPremiumNotice .tw-aiPreviewCta.tw-btnPrimary,#toki-wheel-root #twSpinExperience .tw-creativeLabLockNotice.tw-aiPremiumNotice .tw-aiPreviewCta.tw-btnPrimary{box-sizing:border-box!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;width:auto!important;min-width:210px!important;max-width:100%!important;height:46px!important;min-height:46px!important;max-height:46px!important;margin:3px auto 0!important;padding:0 22px!important;border-radius:999px!important;background:linear-gradient(105deg,#ff3f9d 0%,#a05cff 52%,#20c9dc 100%)!important;border:1px solid rgba(255,255,255,.28)!important;color:#fff!important;-webkit-text-fill-color:#fff!important;font-size:14px!important;line-height:1!important;font-weight:950!important;white-space:nowrap!important;box-shadow:0 14px 34px rgba(145,72,225,.35),inset 0 1px 0 rgba(255,255,255,.30)!important;}',

    /* iPhone/iPad overlay must expose a scrollable vault below the centered wheel. */
    '@media(max-width:1024px){#toki-wheel-root .tw-wrap.tw-inOverlay{overflow:hidden!important;}#toki-wheel-root .tw-inOverlay .tw-main{display:grid!important;max-height:calc(100dvh - env(safe-area-inset-top,0px) - env(safe-area-inset-bottom,0px))!important;height:auto!important;overflow-x:hidden!important;overflow-y:auto!important;-webkit-overflow-scrolling:touch!important;align-content:start!important;padding-bottom:calc(28px + env(safe-area-inset-bottom,0px))!important;}#toki-wheel-root .tw-inOverlay .tw-vaultRebuilt,#toki-wheel-root .tw-inOverlay .tw-vaultRebuilt.tw-accord{display:block!important;visibility:visible!important;opacity:1!important;position:relative!important;z-index:5!important;grid-area:vault!important;width:100%!important;max-width:none!important;min-height:90px!important;height:auto!important;overflow:visible!important;}#toki-wheel-root .tw-inOverlay .tw-vaultRebuilt .tw-vaultHeader,#toki-wheel-root .tw-inOverlay .tw-vaultRebuilt .tw-vaultBody{display:flex!important;visibility:visible!important;opacity:1!important;}#toki-wheel-root .tw-inOverlay .tw-vaultRebuilt .tw-vaultBody{flex-direction:column!important;}}'
  ].join('');
  document.head.appendChild(style);

  /* Inline-important animation values bypass the legacy Apple transform/shadow rules. */
  var pulseStart = performance.now();
  function runReliableSpinPulse(now){
    var btn = document.getElementById('twSpin');
    if(btn){
      btn.style.setProperty('animation','none','important');
      btn.style.setProperty('-webkit-animation','none','important');
      if(btn.classList.contains('tw-spinIdlePulse') && !btn.disabled){
        var wave = (Math.sin((now - pulseStart) / 430) + 1) / 2;
        var scale = 1 + wave * 0.018;
        btn.style.setProperty('transform','scale(' + scale.toFixed(4) + ')','important');
        btn.style.setProperty('-webkit-transform','scale(' + scale.toFixed(4) + ')','important');
        btn.style.setProperty('filter','brightness(' + (1 + wave * 0.055).toFixed(3) + ')','important');
        btn.style.setProperty('box-shadow','inset 0 1px 0 rgba(255,255,255,.52),0 ' + (8 + wave * 4).toFixed(1) + 'px ' + (18 + wave * 9).toFixed(1) + 'px rgba(67,175,216,' + (0.20 + wave * 0.22).toFixed(3) + ')','important');
      }else{
        btn.style.setProperty('transform','none','important');
        btn.style.setProperty('-webkit-transform','none','important');
        btn.style.setProperty('filter','none','important');
        btn.style.removeProperty('box-shadow');
      }
    }
    requestAnimationFrame(runReliableSpinPulse);
  }
  requestAnimationFrame(runReliableSpinPulse);
})();

/* Must remain last: remove ad circles, align banners/CTAs, and prevent pulse clipping. */
(function installAdAndPulseFinish0730F(){
  if(window.__twAdAndPulseFinish0730F) return;
  window.__twAdAndPulseFinish0730F = true;
  var style = document.createElement('style');
  style.id = 'tw-ad-and-pulse-finish-0730f';
  style.textContent = [
    /* Remove every decorative circular ornament from advertising surfaces/cards. */
    '#toki-wheel-root .tw-quickStickerPromo::before,#toki-wheel-root .tw-quickStickerPromo::after,#toki-wheel-root .tw-labPackChoicePanel::before,#toki-wheel-root .tw-labPackChoicePanel::after,#toki-wheel-root .tw-subscriptionChoicePanel::before,#toki-wheel-root .tw-subscriptionChoicePanel::after,#toki-wheel-root .tw-labPackChoiceCard::before,#toki-wheel-root .tw-subscriptionChoiceCard::before{content:none!important;display:none!important;background:none!important;box-shadow:none!important;}',

    /* Horizontal Lab Pack art sits at the true vertical midpoint of the sticker/copy column. */
    '#toki-wheel-root .tw-quickStickerPromoInner{align-items:center!important;}',
    '#toki-wheel-root .tw-quickStickerPromoMedia{align-self:center!important;height:auto!important;min-height:0!important;margin-top:auto!important;margin-bottom:auto!important;}',
    '#toki-wheel-root .tw-quickStickerPromoCopy{align-self:center!important;}',
    '#toki-wheel-root .tw-labPackChoiceMedia{align-self:center!important;}',

    /* Lab Pack and subscription CTAs share one exact geometry. */
    '#toki-wheel-root .tw-quickStickerPromoBtn,#toki-wheel-root .tw-quickStickerPromoAll,#toki-wheel-root .tw-labPackChoiceBtn,#toki-wheel-root .tw-labPackChoiceAll,#toki-wheel-root .tw-subscriptionChoiceBtn{box-sizing:border-box!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;width:min(100%,160px)!important;min-width:0!important;max-width:160px!important;height:42px!important;min-height:42px!important;max-height:42px!important;margin-top:16px!important;padding:0 14px!important;border-radius:999px!important;font-size:12px!important;line-height:1!important;font-weight:950!important;text-align:center!important;white-space:normal!important;}',
    '#toki-wheel-root .tw-quickStickerPromoActions{align-items:center!important;}',

    /* Let the physical Spin pulse breathe without exposing a clipped rectangle on WebKit. */
    '#toki-wheel-root .tw-wheelCard,#toki-wheel-root .tw-controls{overflow:visible!important;clip-path:none!important;-webkit-clip-path:none!important;}',
    '#toki-wheel-root .tw-controls{padding-left:7px!important;padding-right:7px!important;}',
    '#toki-wheel-root #twSpin{isolation:isolate!important;border-radius:999px!important;background-clip:padding-box!important;-webkit-background-clip:padding-box!important;}',
    '@media(max-width:760px){#toki-wheel-root .tw-quickStickerPromoBtn,#toki-wheel-root .tw-quickStickerPromoAll,#toki-wheel-root .tw-labPackChoiceBtn,#toki-wheel-root .tw-labPackChoiceAll,#toki-wheel-root .tw-subscriptionChoiceBtn{width:min(100%,160px)!important;max-width:160px!important;height:42px!important;min-height:42px!important;max-height:42px!important;flex:0 1 160px!important;}}'
  ].join('');
  document.head.appendChild(style);
})();

/* Must remain last: exact ad CTA geometry and shared grid rhythm. */
(function installAdGeometryFinish0730G(){
  if(window.__twAdGeometryFinish0730G) return;
  window.__twAdGeometryFinish0730G = true;
  var style = document.createElement('style');
  style.id = 'tw-ad-geometry-finish-0730g';
  style.textContent = [
    /* One quiet constellation scale across Quick Lab Packs, lower Lab Packs, and subscriptions. */
    '#toki-wheel-root .tw-quickStickerPromo,#toki-wheel-root .tw-labPackChoicePanel,#toki-wheel-root .tw-subscriptionChoicePanel{background-color:#fff8ee!important;background-image:radial-gradient(circle,rgba(64,18,104,.105) 0 1.25px,transparent 1.6px),radial-gradient(circle,rgba(204,0,126,.075) 0 1px,transparent 1.4px),radial-gradient(circle,rgba(91,192,235,.08) 0 1.7px,transparent 2.1px),radial-gradient(circle at 100% 0%,rgba(204,0,126,.12),transparent 36%),radial-gradient(circle at 0 100%,rgba(64,18,104,.09),transparent 38%)!important;background-size:34px 38px,73px 67px,131px 113px,auto,auto!important;background-position:4px 7px,18px 23px,47px 31px,0 0,0 0!important;background-repeat:repeat,repeat,repeat,no-repeat,no-repeat!important;}',

    /* Every ad CTA is exactly the same size on roomy screens. */
    '#toki-wheel-root .tw-quickStickerPromoBtn,#toki-wheel-root .tw-quickStickerPromoAll,#toki-wheel-root .tw-labPackChoiceBtn,#toki-wheel-root .tw-labPackChoiceAll,#toki-wheel-root .tw-subscriptionChoiceBtn{box-sizing:border-box!important;flex:0 0 160px!important;width:160px!important;min-width:160px!important;max-width:160px!important;height:42px!important;min-height:42px!important;max-height:42px!important;padding:0 14px!important;margin-top:16px!important;font-size:12px!important;line-height:1!important;}',

    /* Optical centering: the wide Lab Pack banner read slightly high beside 12 tiles. */
    '@media(min-width:761px){#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo) .tw-quickStickerPromoMedia{transform:translateY(12px)!important;}}',
    '@media(max-width:760px){#toki-wheel-root .tw-quickStickerPromoBtn,#toki-wheel-root .tw-quickStickerPromoAll,#toki-wheel-root .tw-labPackChoiceBtn,#toki-wheel-root .tw-labPackChoiceAll,#toki-wheel-root .tw-subscriptionChoiceBtn{flex:1 1 140px!important;width:auto!important;min-width:0!important;max-width:160px!important;height:42px!important;min-height:42px!important;max-height:42px!important;}#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo) .tw-quickStickerPromoMedia{transform:none!important;}}'
  ].join('');
  document.head.appendChild(style);
})();

/* Must remain last: Quick Tweaks Lab Pack must match the full-size ad system. */
(function installQuickLabExactParity0730H(){
  if(window.__twQuickLabExactParity0730H) return;
  window.__twQuickLabExactParity0730H = true;
  var style = document.createElement('style');
  style.id = 'tw-quick-lab-exact-parity-0730h';
  style.textContent = [
    '#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo){box-sizing:border-box!important;width:100%!important;max-width:none!important;padding:clamp(18px,3vw,26px)!important;border-radius:26px!important;background-color:#fff8ee!important;background-image:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'280\' height=\'190\' viewBox=\'0 0 280 190\'%3E%3Cg fill=\'none\'%3E%3Ccircle cx=\'14\' cy=\'21\' r=\'2.2\' fill=\'%236a38b8\' opacity=\'.34\'/%3E%3Ccircle cx=\'47\' cy=\'73\' r=\'1.3\' fill=\'%23cc007e\' opacity=\'.34\'/%3E%3Ccircle cx=\'92\' cy=\'35\' r=\'1.7\' fill=\'%235bc0eb\' opacity=\'.38\'/%3E%3Ccircle cx=\'133\' cy=\'112\' r=\'2.6\' fill=\'%23cc007e\' opacity=\'.25\'/%3E%3Ccircle cx=\'171\' cy=\'57\' r=\'1.2\' fill=\'%236a38b8\' opacity=\'.38\'/%3E%3Ccircle cx=\'224\' cy=\'26\' r=\'2\' fill=\'%235bc0eb\' opacity=\'.32\'/%3E%3Ccircle cx=\'263\' cy=\'91\' r=\'1.5\' fill=\'%23cc007e\' opacity=\'.36\'/%3E%3Ccircle cx=\'28\' cy=\'151\' r=\'1.1\' fill=\'%235bc0eb\' opacity=\'.4\'/%3E%3Ccircle cx=\'79\' cy=\'172\' r=\'2.3\' fill=\'%236a38b8\' opacity=\'.27\'/%3E%3Ccircle cx=\'188\' cy=\'158\' r=\'1.8\' fill=\'%23cc007e\' opacity=\'.3\'/%3E%3Ccircle cx=\'244\' cy=\'174\' r=\'2.5\' fill=\'%236a38b8\' opacity=\'.24\'/%3E%3C/g%3E%3C/svg%3E"),radial-gradient(circle at 100% 0%,rgba(204,0,126,.12),transparent 36%),radial-gradient(circle at 0 100%,rgba(64,18,104,.09),transparent 38%)!important;background-size:280px 190px,auto,auto!important;background-position:0 0,0 0,0 0!important;background-repeat:repeat,no-repeat,no-repeat!important;zoom:1!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo) .tw-quickStickerPromoInner{width:100%!important;max-width:none!important;grid-template-columns:minmax(180px,38%) minmax(0,1fr)!important;align-items:center!important;transform:none!important;zoom:1!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo) .tw-quickStickerPromoActions{display:flex!important;align-items:center!important;justify-content:flex-start!important;gap:10px!important;flex-wrap:wrap!important;width:100%!important;}',
    '#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo) .tw-quickStickerPromoBtn,#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo) .tw-quickStickerPromoAll{box-sizing:border-box!important;flex:0 0 160px!important;width:160px!important;min-width:160px!important;max-width:160px!important;height:42px!important;min-height:42px!important;max-height:42px!important;padding:0 14px!important;margin-top:16px!important;border-radius:999px!important;font-size:12px!important;line-height:1!important;font-weight:950!important;transform:none!important;}',
    '@media(max-width:760px){#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo){padding:16px!important;border-radius:22px!important;}#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo) .tw-quickStickerPromoInner{grid-template-columns:1fr!important;}#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo) .tw-quickStickerPromoBtn,#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo) .tw-quickStickerPromoAll{flex:1 1 160px!important;width:160px!important;min-width:140px!important;max-width:160px!important;height:42px!important;min-height:42px!important;max-height:42px!important;}}'
  ].join('');
  document.head.appendChild(style);
})();

/* Must remain last: final Lab Pack CTA color and Choose Your Lab glow parity. */
(function installFinalAdColorParity0730I(){
  if(window.__twFinalAdColorParity0730I) return;
  window.__twFinalAdColorParity0730I = true;
  var style = document.createElement('style');
  style.id = 'tw-final-ad-color-parity-0730i';
  style.textContent = [
    /* Quick Tweaks uses the exact same pink CTA treatment as lower Lab Packs. */
    '#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo) .tw-quickStickerPromoBtn,#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo) .tw-quickStickerPromoAll,#toki-wheel-root .tw-labPackChoiceBtn,#toki-wheel-root .tw-labPackChoiceAll{background:linear-gradient(135deg,#cc007e,#a80068)!important;border:1px solid rgba(126,0,77,.24)!important;color:#fff8ee!important;-webkit-text-fill-color:#fff8ee!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.32),0 8px 19px rgba(204,0,126,.20)!important;}',

    /* Choose Your Lab glows blue in both Quick Tweaks and below the wheel. */
    '#toki-wheel-root .tw-subscriptionChoicePanel,#toki-wheel-root #twOptions .tw-quickSubscriptionPromo.tw-subscriptionChoicePanel{border-top-color:#173f75!important;box-shadow:0 19px 44px rgba(30,41,72,.15),0 0 44px rgba(35,91,159,.34),inset 0 1px 0 #fff!important;}',

    /* One repeatable Vortex constellation surface across all Lab/plan ad panels. */
    '#toki-wheel-root #twOptions .tw-quickStickerPromo,#toki-wheel-root .tw-labPackChoicePanel,#toki-wheel-root .tw-subscriptionChoicePanel,#toki-wheel-root .tw-stickerDrops,#toki-wheel-root .tw-subscriptionDrops{background-color:#fff8ee!important;background-image:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'280\' height=\'190\' viewBox=\'0 0 280 190\'%3E%3Cg fill=\'none\'%3E%3Ccircle cx=\'14\' cy=\'21\' r=\'2.2\' fill=\'%236a38b8\' opacity=\'.34\'/%3E%3Ccircle cx=\'47\' cy=\'73\' r=\'1.3\' fill=\'%23cc007e\' opacity=\'.34\'/%3E%3Ccircle cx=\'92\' cy=\'35\' r=\'1.7\' fill=\'%235bc0eb\' opacity=\'.38\'/%3E%3Ccircle cx=\'133\' cy=\'112\' r=\'2.6\' fill=\'%23cc007e\' opacity=\'.25\'/%3E%3Ccircle cx=\'171\' cy=\'57\' r=\'1.2\' fill=\'%236a38b8\' opacity=\'.38\'/%3E%3Ccircle cx=\'224\' cy=\'26\' r=\'2\' fill=\'%235bc0eb\' opacity=\'.32\'/%3E%3Ccircle cx=\'263\' cy=\'91\' r=\'1.5\' fill=\'%23cc007e\' opacity=\'.36\'/%3E%3Ccircle cx=\'28\' cy=\'151\' r=\'1.1\' fill=\'%235bc0eb\' opacity=\'.4\'/%3E%3Ccircle cx=\'79\' cy=\'172\' r=\'2.3\' fill=\'%236a38b8\' opacity=\'.27\'/%3E%3Ccircle cx=\'188\' cy=\'158\' r=\'1.8\' fill=\'%23cc007e\' opacity=\'.3\'/%3E%3Ccircle cx=\'244\' cy=\'174\' r=\'2.5\' fill=\'%236a38b8\' opacity=\'.24\'/%3E%3C/g%3E%3C/svg%3E"),radial-gradient(circle at 100% 0%,rgba(204,0,126,.12),transparent 36%),radial-gradient(circle at 0 100%,rgba(64,18,104,.09),transparent 38%)!important;background-size:280px 190px,auto,auto!important;background-position:0 0,0 0,0 0!important;background-repeat:repeat,no-repeat,no-repeat!important;background-attachment:scroll!important;}',

    /* Tighter stacked CTA rhythm on phones. */
    '@media(max-width:760px){#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo) .tw-quickStickerPromoActions{column-gap:8px!important;row-gap:5px!important;margin-top:10px!important;}#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo) .tw-quickStickerPromoBtn,#toki-wheel-root #twOptions .tw-quickStickerPromo:not(.tw-quickSubscriptionPromo) .tw-quickStickerPromoAll{margin-top:0!important;}}'
  ].join('');
  document.head.appendChild(style);
})();

/* Absolute final guard for the 2026-08-05 menu and presentation repair. */
(function installPresentationParityFinal0805(){
  if(window.__twPresentationParityFinal0805) return;
  window.__twPresentationParityFinal0805 = true;
  var prior = document.getElementById('tw-presentation-parity-repair-0805');
  if(!prior) return;
  var style = document.createElement('style');
  style.id = 'tw-presentation-parity-final-0805';
  style.textContent = prior.textContent;
  document.head.appendChild(style);

})();

/* Absolute final cascade guard for the 2026-08-10 lab and Apple tablet repair. */
(function installLabAndAppleCascadeFinal0810(){
  var prior = document.getElementById('tw-lab-and-apple-finish-0810');
  if(!prior) return;
  var style = document.createElement('style');
  style.id = 'tw-lab-and-apple-cascade-final-0810';
  style.textContent = prior.textContent;
  document.head.appendChild(style);
})();

/* First-visit invitation motion. It intentionally lives outside the spin
   runtime, stops forever on the first Spin press, and never changes spin state,
   winner selection, duration, or saved wheel rotation. */
(function installPreSpinInvitation0813(){
  if(window.__twPreSpinInvitation0813) return;
  window.__twPreSpinInvitation0813 = true;

  var TW = window.TokiWheel;
  if(!TW) return;

  var invitation = TW._preSpinInvitation = TW._preSpinInvitation || {
    stopped:false, timer:0, animation:null, sliceAnimation:null, step:0
  };

  function reducedMotion(){
    try{ return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    catch(_){ return false; }
  }

  function clearAnimation(){
    if(invitation.timer){ clearTimeout(invitation.timer); invitation.timer = 0; }
    try{ if(invitation.animation) invitation.animation.cancel(); }catch(_){}
    try{ if(invitation.sliceAnimation) invitation.sliceAnimation.cancel(); }catch(_){}
    invitation.animation = null;
    invitation.sliceAnimation = null;
    var R = TW.refs || {};
    try{
      if(R.wheelSvg){
        R.wheelSvg.style.removeProperty('will-change');
        R.wheelSvg.style.removeProperty('transform');
        R.wheelSvg.style.removeProperty('-webkit-transform');
      }
      (R._sliceNodes || []).forEach(function(node){
        node.style.removeProperty('will-change');
        node.style.removeProperty('transform-box');
        node.style.removeProperty('transform-origin');
      });
    }catch(_){}
  }

  function stopInvitation(){
    if(invitation.stopped) return;
    invitation.stopped = true;
    clearAnimation();
  }
  TW.stopPreSpinInvitation = stopInvitation;

  function canInvite(){
    var R = TW.refs || {};
    return !invitation.stopped && !reducedMotion() && !document.hidden &&
      R.wheelSvg && R.wheelWrap && R.btnSpin && !R.btnSpin.disabled &&
      !(TW._rt && TW._rt.spinning) &&
      !(R.modalBack && !R.modalBack.hidden);
  }

  function schedule(delay){
    if(invitation.stopped) return;
    if(invitation.timer) clearTimeout(invitation.timer);
    invitation.timer = setTimeout(playNext, delay == null ? 3900 : delay);
  }

  function animateWheel(keyframes, duration){
    var svg = TW.refs && TW.refs.wheelSvg;
    if(!svg || typeof svg.animate !== 'function') return false;
    svg.style.willChange = 'transform';
    invitation.animation = svg.animate(keyframes, {
      duration:duration, easing:'cubic-bezier(.22,.72,.24,1)', fill:'none'
    });
    invitation.animation.onfinish = function(){
      invitation.animation = null;
      svg.style.removeProperty('will-change');
    };
    return true;
  }

  function popSlice(){
    var R = TW.refs || {};
    var nodes = R._sliceNodes || [];
    var vecs = R._sliceVecs || [];
    if(!nodes.length) return false;
    var index = invitation.step % nodes.length;
    var node = nodes[index];
    var vec = vecs[index] || {x:0,y:-1};
    if(!node || typeof node.animate !== 'function') return false;
    node.style.transformBox = 'fill-box';
    node.style.transformOrigin = 'center';
    node.style.willChange = 'transform';
    var outX = (vec.x * 13).toFixed(2);
    var outY = (vec.y * 13).toFixed(2);
    invitation.sliceAnimation = node.animate([
      {transform:'translate(0px,0px) scale(1)'},
      {transform:'translate('+outX+'px,'+outY+'px) scale(1.018)',offset:.38},
      {transform:'translate('+(-vec.x*2.2).toFixed(2)+'px,'+(-vec.y*2.2).toFixed(2)+'px) scale(.997)',offset:.76},
      {transform:'translate(0px,0px) scale(1)'}
    ], {duration:1050,easing:'cubic-bezier(.2,.82,.2,1)',fill:'none'});
    invitation.sliceAnimation.onfinish = function(){
      invitation.sliceAnimation = null;
      node.style.removeProperty('will-change');
    };
    return true;
  }

  function playNext(){
    invitation.timer = 0;
    if(!canInvite()){ schedule(1800); return; }
    clearAnimation();
    var movement = invitation.step++ % 3;
    if(movement === 0){
      animateWheel([
        {transform:'translateZ(0) rotate(0deg)'},
        {transform:'translateZ(0) rotate(-3.2deg)',offset:.35},
        {transform:'translateZ(0) rotate(1.1deg)',offset:.72},
        {transform:'translateZ(0) rotate(0deg)'}
      ], 980);
    }else if(movement === 1){
      popSlice();
    }else{
      animateWheel([
        {transform:'translateZ(0) rotate(0deg)'},
        {transform:'translateZ(0) rotate(1.8deg)',offset:.18},
        {transform:'translateZ(0) rotate(-7deg)',offset:.48},
        {transform:'translateZ(0) rotate(.9deg)',offset:.82},
        {transform:'translateZ(0) rotate(0deg)'}
      ], 1250);
    }
    schedule(4300);
  }

  /* Capture both pointer and keyboard activation, including the homepage
     loader's cloned button. startSpin is also wrapped for programmatic entry. */
  document.addEventListener('pointerdown', function(event){
    if(event.target && event.target.closest && event.target.closest('#twSpin')) stopInvitation();
  }, true);
  document.addEventListener('click', function(event){
    if(event.target && event.target.closest && event.target.closest('#twSpin')) stopInvitation();
  }, true);
  var originalStartSpin = TW.startSpin;
  if(typeof originalStartSpin === 'function'){
    TW.startSpin = function(){
      stopInvitation();
      return originalStartSpin.apply(this, arguments);
    };
  }
  document.addEventListener('visibilitychange', function(){
    if(document.hidden) clearAnimation();
    else if(!invitation.stopped) schedule(900);
  });
  schedule(1400);
})();

/* One-time, action-verified customization discovery tour. */
(function installCustomizationTour0813(){
  if(window.__twCustomizationTour0813) return;
  window.__twCustomizationTour0813=true;
  var TW=window.TokiWheel;if(!TW)return;
  var T=TW.i18n&&TW.i18n.t?TW.i18n.t:function(value){return value;};
  var KEY='tokiCustomizationTourV1';
  var steps=[
    ['color','🎨',T('Change a segment color'),T('Open any segment’s Color picker and choose a new color.'),'quick'],
    ['sticker','✨',T('Add a sticker'),T('Choose a Sticker for any segment and apply it to the wheel.'),'quick'],
    ['countdown','⏱',T('Turn on a countdown'),T('In Spin Studio, set Countdown to Yes.'),'studio'],
    ['sound','♫',T('Choose a new sound'),T('Change either the Spin sound or Celebration sound.'),'studio'],
    ['voice','🎙',T('Personalize the winner voice'),T('Change the winner phrase, choose a voice, or record your own phrase.'),'studio'],
    ['spin','↻',T('Spin your creation'),T('Your custom wheel is ready for its first spin.'),'wheel']
  ];
  var tour={active:false,index:0,card:null,busy:false,base:null};
  function stored(){try{return localStorage.getItem(KEY)||'';}catch(_){return '';}}
  function remember(v){try{localStorage.setItem(KEY,v);}catch(_){}}
  function snap(){var s=TW.state||{},u=s.ui||{},a=s.segments||[];return{colors:a.map(function(x){return x&&x.color||'';}).join('|'),stickers:a.map(function(x){return x&&x.sliceImgUrl||'';}).join('|'),countdown:String(u.countdownOn||'no'),spin:String(u.spinSoundId||''),win:String(u.winSoundId||''),phrase:String(u.winnerPhrase||''),voice:String(u.voiceName||''),recording:String(u.recordedPhraseDataUrl||'')};}
  function scroll(node){if(!node)return;var visual=node._twMenuButton||node,ua=navigator.userAgent||'',apple=/iPad|iPhone|iPod/.test(ua)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1),vh=window.visualViewport?window.visualViewport.height:innerHeight,inside=visual.closest&&visual.closest('#twOptions,#twCustomize'),context=inside?(apple?Math.min(235,Math.max(165,vh*.24)):Math.min(170,Math.max(118,vh*.18))):118;if(!apple){setTimeout(function(){var rect=visual.getBoundingClientRect(),top=window.pageYOffset+rect.top-context;try{window.scrollTo({top:Math.max(0,top),behavior:'smooth'});}catch(_){window.scrollTo(0,Math.max(0,top));}},100);return;}function place(behavior){try{visual.scrollIntoView({behavior:behavior,block:'start',inline:'nearest'});}catch(_){visual.scrollIntoView(true);}setTimeout(function(){try{window.scrollBy({top:-context,left:0,behavior:'auto'});}catch(_){window.scrollBy(0,-context);}},55);}setTimeout(function(){place('smooth');},160);setTimeout(function(){place('auto');},700);}
  function targetForStep(){var R=TW.refs||{},id=steps[tour.index][0],buttons=document.querySelectorAll('#twOptions .tw-swatchBtn'),found=null,colorLabel=String(T('Color')).toLowerCase(),stickerLabel=String(T('Sticker')).toLowerCase();for(var i=0;i<buttons.length;i++){var label=String(buttons[i].textContent||'').toLowerCase();if(id==='color'&&(label.indexOf('color')>=0||label.indexOf(colorLabel)>=0)){found=buttons[i];break;}if(id==='sticker'&&(label.indexOf('sticker')>=0||label.indexOf(stickerLabel)>=0)){found=buttons[i];break;}}if(found)return found;if(id==='color'||id==='sticker')return R.optDetails;if(id==='countdown')return R.selCountdownOn;if(id==='sound')return R.selSpinSound||R.selWinSound;if(id==='voice')return R.inWinnerPhrase||R.selVoice;if(id==='spin')return R.wheelCard||document.querySelector('#toki-wheel-root .tw-wheelCard')||R.btnSpin;return null;}
  function spotlight(node){if(!node)return;var visual=(node._twMenuButton||node);visual.classList.add('tw-tourTarget');setTimeout(function(){visual.classList.remove('tw-tourTarget');},2200);}
  function showArea(area){var R=TW.refs||{},panel,target;if(area==='quick'){panel=R.optDetails||document.getElementById('twOptions');if(panel)panel.open=true;if(R.cusDetails)R.cusDetails.open=false;}else if(area==='studio'){panel=R.cusDetails||document.getElementById('twCustomize');if(panel)panel.open=true;if(R.optDetails)R.optDetails.open=false;}else panel=R.wheelWrap||document.getElementById('twWheelWrap');setTimeout(function(){target=targetForStep()||panel;scroll(target);spotlight(target);},120);}
  function render(){if(!tour.card)return;var s=steps[tour.index],list=tour.card.querySelector('.tw-tourList');tour.card.querySelector('.tw-tourProgress').textContent=T('Step')+' '+(tour.index+1)+' '+T('of')+' '+steps.length;tour.card.querySelector('.tw-tourHeroIcon').textContent=s[1];tour.card.querySelector('.tw-tourTitle').textContent=s[2];tour.card.querySelector('.tw-tourText').textContent=s[3];tour.card.querySelector('.tw-tourAction').textContent=s[0]==='spin'?T('Now let’s spin'):T('Take me to this control');list.innerHTML='';steps.forEach(function(x,i){var row=document.createElement('div');row.className='tw-tourStep '+(i<tour.index?'isDone':i===tour.index?'isCurrent':'');row.innerHTML='<span class="tw-tourStepIcon">'+(i<tour.index?'✓':x[1])+'</span><span>'+x[2]+'</span>';list.appendChild(row);});}
  function burst(){if(!tour.card)return;try{if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;}catch(_){}var b=document.createElement('div');b.className='tw-tourBurst';for(var i=0;i<12;i++){var bit=document.createElement('i');bit.style.setProperty('--i',i);b.appendChild(bit);}tour.card.appendChild(b);setTimeout(function(){b.remove();},850);}
  function next(){if(tour.busy||tour.index>=steps.length-1)return;tour.busy=true;burst();tour.card.classList.add('isCelebrating');setTimeout(function(){tour.index++;tour.base=snap();tour.card.classList.remove('isCelebrating');tour.busy=false;render();showArea(steps[tour.index][4]);},520);}
  function close(status){tour.active=false;remember(status||'dismissed');if(tour.card)tour.card.remove();tour.card=null;}
  TW.completeCustomizationTourFromSpin=function(){if(!tour.active||steps[tour.index][0]!=='spin')return false;try{localStorage.setItem('tokiCustomizationTourShareV1','pending');}catch(_){}close('completed');return true;};
  function makeDraggable(card,handle){if(!card||!handle)return;var drag=null;handle.addEventListener('pointerdown',function(e){if(e.button!=null&&e.button!==0)return;var r=card.getBoundingClientRect();drag={x:e.clientX,y:e.clientY,left:r.left,top:r.top};card.style.right='auto';card.style.bottom='auto';card.style.left=r.left+'px';card.style.top=r.top+'px';card.classList.add('isDragging');try{handle.setPointerCapture(e.pointerId);}catch(_){}e.preventDefault();});handle.addEventListener('pointermove',function(e){if(!drag)return;var margin=6,maxX=Math.max(margin,innerWidth-card.offsetWidth-margin),maxY=Math.max(margin,innerHeight-card.offsetHeight-margin),left=Math.max(margin,Math.min(maxX,drag.left+e.clientX-drag.x)),top=Math.max(margin,Math.min(maxY,drag.top+e.clientY-drag.y));card.style.left=left+'px';card.style.top=top+'px';});function end(){drag=null;card.classList.remove('isDragging');}handle.addEventListener('pointerup',end);handle.addEventListener('pointercancel',end);}
  function start(){if(stored()||tour.active)return;tour.active=true;tour.index=0;tour.base=snap();var c=document.createElement('section');c.className='tw-customTour';c.setAttribute('role','dialog');c.setAttribute('aria-label','Wheel customization tour');c.innerHTML='<button class="tw-tourClose" type="button" aria-label="Close guided tour">×</button><div class="tw-tourDrag" title="Drag to move"><div class="tw-tourKicker">YOUR QUICK CREATIVE TOUR</div><div class="tw-tourProgress"></div></div><div class="tw-tourHero"><div class="tw-tourHeroIcon">✦</div><div><strong class="tw-tourTitle"></strong><p class="tw-tourText"></p></div></div><div class="tw-tourList"></div><button class="tw-btn tw-btnPrimary tw-tourAction" type="button"></button><small>Your choice is remembered on this device. Close anytime to skip.</small>';document.body.appendChild(c);c.setAttribute('aria-label',T('Wheel customization tour'));c.querySelector('.tw-tourClose').setAttribute('aria-label',T('Close guided tour'));c.querySelector('.tw-tourDrag').setAttribute('title',T('Drag to move'));c.querySelector('.tw-tourKicker').textContent=T('YOUR QUICK CREATIVE TOUR');c.querySelector('small').textContent=T('Your choice is remembered on this device. Close anytime to skip.');tour.card=c;makeDraggable(c,c.querySelector('.tw-tourDrag'));c.querySelector('.tw-tourClose').onclick=function(){close('dismissed');};c.querySelector('.tw-tourAction').onclick=function(){var s=steps[tour.index];if(s[0]==='spin'){close('completed');showArea('wheel');setTimeout(function(){var b=document.getElementById('twSpin');if(b)b.focus();},650);}else showArea(s[4]);};render();showArea('quick');try{TW.track&&TW.track('customization_tour_started',{source:'make_yours'});}catch(_){}}
  TW.startCustomizationTour=start;
  document.addEventListener('click',function(e){var plan=TW.access&&TW.access.getUserPlan?TW.access.getUserPlan():'free';if(plan==='free'&&e.target&&e.target.closest&&e.target.closest('.tw-startEditing'))setTimeout(start,0);},true);
  function check(e){if(!tour.active||tour.busy)return;var id=steps[tour.index][0],n=snap(),t=e&&e.target,R=TW.refs||{};if(id==='color'&&n.colors!==tour.base.colors)next();else if(id==='sticker'&&n.stickers!==tour.base.stickers)next();else if(id==='countdown'&&n.countdown==='yes'&&t===R.selCountdownOn)next();else if(id==='sound'&&(n.spin!==tour.base.spin||n.win!==tour.base.win))next();else if(id==='voice'){var committedPhrase=e&&e.type==='change'&&t===R.inWinnerPhrase&&n.phrase.trim().length>=3&&n.phrase.trim()!==tour.base.phrase.trim();if(committedPhrase||n.voice!==tour.base.voice||n.recording!==tour.base.recording)next();}}
  ['change','input'].forEach(function(type){document.addEventListener(type,function(e){setTimeout(function(){check(e);},0);},true);});document.addEventListener('click',function(e){if(tour.active)setTimeout(function(){check(e);},220);},true);
  var st=document.createElement('style');st.id='tw-customization-tour-0813';st.textContent='.tw-customTour{position:fixed;z-index:2147483000;right:clamp(12px,2vw,28px);bottom:clamp(12px,2vw,28px);box-sizing:border-box;width:min(390px,calc(100vw - 24px));max-height:min(720px,calc(100dvh - 24px));overflow:auto;padding:20px;border:1px solid rgba(255,255,255,.20);border-radius:24px;background:radial-gradient(circle at 8% 0,rgba(255,63,157,.32),transparent 40%),radial-gradient(circle at 100% 100%,rgba(32,201,220,.18),transparent 38%),linear-gradient(145deg,rgba(38,15,61,.98),rgba(10,29,42,.98));color:#fff8ee;box-shadow:0 18px 44px rgba(7,4,20,.38),inset 0 1px 0 rgba(255,255,255,.16);font-family:Fredoka,system-ui,sans-serif;isolation:isolate}.tw-tourClose{position:absolute;z-index:2;right:12px;top:10px;width:34px;height:34px;border:1px solid rgba(255,255,255,.18);border-radius:50%;background:rgba(255,255,255,.09);color:#fff8ee;font-size:24px;cursor:pointer}.tw-tourDrag{padding-right:40px;cursor:grab;touch-action:none;user-select:none}.tw-customTour.isDragging .tw-tourDrag{cursor:grabbing}.tw-tourKicker{color:#bff5ff;font-size:10px;font-weight:950;letter-spacing:.12em}.tw-tourProgress{margin-top:5px;color:rgba(255,248,238,.7);font-size:11px;font-weight:800}.tw-tourHero{display:grid;grid-template-columns:48px 1fr;gap:12px;align-items:center;margin:14px 0 16px}.tw-tourHeroIcon{display:grid;place-items:center;width:48px;height:48px;border:1px solid rgba(255,255,255,.20);border-radius:16px;background:linear-gradient(145deg,rgba(255,63,157,.48),rgba(160,92,255,.32));color:#fff;font-size:24px;box-shadow:0 10px 24px rgba(145,72,225,.24)}.tw-tourHero strong{display:block;font-size:19px;line-height:1.08;color:#fff8ee}.tw-tourHero p{margin:5px 0 0;color:rgba(255,248,238,.80);font-size:12px;line-height:1.35}.tw-tourList{display:grid;gap:6px}.tw-tourStep{display:grid;grid-template-columns:31px 1fr;gap:9px;align-items:center;min-height:38px;padding:5px 9px;border-radius:12px;color:rgba(255,248,238,.56);font-size:12px;font-weight:750}.tw-tourStepIcon{display:grid;place-items:center;width:29px;height:29px;border-radius:9px;background:rgba(255,255,255,.08)}.tw-tourStep.isCurrent{background:rgba(255,255,255,.11);color:#fff8ee;box-shadow:inset 0 0 0 1px rgba(255,255,255,.13)}.tw-tourStep.isDone{color:#aaf4d1}.tw-tourStep.isDone .tw-tourStepIcon{background:rgba(68,204,139,.22);color:#bfffdc;font-weight:950}.tw-customTour .tw-tourAction{width:100%;margin-top:14px;min-height:44px;border:1px solid rgba(255,255,255,.24);border-radius:999px;background:linear-gradient(135deg,#cc007e,#7044bd);color:#fff!important;font-weight:950;box-shadow:inset 0 1px 0 rgba(255,255,255,.32),0 8px 19px rgba(204,0,126,.20)}.tw-customTour>small{display:block;margin-top:8px;text-align:center;color:rgba(255,248,238,.62);font-size:9px}.tw-tourTarget{position:relative!important;z-index:2147482000!important;animation:twTourTarget 1.05s ease 2!important;box-shadow:0 0 0 5px rgba(255,63,157,.24),0 0 28px rgba(32,201,220,.62)!important}.tw-customTour.isCelebrating{animation:twTourCelebrate .52s ease}.tw-tourBurst{position:absolute;left:50%;top:45%;pointer-events:none}.tw-tourBurst i{--a:calc(var(--i)*30deg);position:absolute;width:7px;height:10px;border-radius:3px;background:hsl(calc(var(--i)*29) 78% 58%);animation:twTourBit .8s ease-out forwards;transform:rotate(var(--a)) translateY(-8px)}@keyframes twTourCelebrate{50%{transform:translateY(-4px) scale(1.012)}}@keyframes twTourTarget{50%{filter:brightness(1.22);transform:scale(1.025)}}@keyframes twTourBit{to{transform:rotate(var(--a)) translateY(-105px) rotate(180deg);opacity:0}}@media(max-width:640px){.tw-customTour{right:10px;bottom:10px;width:min(340px,calc(100vw - 20px));max-height:48dvh;padding:15px;border-radius:21px}.tw-tourHero{margin:10px 0}.tw-tourHeroIcon{width:42px;height:42px}.tw-tourList .tw-tourStep:not(.isCurrent){display:none}.tw-tourList{gap:0}.tw-tourStep.isCurrent{min-height:38px}.tw-customTour .tw-tourAction{margin-top:10px;min-height:42px}.tw-customTour>small{display:none}}@media(prefers-reduced-motion:reduce){.tw-customTour,.tw-customTour *{animation:none!important;transition:none!important}.tw-tourBurst{display:none!important}}';document.head.appendChild(st);
})();

